import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AccountNumber: any;
  BigInt: any;
  Byte: any;
  CountryCode: any;
  Cuid: any;
  Currency: string;
  DID: any;
  Date: string;
  DateTime: string;
  DeweyDecimal: any;
  Duration: any;
  EmailAddress: any;
  GUID: any;
  HSL: any;
  HSLA: any;
  HexColorCode: any;
  Hexadecimal: any;
  IBAN: any;
  IP: any;
  IPCPatent: any;
  IPv4: any;
  IPv6: any;
  ISBN: any;
  ISO8601Duration: any;
  JSON: string;
  JSONObject: any;
  JWT: any;
  LCCSubclass: any;
  Latitude: any;
  LocalDate: any;
  LocalEndTime: any;
  LocalTime: any;
  Locale: string;
  Long: any;
  Longitude: any;
  MAC: any;
  NegativeFloat: any;
  NegativeInt: any;
  NonEmptyString: any;
  NonNegativeFloat: any;
  NonNegativeInt: any;
  NonPositiveFloat: any;
  NonPositiveInt: any;
  ObjectID: any;
  PhoneNumber: any;
  Port: any;
  PositiveFloat: any;
  PositiveInt: any;
  PostalCode: any;
  RGB: any;
  RGBA: any;
  RoutingNumber: any;
  SafeInt: any;
  SemVer: any;
  Time: any;
  TimeZone: string;
  Timestamp: any;
  URL: string;
  USCurrency: any;
  UUID: string;
  UnsignedFloat: any;
  UnsignedInt: any;
  UtcOffset: any;
  Void: any;
};

export type Account = {
  __typename?: 'Account';
  accountCharges: Array<AccountCharge>;
  address1: Scalars['String'];
  address2: Scalars['String'];
  altHandling: Scalars['String'];
  buscode?: Maybe<AccountBusinessCode>;
  busnumber?: Maybe<Scalars['String']>;
  client: Scalars['String'];
  contacts: Array<AccountContact>;
  country: Country;
  countryid: Scalars['Int'];
  createdByOffice: Account;
  dateCreated: Scalars['DateTime'];
  dateDeleted?: Maybe<Scalars['DateTime']>;
  dateModified: Scalars['DateTime'];
  defaultCollectionAddress: Scalars['String'];
  defaultInvoicePartyID: Scalars['Int'];
  dgioffice: Scalars['Boolean'];
  discountrate: Scalars['Int'];
  eawbemail?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fax: Scalars['String'];
  finemail?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  industryType?: Maybe<AccountIndustryType>;
  isActive: Scalars['Boolean'];
  isAgent: Scalars['Boolean'];
  isJobHoldActive: Scalars['Boolean'];
  isPreferredAgent: Scalars['Boolean'];
  isRegisteredForTax: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
  lastAccessed: Scalars['DateTime'];
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  notes: Array<AccountNote>;
  officeConfiguration?: Maybe<OfficeConfiguration>;
  officeid: Scalars['Int'];
  openPurchaseOrder?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  placeID?: Maybe<Scalars['String']>;
  postal: Scalars['String'];
  recentActivity: Array<ActivityLog>;
  relatedAccounts: Array<RelatedAccount>;
  repregion?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  town: Scalars['String'];
  uploadedDocuments: Array<UploadedDocument>;
  web: Scalars['String'];
  zip: Scalars['String'];
};


export type AccountaccountChargesArgs = {
  bookingDeliveryTypes?: InputMaybe<Array<BookingDeliveryType>>;
  bookingTypes?: InputMaybe<Array<BookingType>>;
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  take?: InputMaybe<Scalars['Int']>;
};

/** What type of code is the business number, GST, VAT or ABN */
export enum AccountBusinessCode {
  ABN = 'ABN',
  GST = 'GST',
  Siret = 'Siret',
  TAX = 'TAX',
  VAT = 'VAT'
}

export type AccountCharge = {
  __typename?: 'AccountCharge';
  amount: Scalars['Float'];
  charge_citymetro: Scalars['Boolean'];
  charge_domestic: Scalars['Boolean'];
  charge_euro: Scalars['Boolean'];
  charge_import: Scalars['Boolean'];
  charge_international: Scalars['Boolean'];
  charge_interoffice: Scalars['Boolean'];
  charge_packaging: Scalars['Boolean'];
  charge_shipdecpack: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  delivery_dgi: Scalars['Boolean'];
  delivery_overnight: Scalars['Boolean'];
  delivery_road: Scalars['Boolean'];
  delivery_sameday: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  taxable: Scalars['Boolean'];
  type: AccountChargeType;
};

/** Fixed or Percentage */
export enum AccountChargeType {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export type AccountContact = {
  __typename?: 'AccountContact';
  account: Account;
  address1: Scalars['String'];
  address2: Scalars['String'];
  country: Country;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  email: Scalars['String'];
  fax: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  notes: Scalars['String'];
  phone: Scalars['String'];
  phone2: Scalars['String'];
  position: Scalars['String'];
  state: Scalars['String'];
  town: Scalars['String'];
  zip: Scalars['String'];
};

/** Industry type of the account */
export enum AccountIndustryType {
  Aeronautical = 'Aeronautical',
  Chemicals = 'Chemicals',
  ConsumerProducts = 'ConsumerProducts',
  EducationalInstitution = 'EducationalInstitution',
  Energy = 'Energy',
  Food = 'Food',
  Government = 'Government',
  HealthLifeScience = 'HealthLifeScience',
  LaboratoryTesting = 'LaboratoryTesting',
  Manufacturing = 'Manufacturing',
  OilGas = 'OilGas',
  Petrochemicals = 'Petrochemicals',
  Transport = 'Transport'
}

export type AccountNote = {
  __typename?: 'AccountNote';
  account: Account;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee: Employee;
  id: Scalars['Int'];
  isEdited: Scalars['Boolean'];
  noteinfo: Scalars['String'];
};

export type AccountSearchResults = {
  __typename?: 'AccountSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The accounts data */
  records: Array<Account>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  account?: Maybe<Account>;
  booking?: Maybe<Booking>;
  contact?: Maybe<AccountContact>;
  dateCreated: Scalars['DateTime'];
  description: Scalars['String'];
  employee?: Maybe<Employee>;
  eventid: Scalars['Int'];
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['JSON']>;
  office?: Maybe<Account>;
};

export type AddRelatedAccountInputs = {
  notes: Scalars['String'];
  primaryAccountID: Scalars['Int'];
  relatedAccountID: Scalars['Int'];
};

export type AddressSuggestion = {
  __typename?: 'AddressSuggestion';
  PlaceId: Scalars['String'];
  Text: Scalars['String'];
};

export type Airline = {
  __typename?: 'Airline';
  airlineadd1: Scalars['String'];
  airlineadd2: Scalars['String'];
  airlinecode: Scalars['String'];
  airlineid: Scalars['String'];
  airlinename: Scalars['String'];
  airlinephone: Scalars['String'];
  airlineweb: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  notes: Scalars['String'];
};

export type AssignEmployeePermissionsInputs = {
  employeeId: Scalars['Int'];
  permissions: Array<Scalars['String']>;
};

export type AssignedMawbVoucher = {
  __typename?: 'AssignedMawbVoucher';
  booking: Booking;
  bookingID: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  id: Scalars['Int'];
  voucherID: Scalars['Int'];
};

export type AuthEventLog = {
  __typename?: 'AuthEventLog';
  audience: Scalars['String'];
  client_id: Scalars['String'];
  client_name: Scalars['String'];
  connection: Scalars['String'];
  connection_id: Scalars['String'];
  date: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  description: Scalars['String'];
  details: Scalars['JSON'];
  hostname: Scalars['String'];
  ip: Scalars['String'];
  isMobile: Scalars['Boolean'];
  location_info_city_name: Scalars['String'];
  location_info_continent_code: Scalars['String'];
  location_info_country_code: Scalars['String'];
  location_info_country_code3: Scalars['String'];
  location_info_country_name: Scalars['String'];
  location_info_latitude: Scalars['String'];
  location_info_longitude: Scalars['String'];
  location_info_time_zone: Scalars['String'];
  log_id: Scalars['String'];
  scope: Scalars['String'];
  strategy: Scalars['String'];
  strategy_type: Scalars['String'];
  type: LogEventTypeCode;
  user_agent: Scalars['String'];
  user_id: Scalars['String'];
  user_name: Scalars['String'];
};

export type BaseCharge = {
  __typename?: 'BaseCharge';
  discountrate: Scalars['Float'];
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  net: Scalars['Float'];
  source: ChargeSource;
  tax: Scalars['Float'];
  taxable: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type BaseChargeInput = {
  discountrate: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  net: Scalars['Float'];
  source: ChargeSource;
  tax: Scalars['Float'];
  taxable: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type BaseCost = {
  clientname: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  invoiceamt: Scalars['Float'];
  invoicedate: Scalars['DateTime'];
  invoiceno: Scalars['String'];
  purchasenumber: Scalars['String'];
  taxamt: Scalars['Float'];
  taxcode: ChargeTaxCode;
  type: CostOfSaleType;
};

export type BaseFixedCharge = {
  /** The presence of an ID indicated an update instead of create */
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  net: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type BaseFlight = {
  airlineIataCode: Scalars['String'];
  airlineName: Scalars['String'];
  airlinecode: Scalars['String'];
  dest: Scalars['String'];
  flightnum: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
};

export type BasePackaging = {
  cost: Scalars['Float'];
  /** To update an existing packaging item, pass it's ID */
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  numused: Scalars['Int'];
  size: Scalars['String'];
};

export type Booking = {
  __typename?: 'Booking';
  agenthawb?: Maybe<Scalars['String']>;
  bookingArrival?: Maybe<BookingArrival>;
  bookingCharges: Array<BookingCharge>;
  bookingCosts: Array<CostOfSale>;
  bookingDelivery?: Maybe<BookingDelivery>;
  bookingFormInputs?: Maybe<BookingFormInput>;
  bookingOffice: Account;
  bookingPickup?: Maybe<BookingPickup>;
  bookingTimeline: Array<BookingTimelineEvent>;
  bookingTransport?: Maybe<BookingTransport>;
  bookingTypeConfiguration: BookingTypeConfiguration;
  bookingtype: BookingType;
  categoryType: BookingCategoryType;
  client: Account;
  consigadd1: Scalars['String'];
  consigadd2: Scalars['String'];
  consigemail: Scalars['String'];
  consigfax: Scalars['String'];
  consignee?: Maybe<Account>;
  consigneeCountry?: Maybe<Country>;
  consignotify: Scalars['Boolean'];
  consigstate?: Maybe<Scalars['String']>;
  consigtown: Scalars['String'];
  consigzip: Scalars['String'];
  costcode?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  coyhawb: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  /** 3 letter destination portcode */
  destcode: Scalars['String'];
  destination?: Maybe<Portcode>;
  email: Scalars['String'];
  employee: Employee;
  flights: Array<BookingFlight>;
  id: Scalars['Int'];
  invoiceParty: Account;
  invoiced: Scalars['Boolean'];
  /** The pickup date of the shipment, use this date on invoices */
  invoicedate?: Maybe<Scalars['DateTime']>;
  /** The invoice ID used for this booking. Periculum does 1:1 booking to invoice but may do 1 to many bookings to invoices later */
  invoiceno?: Maybe<Scalars['String']>;
  /** The date the last invoice was sent to the client */
  invoicesentdate?: Maybe<Scalars['DateTime']>;
  jobdate: Scalars['Date'];
  /** The date the last note was added to the bookin */
  lastNoteDate?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  notes: Array<BookingNote>;
  /** 3 letter origin portcode */
  origcode: Scalars['String'];
  origin?: Maybe<Portcode>;
  packaging: Array<BookingPackaging>;
  parentBooking?: Maybe<Booking>;
  persrep: Scalars['String'];
  persrepphone: Scalars['String'];
  phone: Scalars['String'];
  quote?: Maybe<Quote>;
  recentActivity: Array<ActivityLog>;
  /** The coyhawb of the booking parent */
  returnjob?: Maybe<Scalars['String']>;
  shipments: Array<Shipment>;
  shippersref: Scalars['String'];
  /** Special instructions relevant to the booking */
  specinst?: Maybe<Scalars['String']>;
  status: BookingJobStatus;
  step: BookingJobStep;
  tariffMinWeight: Scalars['Float'];
  tariffMinWeightKG: Scalars['Int'];
  tariffPerKG: Scalars['Float'];
  /** Snapshot of the name of the tariff for the job when created */
  tariffZone: Scalars['String'];
  transitTime: Scalars['Int'];
  transitTimeAllowed: Scalars['Int'];
  uploadedDocuments: Array<UploadedDocument>;
};


export type BookingbookingFormInputsArgs = {
  formID: PericulumFormID;
};

export type BookingArrival = {
  __typename?: 'BookingArrival';
  agent?: Maybe<Account>;
  booking: Booking;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  /** Date of shipment arrival at DGI office */
  dateReceived: Scalars['Date'];
  dgdRaisedBy?: Maybe<Employee>;
  dryicekg: Scalars['Float'];
  id: Scalars['Int'];
  includesDryIce: Scalars['Boolean'];
  isComplete: Scalars['Boolean'];
  isDgdRaised: BookingArrivalDgdRaised;
  isRepacked: Scalars['Boolean'];
};

/** Was a DGD raised for this arrival? */
export enum BookingArrivalDgdRaised {
  No = 'No',
  NotApplicable = 'NotApplicable',
  Yes = 'Yes'
}

/** Category type of booking such as from quote, agent, return or standard job */
export enum BookingCategoryType {
  agent = 'agent',
  quote = 'quote',
  return = 'return',
  standard = 'standard'
}

export type BookingCharge = {
  __typename?: 'BookingCharge';
  booking: Booking;
  discountrate: Scalars['Float'];
  id: Scalars['Int'];
  name: Scalars['String'];
  net: Scalars['Float'];
  source: ChargeSource;
  tax: Scalars['Float'];
  taxable: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type BookingDelivery = {
  __typename?: 'BookingDelivery';
  dateCreated: Scalars['DateTime'];
  /** Has the shipper been notified of the delivery? */
  emailsent: Scalars['Boolean'];
  /** The date the shipper was last notified */
  emailsentDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  poddate: Scalars['DateTime'];
  podname: Scalars['String'];
  /** Base64 encoded signature of receiver */
  podsig?: Maybe<Scalars['String']>;
};

/** The method of delivery */
export enum BookingDeliveryType {
  DGI = 'DGI',
  Overnight = 'Overnight',
  Road = 'Road',
  SameDay = 'SameDay'
}

export type BookingFlight = {
  __typename?: 'BookingFlight';
  /** 2 letter airline code. e.g, 'QF' for Qantas */
  airlineIataCode: Scalars['String'];
  airlineName: Scalars['String'];
  /**  3 number airline code. e.g, 081 for Qantas */
  airlinecode: Scalars['String'];
  /** 3 letter destination portcode */
  dest: Scalars['String'];
  flightnum: Scalars['String'];
  id: Scalars['Int'];
  journeynum: Scalars['Int'];
};

export type BookingFormInput = {
  __typename?: 'BookingFormInput';
  coyhawb: Scalars['String'];
  formID: PericulumFormID;
  id: Scalars['Int'];
  inputsJSON: Scalars['JSON'];
};

/** Phases of the booking process */
export enum BookingJobStatus {
  Arrived = 'Arrived',
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  Delivered = 'Delivered',
  InTransit = 'InTransit',
  PickedUp = 'PickedUp'
}

/** Steps of the booking process */
export enum BookingJobStep {
  Arrival = 'Arrival',
  Delivery = 'Delivery',
  Details = 'Details',
  Pickup = 'Pickup',
  Shipments = 'Shipments',
  Transport = 'Transport'
}

export type BookingNote = {
  __typename?: 'BookingNote';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee?: Maybe<Employee>;
  id: Scalars['Int'];
  isEdited: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  isSent: Scalars['Boolean'];
  noteinfo: Scalars['String'];
  subject: BookingNoteSubject;
};

/** The creation context of the note */
export enum BookingNoteSubject {
  action = 'action',
  admin = 'admin',
  arrival = 'arrival',
  booked = 'booked',
  flight = 'flight',
  flightPrivate = 'flightPrivate',
  user = 'user'
}

export type BookingPackaging = {
  __typename?: 'BookingPackaging';
  cost: Scalars['Float'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  numused: Scalars['Int'];
  size: Scalars['String'];
};

export type BookingPickup = {
  __typename?: 'BookingPickup';
  aircraftType: PickupAircraftType;
  arrangedByEmployee?: Maybe<Employee>;
  /** Collection address */
  collectionAddress: Scalars['String'];
  /** Collection method */
  collectionMethod: PickupCollectionMethod;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  /** Has a dangerous goods inspection been completed? */
  dgInspectionComplete: Scalars['Boolean'];
  /** Why inspection was not performed? */
  dgInspectionJustification: Scalars['String'];
  id: Scalars['Int'];
  /** Is the pickup phase complete? */
  isBooked: Scalars['Boolean'];
  /** Has a Decleration of Dangerous Goods (DGD) document been completed? */
  isDGDCompleted: Scalars['Boolean'];
  /** Has pickup been arranged? */
  isPickupArranged: Scalars['Boolean'];
  /** Date of pickup */
  pickupdate: Scalars['Date'];
  /** Why is pickup not required? */
  pickupjustification: Scalars['String'];
  radioactive: Scalars['Boolean'];
};

export type BookingSearchResults = {
  __typename?: 'BookingSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The booking records */
  records: Array<Booking>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

export type BookingTimelineEvent = {
  __typename?: 'BookingTimelineEvent';
  date: Scalars['Date'];
  event: Scalars['String'];
};

export type BookingTransport = {
  __typename?: 'BookingTransport';
  agent?: Maybe<Account>;
  /** Is the delivery being handled by the customers own broker/agent */
  agentcob: Scalars['Boolean'];
  /** Connote / Road / Sea No or airway bill */
  connote: Scalars['String'];
  /** Generated DGI manifest number used for consolidating shipments */
  coymanifest: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  /** Delivery method of booking */
  delivery: BookingDeliveryType;
  /** Date of shipment confirmation at destination office */
  flightarrival: Scalars['DateTime'];
  id: Scalars['Int'];
  incotermId?: Maybe<Scalars['Int']>;
  /** Is the booking transport phase complete? */
  isComplete: Scalars['Boolean'];
  /** Has the booking shipments been consolidated with another booking going to same destination under the same MAWB/manifest */
  isConsolidated: Scalars['Boolean'];
  /** Has the agent been sent a pre-alert that the shipment is in bound? */
  isPrealertSent: Scalars['Boolean'];
  /** Airline assigned MAWB number */
  mawb?: Maybe<Scalars['String']>;
  /** Post flight shipment received date */
  postdate?: Maybe<Scalars['Date']>;
  /** Post flight check to confirm what was sent is what was received */
  postfab: Scalars['Boolean'];
  /** Date the last pre-alert was sent */
  prealertSentDate?: Maybe<Scalars['DateTime']>;
  /** Expected shipment arrival time at destination airport */
  shiparrived: Scalars['Boolean'];
};

/** The type of booking (domestic, international, etc) */
export enum BookingType {
  CityMetro = 'CityMetro',
  Domestic = 'Domestic',
  Europe = 'Europe',
  Import = 'Import',
  InterOffice = 'InterOffice',
  International = 'International',
  Packaging = 'Packaging',
  ShipDecAndPack = 'ShipDecAndPack'
}

export type BookingTypeConfiguration = {
  __typename?: 'BookingTypeConfiguration';
  bookingtype: BookingType;
  /** Should bookings of this type charge a freight charge? */
  chargefreightcost: Scalars['Boolean'];
  /** Should bookings of this type charge tax? */
  chargetax: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  requiredSteps: Array<BookingJobStep>;
  /** Apply a mutlipler to all base freight charges of this booking type */
  tariffmultiplier: Scalars['Float'];
};

export type BugReport = {
  __typename?: 'BugReport';
  action: Scalars['String'];
  actualresult: Scalars['String'];
  comments: Scalars['String'];
  commentsCount: Scalars['Int'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee: Employee;
  /** The office the employee had set in Periculum at the time of report creation */
  employeeOffice: Account;
  errordate: Scalars['DateTime'];
  errormessage: Scalars['String'];
  expectedresult: Scalars['String'];
  frequency: BugReportFrequency;
  id: Scalars['Int'];
  job: Scalars['String'];
  priority: BugReportPriority;
  reportComments: Array<BugReportComment>;
  status: BugReportStatus;
  title: Scalars['String'];
};

export type BugReportComment = {
  __typename?: 'BugReportComment';
  bugReport: BugReport;
  comment: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee: Employee;
  id: Scalars['Int'];
};

/** The frequency you encounter the bug */
export enum BugReportFrequency {
  EveryTime = 'EveryTime',
  HardlyEver = 'HardlyEver',
  Occasionally = 'Occasionally',
  Once = 'Once'
}

/** The priority of this bug to the requestor */
export enum BugReportPriority {
  Critical = 'Critical',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** The status of the bug */
export enum BugReportStatus {
  Closed = 'Closed',
  Complete = 'Complete',
  InProgress = 'InProgress',
  MoreInformationRequired = 'MoreInformationRequired',
  Open = 'Open'
}

export type CalculatedChargeEntity = {
  discountrate: Scalars['Float'];
  name: Scalars['String'];
  net: Scalars['Float'];
  source: ChargeSource;
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type Chapter = {
  __typename?: 'Chapter';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
};

export type ChargeOption = {
  __typename?: 'ChargeOption';
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

/** What the source of a charge is */
export enum ChargeSource {
  additional = 'additional',
  office = 'office',
  shipper = 'shipper',
  tariff = 'tariff'
}

/** Tax codes for charges */
export enum ChargeTaxCode {
  FRE = 'FRE',
  TAX = 'TAX'
}

export type CloneBookingInputs = {
  bookingtype: BookingType;
  coyhawb: Scalars['String'];
  parts: Array<CloneBookingPart>;
};

/** The parts of a booking that can be cloned */
export enum CloneBookingPart {
  Arrival = 'Arrival',
  Charges = 'Charges',
  CostOfSales = 'CostOfSales',
  Flights = 'Flights',
  Notes = 'Notes',
  Packaging = 'Packaging',
  Pickup = 'Pickup',
  Shipments = 'Shipments',
  Transport = 'Transport'
}

export type CommoditySection = {
  __typename?: 'CommoditySection';
  code: Scalars['String'];
  commodityChapters: Array<Chapter>;
  description: Scalars['String'];
  id: Scalars['Int'];
  section: Scalars['String'];
};

export type ContactSearchResults = {
  __typename?: 'ContactSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The contacts that match the search criteria */
  records: Array<AccountContact>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

export type CostOfSale = {
  __typename?: 'CostOfSale';
  booking?: Maybe<Booking>;
  clientname: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  invoiceamt: Scalars['Float'];
  invoicedate: Scalars['Date'];
  invoiceno: Scalars['String'];
  /** The raw job entered, may not be a valid job number */
  job?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  moneysymbol: Scalars['String'];
  purchasenumber: Scalars['String'];
  taxamt: Scalars['Float'];
  taxcode: ChargeTaxCode;
  type: CostOfSaleType;
};

/** Unconfirmed is entered by employee and confirmed is confirmation by accounting team with proof */
export enum CostOfSaleType {
  Confirmed = 'Confirmed',
  Unconfirmed = 'Unconfirmed'
}

export type CostOfSalesUpload = {
  clientname: Scalars['String'];
  description: Scalars['String'];
  invoiceamt: Scalars['Float'];
  invoicedate: Scalars['DateTime'];
  invoiceno: Scalars['String'];
  job: Scalars['String'];
  purchasenumber: Scalars['String'];
  taxamt: Scalars['Float'];
  taxcode: ChargeTaxCode;
};

export type CostOfSalesUploadInputs = {
  data: Array<CostOfSalesUpload>;
  locale: Scalars['String'];
  moneysymbol: Scalars['String'];
};

export type Country = {
  __typename?: 'Country';
  Country: Scalars['String'];
  countrycode?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  daylight?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  itemdesc?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  membercountry: Scalars['Boolean'];
  moneycode?: Maybe<Scalars['String']>;
  moneysymbol?: Maybe<Scalars['String']>;
  moneytype?: Maybe<Scalars['String']>;
  officeid?: Maybe<Scalars['Int']>;
  taxrate?: Maybe<Scalars['Float']>;
  taxtype: CountryTaxType;
  timeway?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['Int']>;
  weighttype?: Maybe<Scalars['String']>;
  zone: Scalars['Int'];
};

/** Country Tax Type e.g. GST, VAT, Other or None */
export enum CountryTaxType {
  GST = 'GST',
  None = 'None',
  Other = 'Other',
  VAT = 'VAT'
}

export type CreateAccountContactInput = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  clientid: Scalars['Int'];
  countryid: Scalars['Int'];
  email: Scalars['String'];
  fax: Scalars['String'];
  name: Scalars['String'];
  notes: Scalars['String'];
  phone: Scalars['String'];
  phone2: Scalars['String'];
  position: Scalars['String'];
  state: Scalars['String'];
  town: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateAccountInputs = {
  address1: Scalars['String'];
  address2: Scalars['String'];
  agentflag: Scalars['Int'];
  altHandling: Scalars['String'];
  buscode?: InputMaybe<AccountBusinessCode>;
  busnumber?: InputMaybe<Scalars['String']>;
  client: Scalars['String'];
  countryid: Scalars['Int'];
  defaultInvoicePartyID?: InputMaybe<Scalars['Int']>;
  eawbemail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fax: Scalars['String'];
  finemail: Scalars['String'];
  industryType?: InputMaybe<AccountIndustryType>;
  isAgent: Scalars['Boolean'];
  isPreferredAgent: Scalars['Boolean'];
  isRegisteredForTax: Scalars['Boolean'];
  isSupplier: Scalars['Boolean'];
  openPurchaseOrder?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postal: Scalars['String'];
  repregion?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  town: Scalars['String'];
  web: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateAccountNoteInputs = {
  clientid: Scalars['Int'];
  noteinfo: Scalars['String'];
};

export type CreateAirlineInputs = {
  airlineadd1: Scalars['String'];
  airlineadd2: Scalars['String'];
  airlinecode: Scalars['String'];
  airlineid: Scalars['String'];
  airlinename: Scalars['String'];
  airlinephone: Scalars['String'];
  airlineweb: Scalars['String'];
  notes: Scalars['String'];
};

export type CreateBookingInputs = {
  agenthawb: Scalars['String'];
  bookingtype: BookingType;
  categoryType: BookingCategoryType;
  clientid: Scalars['Int'];
  consigadd1?: InputMaybe<Scalars['String']>;
  consigadd2?: InputMaybe<Scalars['String']>;
  consigcountryID?: InputMaybe<Scalars['Int']>;
  consigemail?: InputMaybe<Scalars['String']>;
  consigfax?: InputMaybe<Scalars['String']>;
  consigid?: InputMaybe<Scalars['Int']>;
  consigstate?: InputMaybe<Scalars['String']>;
  consigtown?: InputMaybe<Scalars['String']>;
  consigzip?: InputMaybe<Scalars['String']>;
  costcode: Scalars['String'];
  destcode: Scalars['String'];
  email: Scalars['String'];
  invoiceid?: InputMaybe<Scalars['Int']>;
  jobdate: Scalars['Date'];
  name: Scalars['String'];
  origcode: Scalars['String'];
  persrep?: InputMaybe<Scalars['String']>;
  persrepphone?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  quoteid?: InputMaybe<Scalars['Int']>;
  /** The original job number if the job was created as an Agent or Return job */
  returnjob?: InputMaybe<Scalars['String']>;
  shippersref: Scalars['String'];
  specinst: Scalars['String'];
  tariffMinWeight: Scalars['Float'];
  tariffMinWeightKG: Scalars['Int'];
  tariffPerKG: Scalars['Float'];
  tariffZone: Scalars['String'];
};

export type CreateBookingNoteInputs = {
  coyhawb: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  noteinfo: Scalars['String'];
};

export type CreateBugReportCommentInputs = {
  comment: Scalars['String'];
  reportid: Scalars['Int'];
};

export type CreateBugReportInputs = {
  /** The action performed that triggered the bug */
  action: Scalars['String'];
  /** What actually occured */
  actualresult: Scalars['String'];
  /** Any additional comments to replicate */
  comments: Scalars['String'];
  errordate: Scalars['Date'];
  /** Any error message displayed on the screen */
  errormessage: Scalars['String'];
  /** The expected outcome that should have occured */
  expectedresult: Scalars['String'];
  frequency: BugReportFrequency;
  /** The job or quote number this bug is related to */
  job: Scalars['String'];
  priority: BugReportPriority;
  title: Scalars['String'];
};

export type CreateCountryInputs = {
  Country: Scalars['String'];
  countrycode?: InputMaybe<Scalars['String']>;
  daylight?: InputMaybe<Scalars['String']>;
  itemdesc?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  membercountry: Scalars['Boolean'];
  moneycode?: InputMaybe<Scalars['String']>;
  moneysymbol?: InputMaybe<Scalars['String']>;
  moneytype?: InputMaybe<Scalars['String']>;
  officeid?: InputMaybe<Scalars['Int']>;
  taxrate?: InputMaybe<Scalars['Float']>;
  taxtype: CountryTaxType;
  timeway?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
  weighttype?: InputMaybe<Scalars['String']>;
  zone: Scalars['Int'];
};

export type CreateEmployeeInputs = {
  dgnumber?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullname: Scalars['String'];
  officeid: Scalars['Int'];
  position?: InputMaybe<Scalars['String']>;
};

export type CreateFeatureRequestInputs = {
  comments: Scalars['String'];
  description: Scalars['String'];
  priority: FeatureRequestPriority;
  title: Scalars['String'];
};

export type CreateFixedChargeInputs = {
  jobid: Scalars['String'];
  name: Scalars['String'];
  net: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
  type: FixedChargeType;
};

export type CreateHomeBookmarkInputs = {
  icon: Scalars['String'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type CreateJobTariffInputs = {
  category: JobTariffCategory;
  minweight: Scalars['Float'];
  minweightkg: Scalars['Int'];
  officeid?: InputMaybe<Scalars['Int']>;
  perkg: Scalars['Float'];
  regionid?: InputMaybe<Scalars['Int']>;
  zone: Scalars['String'];
};

export type CreateMawbVouchersInputs = {
  airlineCode: Scalars['String'];
  firstNumber: Scalars['String'];
  numberToGenerate: Scalars['Int'];
  officeid: Scalars['Int'];
};

export type CreateOfficeChargeInputs = {
  amount: Scalars['Float'];
  bookingTypes: Array<BookingType>;
  chargeid?: InputMaybe<Scalars['Int']>;
  customChargeName?: InputMaybe<Scalars['String']>;
  deliveryTypes: Array<BookingDeliveryType>;
  officeid: Scalars['Int'];
  taxable: Scalars['Boolean'];
  type: OfficeChargeType;
};

export type CreateOfficeConfigurationInputs = {
  bankaccount: Scalars['String'];
  /** BSB or Swift number */
  bankcode: Scalars['String'];
  bankname: Scalars['String'];
  bookingPrefix: Scalars['String'];
  cityMetro: Scalars['String'];
  clientid: Scalars['Int'];
  currencyCode: Scalars['Currency'];
  currencyName: Scalars['String'];
  domestic: Scalars['String'];
  email: Scalars['EmailAddress'];
  europe: Scalars['String'];
  iataCode: Scalars['String'];
  ibanNumber: Scalars['String'];
  import: Scalars['String'];
  interOffice: Scalars['String'];
  international: Scalars['String'];
  invoicemsg: Scalars['String'];
  legalname: Scalars['String'];
  locale: Scalars['Locale'];
  paymentTermDays: Scalars['Int'];
  quotePrefix: Scalars['String'];
  regionid?: InputMaybe<Scalars['Int']>;
  shippersDec: Scalars['String'];
  slug: Scalars['String'];
  taxRate: Scalars['Float'];
  taxType: OfficeTaxType;
  timezone: Scalars['TimeZone'];
};

export type CreatePackagingOptionInputs = {
  name: Scalars['String'];
};

export type CreatePackagingTariffInputs = {
  cost: Scalars['Float'];
  cost2: Scalars['Float'];
  officeid: Scalars['Int'];
  packsize: Scalars['String'];
  packtype: Scalars['String'];
};

export type CreatePortcodeInputs = {
  cityname: Scalars['String'];
  countryid: Scalars['Int'];
  extraShippingDays: Scalars['Int'];
  isRemoteLocation: Scalars['Boolean'];
  notes: Scalars['String'];
  portcode: Scalars['String'];
  state: Scalars['String'];
};

export type CreateQuoteInputs = {
  bookingtype: BookingType;
  clientid?: InputMaybe<Scalars['Int']>;
  clientnamenew?: InputMaybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: Scalars['String'];
  deliveryType: BookingDeliveryType;
  destcode: Scalars['String'];
  dgdraised: Scalars['Boolean'];
  dryiceamt: Scalars['Float'];
  fixedCharges: Array<BaseFixedCharge>;
  itemdesc: Scalars['String'];
  itemweight: Scalars['Float'];
  leadorigin: QuoteLeadOrigin;
  officeCharges: Array<BaseChargeInput>;
  origcode: Scalars['String'];
  packaging: Array<BasePackaging>;
  repacked: Scalars['Boolean'];
  returnclienttype: QuoteClientType;
  tariffid: Scalars['Int'];
};

export type CreateQuoteNoteInputs = {
  noteinfo: Scalars['String'];
  quoteid: Scalars['String'];
};

export type CreateRegionInputs = {
  name: Scalars['String'];
};

export type CreateRegulationInputs = {
  packinggrp: Scalars['String'];
  packintcar: Scalars['String'];
  packintltd: Scalars['String'];
  packintpass: Scalars['String'];
  packqtycar: Scalars['String'];
  packqtyltd: Scalars['String'];
  packqtypass: Scalars['String'];
  unno: Scalars['String'];
};

export type CreateRoleInputs = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type CreateStandardChargeInputs = {
  description: Scalars['String'];
  name: Scalars['String'];
  type?: InputMaybe<OfficeChargeType>;
};

export type CreateUNNumberInputs = {
  classdiv: Scalars['String'];
  ergcode: Scalars['String'];
  extraname: Scalars['String'];
  hazlabel: Scalars['String'];
  isAuthRequired: Scalars['Boolean'];
  labelno: Scalars['String'];
  propername: Scalars['String'];
  specialProvision: Scalars['String'];
  subrisk: Scalars['String'];
  unno: Scalars['String'];
};

export type CurrencyOption = {
  __typename?: 'CurrencyOption';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CustomerPortalAccount = {
  __typename?: 'CustomerPortalAccount';
  dateCreated: Scalars['String'];
  dateModified: Scalars['String'];
  email: Scalars['String'];
  fullAddress: Scalars['String'];
  id: Scalars['Int'];
  industry?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  location: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type CustomerPortalAccountSearchResults = {
  __typename?: 'CustomerPortalAccountSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The accounts */
  records: Array<CustomerPortalAccount>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

export type CustomerPortalCreateQuoteContact = {
  address?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  purchaseOrder?: InputMaybe<Scalars['String']>;
};

export type CustomerPortalCreateQuoteInputs = {
  bookingType?: InputMaybe<BookingType>;
  collectionDate?: InputMaybe<Scalars['String']>;
  consigneeContact?: InputMaybe<CustomerPortalCreateQuoteContact>;
  consigneeId?: InputMaybe<Scalars['Int']>;
  deliveryType?: InputMaybe<BookingDeliveryType>;
  destinationCode?: InputMaybe<Scalars['String']>;
  invoiceRecipientId?: InputMaybe<Scalars['Int']>;
  originCode?: InputMaybe<Scalars['String']>;
  packages: Array<CustomerPortalCreateQuotePackage>;
  requirements: CustomerPortalCreateQuoteRequirements;
  shipperContact?: InputMaybe<CustomerPortalCreateQuoteContact>;
  shipperId?: InputMaybe<Scalars['Int']>;
  uploadedDocuments?: Array<Scalars['String']>;
};

export type CustomerPortalCreateQuotePackage = {
  description: Scalars['String'];
  grossWeight?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  length?: InputMaybe<Scalars['Float']>;
  litres?: InputMaybe<Scalars['Float']>;
  netWeight: Scalars['Float'];
  pieces?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type CustomerPortalCreateQuoteRequirements = {
  dryIceAmount?: Scalars['Float'];
  dryIceRequired?: Scalars['Boolean'];
  furtherComments?: InputMaybe<Scalars['String']>;
  packagingRequired?: Scalars['Boolean'];
  permitRequired?: Scalars['Boolean'];
  properShippingName?: InputMaybe<Scalars['String']>;
  safetyDataSheetRequired?: Scalars['Boolean'];
};

export type CustomerPortalPortcode = {
  __typename?: 'CustomerPortalPortcode';
  cityname: Scalars['String'];
  country?: Maybe<Country>;
  portcode: Scalars['String'];
  state: Scalars['String'];
};

export type CustomerPortalQuote = {
  __typename?: 'CustomerPortalQuote';
  bookingType: BookingType;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: Scalars['String'];
  dateCreated: Scalars['String'];
  dateModified: Scalars['String'];
  deliveryType: BookingDeliveryType;
  destinationCode: Scalars['String'];
  destinationPortcode?: Maybe<CustomerPortalPortcode>;
  dgdRequired?: Maybe<Scalars['Boolean']>;
  dryIceAmount?: Maybe<Scalars['Float']>;
  dryIceRequired?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isQuoteSent: Scalars['Boolean'];
  itemDescription: Scalars['String'];
  originCode: Scalars['String'];
  originPortcode?: Maybe<CustomerPortalPortcode>;
  quoteId: Scalars['String'];
  quoteSentDate?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  totalAmount?: Maybe<Scalars['Float']>;
  totalWeight: Scalars['Float'];
};

export type CustomerPortalQuoteDetails = {
  __typename?: 'CustomerPortalQuoteDetails';
  bookingType: BookingType;
  consigneeName?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: Scalars['String'];
  dateCreated: Scalars['String'];
  dateModified: Scalars['String'];
  deliveryType: BookingDeliveryType;
  destinationCode: Scalars['String'];
  destinationPortcode?: Maybe<CustomerPortalPortcode>;
  dgdRequired?: Maybe<Scalars['Boolean']>;
  dryIceAmount?: Maybe<Scalars['Float']>;
  dryIceRequired?: Maybe<Scalars['Boolean']>;
  furtherComments?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isQuoteSent: Scalars['Boolean'];
  itemDescription: Scalars['String'];
  originCode: Scalars['String'];
  originPortcode?: Maybe<CustomerPortalPortcode>;
  packages: Array<CustomerPortalQuotePackage>;
  quoteId: Scalars['String'];
  quoteSentDate?: Maybe<Scalars['String']>;
  shipperName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  totalAmount?: Maybe<Scalars['Float']>;
  totalWeight: Scalars['Float'];
};

export type CustomerPortalQuotePackage = {
  __typename?: 'CustomerPortalQuotePackage';
  description: Scalars['String'];
  grossWeight?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  length?: Maybe<Scalars['Float']>;
  litres?: Maybe<Scalars['Float']>;
  netWeight: Scalars['Float'];
  pieces?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Float']>;
};

export type CustomerPortalQuoteResponse = {
  __typename?: 'CustomerPortalQuoteResponse';
  message: Scalars['String'];
  quoteId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CustomerPortalQuoteSearchResults = {
  __typename?: 'CustomerPortalQuoteSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The quotes */
  records: Array<CustomerPortalQuote>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

export type CustomerPortalShipment = {
  __typename?: 'CustomerPortalShipment';
  consignee: Scalars['String'];
  coyhawb: Scalars['String'];
  dateCreated: Scalars['String'];
  dateDeleted: Scalars['String'];
  dateModified: Scalars['String'];
  datePickedUp: Scalars['String'];
  description: Scalars['String'];
  destinationPortcode?: Maybe<CustomerPortalPortcode>;
  id: Scalars['Int'];
  originPortcode?: Maybe<CustomerPortalPortcode>;
  shipper: Scalars['String'];
  status: CustomerPortalShipmentStatus;
  type: Scalars['String'];
  vehicle: Scalars['String'];
};

export type CustomerPortalShipmentSearchResults = {
  __typename?: 'CustomerPortalShipmentSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The shipments */
  records: Array<CustomerPortalShipment>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

/** Status of a shipment in the customer portal */
export enum CustomerPortalShipmentStatus {
  ARRIVED = 'ARRIVED',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  IN_TRANSIT = 'IN_TRANSIT',
  PENDING = 'PENDING',
  PICKED_UP = 'PICKED_UP',
  QUOTE_PENDING = 'QUOTE_PENDING',
  QUOTE_SENT = 'QUOTE_SENT'
}

export type EmailAgentPrealertInputs = {
  bookingFiles: Array<Scalars['Int']>;
  coyhawb: Scalars['String'];
  forms: Array<PericulumFormID>;
  recipients: Array<Scalars['String']>;
};

export type EmailBookingNoteInputs = {
  message: Scalars['String'];
  noteID: Scalars['Int'];
  recipients: Scalars['String'];
  subject: Scalars['String'];
};

export type EmailContact = {
  __typename?: 'EmailContact';
  email: Scalars['String'];
  name: Scalars['String'];
};

export type EmailInvoiceInputs = {
  ccEmails: Array<Scalars['EmailAddress']>;
  hawb: Scalars['String'];
  message: Scalars['String'];
  recipients: Array<Scalars['EmailAddress']>;
};

export type EmailLog = {
  __typename?: 'EmailLog';
  attachments?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  emailbcc: Scalars['String'];
  emailbody: Scalars['String'];
  emailcc: Scalars['String'];
  emailsubject: Scalars['String'];
  emailto: Scalars['String'];
  id: Scalars['Int'];
};

export type EmailPODInputs = {
  bcc: Array<Scalars['String']>;
  body: Scalars['String'];
  bookingFiles: Array<Scalars['Int']>;
  cc: Array<Scalars['String']>;
  coyhawb: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type EmailQuoteInputs = {
  id: Scalars['Int'];
  message: Scalars['String'];
  recipients: Array<Scalars['EmailAddress']>;
};

export type EmailQuoteReminderInputs = {
  bodyHtml: Scalars['String'];
  cc: Array<Scalars['EmailAddress']>;
  quoteid: Scalars['String'];
  resendQuote: Scalars['Boolean'];
  to: Array<Scalars['EmailAddress']>;
};

export type Employee = {
  __typename?: 'Employee';
  authSubject?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  dgnumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['EmailAddress']>;
  fullname: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isPericulumSetup: Scalars['Boolean'];
  /** The office the employee works at, not the active Periculum office. */
  office?: Maybe<Account>;
  permissions: Array<Permission>;
  picture?: Maybe<Scalars['URL']>;
  position?: Maybe<Scalars['String']>;
  roles: Array<Role>;
};

export type FeatureRequest = {
  __typename?: 'FeatureRequest';
  closingcomments?: Maybe<Scalars['String']>;
  comments: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  employee: Employee;
  hasUserVoted: Scalars['Boolean'];
  id: Scalars['Int'];
  office: Account;
  priority: FeatureRequestPriority;
  status: FeatureRequestStatus;
  title: Scalars['String'];
  voteCount: Scalars['Int'];
};

/** Priority level of feature request */
export enum FeatureRequestPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** Status level of feature request */
export enum FeatureRequestStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotGoingAhead = 'NotGoingAhead',
  OnHold = 'OnHold',
  Submitted = 'Submitted',
  UnderReview = 'UnderReview'
}

export type FilterActivityLogs = {
  accountid?: InputMaybe<Scalars['Int']>;
  bookingid?: InputMaybe<Scalars['Int']>;
  contactid?: InputMaybe<Scalars['Int']>;
  employeeid?: InputMaybe<Scalars['Int']>;
  eventid?: InputMaybe<Scalars['Int']>;
  officeid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type FilterAirlinesInputs = {
  airlinecode?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type FilterEmailLogs = {
  employeeid?: InputMaybe<Scalars['Int']>;
  officeids?: InputMaybe<Array<Scalars['Int']>>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type FixedCharge = {
  __typename?: 'FixedCharge';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  /** A booking hawb or quote id starting with Q */
  jobid: Scalars['String'];
  name: Scalars['String'];
  net: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
  type: FixedChargeType;
};

/** Indicate if a fixed charge is applied to a booking or quote */
export enum FixedChargeType {
  Booking = 'Booking',
  Quote = 'Quote'
}

export type GetAccountContactsFilter = {
  accountid: Scalars['Float'];
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetBookingEmailInputs = {
  agentid?: InputMaybe<Scalars['Int']>;
  bookingContacts?: InputMaybe<Scalars['Boolean']>;
  bookingOffice?: InputMaybe<Scalars['Boolean']>;
  consigneeAccount?: InputMaybe<Scalars['Boolean']>;
  consigneeContacts?: InputMaybe<Scalars['Boolean']>;
  coyhawb: Scalars['String'];
  invoicePartyAccount?: InputMaybe<Scalars['Boolean']>;
  invoicePartyContacts?: InputMaybe<Scalars['Boolean']>;
  invoicePartyFinance?: InputMaybe<Scalars['Boolean']>;
  shipperAccount?: InputMaybe<Scalars['Boolean']>;
  shipperContacts?: InputMaybe<Scalars['Boolean']>;
};

export type GetBookingEmailResponse = {
  __typename?: 'GetBookingEmailResponse';
  contacts: Array<EmailContact>;
  group: Scalars['String'];
};

export type GetBugReportsFilters = {
  officeid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<BugReportStatus>>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetChargeOptionsFilters = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetCostOfSalesFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetCountriesFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
  zone: Scalars['Int'];
};

export type GetDriveFileInput = {
  convertTo?: InputMaybe<Scalars['String']>;
  fileId: Scalars['String'];
};

export type GetEmployeesFilters = {
  officeid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetFeatureRequestsFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<FeatureRequestStatus>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetFixedChargesInputs = {
  jobid: Scalars['String'];
  type: FixedChargeType;
};

export type GetJobTariffsFilters = {
  category?: InputMaybe<JobTariffCategory>;
  officeid?: InputMaybe<Scalars['Int']>;
  regionid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetMawbVoucherFilters = {
  isBorrowed?: InputMaybe<Scalars['Boolean']>;
  isUsed?: InputMaybe<Scalars['Boolean']>;
  officeid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetPackagingOptionsFilters = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetPackagingTariffsFilters = {
  officeid: Scalars['Int'];
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  regionid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetPortcodesFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetTrackingRequestFilters = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GetUNNumbersFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type GlobalConfig = {
  __typename?: 'GlobalConfig';
  dataType: GlobalConfigDataType;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  item: GlobalConfigItem;
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Data type options for global config */
export enum GlobalConfigDataType {
  Boolean = 'Boolean',
  Float = 'Float',
  Integer = 'Integer',
  String = 'String'
}

/** Possible global config items */
export enum GlobalConfigItem {
  ClientNotification = 'ClientNotification',
  DomesticRemoteFuelSurcharge = 'DomesticRemoteFuelSurcharge',
  EmailDisclaimer = 'EmailDisclaimer',
  EmailDisclaimerFrench = 'EmailDisclaimerFrench',
  InternationalRemoteFuelSurcharge = 'InternationalRemoteFuelSurcharge',
  NewEmployeeRole = 'NewEmployeeRole',
  QuoteDisclaimer = 'QuoteDisclaimer'
}

export type GoogleDriveFile = {
  __typename?: 'GoogleDriveFile';
  iconLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  webContentLink?: Maybe<Scalars['String']>;
  webViewLink?: Maybe<Scalars['String']>;
};

export type HomeBookmark = {
  __typename?: 'HomeBookmark';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee: Employee;
  icon: Scalars['String'];
  id: Scalars['Int'];
  label: Scalars['String'];
  url: Scalars['String'];
};

export type Incoterm = {
  __typename?: 'Incoterm';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Job = {
  __typename?: 'Job';
  /** Is the job active */
  disabled?: Maybe<Scalars['Boolean']>;
  /** The number of times the job has failed. */
  failCount?: Maybe<Scalars['Int']>;
  /** The reason the job failed. */
  failReason?: Maybe<Scalars['String']>;
  /** The date/time the job last failed. */
  failedAt?: Maybe<Scalars['DateTime']>;
  id: PericulumJobID;
  isRunning: Scalars['Boolean'];
  /** Name of the job */
  name: Scalars['String'];
  /** Date/time the job is next scheduled to run */
  nextRunAt?: Maybe<Scalars['DateTime']>;
  /** How often the job runs */
  schedule: Scalars['String'];
};

export type JobCompleteEvent = {
  __typename?: 'JobCompleteEvent';
  history: SchedulerJobHistory;
  jobID: PericulumJobID;
};

export type JobEvent = JobCompleteEvent | RunJobEvent | ToggleJobEvent;

export type JobHistoryFilters = {
  jobIDs?: InputMaybe<Array<PericulumJobID>>;
  result?: InputMaybe<JobResultFilter>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<JobType>;
};

/** Filter jobs by result */
export enum JobResultFilter {
  all = 'all',
  fail = 'fail',
  success = 'success'
}

export type JobTariff = {
  __typename?: 'JobTariff';
  category: JobTariffCategory;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  minweight: Scalars['Float'];
  minweightkg: Scalars['Int'];
  officeAccount?: Maybe<Account>;
  perkg: Scalars['Float'];
  region?: Maybe<Region>;
  zone: Scalars['String'];
};

/** Category of a job tariff */
export enum JobTariffCategory {
  DOMESTIC_OVERNIGHT = 'DOMESTIC_OVERNIGHT',
  DOMESTIC_OVERNIGHT_BULK = 'DOMESTIC_OVERNIGHT_BULK',
  DOMESTIC_ROAD = 'DOMESTIC_ROAD',
  DOMESTIC_ROAD_BULK = 'DOMESTIC_ROAD_BULK',
  DOMESTIC_SAMEDATE = 'DOMESTIC_SAMEDATE',
  IMPORT_OVERNIGHT = 'IMPORT_OVERNIGHT',
  IMPORT_SAMEDAY = 'IMPORT_SAMEDAY',
  INTERNATIONAL_AIR = 'INTERNATIONAL_AIR',
  INTERNATIONAL_AIR_BULK = 'INTERNATIONAL_AIR_BULK',
  INTERNATIONAL_ROAD = 'INTERNATIONAL_ROAD',
  INTERNATIONAL_ROAD_BULK = 'INTERNATIONAL_ROAD_BULK',
  MANUAL_QUOTE = 'MANUAL_QUOTE'
}

/** If the job was scheduled or manually run */
export enum JobType {
  Manual = 'Manual',
  Scheduled = 'Scheduled'
}

export type ListDriveFilesInput = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

/** What type of auth event it is, see: https://auth0.com/docs/deploy-monitor/logs/log-event-type-codes */
export enum LogEventTypeCode {
  admin_update_launch = 'admin_update_launch',
  api_limit = 'api_limit',
  cls = 'cls',
  cs = 'cs',
  depnote = 'depnote',
  du = 'du',
  f = 'f',
  fapi = 'fapi',
  fc = 'fc',
  fce = 'fce',
  fco = 'fco',
  fcoa = 'fcoa',
  fcp = 'fcp',
  fcph = 'fcph',
  fcpn = 'fcpn',
  fcpr = 'fcpr',
  fcpro = 'fcpro',
  fcu = 'fcu',
  fd = 'fd',
  fdeac = 'fdeac',
  fdeaz = 'fdeaz',
  fdecc = 'fdecc',
  fdu = 'fdu',
  feacft = 'feacft',
  feccft = 'feccft',
  fede = 'fede',
  fens = 'fens',
  feoobft = 'feoobft',
  feotpft = 'feotpft',
  fepft = 'fepft',
  fepotpft = 'fepotpft',
  fercft = 'fercft',
  ferrt = 'ferrt',
  fertft = 'fertft',
  fi = 'fi',
  flo = 'flo',
  fn = 'fn',
  fp = 'fp',
  fs = 'fs',
  fsa = 'fsa',
  fu = 'fu',
  fui = 'fui',
  fv = 'fv',
  fvr = 'fvr',
  gd_auth_failed = 'gd_auth_failed',
  gd_auth_rejected = 'gd_auth_rejected',
  gd_auth_succeed = 'gd_auth_succeed',
  gd_enrollment_complete = 'gd_enrollment_complete',
  gd_otp_rate_limit_exceed = 'gd_otp_rate_limit_exceed',
  gd_recovery_failed = 'gd_recovery_failed',
  gd_recovery_rate_limit_exceed = 'gd_recovery_rate_limit_exceed',
  gd_recovery_succeed = 'gd_recovery_succeed',
  gd_send_email = 'gd_send_email',
  gd_send_pn = 'gd_send_pn',
  gd_send_pn_failure = 'gd_send_pn_failure',
  gd_send_sms = 'gd_send_sms',
  gd_send_sms_failure = 'gd_send_sms_failure',
  gd_send_voice = 'gd_send_voice',
  gd_send_voice_failure = 'gd_send_voice_failure',
  gd_start_auth = 'gd_start_auth',
  gd_start_enroll = 'gd_start_enroll',
  gd_start_enroll_failed = 'gd_start_enroll_failed',
  gd_tenant_update = 'gd_tenant_update',
  gd_unenroll = 'gd_unenroll',
  gd_update_device_account = 'gd_update_device_account',
  gd_webauthn_challenge_failed = 'gd_webauthn_challenge_failed',
  gd_webauthn_enrollment_failed = 'gd_webauthn_enrollment_failed',
  limit_delegation = 'limit_delegation',
  limit_mu = 'limit_mu',
  limit_sul = 'limit_sul',
  limit_wc = 'limit_wc',
  mfar = 'mfar',
  mgmt_api_read = 'mgmt_api_read',
  pla = 'pla',
  pwd_leak = 'pwd_leak',
  resource_cleanup = 'resource_cleanup',
  s = 's',
  sapi = 'sapi',
  sce = 'sce',
  scoa = 'scoa',
  scp = 'scp',
  scph = 'scph',
  scpn = 'scpn',
  scpr = 'scpr',
  scu = 'scu',
  sd = 'sd',
  sdu = 'sdu',
  seacft = 'seacft',
  seccft = 'seccft',
  sede = 'sede',
  sens = 'sens',
  seoobft = 'seoobft',
  seotpft = 'seotpft',
  sepft = 'sepft',
  sercft = 'sercft',
  sertft = 'sertft',
  si = 'si',
  signup_pwd_leak = 'signup_pwd_leak',
  slo = 'slo',
  srrt = 'srrt',
  ss = 'ss',
  ssa = 'ssa',
  sui = 'sui',
  sv = 'sv',
  svr = 'svr',
  sys_os_update_end = 'sys_os_update_end',
  sys_os_update_start = 'sys_os_update_start',
  sys_update_end = 'sys_update_end',
  sys_update_start = 'sys_update_start',
  ublkdu = 'ublkdu',
  w = 'w'
}

/** Available airline MAWB documents for international flights */
export type MawbVoucher = {
  __typename?: 'MawbVoucher';
  airline: Airline;
  airlinecode: Scalars['String'];
  assignments?: Maybe<Array<AssignedMawbVoucher>>;
  borrowedByOffice?: Maybe<Account>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  isBorrowed: Scalars['Boolean'];
  isConsolidated: Scalars['Boolean'];
  /** Has the voucher been used in a booking? */
  isUsed: Scalars['Boolean'];
  mawbNumber: Scalars['Int'];
  ownedByOffice: Account;
};

export type MergeAccountCheckResponse = {
  __typename?: 'MergeAccountCheckResponse';
  accountCharges: Scalars['Int'];
  contacts: Scalars['Int'];
  jobs: Scalars['Int'];
  notes: Scalars['Int'];
  quotes: Scalars['Int'];
  uploads: Scalars['Int'];
};

export type MergeAccountInputs = {
  accountID: Scalars['Int'];
  mergeIntoAccountID: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addRelatedAccount: RelatedAccount;
  assignPermissions: Employee;
  cancelBooking: Booking;
  changeActiveOffice: Scalars['Boolean'];
  cloneBooking: Booking;
  completeBookingArrival: Booking;
  completeBookingDelivery: Booking;
  completeBookingPickup: Booking;
  completeBookingTransport: Booking;
  /** Confirms client upload was a success and indexes the document in the database */
  confirmUpload: UploadedDocument;
  createAccount: Account;
  createAccountContact: AccountContact;
  createAccountNote: Account;
  createAirline: Airline;
  createBooking: Booking;
  createBookingNote: Booking;
  createBookmark: HomeBookmark;
  createBugReport: BugReport;
  createBugReportComment: BugReportComment;
  createCountry: Country;
  createCustomerPortalQuote: CustomerPortalQuoteResponse;
  createEmployee: Employee;
  createFeatureRequest: FeatureRequest;
  createFixedCharge: FixedCharge;
  createJobTariff: JobTariff;
  createMawbVouchers: Scalars['Int'];
  createOfficeCharge: OfficeCharge;
  createOfficeConfiguration: OfficeConfiguration;
  createPackagingOption: PackagingOption;
  createPackagingTariff: PackagingTariff;
  createPortcode: Portcode;
  createQuote: Quote;
  createQuoteNote: Quote;
  createRegion: Region;
  createRegulation: Regulation;
  createRole: Role;
  createStandardCharge: StandardCharge;
  createUNNumber: UNNumber;
  deleteAccountCharge: AccountCharge;
  deleteAccountContact: AccountContact;
  deleteAccountNote: AccountNote;
  deleteAirline: Airline;
  deleteBooking: Booking;
  deleteBookingNote: BookingNote;
  deleteBookmark: HomeBookmark;
  deleteBugReport: BugReport;
  deleteBugReportComment: BugReportComment;
  deleteChargeOption: ChargeOption;
  deleteCostOfSale: CostOfSale;
  deleteDocument: UploadedDocument;
  deleteFeatureRequest: FeatureRequest;
  deleteFixedCharge: FixedCharge;
  deleteJobTariff: JobTariff;
  deleteMawbVoucher: MawbVoucher;
  deleteOfficeCharge: OfficeCharge;
  deleteOfficeConfiguration: OfficeConfiguration;
  deletePackagingOption: PackagingOption;
  deletePortcode: Portcode;
  deleteQuote: Quote;
  deleteQuoteNote: QuoteNote;
  deleteRegion: Region;
  deleteRegulation: Regulation;
  deleteRole: Role;
  deleteStandardCharge: StandardCharge;
  deleteUNNumber: UNNumber;
  downloadDocument: Scalars['String'];
  emailAgentPrealert: Booking;
  emailBookingInvoice: Booking;
  emailNote: Booking;
  emailQuote: Quote;
  emailQuoteReminder: Quote;
  emailShipperPOD: Booking;
  generateInvoice: Booking;
  generatePericulumForm: Scalars['String'];
  mergeAccount: Account;
  purgeCache: Array<Scalars['String']>;
  removeRelatedAccount: RelatedAccount;
  repairBooking: Booking;
  runJob: Job;
  saveAccountCharge: AccountCharge;
  saveBookingArrival: Booking;
  saveBookingFinance: Booking;
  saveBookingPickup: Booking;
  saveBookingShipments: Booking;
  saveBookingTransport: Booking;
  saveChargeOption: ChargeOption;
  sendOTP: SendOTPResponse;
  /** Request to upload a document returns a presigned S3 URL for the client to upload directly to S3 */
  startUpload: Array<Scalars['String']>;
  toggleFeatureRequestVote: FeatureRequest;
  toggleJobStatus: Job;
  uncancelBooking: Booking;
  updateAccount: Account;
  updateAccountContact: AccountContact;
  updateAccountNote: Account;
  updateAirline: Airline;
  updateBooking: Booking;
  updateBookingNote: Booking;
  updateBookmark: HomeBookmark;
  updateBugReport: BugReport;
  updateCountry: Country;
  updateEmployee: Employee;
  updateFeatureRequest: FeatureRequest;
  updateFixedCharge: FixedCharge;
  updateGlobalConfig: GlobalConfig;
  updateJobTariff: JobTariff;
  updateOfficeCharge: OfficeCharge;
  updateOfficeConfiguration: OfficeConfiguration;
  updatePackagingOption: PackagingOption;
  updatePackagingTariff: PackagingTariff;
  updatePortcode: Portcode;
  updateQuote: Quote;
  updateQuoteNote: Quote;
  updateQuoteStatus: Quote;
  updateRegion: Region;
  updateRegulation: Regulation;
  updateRole: Role;
  updateStandardCharge: StandardCharge;
  updateTransitTime: TransitTime;
  updateUNNumber: UNNumber;
  uploadCostOfSales: Scalars['Int'];
  verifyOTP: VerifyOTPResponse;
};


export type MutationaddRelatedAccountArgs = {
  inputs: AddRelatedAccountInputs;
};


export type MutationassignPermissionsArgs = {
  inputs: AssignEmployeePermissionsInputs;
};


export type MutationcancelBookingArgs = {
  hawb: Scalars['String'];
};


export type MutationchangeActiveOfficeArgs = {
  officeConfigID: Scalars['Int'];
};


export type MutationcloneBookingArgs = {
  inputs: CloneBookingInputs;
};


export type MutationcompleteBookingArrivalArgs = {
  coyhawb: Scalars['String'];
};


export type MutationcompleteBookingDeliveryArgs = {
  inputs: SaveBookingDeliveryInputs;
};


export type MutationcompleteBookingPickupArgs = {
  coyhawb: Scalars['String'];
};


export type MutationcompleteBookingTransportArgs = {
  coyhawb: Scalars['String'];
};


export type MutationconfirmUploadArgs = {
  inputs: UploadDocumentInputs;
};


export type MutationcreateAccountArgs = {
  inputs: CreateAccountInputs;
};


export type MutationcreateAccountContactArgs = {
  inputs: CreateAccountContactInput;
};


export type MutationcreateAccountNoteArgs = {
  inputs: CreateAccountNoteInputs;
};


export type MutationcreateAirlineArgs = {
  inputs: CreateAirlineInputs;
};


export type MutationcreateBookingArgs = {
  inputs: CreateBookingInputs;
};


export type MutationcreateBookingNoteArgs = {
  inputs: CreateBookingNoteInputs;
};


export type MutationcreateBookmarkArgs = {
  inputs: CreateHomeBookmarkInputs;
};


export type MutationcreateBugReportArgs = {
  inputs: CreateBugReportInputs;
};


export type MutationcreateBugReportCommentArgs = {
  inputs: CreateBugReportCommentInputs;
};


export type MutationcreateCountryArgs = {
  inputs: CreateCountryInputs;
};


export type MutationcreateCustomerPortalQuoteArgs = {
  inputs: CustomerPortalCreateQuoteInputs;
};


export type MutationcreateEmployeeArgs = {
  inputs: CreateEmployeeInputs;
};


export type MutationcreateFeatureRequestArgs = {
  inputs: CreateFeatureRequestInputs;
};


export type MutationcreateFixedChargeArgs = {
  inputs: CreateFixedChargeInputs;
};


export type MutationcreateJobTariffArgs = {
  inputs: CreateJobTariffInputs;
};


export type MutationcreateMawbVouchersArgs = {
  inputs: CreateMawbVouchersInputs;
};


export type MutationcreateOfficeChargeArgs = {
  inputs: CreateOfficeChargeInputs;
};


export type MutationcreateOfficeConfigurationArgs = {
  inputs: CreateOfficeConfigurationInputs;
};


export type MutationcreatePackagingOptionArgs = {
  inputs: CreatePackagingOptionInputs;
};


export type MutationcreatePackagingTariffArgs = {
  inputs: CreatePackagingTariffInputs;
};


export type MutationcreatePortcodeArgs = {
  inputs: CreatePortcodeInputs;
};


export type MutationcreateQuoteArgs = {
  inputs: CreateQuoteInputs;
};


export type MutationcreateQuoteNoteArgs = {
  inputs: CreateQuoteNoteInputs;
};


export type MutationcreateRegionArgs = {
  inputs: CreateRegionInputs;
};


export type MutationcreateRegulationArgs = {
  inputs: CreateRegulationInputs;
};


export type MutationcreateRoleArgs = {
  inputs: CreateRoleInputs;
};


export type MutationcreateStandardChargeArgs = {
  inputs: CreateStandardChargeInputs;
};


export type MutationcreateUNNumberArgs = {
  inputs: CreateUNNumberInputs;
};


export type MutationdeleteAccountChargeArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteAccountContactArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteAccountNoteArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteAirlineArgs = {
  airlineID: Scalars['Int'];
};


export type MutationdeleteBookingArgs = {
  coyhawb: Scalars['String'];
};


export type MutationdeleteBookingNoteArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteBookmarkArgs = {
  id: Scalars['Float'];
};


export type MutationdeleteBugReportArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteBugReportCommentArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteChargeOptionArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteCostOfSaleArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteFeatureRequestArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteFixedChargeArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteJobTariffArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteMawbVoucherArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteOfficeChargeArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteOfficeConfigurationArgs = {
  id: Scalars['Int'];
};


export type MutationdeletePackagingOptionArgs = {
  id: Scalars['Int'];
};


export type MutationdeletePortcodeArgs = {
  portcodeID: Scalars['Int'];
};


export type MutationdeleteQuoteArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteQuoteNoteArgs = {
  noteID: Scalars['Int'];
};


export type MutationdeleteRegionArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteRegulationArgs = {
  id: Scalars['Float'];
};


export type MutationdeleteRoleArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteStandardChargeArgs = {
  id: Scalars['Int'];
};


export type MutationdeleteUNNumberArgs = {
  id: Scalars['Float'];
};


export type MutationdownloadDocumentArgs = {
  id: Scalars['Int'];
};


export type MutationemailAgentPrealertArgs = {
  inputs: EmailAgentPrealertInputs;
};


export type MutationemailBookingInvoiceArgs = {
  inputs: EmailInvoiceInputs;
};


export type MutationemailNoteArgs = {
  inputs: EmailBookingNoteInputs;
};


export type MutationemailQuoteArgs = {
  inputs: EmailQuoteInputs;
};


export type MutationemailQuoteReminderArgs = {
  inputs: EmailQuoteReminderInputs;
};


export type MutationemailShipperPODArgs = {
  inputs: EmailPODInputs;
};


export type MutationgenerateInvoiceArgs = {
  hawb: Scalars['String'];
};


export type MutationgeneratePericulumFormArgs = {
  formID: PericulumFormID;
  format: PericulumFormFormat;
  hawb: Scalars['String'];
  inputs?: InputMaybe<Scalars['JSONObject']>;
};


export type MutationmergeAccountArgs = {
  inputs: MergeAccountInputs;
};


export type MutationpurgeCacheArgs = {
  pattern: Scalars['String'];
};


export type MutationremoveRelatedAccountArgs = {
  relationID: Scalars['Int'];
};


export type MutationrepairBookingArgs = {
  inputs: RepairBookingInputs;
};


export type MutationrunJobArgs = {
  data?: InputMaybe<Scalars['JSON']>;
  jobID: PericulumJobID;
};


export type MutationsaveAccountChargeArgs = {
  inputs: SaveAccountChargeInputs;
};


export type MutationsaveBookingArrivalArgs = {
  inputs: SaveBookingArrivalInputs;
};


export type MutationsaveBookingFinanceArgs = {
  inputs: SaveBookingFinanceInputs;
};


export type MutationsaveBookingPickupArgs = {
  inputs: SaveBookingPickupInputs;
};


export type MutationsaveBookingShipmentsArgs = {
  inputs: SaveBookingShipmentsInputs;
};


export type MutationsaveBookingTransportArgs = {
  inputs: SaveBookingTransportInputs;
};


export type MutationsaveChargeOptionArgs = {
  inputs: SaveChargeOptionInputs;
};


export type MutationsendOTPArgs = {
  email: Scalars['String'];
};


export type MutationstartUploadArgs = {
  inputs: Array<UploadDocumentInputs>;
};


export type MutationtoggleFeatureRequestVoteArgs = {
  featureRequestID: Scalars['Int'];
};


export type MutationtoggleJobStatusArgs = {
  jobID: PericulumJobID;
};


export type MutationuncancelBookingArgs = {
  hawb: Scalars['String'];
};


export type MutationupdateAccountArgs = {
  inputs: UpdateAccountInputs;
};


export type MutationupdateAccountContactArgs = {
  inputs: UpdateAccountContactInput;
};


export type MutationupdateAccountNoteArgs = {
  inputs: UpdateAccountNoteInputs;
};


export type MutationupdateAirlineArgs = {
  inputs: UpdateAirlineInputs;
};


export type MutationupdateBookingArgs = {
  inputs: UpdateBookingInputs;
};


export type MutationupdateBookingNoteArgs = {
  inputs: UpdateBookingNoteInputs;
};


export type MutationupdateBookmarkArgs = {
  inputs: UpdateHomeBookmarkInputs;
};


export type MutationupdateBugReportArgs = {
  inputs: UpdateBugReportInputs;
};


export type MutationupdateCountryArgs = {
  inputs: UpdateCountryInputs;
};


export type MutationupdateEmployeeArgs = {
  inputs: UpdateEmployeeInputs;
};


export type MutationupdateFeatureRequestArgs = {
  inputs: UpdateFeatureRequestInputs;
};


export type MutationupdateFixedChargeArgs = {
  inputs: UpdateFixedChargeInputs;
};


export type MutationupdateGlobalConfigArgs = {
  inputs: UpdateGlobalConfigInputs;
};


export type MutationupdateJobTariffArgs = {
  inputs: UpdateJobTariffInputs;
};


export type MutationupdateOfficeChargeArgs = {
  inputs: UpdateOfficeChargeInputs;
};


export type MutationupdateOfficeConfigurationArgs = {
  inputs: UpdateOfficeConfigurationInputs;
};


export type MutationupdatePackagingOptionArgs = {
  inputs: UpdatePackagingOptionInputs;
};


export type MutationupdatePackagingTariffArgs = {
  inputs: UpdatePackagingTariffInputs;
};


export type MutationupdatePortcodeArgs = {
  inputs: UpdatePortcodeInputs;
};


export type MutationupdateQuoteArgs = {
  inputs: UpdateQuoteInputs;
};


export type MutationupdateQuoteNoteArgs = {
  inputs: UpdateQuoteNoteInputs;
};


export type MutationupdateQuoteStatusArgs = {
  newStatus: QuoteStatus;
  quoteID: Scalars['String'];
};


export type MutationupdateRegionArgs = {
  inputs: UpdateRegionInputs;
};


export type MutationupdateRegulationArgs = {
  inputs: UpdateRegulationInputs;
};


export type MutationupdateRoleArgs = {
  inputs: UpdateRoleInputs;
};


export type MutationupdateStandardChargeArgs = {
  inputs: UpdateStandardChargeInputs;
};


export type MutationupdateTransitTimeArgs = {
  inputs: UpdateTransitTimeInputs;
};


export type MutationupdateUNNumberArgs = {
  inputs: UpdateUNNumberInputs;
};


export type MutationuploadCostOfSalesArgs = {
  inputs: CostOfSalesUploadInputs;
};


export type MutationverifyOTPArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};

export type OfficeCharge = {
  __typename?: 'OfficeCharge';
  amount: Scalars['Float'];
  bookingTypes: Array<BookingType>;
  charge?: Maybe<StandardCharge>;
  /** If office charge is not a global office charge (chargeid is null) then this field is populated with the custom charges name */
  customChargeName?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  deliveryTypes: Array<BookingDeliveryType>;
  id: Scalars['Int'];
  office: Account;
  taxable: Scalars['Boolean'];
  type: OfficeChargeType;
};

/** Fixed or Percentage */
export enum OfficeChargeType {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export type OfficeConfiguration = {
  __typename?: 'OfficeConfiguration';
  bankaccount: Scalars['String'];
  bankcode: Scalars['String'];
  bankname: Scalars['String'];
  bookingPrefix: Scalars['String'];
  cityMetro: Scalars['String'];
  currencyCode: Scalars['Currency'];
  currencyName: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  domestic: Scalars['String'];
  email: Scalars['String'];
  europe: Scalars['String'];
  iataCode: Scalars['String'];
  ibanNumber: Scalars['String'];
  id: Scalars['Int'];
  import: Scalars['String'];
  interOffice: Scalars['String'];
  international: Scalars['String'];
  /** Appears at the bottom of an invoice from this office */
  invoicemsg: Scalars['String'];
  lastBookingID: Scalars['Int'];
  lastQuoteID: Scalars['Int'];
  legalname: Scalars['String'];
  locale: Scalars['Locale'];
  office: Account;
  paymentTermDays: Scalars['Int'];
  quotePrefix: Scalars['String'];
  region?: Maybe<Region>;
  shippersDec: Scalars['String'];
  slug: Scalars['String'];
  taxRate: Scalars['Float'];
  taxType: OfficeTaxType;
  timezone: Scalars['TimeZone'];
};

/** The type of tax used by the office */
export enum OfficeTaxType {
  GST = 'GST',
  None = 'None',
  Other = 'Other',
  TAX = 'TAX',
  VAT = 'VAT'
}

export type PackagingOption = {
  __typename?: 'PackagingOption';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type PackagingTariff = {
  __typename?: 'PackagingTariff';
  cost: Scalars['Float'];
  cost2: Scalars['Float'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  office: Account;
  packsize: Scalars['String'];
  packtype: Scalars['String'];
  region?: Maybe<Region>;
};

/** The format of the Periculum form */
export enum PericulumFormFormat {
  pdf = 'pdf',
  word = 'word'
}

/** A Periculum generated form */
export enum PericulumFormID {
  AirlineBooking = 'AirlineBooking',
  CollectionNote = 'CollectionNote',
  DeliveryNote = 'DeliveryNote',
  HouseAirwayBill = 'HouseAirwayBill',
  Invoice = 'Invoice',
  JobCard = 'JobCard',
  Manifest = 'Manifest',
  ProformaInvoice = 'ProformaInvoice',
  Quote = 'Quote',
  RoadDec = 'RoadDec',
  RoadDecUK = 'RoadDecUK',
  ShipmentPrealert = 'ShipmentPrealert',
  ShippersDec = 'ShippersDec',
  ShippingLabels = 'ShippingLabels'
}

/** The id of a job */
export enum PericulumJobID {
  CheckPdfServiceHealthy = 'CheckPdfServiceHealthy',
  CloseStaleQuotes = 'CloseStaleQuotes',
  DeleteTempDocs = 'DeleteTempDocs',
  SyncAuth0Logs = 'SyncAuth0Logs',
  SyncGooglePhotos = 'SyncGooglePhotos'
}

/** Available Periculum report export formats */
export enum PericulumReportFormat {
  CSV = 'CSV',
  GOOGLE_SHEETS = 'GOOGLE_SHEETS',
  PDF = 'PDF'
}

/** Available Periculum report IDs */
export enum PericulumReportID {
  CustomerAnalysisReport = 'CustomerAnalysisReport',
  CustomerInvoices = 'CustomerInvoices',
  QuotesReport = 'QuotesReport',
  Reconciliation = 'Reconciliation',
  ShipmentsReport = 'ShipmentsReport',
  SummaryReport = 'SummaryReport',
  WeeklyJobs = 'WeeklyJobs'
}

/** Permissions are scopes assigned to an employee, they can be directly assigned or inherited from a role */
export type Permission = {
  __typename?: 'Permission';
  id: Scalars['Int'];
  /** A scope e.g. Account:Read */
  name: Scalars['String'];
  source: PermissionSource;
  sourceName?: Maybe<Scalars['String']>;
};

/** Where the permission comes from, either directly applied or inherited from a role */
export enum PermissionSource {
  Direct = 'Direct',
  Role = 'Role'
}

/** Pickup form aircraft type */
export enum PickupAircraftType {
  CargoOnly = 'CargoOnly',
  PassengerCargo = 'PassengerCargo'
}

/** Pickup collection method */
export enum PickupCollectionMethod {
  DGI = 'DGI',
  Overnight = 'Overnight',
  Road = 'Road',
  SameDay = 'SameDay'
}

export type Place = {
  __typename?: 'Place';
  AddressNumber?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  Geometry?: Maybe<PlaceGeometry>;
  Interpolated?: Maybe<Scalars['Boolean']>;
  Label?: Maybe<Scalars['String']>;
  Municipality?: Maybe<Scalars['String']>;
  Neighborhood?: Maybe<Scalars['String']>;
  PlaceId: Scalars['String'];
  PostalCode?: Maybe<Scalars['String']>;
  Region?: Maybe<Scalars['String']>;
  Street?: Maybe<Scalars['String']>;
  SubRegion?: Maybe<Scalars['String']>;
  TimeZone?: Maybe<PlaceTimezone>;
  UnitNumber?: Maybe<Scalars['String']>;
  UnitType?: Maybe<Scalars['String']>;
};

export type PlaceGeometry = {
  __typename?: 'PlaceGeometry';
  /** The coordinates of the point in format [long, lat] */
  Point: Array<Scalars['Float']>;
};

export type PlaceTimezone = {
  __typename?: 'PlaceTimezone';
  Name?: Maybe<Scalars['String']>;
  Offset?: Maybe<Scalars['Int']>;
};

export type Portcode = {
  __typename?: 'Portcode';
  agents: Array<Account>;
  cityname: Scalars['String'];
  country?: Maybe<Country>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  /** Add extra shipping days ontop of the days allocated via zone */
  extraShippingDays: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  /** Remote locations will have an additional 'Out of Area Surcharge' attached */
  isRemoteLocation: Scalars['Boolean'];
  notes: Scalars['String'];
  portcode: Scalars['String'];
  state: Scalars['String'];
};

export type Profile = {
  __typename?: 'Profile';
  employee: Employee;
  /** The office currently set in Periculum */
  periculumOffice?: Maybe<OfficeConfiguration>;
  permissions: Array<Permission>;
  roles: Array<Role>;
};

export type Query = {
  __typename?: 'Query';
  GetBookingEmailInputs: Array<GetBookingEmailResponse>;
  accountByID?: Maybe<Account>;
  accountContact?: Maybe<AccountContact>;
  /** @deprecated Use searchContacts instead */
  accountContacts: Array<AccountContact>;
  accountNotesByAccountID: Array<AccountNote>;
  activityLogs: Array<ActivityLog>;
  activityLogsCount: Scalars['Int'];
  addressSuggestions: Array<AddressSuggestion>;
  airline: Airline;
  airlines: Array<Airline>;
  booking?: Maybe<Booking>;
  bookingTypeConfiguration: BookingTypeConfiguration;
  bugReport: BugReport;
  bugReportComments: Array<BugReportComment>;
  bugReports: Array<BugReport>;
  bugReportsCount: Scalars['Int'];
  chargeOptions: Array<ChargeOption>;
  commoditySections: Array<CommoditySection>;
  costOfSales: Array<CostOfSale>;
  costOfSalesCount: Scalars['Int'];
  countries: Array<Country>;
  countriesCount: Scalars['Int'];
  countryByID?: Maybe<Country>;
  currencies: Array<CurrencyOption>;
  downloadBookingInvoice: Scalars['URL'];
  employeeByID?: Maybe<Employee>;
  employees: Array<Employee>;
  employeesCount: Scalars['Int'];
  featureRequest: FeatureRequest;
  featureRequests: Array<FeatureRequest>;
  featureRequestsCount: Scalars['Int'];
  fixedCharges: Array<FixedCharge>;
  generateBookingCharges: Array<BaseCharge>;
  generateReport: Scalars['String'];
  getCustomerPortalQuoteDetails?: Maybe<CustomerPortalQuoteDetails>;
  getGoogleDriveFileContent: Scalars['String'];
  getKeys: Array<Scalars['String']>;
  getUnusedAndRecentlyUsedMawbVouchers: Array<MawbVoucher>;
  globalConfig: Array<GlobalConfig>;
  homeBookmarks: Array<HomeBookmark>;
  incoterms: Array<Incoterm>;
  /** @deprecated TODO: Convert this to a fieldresovler on a portcode and update usage */
  isPortcodeRemote: Scalars['Boolean'];
  jobTariffByID?: Maybe<JobTariff>;
  jobTariffByName?: Maybe<JobTariff>;
  jobTariffs: Array<JobTariff>;
  jobTariffsByOfficeID: Array<JobTariff>;
  jobTariffsByRegion: Array<JobTariff>;
  jobTariffsCount: Scalars['Int'];
  jobs: Array<Job>;
  listGoogleDriveFiles: Array<GoogleDriveFile>;
  locales: Array<Scalars['Locale']>;
  mawbVouchers: Array<MawbVoucher>;
  mawbVouchersCount: Scalars['Int'];
  /** Check what data will be merged */
  mergeAccountCheck: MergeAccountCheckResponse;
  /** Get all active booking manifests for an office by office client ID */
  officeActiveManifests: Array<Scalars['String']>;
  officeChargeByID?: Maybe<OfficeCharge>;
  officeCharges: Array<OfficeCharge>;
  officeChargesByOfficeID: Array<OfficeCharge>;
  officeConfigurationByID?: Maybe<OfficeConfiguration>;
  officeConfigurations: Array<OfficeConfiguration>;
  packagingOptions: Array<PackagingOption>;
  packagingOptionsCount: Scalars['Int'];
  packagingTariffs: Array<PackagingTariff>;
  place: Place;
  portcodeByID: Portcode;
  portcodes: Array<Portcode>;
  profile: Profile;
  quoteByID?: Maybe<Quote>;
  quoteByQuoteID?: Maybe<Quote>;
  recentlyUpdatedAccounts: Array<Account>;
  regions: Array<Region>;
  regulationsByUNNumber: Array<Regulation>;
  regulationsByUNNumberID: Array<Regulation>;
  roles: Array<Role>;
  schedulerJobHistory: Array<SchedulerJobHistory>;
  schedulerJobHistoryCount: Scalars['Int'];
  searchAccounts: AccountSearchResults;
  searchAuth0Logs: Array<AuthEventLog>;
  searchAuth0LogsCount: Scalars['Int'];
  searchBookings: BookingSearchResults;
  searchContacts: ContactSearchResults;
  searchCustomerPortalAccounts: CustomerPortalAccountSearchResults;
  searchCustomerPortalQuotes: CustomerPortalQuoteSearchResults;
  searchEmailLogs: Array<EmailLog>;
  searchEmailLogsCount: Scalars['Int'];
  searchQuotes: QuoteSearchResults;
  searchShipments: CustomerPortalShipmentSearchResults;
  standardChargeByID?: Maybe<StandardCharge>;
  standardCharges: Array<StandardCharge>;
  timezones: Array<Scalars['String']>;
  trackingRequests: Array<TrackingRequest>;
  trackingRequestsCount: Scalars['Int'];
  trackingRequestsMonthAggregation: Array<TrackingMonthAggregation>;
  transitTimes: Array<TransitTime>;
  unNumber: UNNumber;
  unNumbers: Array<UNNumber>;
  unNumbersCount: Scalars['Int'];
  uncreatedAccountsWithName: Scalars['Float'];
  unreadEmailCount: Scalars['Int'];
  userProfile: UserProfile;
};


export type QueryGetBookingEmailInputsArgs = {
  inputs: GetBookingEmailInputs;
};


export type QueryaccountByIDArgs = {
  id: Scalars['Int'];
};


export type QueryaccountContactArgs = {
  id: Scalars['Int'];
};


export type QueryaccountContactsArgs = {
  filters: GetAccountContactsFilter;
};


export type QueryaccountNotesByAccountIDArgs = {
  accountID: Scalars['Int'];
};


export type QueryactivityLogsArgs = {
  inputs?: InputMaybe<FilterActivityLogs>;
};


export type QueryactivityLogsCountArgs = {
  inputs?: InputMaybe<FilterActivityLogs>;
};


export type QueryaddressSuggestionsArgs = {
  biasAccountID?: InputMaybe<Scalars['Float']>;
  countryCodes?: InputMaybe<Array<Scalars['String']>>;
  partialAddress: Scalars['String'];
};


export type QueryairlineArgs = {
  airlineID: Scalars['Int'];
};


export type QueryairlinesArgs = {
  filters?: InputMaybe<FilterAirlinesInputs>;
};


export type QuerybookingArgs = {
  hawb: Scalars['String'];
};


export type QuerybookingTypeConfigurationArgs = {
  bookingtype: BookingType;
};


export type QuerybugReportArgs = {
  id: Scalars['Int'];
};


export type QuerybugReportCommentsArgs = {
  reportID: Scalars['Int'];
};


export type QuerybugReportsArgs = {
  filters?: InputMaybe<GetBugReportsFilters>;
};


export type QuerybugReportsCountArgs = {
  filters?: InputMaybe<GetBugReportsFilters>;
};


export type QuerychargeOptionsArgs = {
  filters?: InputMaybe<GetChargeOptionsFilters>;
};


export type QuerycostOfSalesArgs = {
  filters?: InputMaybe<GetCostOfSalesFilters>;
};


export type QuerycostOfSalesCountArgs = {
  filters?: InputMaybe<GetCostOfSalesFilters>;
};


export type QuerycountriesArgs = {
  inputs?: InputMaybe<GetCountriesFilters>;
};


export type QuerycountriesCountArgs = {
  inputs?: InputMaybe<GetCountriesFilters>;
};


export type QuerycountryByIDArgs = {
  id: Scalars['Int'];
};


export type QuerydownloadBookingInvoiceArgs = {
  hawb: Scalars['String'];
};


export type QueryemployeeByIDArgs = {
  id: Scalars['Int'];
};


export type QueryemployeesArgs = {
  filters?: InputMaybe<GetEmployeesFilters>;
};


export type QueryemployeesCountArgs = {
  filters?: InputMaybe<GetEmployeesFilters>;
};


export type QueryfeatureRequestArgs = {
  id: Scalars['Int'];
};


export type QueryfeatureRequestsArgs = {
  filters?: InputMaybe<GetFeatureRequestsFilters>;
};


export type QueryfeatureRequestsCountArgs = {
  filters?: InputMaybe<GetFeatureRequestsFilters>;
};


export type QueryfixedChargesArgs = {
  inputs: GetFixedChargesInputs;
};


export type QuerygenerateBookingChargesArgs = {
  coyhawb: Scalars['String'];
};


export type QuerygenerateReportArgs = {
  format: PericulumReportFormat;
  inputs?: InputMaybe<Scalars['JSONObject']>;
  reportID: PericulumReportID;
};


export type QuerygetCustomerPortalQuoteDetailsArgs = {
  quoteId: Scalars['String'];
};


export type QuerygetGoogleDriveFileContentArgs = {
  input: GetDriveFileInput;
};


export type QuerygetKeysArgs = {
  pattern?: InputMaybe<Scalars['String']>;
};


export type QuerygetUnusedAndRecentlyUsedMawbVouchersArgs = {
  days?: InputMaybe<Scalars['Float']>;
  officeid: Scalars['Int'];
};


export type QueryisPortcodeRemoteArgs = {
  portcode: Scalars['String'];
};


export type QueryjobTariffByIDArgs = {
  id: Scalars['Int'];
};


export type QueryjobTariffByNameArgs = {
  name: Scalars['String'];
  officeid: Scalars['Int'];
};


export type QueryjobTariffsArgs = {
  inputs?: InputMaybe<GetJobTariffsFilters>;
};


export type QueryjobTariffsByOfficeIDArgs = {
  officeid: Scalars['Int'];
};


export type QueryjobTariffsByRegionArgs = {
  regionid: Scalars['Int'];
};


export type QueryjobTariffsCountArgs = {
  inputs?: InputMaybe<GetJobTariffsFilters>;
};


export type QuerylistGoogleDriveFilesArgs = {
  input?: InputMaybe<ListDriveFilesInput>;
};


export type QuerymawbVouchersArgs = {
  filters?: InputMaybe<GetMawbVoucherFilters>;
};


export type QuerymawbVouchersCountArgs = {
  filters?: InputMaybe<GetMawbVoucherFilters>;
};


export type QuerymergeAccountCheckArgs = {
  accountID: Scalars['Int'];
};


export type QueryofficeActiveManifestsArgs = {
  officeid: Scalars['Int'];
};


export type QueryofficeChargeByIDArgs = {
  id: Scalars['Int'];
};


export type QueryofficeChargesByOfficeIDArgs = {
  id: Scalars['Int'];
};


export type QueryofficeConfigurationByIDArgs = {
  id: Scalars['Int'];
};


export type QuerypackagingOptionsArgs = {
  filters?: InputMaybe<GetPackagingOptionsFilters>;
};


export type QuerypackagingOptionsCountArgs = {
  filters?: InputMaybe<GetPackagingOptionsFilters>;
};


export type QuerypackagingTariffsArgs = {
  filters: GetPackagingTariffsFilters;
};


export type QueryplaceArgs = {
  placeID: Scalars['String'];
};


export type QueryportcodeByIDArgs = {
  portcodeID: Scalars['Int'];
};


export type QueryportcodesArgs = {
  filters?: InputMaybe<GetPortcodesFilters>;
};


export type QueryquoteByIDArgs = {
  id: Scalars['Float'];
};


export type QueryquoteByQuoteIDArgs = {
  quoteID: Scalars['String'];
};


export type QueryrecentlyUpdatedAccountsArgs = {
  since: Scalars['DateTime'];
};


export type QueryregulationsByUNNumberArgs = {
  unno: Scalars['String'];
};


export type QueryregulationsByUNNumberIDArgs = {
  id: Scalars['Int'];
};


export type QueryschedulerJobHistoryArgs = {
  filters?: InputMaybe<JobHistoryFilters>;
};


export type QueryschedulerJobHistoryCountArgs = {
  filters?: InputMaybe<JobHistoryFilters>;
};


export type QuerysearchAccountsArgs = {
  filters: SearchAccountsFilters;
};


export type QuerysearchAuth0LogsArgs = {
  authSubject?: InputMaybe<Scalars['String']>;
  eventCodes?: InputMaybe<Array<LogEventTypeCode>>;
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerysearchAuth0LogsCountArgs = {
  authSubject?: InputMaybe<Scalars['String']>;
  eventCodes?: InputMaybe<Array<LogEventTypeCode>>;
  searchText?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerysearchBookingsArgs = {
  filters?: InputMaybe<SearchBookingsFilters>;
};


export type QuerysearchContactsArgs = {
  filters: SearchContactsFilters;
};


export type QuerysearchCustomerPortalAccountsArgs = {
  filters?: InputMaybe<SearchCustomerPortalAccountFilters>;
};


export type QuerysearchCustomerPortalQuotesArgs = {
  filters?: InputMaybe<SearchCustomerPortalQuoteFilters>;
};


export type QuerysearchEmailLogsArgs = {
  inputs?: InputMaybe<FilterEmailLogs>;
};


export type QuerysearchEmailLogsCountArgs = {
  inputs?: InputMaybe<FilterEmailLogs>;
};


export type QuerysearchQuotesArgs = {
  filters?: InputMaybe<SearchQuotesFilters>;
};


export type QuerysearchShipmentsArgs = {
  filters?: InputMaybe<SearchCustomerPortalShipmentFilters>;
};


export type QuerystandardChargeByIDArgs = {
  id: Scalars['Int'];
};


export type QuerytrackingRequestsArgs = {
  filters?: InputMaybe<GetTrackingRequestFilters>;
};


export type QuerytrackingRequestsCountArgs = {
  filters?: InputMaybe<GetTrackingRequestFilters>;
};


export type QueryunNumberArgs = {
  id: Scalars['Int'];
};


export type QueryunNumbersArgs = {
  filters?: InputMaybe<GetUNNumbersFilters>;
};


export type QueryunNumbersCountArgs = {
  filters?: InputMaybe<GetUNNumbersFilters>;
};


export type QueryuncreatedAccountsWithNameArgs = {
  name: Scalars['String'];
};

export type Quote = {
  __typename?: 'Quote';
  activity: QuoteStatus;
  booking?: Maybe<Booking>;
  bookingsFromQuote: Array<Booking>;
  bookingtype: BookingType;
  client?: Maybe<Account>;
  clientnamenew?: Maybe<Scalars['String']>;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  deliveryType: BookingDeliveryType;
  destcode: Scalars['String'];
  destination?: Maybe<Portcode>;
  dgdraised: Scalars['Boolean'];
  dryiceamt: Scalars['Float'];
  dryiceused: Scalars['Boolean'];
  employee: Employee;
  /** Total formatted in office currency */
  formattedTotal: Scalars['String'];
  id: Scalars['Int'];
  isQuoteSent: Scalars['Boolean'];
  itemdesc: Scalars['String'];
  itemweight: Scalars['Float'];
  lastNoteDate?: Maybe<Scalars['DateTime']>;
  leadorigin: QuoteLeadOrigin;
  office: Account;
  origcode: Scalars['String'];
  origin?: Maybe<Portcode>;
  quoteCharges: Array<QuoteCharge>;
  quoteNotes: Array<QuoteNote>;
  quotePackaging: Array<QuotePackaging>;
  quoteSentDate?: Maybe<Scalars['DateTime']>;
  quoteid: Scalars['String'];
  repacked: Scalars['Boolean'];
  returnclienttype: QuoteClientType;
  tariffMinWeight: Scalars['Float'];
  tariffMinWeightKG: Scalars['Int'];
  tariffPerKG: Scalars['Float'];
  tariffZone: Scalars['String'];
  total: Scalars['Float'];
};

export type QuoteCharge = {
  __typename?: 'QuoteCharge';
  discountrate: Scalars['Float'];
  id: Scalars['Int'];
  name: Scalars['String'];
  net: Scalars['Float'];
  source: ChargeSource;
  tax: Scalars['Float'];
  taxable: Scalars['Boolean'];
  total: Scalars['Float'];
};

/** If the client is new or existing */
export enum QuoteClientType {
  ExistingClient = 'ExistingClient',
  NewClient = 'NewClient'
}

/** Where the lead came from */
export enum QuoteLeadOrigin {
  CUSTOMER_PORTAL = 'CUSTOMER_PORTAL',
  OnlineEnquiry = 'OnlineEnquiry',
  OrganicSales = 'OrganicSales',
  ReturningBusiness = 'ReturningBusiness',
  TelephoneEnquiry = 'TelephoneEnquiry'
}

export type QuoteNote = {
  __typename?: 'QuoteNote';
  canEdit: Scalars['Boolean'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  employee?: Maybe<Employee>;
  id: Scalars['Int'];
  isEdited: Scalars['Boolean'];
  noteinfo: Scalars['String'];
};

export type QuotePackaging = {
  __typename?: 'QuotePackaging';
  cost: Scalars['Float'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  numused: Scalars['Int'];
  size: Scalars['String'];
};

export type QuoteSearchResults = {
  __typename?: 'QuoteSearchResults';
  /** The number of results returned */
  count: Scalars['Int'];
  /** Query that was used to get the search results */
  query: Scalars['String'];
  /** The quotes */
  records: Array<Quote>;
  /** The total number of results in the database */
  total: Scalars['Int'];
};

/** Current status of a quote: Active, Won or Lost */
export enum QuoteStatus {
  Active = 'Active',
  Lost = 'Lost',
  Won = 'Won'
}

export type Region = {
  __typename?: 'Region';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Regulation = {
  __typename?: 'Regulation';
  id: Scalars['Int'];
  packinggrp: Scalars['String'];
  packintcar: Scalars['String'];
  packintltd: Scalars['String'];
  packintpass: Scalars['String'];
  packqtycar: Scalars['String'];
  packqtyltd: Scalars['String'];
  packqtypass: Scalars['String'];
  unno: Scalars['String'];
};

export type RelatedAccount = {
  __typename?: 'RelatedAccount';
  id: Scalars['Int'];
  notes: Scalars['String'];
  primaryAccount: Account;
  relatedAccount: Account;
};

export type RepairBookingInputs = {
  id: Scalars['Int'];
  status: BookingJobStatus;
};

export type Role = {
  __typename?: 'Role';
  assignedEmployees: Array<Employee>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  scopes: Array<Scope>;
};

export type RunJobEvent = {
  __typename?: 'RunJobEvent';
  jobID: PericulumJobID;
  jobIsRunningState: RunJobEventState;
  startedByEmployee?: Maybe<Employee>;
};

/** A job may be started or finished */
export enum RunJobEventState {
  Finished = 'Finished',
  Running = 'Running'
}

export type SaveAccountChargeInputs = {
  amount: Scalars['Float'];
  charge_citymetro: Scalars['Boolean'];
  charge_domestic: Scalars['Boolean'];
  charge_euro: Scalars['Boolean'];
  charge_import: Scalars['Boolean'];
  charge_international: Scalars['Boolean'];
  charge_interoffice: Scalars['Boolean'];
  charge_packaging: Scalars['Boolean'];
  charge_shipdecpack: Scalars['Boolean'];
  clientid: Scalars['Int'];
  delivery_dgi: Scalars['Boolean'];
  delivery_overnight: Scalars['Boolean'];
  delivery_road: Scalars['Boolean'];
  delivery_sameday: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  taxable: Scalars['Boolean'];
  type: AccountChargeType;
};

export type SaveBookingArrivalInputs = {
  agentid: Scalars['Int'];
  coyhawb: Scalars['String'];
  dateReceived: Scalars['Date'];
  dgdRaisedByID?: InputMaybe<Scalars['Int']>;
  dryicekg: Scalars['Float'];
  id?: InputMaybe<Scalars['Int']>;
  isDgdRaised: BookingArrivalDgdRaised;
  isRepacked: Scalars['Boolean'];
  packaging: Array<BasePackaging>;
};

export type SaveBookingDeliveryInputs = {
  coyhawb: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  poddate: Scalars['DateTime'];
  podname: Scalars['String'];
  podsig?: InputMaybe<Scalars['String']>;
};

export type SaveBookingFinanceInputs = {
  charges?: InputMaybe<Array<BaseChargeInput>>;
  costs?: InputMaybe<Array<BaseCost>>;
  coyhawb: Scalars['String'];
};

export type SaveBookingPickupInputs = {
  aircraftType: PickupAircraftType;
  arrangedByEmployeeID: Scalars['Int'];
  collectionAddress: Scalars['String'];
  collectionMethod: PickupCollectionMethod;
  coyhawb: Scalars['String'];
  dgInspectionComplete: Scalars['Boolean'];
  dgInspectionJustification: Scalars['String'];
  /** Pass in an existing record ID to update otherwise it will create */
  id?: InputMaybe<Scalars['Int']>;
  isDGDCompleted: Scalars['Boolean'];
  isPickupArranged: Scalars['Boolean'];
  pickupdate: Scalars['Date'];
  pickupjustification: Scalars['String'];
  radioactive: Scalars['Boolean'];
};

export type SaveBookingShipmentsInputs = {
  coyhawb: Scalars['String'];
  shipments: Array<UnsavedBookingShipment>;
};

export type SaveBookingTransportInputs = {
  agentcob: Scalars['Boolean'];
  agentid?: InputMaybe<Scalars['Int']>;
  connote: Scalars['String'];
  coyhawb: Scalars['String'];
  coymanifest: Scalars['String'];
  delivery: BookingDeliveryType;
  flightarrival: Scalars['DateTime'];
  flights: Array<BaseFlight>;
  id?: InputMaybe<Scalars['Int']>;
  incotermId?: InputMaybe<Scalars['Int']>;
  isConsolidated: Scalars['Boolean'];
  mawb?: InputMaybe<Scalars['String']>;
  postdate?: InputMaybe<Scalars['Date']>;
  postfab: Scalars['Boolean'];
  shiparrived: Scalars['Boolean'];
};

export type SaveChargeOptionInputs = {
  id?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SchedulerJobHistory = {
  __typename?: 'SchedulerJobHistory';
  dateCreated: Scalars['DateTime'];
  dateFinished: Scalars['DateTime'];
  dateStarted: Scalars['DateTime'];
  durationMS: Scalars['String'];
  employee?: Maybe<Employee>;
  failReason?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobID: PericulumJobID;
  jobName: Scalars['String'];
  results: Scalars['JSON'];
  type: JobType;
};

/** Scopes are defined in code and stored after first use */
export type Scope = {
  __typename?: 'Scope';
  /** e.g., Account:Create */
  action: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  id: Scalars['Int'];
};

export type SearchAccountsFilters = {
  countryid?: InputMaybe<Scalars['Int']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  isClient?: InputMaybe<Scalars['Boolean']>;
  isOffice?: InputMaybe<Scalars['Boolean']>;
  isPreferredAgent?: InputMaybe<Scalars['Boolean']>;
  isSupplier?: InputMaybe<Scalars['Boolean']>;
  officeIds?: InputMaybe<Array<Scalars['Int']>>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type SearchBookingsFilters = {
  bookingOfficeIDs?: InputMaybe<Array<Scalars['Int']>>;
  bookingStatus?: InputMaybe<Array<BookingJobStatus>>;
  bookingTypes?: InputMaybe<Array<BookingType>>;
  connote?: InputMaybe<Scalars['String']>;
  consigid?: InputMaybe<Scalars['Int']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  deliveryAgentID?: InputMaybe<Scalars['Int']>;
  destination?: InputMaybe<Scalars['String']>;
  invoiceParty?: InputMaybe<Scalars['Int']>;
  isInvoiced?: InputMaybe<Scalars['Boolean']>;
  mawb?: InputMaybe<Scalars['String']>;
  mustHaveConsignee?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  shipperid?: InputMaybe<Scalars['Int']>;
  shippersRef?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** A booking source may be standard, agent, quote or return */
  source?: InputMaybe<Array<BookingCategoryType>>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
  unno?: InputMaybe<Scalars['String']>;
};

export type SearchContactsFilters = {
  clientid?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<StatusFilter>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type SearchCustomerPortalAccountFilters = {
  searchText?: InputMaybe<Scalars['String']>;
  shipperClientId?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type SearchCustomerPortalQuoteFilters = {
  bookingType?: InputMaybe<BookingType>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  shipperId?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<Scalars['String']>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type SearchCustomerPortalShipmentFilters = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  shipperid?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  status?: InputMaybe<CustomerPortalShipmentStatus>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type SearchQuotesFilters = {
  activityStatus?: InputMaybe<Scalars['String']>;
  bookingOfficeIDs?: InputMaybe<Array<Scalars['Int']>>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  searchText?: InputMaybe<Scalars['String']>;
  shipperid?: InputMaybe<Scalars['Int']>;
  /** Number of items to skip */
  skip?: InputMaybe<Scalars['Int']>;
  /** Sorting field */
  sortBy?: InputMaybe<Scalars['String']>;
  /** Sorting direction (asc or desc) */
  sortDirection?: InputMaybe<SortDirection>;
  /** Number of items to return */
  take?: InputMaybe<Scalars['Int']>;
};

export type SendOTPResponse = {
  __typename?: 'SendOTPResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Shipment = {
  __typename?: 'Shipment';
  aircraftType: ShipmentAircraftType;
  commodityChapterId?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  dimweightfactor: Scalars['Int'];
  hazardous: ShipmentHazardous;
  id: Scalars['Int'];
  objheight: Scalars['Float'];
  objlength: Scalars['Float'];
  objwidth: Scalars['Float'];
  package: Scalars['String'];
  packageamt: Scalars['String'];
  packageqty: Scalars['Float'];
  packinginst: Scalars['String'];
  pieces: Scalars['Int'];
  subsidiary: Scalars['String'];
  unclass: Scalars['String'];
  unno: Scalars['String'];
  unpg: Scalars['String'];
  volume: Scalars['Float'];
  weight: Scalars['Float'];
};

/** The aircraft type the shipment will be flying on */
export enum ShipmentAircraftType {
  Cargo = 'Cargo',
  LimitedQuantity = 'LimitedQuantity',
  NotRequired = 'NotRequired',
  Passenger = 'Passenger'
}

/** Is the shipment hazardous */
export enum ShipmentHazardous {
  no = 'no',
  other = 'other',
  pack = 'pack',
  yes = 'yes'
}

/** Sort direction of the sort, asc or desc */
export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

export type StandardCharge = {
  __typename?: 'StandardCharge';
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** Filter by commonly used status, active, inactive or all */
export enum StatusFilter {
  Active = 'Active',
  All = 'All',
  Inactive = 'Inactive'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to bookings created for an office */
  newBooking: Booking;
  /** Subscribe to see live status of jobs */
  newJobNotification: JobEvent;
};


export type SubscriptionnewBookingArgs = {
  officeid: Scalars['Int'];
};

export type ToggleJobEvent = {
  __typename?: 'ToggleJobEvent';
  disabled: Scalars['Boolean'];
  employeeID: Scalars['Int'];
  jobID: PericulumJobID;
  toggledByEmployee: Employee;
};

export type TrackingMonthAggregation = {
  __typename?: 'TrackingMonthAggregation';
  Count: Scalars['Int'];
  Month: Scalars['String'];
  MonthNumber: Scalars['Int'];
  Year: Scalars['Int'];
};

export type TrackingRequest = {
  __typename?: 'TrackingRequest';
  dateCreated: Scalars['DateTime'];
  hawb: Scalars['String'];
  hostheader: Scalars['String'];
  hostrequest: Scalars['String'];
  id: Scalars['Int'];
  ipaddress: Scalars['String'];
  source: Scalars['String'];
  url: Scalars['String'];
};

export type TransitTime = {
  __typename?: 'TransitTime';
  countries: Array<Country>;
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  days: Scalars['Int'];
  id: Scalars['Int'];
  tozone: Scalars['Int'];
};

export type UNNumber = {
  __typename?: 'UNNumber';
  classdiv: Scalars['String'];
  dateCreated: Scalars['DateTime'];
  dateModified: Scalars['DateTime'];
  ergcode: Scalars['String'];
  extraname: Scalars['String'];
  hazlabel: Scalars['String'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  isAuthRequired: Scalars['Boolean'];
  labelno: Scalars['String'];
  propername: Scalars['String'];
  regulations: Array<Regulation>;
  specialProvision: Scalars['String'];
  subrisk: Scalars['String'];
  unno: Scalars['String'];
};

export type UnsavedBookingShipment = {
  aircraftType: ShipmentAircraftType;
  commodityChapterId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  dimweightfactor: Scalars['Int'];
  hazardous: ShipmentHazardous;
  id?: InputMaybe<Scalars['Int']>;
  objheight: Scalars['Float'];
  objlength: Scalars['Float'];
  objwidth: Scalars['Float'];
  package: Scalars['String'];
  packageamt: Scalars['String'];
  packageqty: Scalars['Float'];
  packinginst: Scalars['String'];
  pieces: Scalars['Int'];
  subsidiary: Scalars['String'];
  unclass: Scalars['String'];
  unno: Scalars['String'];
  unpg: Scalars['String'];
  volume: Scalars['Float'];
  weight: Scalars['Float'];
};

export type UpdateAccountContactInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  clientid?: InputMaybe<Scalars['Int']>;
  countryid?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone2?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountInputs = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  altHandling?: InputMaybe<Scalars['String']>;
  buscode?: InputMaybe<AccountBusinessCode>;
  busnumber?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  countryid?: InputMaybe<Scalars['Int']>;
  defaultInvoicePartyID?: InputMaybe<Scalars['Int']>;
  dgioffice?: InputMaybe<Scalars['Boolean']>;
  discountrate?: InputMaybe<Scalars['Int']>;
  eawbemail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  finemail?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  industryType?: InputMaybe<AccountIndustryType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAgent?: InputMaybe<Scalars['Boolean']>;
  isJobHoldActive?: InputMaybe<Scalars['Boolean']>;
  isPreferredAgent?: InputMaybe<Scalars['Boolean']>;
  isRegisteredForTax?: InputMaybe<Scalars['Boolean']>;
  isSupplier?: InputMaybe<Scalars['Boolean']>;
  openPurchaseOrder?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postal?: InputMaybe<Scalars['String']>;
  repregion?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
  web?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountNoteInputs = {
  id: Scalars['Int'];
  noteinfo: Scalars['String'];
};

export type UpdateAirlineInputs = {
  airlineadd1?: InputMaybe<Scalars['String']>;
  airlineadd2?: InputMaybe<Scalars['String']>;
  airlinecode?: InputMaybe<Scalars['String']>;
  airlineid?: InputMaybe<Scalars['String']>;
  airlinename?: InputMaybe<Scalars['String']>;
  airlinephone?: InputMaybe<Scalars['String']>;
  airlineweb?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingInputs = {
  agenthawb?: InputMaybe<Scalars['String']>;
  clientid?: InputMaybe<Scalars['Int']>;
  consig?: InputMaybe<Scalars['String']>;
  consigadd1?: InputMaybe<Scalars['String']>;
  consigadd2?: InputMaybe<Scalars['String']>;
  consigcountryID?: InputMaybe<Scalars['Int']>;
  consigemail?: InputMaybe<Scalars['String']>;
  consigfax?: InputMaybe<Scalars['String']>;
  consigid?: InputMaybe<Scalars['Int']>;
  consignotify?: InputMaybe<Scalars['Boolean']>;
  consigstate?: InputMaybe<Scalars['String']>;
  consigtown?: InputMaybe<Scalars['String']>;
  consigzip?: InputMaybe<Scalars['String']>;
  costcode?: InputMaybe<Scalars['String']>;
  destcode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  invoiceid?: InputMaybe<Scalars['Int']>;
  jobdate?: InputMaybe<Scalars['Date']>;
  mawb?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  origcode?: InputMaybe<Scalars['String']>;
  persrep?: InputMaybe<Scalars['String']>;
  persrepphone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shippersref?: InputMaybe<Scalars['String']>;
  specinst?: InputMaybe<Scalars['String']>;
  tariffMinWeight: Scalars['Float'];
  tariffMinWeightKG: Scalars['Int'];
  tariffPerKG: Scalars['Float'];
  tariffZone: Scalars['String'];
};

export type UpdateBookingNoteInputs = {
  id: Scalars['Int'];
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  noteinfo?: InputMaybe<Scalars['String']>;
};

export type UpdateBugReportInputs = {
  /** The action performed that triggered the bug */
  action?: InputMaybe<Scalars['String']>;
  /** What actually occured */
  actualresult?: InputMaybe<Scalars['String']>;
  /** Any additional comments to replicate */
  comments?: InputMaybe<Scalars['String']>;
  errordate?: InputMaybe<Scalars['Date']>;
  /** Any error message displayed on the screen */
  errormessage?: InputMaybe<Scalars['String']>;
  /** The expected outcome that should have occured */
  expectedresult?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<BugReportFrequency>;
  id: Scalars['Int'];
  /** The job or quote number this bug is related to */
  job?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<BugReportPriority>;
  status?: InputMaybe<BugReportStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCountryInputs = {
  Country?: InputMaybe<Scalars['String']>;
  countrycode?: InputMaybe<Scalars['String']>;
  daylight?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  itemdesc?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  membercountry?: InputMaybe<Scalars['Boolean']>;
  moneycode?: InputMaybe<Scalars['String']>;
  moneysymbol?: InputMaybe<Scalars['String']>;
  moneytype?: InputMaybe<Scalars['String']>;
  officeid?: InputMaybe<Scalars['Int']>;
  taxrate?: InputMaybe<Scalars['Float']>;
  taxtype?: InputMaybe<CountryTaxType>;
  timeway?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['Int']>;
  weighttype?: InputMaybe<Scalars['String']>;
  zone?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmployeeInputs = {
  dgnumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullname?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  officeid?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
};

export type UpdateFeatureRequestInputs = {
  closingcomments?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  priority?: InputMaybe<FeatureRequestPriority>;
  status?: InputMaybe<FeatureRequestStatus>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFixedChargeInputs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  net: Scalars['Float'];
  tax: Scalars['Float'];
  total: Scalars['Float'];
};

export type UpdateGlobalConfigInputs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateHomeBookmarkInputs = {
  icon?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateJobTariffInputs = {
  category?: InputMaybe<JobTariffCategory>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  minweight?: InputMaybe<Scalars['Float']>;
  minweightkg?: InputMaybe<Scalars['Int']>;
  perkg?: InputMaybe<Scalars['Float']>;
  zone?: InputMaybe<Scalars['String']>;
};

export type UpdateOfficeChargeInputs = {
  amount?: InputMaybe<Scalars['Float']>;
  bookingTypes?: InputMaybe<Array<BookingType>>;
  customChargeName?: InputMaybe<Scalars['String']>;
  deliveryTypes?: InputMaybe<Array<BookingDeliveryType>>;
  id: Scalars['Int'];
  taxable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<OfficeChargeType>;
};

export type UpdateOfficeConfigurationInputs = {
  bankaccount?: InputMaybe<Scalars['String']>;
  /** BSB or Swift number */
  bankcode?: InputMaybe<Scalars['String']>;
  bankname?: InputMaybe<Scalars['String']>;
  cityMetro?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['Currency']>;
  currencyName?: InputMaybe<Scalars['String']>;
  domestic?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  europe?: InputMaybe<Scalars['String']>;
  iataCode?: InputMaybe<Scalars['String']>;
  ibanNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  import?: InputMaybe<Scalars['String']>;
  interOffice?: InputMaybe<Scalars['String']>;
  international?: InputMaybe<Scalars['String']>;
  invoicemsg?: InputMaybe<Scalars['String']>;
  legalname?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['Locale']>;
  paymentTermDays?: InputMaybe<Scalars['Int']>;
  regionid?: InputMaybe<Scalars['Int']>;
  shippersDec?: InputMaybe<Scalars['String']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  taxType?: InputMaybe<OfficeTaxType>;
  timezone?: InputMaybe<Scalars['TimeZone']>;
};

export type UpdatePackagingOptionInputs = {
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePackagingTariffInputs = {
  cost?: InputMaybe<Scalars['Float']>;
  cost2?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  packsize?: InputMaybe<Scalars['String']>;
  packtype?: InputMaybe<Scalars['String']>;
};

export type UpdatePortcodeInputs = {
  agentIDs: Array<Scalars['Int']>;
  cityname: Scalars['String'];
  countryid?: InputMaybe<Scalars['Int']>;
  extraShippingDays?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isRemoteLocation?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  portcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UpdateQuoteInputs = {
  bookingtype?: InputMaybe<BookingType>;
  clientid?: InputMaybe<Scalars['Int']>;
  clientnamenew?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<BookingDeliveryType>;
  destcode?: InputMaybe<Scalars['String']>;
  dgdraised?: InputMaybe<Scalars['Boolean']>;
  dryiceamt?: InputMaybe<Scalars['Float']>;
  fixedCharges: Array<BaseFixedCharge>;
  id: Scalars['Int'];
  itemdesc?: InputMaybe<Scalars['String']>;
  itemweight?: InputMaybe<Scalars['Float']>;
  leadorigin?: InputMaybe<QuoteLeadOrigin>;
  officeCharges: Array<CalculatedChargeEntity>;
  origcode?: InputMaybe<Scalars['String']>;
  /** The new state of packaging on the booking */
  packaging: Array<BasePackaging>;
  repacked?: InputMaybe<Scalars['Boolean']>;
  returnclienttype?: InputMaybe<QuoteClientType>;
  tariffMinWeight: Scalars['Float'];
  tariffMinWeightKG: Scalars['Int'];
  tariffPerKG: Scalars['Float'];
  tariffZone: Scalars['String'];
};

export type UpdateQuoteNoteInputs = {
  id: Scalars['Int'];
  noteinfo: Scalars['String'];
};

export type UpdateRegionInputs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UpdateRegulationInputs = {
  id: Scalars['Int'];
  packinggrp?: InputMaybe<Scalars['String']>;
  packintcar?: InputMaybe<Scalars['String']>;
  packintltd?: InputMaybe<Scalars['String']>;
  packintpass?: InputMaybe<Scalars['String']>;
  packqtycar?: InputMaybe<Scalars['String']>;
  packqtyltd?: InputMaybe<Scalars['String']>;
  packqtypass?: InputMaybe<Scalars['String']>;
};

export type UpdateRoleInputs = {
  assignedEmployeesIDs?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateStandardChargeInputs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OfficeChargeType>;
};

export type UpdateTransitTimeInputs = {
  days: Scalars['Int'];
  id: Scalars['Int'];
};

export type UpdateUNNumberInputs = {
  classdiv?: InputMaybe<Scalars['String']>;
  ergcode?: InputMaybe<Scalars['String']>;
  extraname?: InputMaybe<Scalars['String']>;
  hazlabel?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isAuthRequired?: InputMaybe<Scalars['Boolean']>;
  labelno?: InputMaybe<Scalars['String']>;
  propername?: InputMaybe<Scalars['String']>;
  specialProvision?: InputMaybe<Scalars['String']>;
  subrisk?: InputMaybe<Scalars['String']>;
  unno?: InputMaybe<Scalars['String']>;
};

export type UploadDocumentInputs = {
  bytes: Scalars['Int'];
  fileName: Scalars['String'];
  /** If type=Account, an account ID or if type=Booking, a job number (PER12345) */
  key: Scalars['String'];
  type: UploadDocumentType;
};

/** The destination of the upload e.g, bookings or accounts or quotes */
export enum UploadDocumentType {
  Accounts = 'Accounts',
  Bookings = 'Bookings',
  Quotes = 'Quotes'
}

export type UploadedDocument = {
  __typename?: 'UploadedDocument';
  dateCreated: Scalars['DateTime'];
  employee?: Maybe<Employee>;
  extention: Scalars['String'];
  filesize: Scalars['Int'];
  id: Scalars['Int'];
  mime?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  storageKey: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  position: Scalars['String'];
};

export type VerifyOTPResponse = {
  __typename?: 'VerifyOTPResponse';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type AccountByIDQueryVariables = Exact<{
  accountID: Scalars['Int'];
}>;


export type AccountByIDQuery = { __typename?: 'Query', accountByID?: { __typename?: 'Account', id: number, client: string, isActive: boolean, town: string, countryid: number, defaultInvoicePartyID: number, isAgent: boolean, isPreferredAgent: boolean, address1: string, address2: string, state: string, zip: string, isJobHoldActive: boolean, openPurchaseOrder?: string | null } | null };

export type AddressSuggestionFieldsFragment = { __typename?: 'AddressSuggestion', PlaceId: string, Text: string };

export type AddressSuggestionsQueryVariables = Exact<{
  partialAddress: Scalars['String'];
  biasAccountId?: InputMaybe<Scalars['Float']>;
  countryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AddressSuggestionsQuery = { __typename?: 'Query', addressSuggestions: Array<{ __typename?: 'AddressSuggestion', PlaceId: string, Text: string }> };

export type PlaceFieldsFragment = { __typename?: 'Query', place: { __typename?: 'Place', PlaceId: string, Label?: string | null, AddressNumber?: string | null, Street?: string | null, Neighborhood?: string | null, Municipality?: string | null, SubRegion?: string | null, Region?: string | null, Country?: string | null, PostalCode?: string | null, Interpolated?: boolean | null, UnitType?: string | null, UnitNumber?: string | null, Geometry?: { __typename?: 'PlaceGeometry', Point: Array<number> } | null, TimeZone?: { __typename?: 'PlaceTimezone', Name?: string | null, Offset?: number | null } | null } };

export type PlaceQueryVariables = Exact<{
  placeId: Scalars['String'];
}>;


export type PlaceQuery = { __typename?: 'Query', place: { __typename?: 'Place', PlaceId: string, Label?: string | null, AddressNumber?: string | null, Street?: string | null, Neighborhood?: string | null, Municipality?: string | null, SubRegion?: string | null, Region?: string | null, Country?: string | null, PostalCode?: string | null, Interpolated?: boolean | null, UnitType?: string | null, UnitNumber?: string | null, Geometry?: { __typename?: 'PlaceGeometry', Point: Array<number> } | null, TimeZone?: { __typename?: 'PlaceTimezone', Name?: string | null, Offset?: number | null } | null } };

export type MergeAccountCheckQueryVariables = Exact<{
  accountId: Scalars['Int'];
}>;


export type MergeAccountCheckQuery = { __typename?: 'Query', mergeAccountCheck: { __typename?: 'MergeAccountCheckResponse', quotes: number, jobs: number, contacts: number, uploads: number, accountCharges: number, notes: number } };

export type MergeAccountMutationVariables = Exact<{
  inputs: MergeAccountInputs;
}>;


export type MergeAccountMutation = { __typename?: 'Mutation', mergeAccount: { __typename?: 'Account', id: number, client: string, isActive: boolean, town: string, countryid: number, defaultInvoicePartyID: number, isAgent: boolean, isPreferredAgent: boolean, address1: string, address2: string, state: string, zip: string, isJobHoldActive: boolean, openPurchaseOrder?: string | null } };

export type ActivityLogFieldsFragment = { __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null };

export type AccountActivityQueryVariables = Exact<{
  inputs?: InputMaybe<FilterActivityLogs>;
}>;


export type AccountActivityQuery = { __typename?: 'Query', activityLogsCount: number, activityLogs: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> };

export type SaveAccountChargeMutationVariables = Exact<{
  inputs: SaveAccountChargeInputs;
}>;


export type SaveAccountChargeMutation = { __typename?: 'Mutation', saveAccountCharge: { __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, taxable: boolean, amount: number, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean } };

export type DeleteAccountChargeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAccountChargeMutation = { __typename?: 'Mutation', deleteAccountCharge: { __typename?: 'AccountCharge', id: number } };

export type SearchAccountsQueryVariables = Exact<{
  filters: SearchAccountsFilters;
}>;


export type SearchAccountsQuery = { __typename?: 'Query', searchAccounts: { __typename?: 'AccountSearchResults', count: number, query: string, total: number, records: Array<{ __typename?: 'Account', id: number, client: string, address1: string, town: string, industryType?: AccountIndustryType | null, isActive: boolean, isAgent: boolean, isPreferredAgent: boolean, isSupplier: boolean, dgioffice: boolean, lastAccessed: string, country: { __typename?: 'Country', id: number, Country: string }, createdByOffice: { __typename?: 'Account', id: number, client: string } }> } };

export type EditAccountScreenQueryVariables = Exact<{
  accountID: Scalars['Int'];
  contactsFilter: GetAccountContactsFilter;
}>;


export type EditAccountScreenQuery = { __typename?: 'Query', accountByID?: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, state: string, postal: string, zip: string, countryid: number, phone: string, fax: string, web: string, email: string, isSupplier: boolean, isAgent: boolean, isPreferredAgent: boolean, dgioffice: boolean, discountrate: number, officeid: number, altHandling: string, isActive: boolean, industryType?: AccountIndustryType | null, isJobHoldActive: boolean, repregion?: string | null, isRegisteredForTax: boolean, eawbemail?: string | null, finemail?: string | null, defaultInvoicePartyID: number, buscode?: AccountBusinessCode | null, busnumber?: string | null, dateCreated: string, dateModified: string, openPurchaseOrder?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null }, relatedAccounts: Array<{ __typename?: 'RelatedAccount', id: number, notes: string, relatedAccount: { __typename?: 'Account', id: number, client: string } }>, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, office: { __typename?: 'Account', id: number, client: string } } | null, notes: Array<{ __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }>, accountCharges: Array<{ __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, taxable: boolean, amount: number, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, createdByOffice: { __typename?: 'Account', id: number, client: string }, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> } | null, accountContacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> };

export type AddRelatedAccountMutationVariables = Exact<{
  inputs: AddRelatedAccountInputs;
}>;


export type AddRelatedAccountMutation = { __typename?: 'Mutation', addRelatedAccount: { __typename?: 'RelatedAccount', id: number, notes: string, relatedAccount: { __typename?: 'Account', id: number, client: string } } };

export type RemoveRelatedAccountMutationVariables = Exact<{
  relationId: Scalars['Int'];
}>;


export type RemoveRelatedAccountMutation = { __typename?: 'Mutation', removeRelatedAccount: { __typename?: 'RelatedAccount', id: number } };

export type UpdateAccountDetailsScreenMutationVariables = Exact<{
  inputs: UpdateAccountInputs;
}>;


export type UpdateAccountDetailsScreenMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, state: string, postal: string, zip: string, countryid: number, phone: string, fax: string, web: string, email: string, isSupplier: boolean, isAgent: boolean, isPreferredAgent: boolean, dgioffice: boolean, discountrate: number, officeid: number, altHandling: string, isActive: boolean, industryType?: AccountIndustryType | null, isJobHoldActive: boolean, repregion?: string | null, isRegisteredForTax: boolean, eawbemail?: string | null, finemail?: string | null, defaultInvoicePartyID: number, buscode?: AccountBusinessCode | null, busnumber?: string | null, dateCreated: string, dateModified: string, openPurchaseOrder?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null }, relatedAccounts: Array<{ __typename?: 'RelatedAccount', id: number, notes: string, relatedAccount: { __typename?: 'Account', id: number, client: string } }>, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, office: { __typename?: 'Account', id: number, client: string } } | null, notes: Array<{ __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }>, accountCharges: Array<{ __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, taxable: boolean, amount: number, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, createdByOffice: { __typename?: 'Account', id: number, client: string }, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> } };

export type CreateAccountNoteMutationVariables = Exact<{
  inputs: CreateAccountNoteInputs;
}>;


export type CreateAccountNoteMutation = { __typename?: 'Mutation', createAccountNote: { __typename?: 'Account', id: number, notes: Array<{ __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }> } };

export type UpdateAccountNoteMutationVariables = Exact<{
  inputs: UpdateAccountNoteInputs;
}>;


export type UpdateAccountNoteMutation = { __typename?: 'Mutation', updateAccountNote: { __typename?: 'Account', id: number, notes: Array<{ __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }> } };

export type DeleteAccountNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteAccountNoteMutation = { __typename?: 'Mutation', deleteAccountNote: { __typename?: 'AccountNote', id: number } };

export type DownloadAccountDocumentMutationVariables = Exact<{
  downloadDocumentId: Scalars['Int'];
}>;


export type DownloadAccountDocumentMutation = { __typename?: 'Mutation', downloadDocument: string };

export type StartAccountUploadMutationVariables = Exact<{
  inputs: Array<UploadDocumentInputs> | UploadDocumentInputs;
}>;


export type StartAccountUploadMutation = { __typename?: 'Mutation', startUpload: Array<string> };

export type ConfirmUploadMutationVariables = Exact<{
  inputs: UploadDocumentInputs;
}>;


export type ConfirmUploadMutation = { __typename?: 'Mutation', confirmUpload: { __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null } };

export type DeleteAccountDocumentMutationVariables = Exact<{
  documentID: Scalars['Int'];
}>;


export type DeleteAccountDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'UploadedDocument', id: number } };

export type CreateAccountMutationVariables = Exact<{
  inputs: CreateAccountInputs;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', id: number, client: string, town: string, countryid: number, isAgent: boolean, isPreferredAgent: boolean, address1: string, address2: string, defaultInvoicePartyID: number, isJobHoldActive: boolean, state: string, zip: string, openPurchaseOrder?: string | null, country: { __typename?: 'Country', id: number } } };

export type RelatedAccountFieldsFragment = { __typename?: 'RelatedAccount', id: number, notes: string, relatedAccount: { __typename?: 'Account', id: number, client: string } };

export type EditAccountFieldsFragment = { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, state: string, postal: string, zip: string, countryid: number, phone: string, fax: string, web: string, email: string, isSupplier: boolean, isAgent: boolean, isPreferredAgent: boolean, dgioffice: boolean, discountrate: number, officeid: number, altHandling: string, isActive: boolean, industryType?: AccountIndustryType | null, isJobHoldActive: boolean, repregion?: string | null, isRegisteredForTax: boolean, eawbemail?: string | null, finemail?: string | null, defaultInvoicePartyID: number, buscode?: AccountBusinessCode | null, busnumber?: string | null, dateCreated: string, dateModified: string, openPurchaseOrder?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null }, relatedAccounts: Array<{ __typename?: 'RelatedAccount', id: number, notes: string, relatedAccount: { __typename?: 'Account', id: number, client: string } }>, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, office: { __typename?: 'Account', id: number, client: string } } | null, notes: Array<{ __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }>, accountCharges: Array<{ __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, taxable: boolean, amount: number, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, createdByOffice: { __typename?: 'Account', id: number, client: string }, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> };

export type UploadedDocumentFieldsFragment = { __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null };

export type AccountChargeFieldsFragment = { __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, taxable: boolean, amount: number, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean };

export type AccountNoteFieldsFragment = { __typename?: 'AccountNote', id: number, noteinfo: string, isEdited: boolean, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } };

export type EmployeeAvatarFragment = { __typename?: 'Employee', id: number, picture?: string | null, fullname: string };

export type JobFragment = { __typename?: 'Job', id: PericulumJobID, name: string, isRunning: boolean, schedule: string, disabled?: boolean | null, nextRunAt?: string | null, failReason?: string | null, failCount?: number | null, failedAt?: string | null };

export type SchedulerJobHistoryFragment = { __typename?: 'SchedulerJobHistory', id: number, jobName: string, jobID: PericulumJobID, durationMS: string, failReason?: string | null, type: JobType, results: string, dateStarted: string, dateFinished: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string } | null };

export type JobsQueryVariables = Exact<{
  filters?: InputMaybe<JobHistoryFilters>;
}>;


export type JobsQuery = { __typename?: 'Query', schedulerJobHistoryCount: number, jobs: Array<{ __typename?: 'Job', id: PericulumJobID, name: string, isRunning: boolean, schedule: string, disabled?: boolean | null, nextRunAt?: string | null, failReason?: string | null, failCount?: number | null, failedAt?: string | null }>, schedulerJobHistory: Array<{ __typename?: 'SchedulerJobHistory', id: number, jobName: string, jobID: PericulumJobID, durationMS: string, failReason?: string | null, type: JobType, results: string, dateStarted: string, dateFinished: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string } | null }> };

export type ToggleJobStatusMutationVariables = Exact<{
  jobID: PericulumJobID;
}>;


export type ToggleJobStatusMutation = { __typename?: 'Mutation', toggleJobStatus: { __typename?: 'Job', id: PericulumJobID, disabled?: boolean | null } };

export type RunJobMutationVariables = Exact<{
  jobID: PericulumJobID;
  data?: InputMaybe<Scalars['JSON']>;
}>;


export type RunJobMutation = { __typename?: 'Mutation', runJob: { __typename?: 'Job', id: PericulumJobID, isRunning: boolean } };

export type JobEventSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type JobEventSubscription = { __typename?: 'Subscription', newJobNotification: { __typename?: 'JobCompleteEvent', jobID: PericulumJobID, history: { __typename?: 'SchedulerJobHistory', id: number, results: string } } | { __typename?: 'RunJobEvent', jobID: PericulumJobID, jobIsRunningState: RunJobEventState, startedByEmployee?: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string } | null } | { __typename?: 'ToggleJobEvent', jobID: PericulumJobID, disabled: boolean, toggledByEmployee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string } } };

export type SearchAuth0LogsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  authSubject?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  eventCodes?: InputMaybe<Array<LogEventTypeCode> | LogEventTypeCode>;
}>;


export type SearchAuth0LogsQuery = { __typename?: 'Query', searchAuth0LogsCount: number, searchAuth0Logs: Array<{ __typename?: 'AuthEventLog', log_id: string, type: LogEventTypeCode, audience: string, client_id: string, client_name: string, connection: string, connection_id: string, date: string, description: string, details: string, hostname: string, ip: string, isMobile: boolean, location_info_city_name: string, location_info_continent_code: string, location_info_country_code: string, location_info_country_code3: string, location_info_country_name: string, location_info_latitude: string, location_info_longitude: string, location_info_time_zone: string, scope: string, strategy: string, strategy_type: string, user_id: string, user_agent: string, user_name: string, dateCreated: string }> };

export type ActivityLogsQueryVariables = Exact<{
  inputs?: InputMaybe<FilterActivityLogs>;
}>;


export type ActivityLogsQuery = { __typename?: 'Query', activityLogsCount: number, activityLogs: Array<{ __typename?: 'ActivityLog', id: number, description: string, dateCreated: string, eventid: number, account?: { __typename?: 'Account', id: number, client: string } | null, office?: { __typename?: 'Account', id: number, client: string } | null, contact?: { __typename?: 'AccountContact', id: number, name: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null, employee?: { __typename?: 'Employee', id: number, fullname: string } | null }> };

export type SearchEmailLogsQueryVariables = Exact<{
  inputs?: InputMaybe<FilterEmailLogs>;
}>;


export type SearchEmailLogsQuery = { __typename?: 'Query', searchEmailLogsCount: number, searchEmailLogs: Array<{ __typename?: 'EmailLog', id: number, emailto: string, emailcc: string, emailbcc: string, emailbody: string, emailsubject: string, attachments?: string | null, dateCreated: string }> };

export type OfficeConfigurationFragmentFragment = { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxType: OfficeTaxType, taxRate: number, paymentTermDays: number, iataCode: string, ibanNumber: string, bankname: string, bankcode: string, bankaccount: string, legalname: string, email: string, quotePrefix: string, bookingPrefix: string, slug: string, domestic: string, international: string, import: string, shippersDec: string, europe: string, interOffice: string, cityMetro: string, invoicemsg: string, dateCreated: string, dateModified: string, office: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, isAgent: boolean, buscode?: AccountBusinessCode | null, busnumber?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null, daylight?: string | null, itemdesc?: string | null, locale?: string | null, membercountry: boolean, moneycode?: string | null, moneysymbol?: string | null, moneytype?: string | null, dateCreated: string, dateModified: string } }, region?: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } | null };

export type EditOfficeConfigScreenQueryVariables = Exact<{
  officeConfigurationById: Scalars['Int'];
}>;


export type EditOfficeConfigScreenQuery = { __typename?: 'Query', locales: Array<string>, timezones: Array<string>, officeConfigurationByID?: { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxType: OfficeTaxType, taxRate: number, paymentTermDays: number, iataCode: string, ibanNumber: string, bankname: string, bankcode: string, bankaccount: string, legalname: string, email: string, quotePrefix: string, bookingPrefix: string, slug: string, domestic: string, international: string, import: string, shippersDec: string, europe: string, interOffice: string, cityMetro: string, invoicemsg: string, dateCreated: string, dateModified: string, office: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, isAgent: boolean, buscode?: AccountBusinessCode | null, busnumber?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null, daylight?: string | null, itemdesc?: string | null, locale?: string | null, membercountry: boolean, moneycode?: string | null, moneysymbol?: string | null, moneytype?: string | null, dateCreated: string, dateModified: string } }, region?: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } | null } | null, currencies: Array<{ __typename?: 'CurrencyOption', name: string, code: string }>, regions: Array<{ __typename?: 'Region', id: number, name: string }> };

export type CreateOfficeConfigurationMutationVariables = Exact<{
  inputs: CreateOfficeConfigurationInputs;
}>;


export type CreateOfficeConfigurationMutation = { __typename?: 'Mutation', createOfficeConfiguration: { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxType: OfficeTaxType, taxRate: number, paymentTermDays: number, iataCode: string, ibanNumber: string, bankname: string, bankcode: string, bankaccount: string, legalname: string, email: string, quotePrefix: string, bookingPrefix: string, slug: string, domestic: string, international: string, import: string, shippersDec: string, europe: string, interOffice: string, cityMetro: string, invoicemsg: string, dateCreated: string, dateModified: string, office: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, isAgent: boolean, buscode?: AccountBusinessCode | null, busnumber?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null, daylight?: string | null, itemdesc?: string | null, locale?: string | null, membercountry: boolean, moneycode?: string | null, moneysymbol?: string | null, moneytype?: string | null, dateCreated: string, dateModified: string } }, region?: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } | null } };

export type UpdateOfficeConfigurationMutationVariables = Exact<{
  inputs: UpdateOfficeConfigurationInputs;
}>;


export type UpdateOfficeConfigurationMutation = { __typename?: 'Mutation', updateOfficeConfiguration: { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxType: OfficeTaxType, taxRate: number, paymentTermDays: number, iataCode: string, ibanNumber: string, bankname: string, bankcode: string, bankaccount: string, legalname: string, email: string, quotePrefix: string, bookingPrefix: string, slug: string, domestic: string, international: string, import: string, shippersDec: string, europe: string, interOffice: string, cityMetro: string, invoicemsg: string, dateCreated: string, dateModified: string, office: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, isAgent: boolean, buscode?: AccountBusinessCode | null, busnumber?: string | null, country: { __typename?: 'Country', id: number, Country: string, countrycode?: string | null, daylight?: string | null, itemdesc?: string | null, locale?: string | null, membercountry: boolean, moneycode?: string | null, moneysymbol?: string | null, moneytype?: string | null, dateCreated: string, dateModified: string } }, region?: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } | null } };

export type DeleteOfficeConfigurationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOfficeConfigurationMutation = { __typename?: 'Mutation', deleteOfficeConfiguration: { __typename?: 'OfficeConfiguration', id: number } };

export type CreateRegionMutationVariables = Exact<{
  inputs: CreateRegionInputs;
}>;


export type CreateRegionMutation = { __typename?: 'Mutation', createRegion: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } };

export type UpdateRegionMutationVariables = Exact<{
  inputs: UpdateRegionInputs;
}>;


export type UpdateRegionMutation = { __typename?: 'Mutation', updateRegion: { __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string } };

export type DeleteRegionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion: { __typename?: 'Region', id: number } };

export type RoleFragmentFragment = { __typename?: 'Role', id: number, name: string, description: string, dateModified: string, dateCreated: string, scopes: Array<{ __typename?: 'Scope', id: number, action: string }>, assignedEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string }> };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: number, name: string, description: string, dateModified: string, dateCreated: string, scopes: Array<{ __typename?: 'Scope', id: number, action: string }>, assignedEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string }> }> };

export type CreateRoleMutationVariables = Exact<{
  inputs: CreateRoleInputs;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: number, name: string, description: string, dateModified: string, dateCreated: string, scopes: Array<{ __typename?: 'Scope', id: number, action: string }>, assignedEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string }> } };

export type DeleteRoleMutationVariables = Exact<{
  roleID: Scalars['Int'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'Role', id: number, name: string, description: string, dateModified: string, dateCreated: string, scopes: Array<{ __typename?: 'Scope', id: number, action: string }>, assignedEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string }> } };

export type UpdateRoleMutationVariables = Exact<{
  inputs: UpdateRoleInputs;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: number, name: string, description: string, dateModified: string, dateCreated: string, scopes: Array<{ __typename?: 'Scope', id: number, action: string }>, assignedEmployees: Array<{ __typename?: 'Employee', id: number, fullname: string }> } };

export type standardChargeFragment = { __typename?: 'Query', standardCharges: Array<{ __typename?: 'StandardCharge', id: number, name: string, description: string, type?: string | null, dateCreated: string, dateModified: string }> };

export type StandardChargesQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardChargesQuery = { __typename?: 'Query', standardCharges: Array<{ __typename?: 'StandardCharge', id: number, name: string, description: string, type?: string | null, dateCreated: string, dateModified: string }> };

export type CreateStandardChargeMutationVariables = Exact<{
  inputs: CreateStandardChargeInputs;
}>;


export type CreateStandardChargeMutation = { __typename?: 'Mutation', createStandardCharge: { __typename?: 'StandardCharge', id: number, name: string, description: string, type?: string | null, dateCreated: string, dateModified: string } };

export type UpdateStandardChargeMutationVariables = Exact<{
  inputs: UpdateStandardChargeInputs;
}>;


export type UpdateStandardChargeMutation = { __typename?: 'Mutation', updateStandardCharge: { __typename?: 'StandardCharge', id: number, name: string, description: string, type?: string | null, dateCreated: string, dateModified: string } };

export type DeleteStandardChargeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteStandardChargeMutation = { __typename?: 'Mutation', deleteStandardCharge: { __typename?: 'StandardCharge', id: number, name: string, description: string, type?: string | null, dateCreated: string, dateModified: string } };

export type BookingToRepairQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type BookingToRepairQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: number, coyhawb: string, jobdate: string, step: BookingJobStep, status: BookingJobStatus, client: { __typename?: 'Account', id: number, client: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null } | null };

export type RepairBookingMutationVariables = Exact<{
  inputs: RepairBookingInputs;
}>;


export type RepairBookingMutation = { __typename?: 'Mutation', repairBooking: { __typename?: 'Booking', id: number, coyhawb: string, jobdate: string, step: BookingJobStep, status: BookingJobStatus, client: { __typename?: 'Account', id: number, client: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null } };

export type TrackingRequestsQueryVariables = Exact<{
  filters?: InputMaybe<GetTrackingRequestFilters>;
}>;


export type TrackingRequestsQuery = { __typename?: 'Query', trackingRequestsCount: number, trackingRequestsMonthAggregation: Array<{ __typename?: 'TrackingMonthAggregation', Month: string, MonthNumber: number, Year: number, Count: number }>, trackingRequests: Array<{ __typename?: 'TrackingRequest', id: number, hawb: string, dateCreated: string }> };

export type SearchQuoteFieldsFragment = { __typename?: 'Quote', id: number, quoteid: string, activity: QuoteStatus, clientnamenew?: string | null, total: number, bookingtype: BookingType, itemdesc: string, origcode: string, destcode: string, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, formattedTotal: string, dateCreated: string, contactName: string, contactEmail: string, contactPhone: string, client?: { __typename?: 'Account', id: number, client: string } | null, office: { __typename?: 'Account', id: number, client: string } };

export type SearchActiveQuotesQueryVariables = Exact<{
  filters?: InputMaybe<SearchQuotesFilters>;
}>;


export type SearchActiveQuotesQuery = { __typename?: 'Query', searchQuotes: { __typename?: 'QuoteSearchResults', count: number, total: number, records: Array<{ __typename?: 'Quote', id: number, quoteid: string, activity: QuoteStatus, clientnamenew?: string | null, total: number, bookingtype: BookingType, itemdesc: string, origcode: string, destcode: string, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, formattedTotal: string, dateCreated: string, contactName: string, contactEmail: string, contactPhone: string, client?: { __typename?: 'Account', id: number, client: string } | null, office: { __typename?: 'Account', id: number, client: string } }> } };

export type SearchQuoteByIDQueryVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type SearchQuoteByIDQuery = { __typename?: 'Query', quoteByQuoteID?: { __typename?: 'Quote', id: number, quoteid: string, activity: QuoteStatus, clientnamenew?: string | null, total: number, bookingtype: BookingType, itemdesc: string, origcode: string, destcode: string, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, formattedTotal: string, dateCreated: string, contactName: string, contactEmail: string, contactPhone: string, client?: { __typename?: 'Account', id: number, client: string } | null, office: { __typename?: 'Account', id: number, client: string } } | null };

export type LoadBookingFromQuoteQueryVariables = Exact<{
  shipperid: Scalars['Int'];
}>;


export type LoadBookingFromQuoteQuery = { __typename?: 'Query', accountByID?: { __typename?: 'Account', id: number, client: string, defaultInvoicePartyID: number } | null };

export type CreateBookingMutationVariables = Exact<{
  inputs: CreateBookingInputs;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type PotentialBookingFieldsFragment = { __typename?: 'Booking', coyhawb: string, consigadd1: string, consigadd2: string, consigtown: string, consigemail: string, consigzip: string, consigfax: string, persrep: string, persrepphone: string, agenthawb?: string | null, costcode?: string | null, specinst?: string | null, name: string, email: string, phone: string, consigstate?: string | null, bookingtype: BookingType, tariffZone: string, jobdate: string, origcode: string, destcode: string, shippersref: string, status: BookingJobStatus, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, consigneeCountry?: { __typename?: 'Country', id: number } | null, client: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, countryid: number, zip: string, email: string, fax: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, invoiceParty: { __typename?: 'Account', id: number }, bookingOffice: { __typename?: 'Account', id: number }, employee: { __typename?: 'Employee', id: number, fullname: string, email?: any | null, office?: { __typename?: 'Account', id: number, phone: string } | null } };

export type PotentialReturnJobsQueryVariables = Exact<{
  filters?: InputMaybe<SearchBookingsFilters>;
}>;


export type PotentialReturnJobsQuery = { __typename?: 'Query', searchBookings: { __typename?: 'BookingSearchResults', count: number, total: number, records: Array<{ __typename?: 'Booking', coyhawb: string, consigadd1: string, consigadd2: string, consigtown: string, consigemail: string, consigzip: string, consigfax: string, persrep: string, persrepphone: string, agenthawb?: string | null, costcode?: string | null, specinst?: string | null, name: string, email: string, phone: string, consigstate?: string | null, bookingtype: BookingType, tariffZone: string, jobdate: string, origcode: string, destcode: string, shippersref: string, status: BookingJobStatus, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, consigneeCountry?: { __typename?: 'Country', id: number } | null, client: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, countryid: number, zip: string, email: string, fax: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, invoiceParty: { __typename?: 'Account', id: number }, bookingOffice: { __typename?: 'Account', id: number }, employee: { __typename?: 'Employee', id: number, fullname: string, email?: any | null, office?: { __typename?: 'Account', id: number, phone: string } | null } }> } };

export type PotentialAgentJobsQueryVariables = Exact<{
  filters?: InputMaybe<SearchBookingsFilters>;
}>;


export type PotentialAgentJobsQuery = { __typename?: 'Query', searchBookings: { __typename?: 'BookingSearchResults', count: number, total: number, records: Array<{ __typename?: 'Booking', coyhawb: string, consigadd1: string, consigadd2: string, consigtown: string, consigemail: string, consigzip: string, consigfax: string, persrep: string, persrepphone: string, agenthawb?: string | null, costcode?: string | null, specinst?: string | null, name: string, email: string, phone: string, consigstate?: string | null, bookingtype: BookingType, tariffZone: string, jobdate: string, origcode: string, destcode: string, shippersref: string, status: BookingJobStatus, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, consigneeCountry?: { __typename?: 'Country', id: number } | null, client: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, countryid: number, zip: string, email: string, fax: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, invoiceParty: { __typename?: 'Account', id: number }, bookingOffice: { __typename?: 'Account', id: number }, employee: { __typename?: 'Employee', id: number, fullname: string, email?: any | null, office?: { __typename?: 'Account', id: number, phone: string } | null } }> } };

export type SaveBookingArrivalMutationVariables = Exact<{
  inputs: SaveBookingArrivalInputs;
}>;


export type SaveBookingArrivalMutation = { __typename?: 'Mutation', saveBookingArrival: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type CompleteBookingArrivalMutationVariables = Exact<{
  coyhawb: Scalars['String'];
}>;


export type CompleteBookingArrivalMutation = { __typename?: 'Mutation', completeBookingArrival: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type CompleteBookingDeliveryMutationVariables = Exact<{
  inputs: SaveBookingDeliveryInputs;
}>;


export type CompleteBookingDeliveryMutation = { __typename?: 'Mutation', completeBookingDelivery: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type EmailShipperPODMutationVariables = Exact<{
  inputs: EmailPODInputs;
}>;


export type EmailShipperPODMutation = { __typename?: 'Mutation', emailShipperPOD: { __typename?: 'Booking', coyhawb: string, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, emailsent: boolean, emailsentDate?: string | null } | null } };

export type AccountContactsQueryVariables = Exact<{
  filters: GetAccountContactsFilter;
}>;


export type AccountContactsQuery = { __typename?: 'Query', accountContacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string, phone: string, fax: string }> };

export type JobTariffByNameQueryVariables = Exact<{
  officeid: Scalars['Int'];
  tariffZone: Scalars['String'];
}>;


export type JobTariffByNameQuery = { __typename?: 'Query', jobTariffByName?: { __typename?: 'JobTariff', id: number, category: JobTariffCategory, zone: string, minweightkg: number, minweight: number, perkg: number } | null };

export type SaveBookingPickupMutationVariables = Exact<{
  inputs: SaveBookingPickupInputs;
}>;


export type SaveBookingPickupMutation = { __typename?: 'Mutation', saveBookingPickup: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type CompleteBookingPickupMutationVariables = Exact<{
  coyhawb: Scalars['String'];
}>;


export type CompleteBookingPickupMutation = { __typename?: 'Mutation', completeBookingPickup: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type LookupEmployeeByIDQueryVariables = Exact<{
  employeeID: Scalars['Int'];
}>;


export type LookupEmployeeByIDQuery = { __typename?: 'Query', employeeByID?: { __typename?: 'Employee', id: number, fullname: string, position?: string | null, picture?: string | null, dgnumber?: string | null, email?: any | null, isActive: boolean, isPericulumSetup: boolean, authSubject?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null };

export type LookupBookingShipmentsQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type LookupBookingShipmentsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', coyhawb: string, jobdate: string, step: BookingJobStep, status: BookingJobStatus, dateCreated: string, dateModified: string, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingOffice: { __typename?: 'Account', id: number, client: string }, employee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string } } | null };

export type CommoditySectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommoditySectionsQuery = { __typename?: 'Query', commoditySections: Array<{ __typename?: 'CommoditySection', id: number, section: string, description: string, commodityChapters: Array<{ __typename?: 'Chapter', id: number, code: string, description: string }> }> };

export type SaveBookingTransportMutationVariables = Exact<{
  inputs: SaveBookingTransportInputs;
}>;


export type SaveBookingTransportMutation = { __typename?: 'Mutation', saveBookingTransport: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type CompleteBookingTransportMutationVariables = Exact<{
  coyhawb: Scalars['String'];
}>;


export type CompleteBookingTransportMutation = { __typename?: 'Mutation', completeBookingTransport: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type OfficeActiveManifestsQueryVariables = Exact<{
  officeid: Scalars['Int'];
}>;


export type OfficeActiveManifestsQuery = { __typename?: 'Query', officeActiveManifests: Array<string> };

export type GetUnusedAndRecentlyUsedMawbVouchersQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Float']>;
  officeid: Scalars['Int'];
}>;


export type GetUnusedAndRecentlyUsedMawbVouchersQuery = { __typename?: 'Query', getUnusedAndRecentlyUsedMawbVouchers: Array<{ __typename?: 'MawbVoucher', id: number, isUsed: boolean, mawbNumber: number, borrowedByOffice?: { __typename?: 'Account', id: number, client: string } | null, ownedByOffice: { __typename?: 'Account', id: number, client: string }, airline: { __typename?: 'Airline', id: number, airlinename: string, airlinecode: string } }> };

export type EmailAgentPrealertMutationVariables = Exact<{
  inputs: EmailAgentPrealertInputs;
}>;


export type EmailAgentPrealertMutation = { __typename?: 'Mutation', emailAgentPrealert: { __typename?: 'Booking', coyhawb: string, bookingTransport?: { __typename?: 'BookingTransport', id: number, isPrealertSent: boolean, prealertSentDate?: string | null } | null } };

export type BookingContactsLookupQueryVariables = Exact<{
  inputs: GetBookingEmailInputs;
}>;


export type BookingContactsLookupQuery = { __typename?: 'Query', GetBookingEmailInputs: Array<{ __typename?: 'GetBookingEmailResponse', group: string, contacts: Array<{ __typename?: 'EmailContact', email: string, name: string }> }> };

export type IncotermsQueryVariables = Exact<{ [key: string]: never; }>;


export type IncotermsQuery = { __typename?: 'Query', incoterms: Array<{ __typename?: 'Incoterm', id: number, code: string, name: string, description: string }> };

export type BookingNoteFieldsFragment = { __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null };

export type ShipmentFragmentFragment = { __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null };

export type BookingPickupFragmentFragment = { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null };

export type BookingArrivalFragmentFragment = { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null };

export type BookingPackagingFragmentFragment = { __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number };

export type BookingTransportFragmentFragment = { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null };

export type BookingFlightFragmentFragment = { __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string };

export type BookingDeliveryFragmentFragment = { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string };

export type EditBookingFieldsFragment = { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> };

export type EditBookingQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type EditBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } | null };

export type UpdateBookingMutationVariables = Exact<{
  inputs: UpdateBookingInputs;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type SaveBookingShipmentsMutationVariables = Exact<{
  inputs: SaveBookingShipmentsInputs;
}>;


export type SaveBookingShipmentsMutation = { __typename?: 'Mutation', saveBookingShipments: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, categoryType: BookingCategoryType, step: BookingJobStep, status: BookingJobStatus, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, quote?: { __typename?: 'Quote', id: number, quoteid: string } | null, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, requiredSteps: Array<BookingJobStep>, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean }, bookingOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number } | null }, client: { __typename?: 'Account', id: number, client: string, defaultCollectionAddress: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, shipments: Array<{ __typename?: 'Shipment', id: number, pieces: number, weight: number, volume: number, unno: string, unclass: string, unpg: string, description: string, package: string, packinginst: string, aircraftType: ShipmentAircraftType, hazardous: ShipmentHazardous, subsidiary: string, objlength: number, objwidth: number, objheight: number, packageqty: number, packageamt: string, dimweightfactor: number, commodityChapterId?: number | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, prealertSentDate?: string | null, shiparrived: boolean, postfab: boolean, postdate?: string | null, isComplete: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, emailsent: boolean, emailsentDate?: string | null, podsig?: string | null, dateCreated: string } | null, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', date: string, event: string }> } };

export type GenerateBookingChargesQueryVariables = Exact<{
  coyhawb: Scalars['String'];
}>;


export type GenerateBookingChargesQuery = { __typename?: 'Query', generateBookingCharges: Array<{ __typename?: 'BaseCharge', name: string, net: number, tax: number, total: number, discountrate: number, source: ChargeSource, taxable: boolean }> };

export type GenerateInvoiceMutationVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type GenerateInvoiceMutation = { __typename?: 'Mutation', generateInvoice: { __typename?: 'Booking', coyhawb: string, invoicedate?: string | null } };

export type BookingInvoiceDownloadURLQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type BookingInvoiceDownloadURLQuery = { __typename?: 'Query', downloadBookingInvoice: string };

export type EmailBookingInvoiceMutationVariables = Exact<{
  inputs: EmailInvoiceInputs;
}>;


export type EmailBookingInvoiceMutation = { __typename?: 'Mutation', emailBookingInvoice: { __typename?: 'Booking', coyhawb: string, invoiced: boolean, invoicedate?: string | null, invoicesentdate?: string | null, invoiceno?: string | null } };

export type BookingChargeFragment = { __typename?: 'BookingCharge', id: number, name: string, source: ChargeSource, discountrate: number, net: number, tax: number, taxable: boolean, total: number };

export type CostOfSaleFragment = { __typename?: 'CostOfSale', id: number, job?: string | null, clientname: string, invoiceno: string, invoicedate: string, invoiceamt: number, taxcode: ChargeTaxCode, taxamt: number, purchasenumber: string, moneysymbol: string, locale: string, type: CostOfSaleType, description: string, dateModified: string };

export type BookingFinanceTabQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type BookingFinanceTabQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', coyhawb: string, bookingCharges: Array<{ __typename?: 'BookingCharge', id: number, name: string, source: ChargeSource, discountrate: number, net: number, tax: number, taxable: boolean, total: number }>, bookingCosts: Array<{ __typename?: 'CostOfSale', id: number, job?: string | null, clientname: string, invoiceno: string, invoicedate: string, invoiceamt: number, taxcode: ChargeTaxCode, taxamt: number, purchasenumber: string, moneysymbol: string, locale: string, type: CostOfSaleType, description: string, dateModified: string }> } | null };

export type SaveBookingFinanceMutationVariables = Exact<{
  inputs: SaveBookingFinanceInputs;
}>;


export type SaveBookingFinanceMutation = { __typename?: 'Mutation', saveBookingFinance: { __typename?: 'Booking', coyhawb: string, bookingCharges: Array<{ __typename?: 'BookingCharge', id: number, name: string, source: ChargeSource, discountrate: number, net: number, tax: number, taxable: boolean, total: number }>, bookingCosts: Array<{ __typename?: 'CostOfSale', id: number, job?: string | null, clientname: string, invoiceno: string, invoicedate: string, invoiceamt: number, taxcode: ChargeTaxCode, taxamt: number, purchasenumber: string, moneysymbol: string, locale: string, type: CostOfSaleType, description: string, dateModified: string }> } };

export type BookingFormInputsQueryVariables = Exact<{
  hawb: Scalars['String'];
  formID: PericulumFormID;
}>;


export type BookingFormInputsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', coyhawb: string, bookingFormInputs?: { __typename?: 'BookingFormInput', id: number, coyhawb: string, formID: PericulumFormID, inputsJSON: string } | null } | null };

export type DownloadBookingDocumentMutationVariables = Exact<{
  downloadDocumentId: Scalars['Int'];
}>;


export type DownloadBookingDocumentMutation = { __typename?: 'Mutation', downloadDocument: string };

export type StartBookingUploadMutationVariables = Exact<{
  inputs: Array<UploadDocumentInputs> | UploadDocumentInputs;
}>;


export type StartBookingUploadMutation = { __typename?: 'Mutation', startUpload: Array<string> };

export type DeleteBookingDocumentMutationVariables = Exact<{
  documentID: Scalars['Int'];
}>;


export type DeleteBookingDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'UploadedDocument', id: number } };

export type ViewBookingFieldsFragment = { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, step: BookingJobStep, status: BookingJobStatus, invoicesentdate?: string | null, invoicedate?: string | null, categoryType: BookingCategoryType, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean, requiredSteps: Array<BookingJobStep> }, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', event: string, date: string }>, bookingOffice: { __typename?: 'Account', id: number, client: string, finemail?: string | null, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, timezone: string, taxRate: number, taxType: OfficeTaxType, email: string } | null }, client: { __typename?: 'Account', id: number, client: string, discountrate: number, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string, finemail?: string | null }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, shiparrived: boolean, postdate?: string | null, postfab: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, podsig?: string | null, emailsent: boolean } | null, shipments: Array<{ __typename?: 'Shipment', id: number, description: string, hazardous: ShipmentHazardous, objheight: number, objlength: number, objwidth: number, package: string, packageamt: string, packageqty: number, packinginst: string, pieces: number, subsidiary: string, unclass: string, unno: string, weight: number, volume: number, dimweightfactor: number, unpg: string, aircraftType: ShipmentAircraftType, commodityChapterId?: number | null }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> };

export type SearchBookingsQueryVariables = Exact<{
  filters?: InputMaybe<SearchBookingsFilters>;
}>;


export type SearchBookingsQuery = { __typename?: 'Query', searchBookings: { __typename?: 'BookingSearchResults', count: number, total: number, query: string, records: Array<{ __typename?: 'Booking', id: number, coyhawb: string, categoryType: BookingCategoryType, lastNoteDate?: string | null, jobdate: string, origcode: string, destcode: string, bookingtype: BookingType, status: BookingJobStatus, client: { __typename?: 'Account', id: number, client: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, bookingOffice: { __typename?: 'Account', id: number, client: string } }> } };

export type ViewBookingQueryVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type ViewBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, step: BookingJobStep, status: BookingJobStatus, invoicesentdate?: string | null, invoicedate?: string | null, categoryType: BookingCategoryType, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean, requiredSteps: Array<BookingJobStep> }, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', event: string, date: string }>, bookingOffice: { __typename?: 'Account', id: number, client: string, finemail?: string | null, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, timezone: string, taxRate: number, taxType: OfficeTaxType, email: string } | null }, client: { __typename?: 'Account', id: number, client: string, discountrate: number, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string, finemail?: string | null }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, shiparrived: boolean, postdate?: string | null, postfab: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, podsig?: string | null, emailsent: boolean } | null, shipments: Array<{ __typename?: 'Shipment', id: number, description: string, hazardous: ShipmentHazardous, objheight: number, objlength: number, objwidth: number, package: string, packageamt: string, packageqty: number, packinginst: string, pieces: number, subsidiary: string, unclass: string, unno: string, weight: number, volume: number, dimweightfactor: number, unpg: string, aircraftType: ShipmentAircraftType, commodityChapterId?: number | null }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> } | null };

export type CreateBookingNoteMutationVariables = Exact<{
  inputs: CreateBookingNoteInputs;
}>;


export type CreateBookingNoteMutation = { __typename?: 'Mutation', createBookingNote: { __typename?: 'Booking', id: number, coyhawb: string, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> } };

export type UpdateBookingNoteMutationVariables = Exact<{
  inputs: UpdateBookingNoteInputs;
}>;


export type UpdateBookingNoteMutation = { __typename?: 'Mutation', updateBookingNote: { __typename?: 'Booking', id: number, coyhawb: string, lastNoteDate?: string | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> } };

export type DeleteBookingNoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBookingNoteMutation = { __typename?: 'Mutation', deleteBookingNote: { __typename?: 'BookingNote', id: number } };

export type EmailBookingNoteMutationVariables = Exact<{
  inputs: EmailBookingNoteInputs;
}>;


export type EmailBookingNoteMutation = { __typename?: 'Mutation', emailNote: { __typename?: 'Booking', id: number, coyhawb: string, lastNoteDate?: string | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> } };

export type BookingActivityQueryVariables = Exact<{
  inputs?: InputMaybe<FilterActivityLogs>;
}>;


export type BookingActivityQuery = { __typename?: 'Query', activityLogsCount: number, activityLogs: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> };

export type GeneratePericulumFormMutationVariables = Exact<{
  formId: PericulumFormID;
  hawb: Scalars['String'];
  format: PericulumFormFormat;
  inputs?: InputMaybe<Scalars['JSONObject']>;
}>;


export type GeneratePericulumFormMutation = { __typename?: 'Mutation', generatePericulumForm: string };

export type DeleteBookingMutationVariables = Exact<{
  coyhawb: Scalars['String'];
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', deleteBooking: { __typename?: 'Booking', coyhawb: string } };

export type CloneBookingMutationVariables = Exact<{
  inputs: CloneBookingInputs;
}>;


export type CloneBookingMutation = { __typename?: 'Mutation', cloneBooking: { __typename?: 'Booking', id: number, coyhawb: string, bookingtype: BookingType, step: BookingJobStep, status: BookingJobStatus, invoicesentdate?: string | null, invoicedate?: string | null, categoryType: BookingCategoryType, jobdate: string, name: string, consigadd1: string, consigadd2: string, email: string, consigtown: string, consigstate?: string | null, phone: string, consigzip: string, shippersref: string, agenthawb?: string | null, persrep: string, persrepphone: string, origcode: string, destcode: string, consigfax: string, specinst?: string | null, consigemail: string, costcode?: string | null, tariffZone: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean, requiredSteps: Array<BookingJobStep> }, bookingTimeline: Array<{ __typename?: 'BookingTimelineEvent', event: string, date: string }>, bookingOffice: { __typename?: 'Account', id: number, client: string, finemail?: string | null, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string, timezone: string, taxRate: number, taxType: OfficeTaxType, email: string } | null }, client: { __typename?: 'Account', id: number, client: string, discountrate: number, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> }, consignee?: { __typename?: 'Account', id: number, client: string, contacts: Array<{ __typename?: 'AccountContact', id: number, name: string, email: string }> } | null, invoiceParty: { __typename?: 'Account', id: number, client: string, finemail?: string | null }, country?: { __typename?: 'Country', id: number, Country: string } | null, origin?: { __typename?: 'Portcode', id: number, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, cityname: string } | null, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, bookingPickup?: { __typename?: 'BookingPickup', id: number, isPickupArranged: boolean, pickupdate: string, pickupjustification: string, collectionAddress: string, collectionMethod: PickupCollectionMethod, isDGDCompleted: boolean, aircraftType: PickupAircraftType, radioactive: boolean, isBooked: boolean, dgInspectionComplete: boolean, dgInspectionJustification: string, arrangedByEmployee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, bookingArrival?: { __typename?: 'BookingArrival', id: number, isComplete: boolean, dateReceived: string, isDgdRaised: BookingArrivalDgdRaised, isRepacked: boolean, includesDryIce: boolean, dryicekg: number, agent?: { __typename?: 'Account', id: number, client: string } | null, dgdRaisedBy?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } | null } | null, packaging: Array<{ __typename?: 'BookingPackaging', id: number, name: string, numused: number, size: string, cost: number }>, bookingTransport?: { __typename?: 'BookingTransport', id: number, mawb?: string | null, connote: string, delivery: BookingDeliveryType, agentcob: boolean, flightarrival: string, isConsolidated: boolean, coymanifest: string, isPrealertSent: boolean, shiparrived: boolean, postdate?: string | null, postfab: boolean, incotermId?: number | null, agent?: { __typename?: 'Account', id: number, client: string } | null } | null, flights: Array<{ __typename?: 'BookingFlight', id: number, journeynum: number, airlineIataCode: string, airlinecode: string, airlineName: string, flightnum: string, dest: string }>, bookingDelivery?: { __typename?: 'BookingDelivery', id: number, poddate: string, podname: string, podsig?: string | null, emailsent: boolean } | null, shipments: Array<{ __typename?: 'Shipment', id: number, description: string, hazardous: ShipmentHazardous, objheight: number, objlength: number, objwidth: number, package: string, packageamt: string, packageqty: number, packinginst: string, pieces: number, subsidiary: string, unclass: string, unno: string, weight: number, volume: number, dimweightfactor: number, unpg: string, aircraftType: ShipmentAircraftType, commodityChapterId?: number | null }>, uploadedDocuments: Array<{ __typename?: 'UploadedDocument', id: number, name: string, storageKey: string, mime?: string | null, filesize: number, extention: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }>, recentActivity: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, description: string, dateCreated: string, metadata?: string | null, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null, office?: { __typename?: 'Account', id: number, client: string } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> } };

export type CancelBookingMutationVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking: { __typename?: 'Booking', coyhawb: string, status: BookingJobStatus, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> } };

export type UncancelBookingMutationVariables = Exact<{
  hawb: Scalars['String'];
}>;


export type UncancelBookingMutation = { __typename?: 'Mutation', uncancelBooking: { __typename?: 'Booking', coyhawb: string, status: BookingJobStatus, notes: Array<{ __typename?: 'BookingNote', id: number, noteinfo: string, subject: BookingNoteSubject, isSent: boolean, isPrivate: boolean, isEdited: boolean, dateCreated: string, dateModified: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> } };

export type OfficeChargeFieldsFragment = { __typename?: 'OfficeCharge', id: number, type: OfficeChargeType, customChargeName?: string | null, bookingTypes: Array<BookingType>, deliveryTypes: Array<BookingDeliveryType>, amount: number, taxable: boolean, dateCreated: string, dateModified: string, office: { __typename?: 'Account', client: string, id: number }, charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null };

export type JobTariffFragment = { __typename?: 'JobTariff', id: number, zone: string, isActive: boolean, minweight: number, minweightkg: number, dateCreated: string, dateModified: string, category: JobTariffCategory, perkg: number, region?: { __typename?: 'Region', id: number, name: string } | null, officeAccount?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, locale?: string | null, moneysymbol?: string | null } } | null };

export type officeChargeFragmentFragment = { __typename?: 'OfficeCharge', charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null };

export type OfficeChargesJobTariffsQueryVariables = Exact<{
  inputs?: InputMaybe<GetJobTariffsFilters>;
}>;


export type OfficeChargesJobTariffsQuery = { __typename?: 'Query', jobTariffsCount: number, jobTariffs: Array<{ __typename?: 'JobTariff', id: number, zone: string, isActive: boolean, minweight: number, minweightkg: number, dateCreated: string, dateModified: string, category: JobTariffCategory, perkg: number, region?: { __typename?: 'Region', id: number, name: string } | null, officeAccount?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, locale?: string | null, moneysymbol?: string | null } } | null }> };

export type JobTariffDetailsByIDQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type JobTariffDetailsByIDQuery = { __typename?: 'Query', jobTariffByID?: { __typename?: 'JobTariff', id: number, zone: string, isActive: boolean, minweight: number, minweightkg: number, dateCreated: string, dateModified: string, category: JobTariffCategory, perkg: number, region?: { __typename?: 'Region', id: number, name: string } | null, officeAccount?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, locale?: string | null, moneysymbol?: string | null } } | null } | null };

export type CreateJobTariffMutationVariables = Exact<{
  inputs: CreateJobTariffInputs;
}>;


export type CreateJobTariffMutation = { __typename?: 'Mutation', createJobTariff: { __typename?: 'JobTariff', id: number, zone: string, isActive: boolean, minweight: number, minweightkg: number, dateCreated: string, dateModified: string, category: JobTariffCategory, perkg: number, region?: { __typename?: 'Region', id: number, name: string } | null, officeAccount?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, locale?: string | null, moneysymbol?: string | null } } | null } };

export type UpdateJobTariffMutationVariables = Exact<{
  inputs: UpdateJobTariffInputs;
}>;


export type UpdateJobTariffMutation = { __typename?: 'Mutation', updateJobTariff: { __typename?: 'JobTariff', id: number, zone: string, isActive: boolean, minweight: number, minweightkg: number, dateCreated: string, dateModified: string, category: JobTariffCategory, perkg: number, region?: { __typename?: 'Region', id: number, name: string } | null, officeAccount?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, locale?: string | null, moneysymbol?: string | null } } | null } };

export type PackagingTariffsQueryVariables = Exact<{
  filters: GetPackagingTariffsFilters;
}>;


export type PackagingTariffsQuery = { __typename?: 'Query', packagingTariffs: Array<{ __typename?: 'PackagingTariff', id: number, packtype: string, packsize: string, cost: number, cost2: number, isActive: boolean, dateModified: string, office: { __typename?: 'Account', id: number } }> };

export type UpdatePackagingTariffMutationVariables = Exact<{
  inputs: UpdatePackagingTariffInputs;
}>;


export type UpdatePackagingTariffMutation = { __typename?: 'Mutation', updatePackagingTariff: { __typename?: 'PackagingTariff', id: number, packtype: string, packsize: string, cost: number, cost2: number, isActive: boolean, dateModified: string } };

export type CreatePackagingTariffMutationVariables = Exact<{
  inputs: CreatePackagingTariffInputs;
}>;


export type CreatePackagingTariffMutation = { __typename?: 'Mutation', createPackagingTariff: { __typename?: 'PackagingTariff', id: number, packtype: string, packsize: string, cost: number, cost2: number, isActive: boolean, dateModified: string } };

export type OfficeChargesByOfficeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OfficeChargesByOfficeQuery = { __typename?: 'Query', officeChargesByOfficeID: Array<{ __typename?: 'OfficeCharge', id: number, type: OfficeChargeType, customChargeName?: string | null, bookingTypes: Array<BookingType>, deliveryTypes: Array<BookingDeliveryType>, amount: number, taxable: boolean, dateCreated: string, dateModified: string, office: { __typename?: 'Account', client: string, id: number }, charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null }> };

export type OfficeChargeByIDQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type OfficeChargeByIDQuery = { __typename?: 'Query', officeChargeByID?: { __typename?: 'OfficeCharge', id: number, type: OfficeChargeType, customChargeName?: string | null, bookingTypes: Array<BookingType>, deliveryTypes: Array<BookingDeliveryType>, amount: number, taxable: boolean, dateCreated: string, dateModified: string, office: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string } | null }, charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null } | null };

export type CreateOfficeChargeMutationVariables = Exact<{
  inputs: CreateOfficeChargeInputs;
}>;


export type CreateOfficeChargeMutation = { __typename?: 'Mutation', createOfficeCharge: { __typename?: 'OfficeCharge', id: number, type: OfficeChargeType, customChargeName?: string | null, bookingTypes: Array<BookingType>, deliveryTypes: Array<BookingDeliveryType>, amount: number, taxable: boolean, dateCreated: string, dateModified: string, office: { __typename?: 'Account', client: string, id: number }, charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null } };

export type UpdateOfficeChargeMutationVariables = Exact<{
  inputs: UpdateOfficeChargeInputs;
}>;


export type UpdateOfficeChargeMutation = { __typename?: 'Mutation', updateOfficeCharge: { __typename?: 'OfficeCharge', id: number, type: OfficeChargeType, customChargeName?: string | null, bookingTypes: Array<BookingType>, deliveryTypes: Array<BookingDeliveryType>, amount: number, taxable: boolean, dateCreated: string, dateModified: string, office: { __typename?: 'Account', client: string, id: number }, charge?: { __typename?: 'StandardCharge', id: number, name: string, type?: string | null, description: string, dateCreated: string, dateModified: string } | null } };

export type DeleteOfficeChargeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteOfficeChargeMutation = { __typename?: 'Mutation', deleteOfficeCharge: { __typename?: 'OfficeCharge', id: number } };

export type SearchContactsQueryVariables = Exact<{
  filters: SearchContactsFilters;
}>;


export type SearchContactsQuery = { __typename?: 'Query', searchContacts: { __typename?: 'ContactSearchResults', count: number, total: number, query: string, records: Array<{ __typename?: 'AccountContact', id: number, name: string, position: string, phone: string, email: string, isActive: boolean, dateModified: string, account: { __typename?: 'Account', id: number, client: string } }> } };

export type AccountContactQueryVariables = Exact<{
  contactID: Scalars['Int'];
  inputs?: InputMaybe<FilterActivityLogs>;
}>;


export type AccountContactQuery = { __typename?: 'Query', accountContact?: { __typename?: 'AccountContact', id: number, name: string, position: string, phone: string, phone2: string, fax: string, email: string, address1: string, address2: string, town: string, state: string, zip: string, isActive: boolean, notes: string, dateCreated: string, dateModified: string, account: { __typename?: 'Account', id: number, client: string, address1: string, address2: string, town: string, country: { __typename?: 'Country', id: number, Country: string } }, country: { __typename?: 'Country', id: number, Country: string } } | null, activityLogs: Array<{ __typename?: 'ActivityLog', id: number, description: string, dateCreated: string, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } | null }> };

export type CreateAccountContactMutationVariables = Exact<{
  inputs: CreateAccountContactInput;
}>;


export type CreateAccountContactMutation = { __typename?: 'Mutation', createAccountContact: { __typename?: 'AccountContact', id: number, name: string, position: string, phone: string, phone2: string, fax: string, email: string, address1: string, address2: string, town: string, state: string, zip: string, isActive: boolean, notes: string, dateCreated: string, dateModified: string, account: { __typename?: 'Account', id: number, client: string }, country: { __typename?: 'Country', id: number, Country: string } } };

export type UpdateAccountContactMutationVariables = Exact<{
  inputs: UpdateAccountContactInput;
}>;


export type UpdateAccountContactMutation = { __typename?: 'Mutation', updateAccountContact: { __typename?: 'AccountContact', id: number, name: string, position: string, phone: string, phone2: string, fax: string, email: string, address1: string, address2: string, town: string, state: string, zip: string, isActive: boolean, notes: string, dateCreated: string, dateModified: string, account: { __typename?: 'Account', id: number, client: string }, country: { __typename?: 'Country', id: number, Country: string } } };

export type DeleteAccountContactMutationVariables = Exact<{
  contactID: Scalars['Int'];
}>;


export type DeleteAccountContactMutation = { __typename?: 'Mutation', deleteAccountContact: { __typename?: 'AccountContact', id: number } };

export type BugReportQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type BugReportQuery = { __typename?: 'Query', bugReport: { __typename?: 'BugReport', id: number, title: string, priority: BugReportPriority, frequency: BugReportFrequency, dateCreated: string, status: BugReportStatus, errordate: string, job: string, action: string, expectedresult: string, actualresult: string, errormessage: string, comments: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, employeeOffice: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', timezone: string } | null } } };

export type BugReportCommentsQueryVariables = Exact<{
  reportId: Scalars['Int'];
}>;


export type BugReportCommentsQuery = { __typename?: 'Query', bugReportComments: Array<{ __typename?: 'BugReportComment', id: number, comment: string, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null } }> };

export type BugReportsQueryVariables = Exact<{
  filters: GetBugReportsFilters;
}>;


export type BugReportsQuery = { __typename?: 'Query', bugReportsCount: number, bugReports: Array<{ __typename?: 'BugReport', id: number, title: string, priority: BugReportPriority, frequency: BugReportFrequency, dateCreated: string, status: BugReportStatus, comments: string, commentsCount: number, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, employeeOffice: { __typename?: 'Account', id: number, client: string } }> };

export type DeleteBugReportMutationVariables = Exact<{
  deleteBugReportId: Scalars['Int'];
}>;


export type DeleteBugReportMutation = { __typename?: 'Mutation', deleteBugReport: { __typename?: 'BugReport', id: number, status: BugReportStatus } };

export type CreateBugReportMutationVariables = Exact<{
  inputs: CreateBugReportInputs;
}>;


export type CreateBugReportMutation = { __typename?: 'Mutation', createBugReport: { __typename?: 'BugReport', id: number, title: string, priority: BugReportPriority, frequency: BugReportFrequency, dateCreated: string, status: BugReportStatus, comments: string, commentsCount: number, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, employeeOffice: { __typename?: 'Account', id: number, client: string } } };

export type UpdateBugReportMutationVariables = Exact<{
  inputs: UpdateBugReportInputs;
}>;


export type UpdateBugReportMutation = { __typename?: 'Mutation', updateBugReport: { __typename?: 'BugReport', id: number, title: string, priority: BugReportPriority, frequency: BugReportFrequency, dateCreated: string, status: BugReportStatus, comments: string, commentsCount: number, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, employeeOffice: { __typename?: 'Account', id: number, client: string } } };

export type CreateBugReportCommentMutationVariables = Exact<{
  inputs: CreateBugReportCommentInputs;
}>;


export type CreateBugReportCommentMutation = { __typename?: 'Mutation', createBugReportComment: { __typename?: 'BugReportComment', id: number, comment: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } } };

export type DeleteBugReportCommentMutationVariables = Exact<{
  deleteBugReportCommentId: Scalars['Int'];
}>;


export type DeleteBugReportCommentMutation = { __typename?: 'Mutation', deleteBugReportComment: { __typename?: 'BugReportComment', id: number } };

export type FeatureRequestQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FeatureRequestQuery = { __typename?: 'Query', featureRequest: { __typename?: 'FeatureRequest', id: number, title: string, priority: FeatureRequestPriority, description: string, comments: string, hasUserVoted: boolean, voteCount: number, status: FeatureRequestStatus, closingcomments?: string | null, dateCreated: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, office: { __typename?: 'Account', id: number, client: string } } };

export type FeatureRequestsQueryVariables = Exact<{
  filters?: InputMaybe<GetFeatureRequestsFilters>;
}>;


export type FeatureRequestsQuery = { __typename?: 'Query', featureRequestsCount: number, featureRequests: Array<{ __typename?: 'FeatureRequest', id: number, title: string, priority: FeatureRequestPriority, description: string, comments: string, hasUserVoted: boolean, voteCount: number, status: FeatureRequestStatus, closingcomments?: string | null, dateCreated: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, office: { __typename?: 'Account', id: number, client: string } }> };

export type CreateFeatureRequestMutationVariables = Exact<{
  inputs: CreateFeatureRequestInputs;
}>;


export type CreateFeatureRequestMutation = { __typename?: 'Mutation', createFeatureRequest: { __typename?: 'FeatureRequest', id: number, title: string, priority: FeatureRequestPriority, description: string, comments: string, hasUserVoted: boolean, voteCount: number, status: FeatureRequestStatus, closingcomments?: string | null, dateCreated: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, office: { __typename?: 'Account', id: number, client: string } } };

export type UpdateFeatureRequestMutationVariables = Exact<{
  inputs: UpdateFeatureRequestInputs;
}>;


export type UpdateFeatureRequestMutation = { __typename?: 'Mutation', updateFeatureRequest: { __typename?: 'FeatureRequest', id: number, title: string, priority: FeatureRequestPriority, description: string, comments: string, hasUserVoted: boolean, voteCount: number, status: FeatureRequestStatus, closingcomments?: string | null, dateCreated: string, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null }, office: { __typename?: 'Account', id: number, client: string } } };

export type DeleteFeatureRequestMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFeatureRequestMutation = { __typename?: 'Mutation', deleteFeatureRequest: { __typename?: 'FeatureRequest', id: number } };

export type ToggleFeatureRequestVoteMutationVariables = Exact<{
  featureRequestId: Scalars['Int'];
}>;


export type ToggleFeatureRequestVoteMutation = { __typename?: 'Mutation', toggleFeatureRequestVote: { __typename?: 'FeatureRequest', id: number, voteCount: number, hasUserVoted: boolean } };

export type NewBookingsSubscriptionSubscriptionVariables = Exact<{
  officeid: Scalars['Int'];
}>;


export type NewBookingsSubscriptionSubscription = { __typename?: 'Subscription', newBooking: { __typename?: 'Booking', coyhawb: string } };

export type HomeScreenDataQueryVariables = Exact<{
  inputs?: InputMaybe<FilterActivityLogs>;
}>;


export type HomeScreenDataQuery = { __typename?: 'Query', activityLogs: Array<{ __typename?: 'ActivityLog', id: number, eventid: number, dateCreated: string, description: string, booking?: { __typename?: 'Booking', coyhawb: string } | null, employee?: { __typename?: 'Employee', fullname: string } | null }>, homeBookmarks: Array<{ __typename?: 'HomeBookmark', id: number, icon: string, label: string, url: string }> };

export type CreateBookmarkMutationVariables = Exact<{
  inputs: CreateHomeBookmarkInputs;
}>;


export type CreateBookmarkMutation = { __typename?: 'Mutation', createBookmark: { __typename?: 'HomeBookmark', id: number, label: string, url: string, icon: string, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string } } };

export type UpdateBookmarkMutationVariables = Exact<{
  inputs: UpdateHomeBookmarkInputs;
}>;


export type UpdateBookmarkMutation = { __typename?: 'Mutation', updateBookmark: { __typename?: 'HomeBookmark', id: number, label: string, url: string, icon: string, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, fullname: string, email?: any | null } } };

export type DeleteBookmarkMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type DeleteBookmarkMutation = { __typename?: 'Mutation', deleteBookmark: { __typename?: 'HomeBookmark', id: number, label: string, url: string, icon: string, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, email?: any | null, fullname: string } } };

export type RecentBookingsQueryVariables = Exact<{
  inputs: SearchBookingsFilters;
}>;


export type RecentBookingsQuery = { __typename?: 'Query', searchBookings: { __typename?: 'BookingSearchResults', count: number, total: number, query: string, records: Array<{ __typename?: 'Booking', coyhawb: string, lastNoteDate?: string | null, categoryType: BookingCategoryType, transitTime: number, transitTimeAllowed: number, jobdate: string, origcode: string, destcode: string, bookingtype: BookingType, status: BookingJobStatus, dateCreated: string, dateModified: string, client: { __typename?: 'Account', id: number, client: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, origin?: { __typename?: 'Portcode', id: number, portcode: string, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, portcode: string, cityname: string } | null, bookingOffice: { __typename?: 'Account', id: number, client: string } }> } };

export type TransitBookingsQueryVariables = Exact<{
  inputs: SearchBookingsFilters;
}>;


export type TransitBookingsQuery = { __typename?: 'Query', searchBookings: { __typename?: 'BookingSearchResults', count: number, total: number, query: string, records: Array<{ __typename?: 'Booking', coyhawb: string, categoryType: BookingCategoryType, lastNoteDate?: string | null, jobdate: string, origcode: string, destcode: string, bookingtype: BookingType, status: BookingJobStatus, dateCreated: string, dateModified: string, transitTime: number, transitTimeAllowed: number, client: { __typename?: 'Account', id: number, client: string }, consignee?: { __typename?: 'Account', id: number, client: string } | null, origin?: { __typename?: 'Portcode', portcode: string, cityname: string } | null, destination?: { __typename?: 'Portcode', portcode: string, cityname: string } | null, bookingOffice: { __typename?: 'Account', id: number, client: string }, bookingPickup?: { __typename?: 'BookingPickup', id: number, pickupdate: string } | null }> } };

export type ChangeActiveOfficeMutationVariables = Exact<{
  officeConfigId: Scalars['Int'];
}>;


export type ChangeActiveOfficeMutation = { __typename?: 'Mutation', changeActiveOffice: boolean };

export type CountUncreatedAccountsWithNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type CountUncreatedAccountsWithNameQuery = { __typename?: 'Query', uncreatedAccountsWithName: number };

export type QuoteAccountContactsQueryVariables = Exact<{
  filters: GetAccountContactsFilter;
}>;


export type QuoteAccountContactsQuery = { __typename?: 'Query', accountContacts: Array<{ __typename?: 'AccountContact', id: number, name: string, position: string, phone: string, email: string, notes: string }> };

export type IsPortcodeRemoteQueryVariables = Exact<{
  portcode: Scalars['String'];
}>;


export type IsPortcodeRemoteQuery = { __typename?: 'Query', isPortcodeRemote: boolean };

export type CreateQuoteMutationVariables = Exact<{
  inputs: CreateQuoteInputs;
}>;


export type CreateQuoteMutation = { __typename?: 'Mutation', createQuote: { __typename?: 'Quote', id: number, quoteid: string, clientnamenew?: string | null, contactName: string, contactEmail: string, contactPhone: string, bookingtype: BookingType, origcode: string, destcode: string, deliveryType: BookingDeliveryType, itemdesc: string, tariffZone: string, tariffMinWeightKG: number, tariffMinWeight: number, tariffPerKG: number, itemweight: number, dgdraised: boolean, repacked: boolean, dryiceused: boolean, dryiceamt: number, activity: QuoteStatus, isQuoteSent: boolean, quoteSentDate?: string | null, returnclienttype: QuoteClientType, leadorigin: QuoteLeadOrigin, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string, position?: string | null }, client?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string } } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null, office: { __typename?: 'Account', id: number, client: string, phone: string, country: { __typename?: 'Country', id: number, taxrate?: number | null }, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, timezone: string, currencyCode: string, currencyName: string, email: string, region?: { __typename?: 'Region', id: number, name: string } | null } | null }, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }>, quotePackaging: Array<{ __typename?: 'QuotePackaging', id: number, name: string, cost: number, numused: number, size: string }>, quoteCharges: Array<{ __typename?: 'QuoteCharge', id: number, name: string, source: ChargeSource, discountrate: number, taxable: boolean, net: number, tax: number, total: number }> } };

export type UpdateQuoteMutationVariables = Exact<{
  inputs: UpdateQuoteInputs;
}>;


export type UpdateQuoteMutation = { __typename?: 'Mutation', updateQuote: { __typename?: 'Quote', id: number, quoteid: string, clientnamenew?: string | null, contactName: string, contactEmail: string, contactPhone: string, bookingtype: BookingType, origcode: string, destcode: string, deliveryType: BookingDeliveryType, itemdesc: string, tariffZone: string, tariffMinWeightKG: number, tariffMinWeight: number, tariffPerKG: number, itemweight: number, dgdraised: boolean, repacked: boolean, dryiceused: boolean, dryiceamt: number, activity: QuoteStatus, isQuoteSent: boolean, quoteSentDate?: string | null, returnclienttype: QuoteClientType, leadorigin: QuoteLeadOrigin, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string, position?: string | null }, client?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string } } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null, office: { __typename?: 'Account', id: number, client: string, phone: string, country: { __typename?: 'Country', id: number, taxrate?: number | null }, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, timezone: string, currencyCode: string, currencyName: string, email: string, region?: { __typename?: 'Region', id: number, name: string } | null } | null }, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }>, quotePackaging: Array<{ __typename?: 'QuotePackaging', id: number, name: string, cost: number, numused: number, size: string }>, quoteCharges: Array<{ __typename?: 'QuoteCharge', id: number, name: string, source: ChargeSource, discountrate: number, taxable: boolean, net: number, tax: number, total: number }> } };

export type QuoteAccountByIDQueryVariables = Exact<{
  accountID: Scalars['Int'];
}>;


export type QuoteAccountByIDQuery = { __typename?: 'Query', accountByID?: { __typename?: 'Account', id: number, client: string, town: string, address1: string, address2: string, state: string, postal: string, zip: string, isJobHoldActive: boolean, industryType?: AccountIndustryType | null, discountrate: number, altHandling: string, country: { __typename?: 'Country', id: number, Country: string }, createdByOffice: { __typename?: 'Account', id: number, client: string }, accountCharges: Array<{ __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, amount: number, taxable: boolean, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean }> } | null };

export type SearchQuotesQueryVariables = Exact<{
  filters?: InputMaybe<SearchQuotesFilters>;
}>;


export type SearchQuotesQuery = { __typename?: 'Query', searchQuotes: { __typename?: 'QuoteSearchResults', count: number, total: number, query: string, records: Array<{ __typename?: 'Quote', id: number, lastNoteDate?: string | null, quoteid: string, clientnamenew?: string | null, contactName: string, origcode: string, destcode: string, itemdesc: string, tariffMinWeight: number, tariffMinWeightKG: number, tariffPerKG: number, tariffZone: string, activity: QuoteStatus, total: number, returnclienttype: QuoteClientType, dateCreated: string, dateModified: string, bookingsFromQuote: Array<{ __typename?: 'Booking', id: number, coyhawb: string }>, client?: { __typename?: 'Account', id: number, client: string } | null, office: { __typename?: 'Account', id: number, client: string, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, currencyCode: string } | null }, origin?: { __typename?: 'Portcode', id: number, portcode: string, cityname: string } | null, destination?: { __typename?: 'Portcode', id: number, portcode: string, cityname: string } | null, employee: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null } }> } };

export type ViewQuoteFieldsFragment = { __typename?: 'Quote', id: number, quoteid: string, clientnamenew?: string | null, contactName: string, contactEmail: string, contactPhone: string, bookingtype: BookingType, origcode: string, destcode: string, deliveryType: BookingDeliveryType, itemdesc: string, tariffZone: string, tariffMinWeightKG: number, tariffMinWeight: number, tariffPerKG: number, itemweight: number, dgdraised: boolean, repacked: boolean, dryiceused: boolean, dryiceamt: number, activity: QuoteStatus, isQuoteSent: boolean, quoteSentDate?: string | null, returnclienttype: QuoteClientType, leadorigin: QuoteLeadOrigin, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string, position?: string | null }, client?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string } } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null, office: { __typename?: 'Account', id: number, client: string, phone: string, country: { __typename?: 'Country', id: number, taxrate?: number | null }, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, timezone: string, currencyCode: string, currencyName: string, email: string, region?: { __typename?: 'Region', id: number, name: string } | null } | null }, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }>, quotePackaging: Array<{ __typename?: 'QuotePackaging', id: number, name: string, cost: number, numused: number, size: string }>, quoteCharges: Array<{ __typename?: 'QuoteCharge', id: number, name: string, source: ChargeSource, discountrate: number, taxable: boolean, net: number, tax: number, total: number }> };

export type ViewQuoteQueryVariables = Exact<{
  quoteId: Scalars['String'];
  inputs: GetFixedChargesInputs;
}>;


export type ViewQuoteQuery = { __typename?: 'Query', quoteByQuoteID?: { __typename?: 'Quote', id: number, quoteid: string, clientnamenew?: string | null, contactName: string, contactEmail: string, contactPhone: string, bookingtype: BookingType, origcode: string, destcode: string, deliveryType: BookingDeliveryType, itemdesc: string, tariffZone: string, tariffMinWeightKG: number, tariffMinWeight: number, tariffPerKG: number, itemweight: number, dgdraised: boolean, repacked: boolean, dryiceused: boolean, dryiceamt: number, activity: QuoteStatus, isQuoteSent: boolean, quoteSentDate?: string | null, returnclienttype: QuoteClientType, leadorigin: QuoteLeadOrigin, dateCreated: string, dateModified: string, employee: { __typename?: 'Employee', id: number, picture?: string | null, fullname: string, position?: string | null }, client?: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string } } | null, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null, office: { __typename?: 'Account', id: number, client: string, phone: string, country: { __typename?: 'Country', id: number, taxrate?: number | null }, officeConfiguration?: { __typename?: 'OfficeConfiguration', id: number, locale: string, timezone: string, currencyCode: string, currencyName: string, email: string, region?: { __typename?: 'Region', id: number, name: string } | null } | null }, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }>, quotePackaging: Array<{ __typename?: 'QuotePackaging', id: number, name: string, cost: number, numused: number, size: string }>, quoteCharges: Array<{ __typename?: 'QuoteCharge', id: number, name: string, source: ChargeSource, discountrate: number, taxable: boolean, net: number, tax: number, total: number }> } | null, fixedCharges: Array<{ __typename?: 'FixedCharge', id: number, jobid: string, type: FixedChargeType, name: string, net: number, tax: number, total: number }> };

export type CreateQuoteNoteMutationVariables = Exact<{
  inputs: CreateQuoteNoteInputs;
}>;


export type CreateQuoteNoteMutation = { __typename?: 'Mutation', createQuoteNote: { __typename?: 'Quote', id: number, lastNoteDate?: string | null, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }> } };

export type UpdateQuoteNoteMutationVariables = Exact<{
  inputs: UpdateQuoteNoteInputs;
}>;


export type UpdateQuoteNoteMutation = { __typename?: 'Mutation', updateQuoteNote: { __typename?: 'Quote', id: number, lastNoteDate?: string | null, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }> } };

export type DeleteQuoteNoteMutationVariables = Exact<{
  noteId: Scalars['Int'];
}>;


export type DeleteQuoteNoteMutation = { __typename?: 'Mutation', deleteQuoteNote: { __typename?: 'QuoteNote', id: number } };

export type DeleteQuoteMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteQuoteMutation = { __typename?: 'Mutation', deleteQuote: { __typename?: 'Quote', id: number } };

export type EmailQuoteMutationVariables = Exact<{
  inputs: EmailQuoteInputs;
}>;


export type EmailQuoteMutation = { __typename?: 'Mutation', emailQuote: { __typename?: 'Quote', id: number, isQuoteSent: boolean, quoteSentDate?: string | null } };

export type UpdateQuoteStatusMutationVariables = Exact<{
  newStatus: QuoteStatus;
  quoteId: Scalars['String'];
}>;


export type UpdateQuoteStatusMutation = { __typename?: 'Mutation', updateQuoteStatus: { __typename?: 'Quote', id: number, activity: QuoteStatus, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }> } };

export type EmailQuoteReminderMutationVariables = Exact<{
  inputs: EmailQuoteReminderInputs;
}>;


export type EmailQuoteReminderMutation = { __typename?: 'Mutation', emailQuoteReminder: { __typename?: 'Quote', id: number, quoteNotes: Array<{ __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null }> } };

export type QuotePackagingFragment = { __typename?: 'QuotePackaging', id: number, name: string, cost: number, numused: number, size: string };

export type QuoteNoteFragment = { __typename?: 'QuoteNote', id: number, dateCreated: string, dateModified: string, noteinfo: string, isEdited: boolean, canEdit: boolean, employee?: { __typename?: 'Employee', id: number, fullname: string, picture?: string | null, office?: { __typename?: 'Account', client: string } | null } | null };

export type QuoteChargeFragment = { __typename?: 'QuoteCharge', id: number, name: string, source: ChargeSource, discountrate: number, taxable: boolean, net: number, tax: number, total: number };

export type AccountChargeFragment = { __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, amount: number, taxable: boolean, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean };

export type QuoteAccountLookupFragment = { __typename?: 'Account', id: number, client: string, town: string, address1: string, address2: string, state: string, postal: string, zip: string, isJobHoldActive: boolean, industryType?: AccountIndustryType | null, discountrate: number, altHandling: string, country: { __typename?: 'Country', id: number, Country: string }, createdByOffice: { __typename?: 'Account', id: number, client: string }, accountCharges: Array<{ __typename?: 'AccountCharge', id: number, name: string, type: AccountChargeType, amount: number, taxable: boolean, charge_international: boolean, charge_domestic: boolean, charge_import: boolean, charge_euro: boolean, charge_shipdecpack: boolean, charge_interoffice: boolean, charge_citymetro: boolean, charge_packaging: boolean, delivery_dgi: boolean, delivery_overnight: boolean, delivery_road: boolean, delivery_sameday: boolean }> };

export type GeneratePericulumReportQueryVariables = Exact<{
  reportId: PericulumReportID;
  inputs?: InputMaybe<Scalars['JSONObject']>;
  format: PericulumReportFormat;
}>;


export type GeneratePericulumReportQuery = { __typename?: 'Query', generateReport: string };

export type AirlineQueryVariables = Exact<{
  airlineID: Scalars['Int'];
}>;


export type AirlineQuery = { __typename?: 'Query', airline: { __typename?: 'Airline', id: number, airlinecode: string, airlineid: string, airlinename: string, airlineweb: string, airlineadd1: string, airlineadd2: string, airlinephone: string, notes: string, dateCreated: string, dateModified: string } };

export type CreateAirlineMutationVariables = Exact<{
  inputs: CreateAirlineInputs;
}>;


export type CreateAirlineMutation = { __typename?: 'Mutation', createAirline: { __typename?: 'Airline', id: number, airlinename: string, airlinecode: string, airlineid: string } };

export type UpdateAirlineMutationVariables = Exact<{
  inputs: UpdateAirlineInputs;
}>;


export type UpdateAirlineMutation = { __typename?: 'Mutation', updateAirline: { __typename?: 'Airline', id: number, airlinename: string, airlinecode: string, airlineid: string } };

export type DeleteAirlineMutationVariables = Exact<{
  airlineId: Scalars['Int'];
}>;


export type DeleteAirlineMutation = { __typename?: 'Mutation', deleteAirline: { __typename?: 'Airline', id: number, airlinename: string, airlinecode: string, airlineid: string } };

export type ChargeOptionsQueryVariables = Exact<{
  filters?: InputMaybe<GetChargeOptionsFilters>;
}>;


export type ChargeOptionsQuery = { __typename?: 'Query', chargeOptions: Array<{ __typename?: 'ChargeOption', id: number, name: string, isActive: boolean }> };

export type DeleteChargeOptionMutationVariables = Exact<{
  deleteChargeOptionId: Scalars['Int'];
}>;


export type DeleteChargeOptionMutation = { __typename?: 'Mutation', deleteChargeOption: { __typename?: 'ChargeOption', id: number, name: string, isActive: boolean } };

export type SaveChargeOptionMutationVariables = Exact<{
  inputs: SaveChargeOptionInputs;
}>;


export type SaveChargeOptionMutation = { __typename?: 'Mutation', saveChargeOption: { __typename?: 'ChargeOption', id: number, name: string, isActive: boolean } };

export type UpdateGlobalConfigMutationVariables = Exact<{
  inputs: UpdateGlobalConfigInputs;
}>;


export type UpdateGlobalConfigMutation = { __typename?: 'Mutation', updateGlobalConfig: { __typename?: 'GlobalConfig', id: number, item: GlobalConfigItem, dataType: GlobalConfigDataType, label: string, value: string, dateCreated: string, dateModified: string } };

export type CostOfSalesQueryVariables = Exact<{
  filters?: InputMaybe<GetCostOfSalesFilters>;
}>;


export type CostOfSalesQuery = { __typename?: 'Query', costOfSalesCount: number, costOfSales: Array<{ __typename?: 'CostOfSale', id: number, job?: string | null, clientname: string, invoiceno: string, invoicedate: string, invoiceamt: number, taxcode: ChargeTaxCode, taxamt: number, purchasenumber: string, moneysymbol: string, locale: string, type: CostOfSaleType, description: string, dateCreated: string, dateModified: string, booking?: { __typename?: 'Booking', id: number, coyhawb: string } | null }> };

export type DeleteCostOfSaleMutationVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type DeleteCostOfSaleMutation = { __typename?: 'Mutation', deleteCostOfSale: { __typename?: 'CostOfSale', id: number } };

export type UploadCostOfSalesMutationVariables = Exact<{
  inputs: CostOfSalesUploadInputs;
}>;


export type UploadCostOfSalesMutation = { __typename?: 'Mutation', uploadCostOfSales: number };

export type CreateCountryMutationVariables = Exact<{
  inputs: CreateCountryInputs;
}>;


export type CreateCountryMutation = { __typename?: 'Mutation', createCountry: { __typename?: 'Country', id: number, Country: string, moneytype?: string | null, moneycode?: string | null, moneysymbol?: string | null, zone: number, timezone?: number | null, timeway?: string | null, taxtype: CountryTaxType, weighttype?: string | null, taxrate?: number | null, membercountry: boolean, officeid?: number | null, itemdesc?: string | null, daylight?: string | null, countrycode?: string | null, locale?: string | null, isActive: boolean, dateCreated: string, dateModified: string } };

export type UpdateCountryMutationVariables = Exact<{
  inputs: UpdateCountryInputs;
}>;


export type UpdateCountryMutation = { __typename?: 'Mutation', updateCountry: { __typename?: 'Country', id: number, Country: string, moneytype?: string | null, moneycode?: string | null, moneysymbol?: string | null, zone: number, timezone?: number | null, timeway?: string | null, taxtype: CountryTaxType, weighttype?: string | null, taxrate?: number | null, membercountry: boolean, officeid?: number | null, itemdesc?: string | null, daylight?: string | null, countrycode?: string | null, locale?: string | null, isActive: boolean, dateCreated: string, dateModified: string } };

export type EmployeeByIDQueryVariables = Exact<{
  employeeID: Scalars['Int'];
}>;


export type EmployeeByIDQuery = { __typename?: 'Query', employeeByID?: { __typename?: 'Employee', id: number, fullname: string, position?: string | null, isActive: boolean, dgnumber?: string | null, email?: any | null, picture?: string | null, isPericulumSetup: boolean, dateCreated: string, dateModified: string, office?: { __typename?: 'Account', id: number, client: string } | null, roles: Array<{ __typename?: 'Role', id: number, name: string, description: string }>, permissions: Array<{ __typename?: 'Permission', id: number, name: string, source: PermissionSource, sourceName?: string | null }> } | null };

export type CreateEmployeeMutationVariables = Exact<{
  inputs: CreateEmployeeInputs;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: number } };

export type UpdateEmployeeMutationVariables = Exact<{
  inputs: UpdateEmployeeInputs;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: number, fullname: string, position?: string | null, isActive: boolean, dgnumber?: string | null, email?: any | null, picture?: string | null, isPericulumSetup: boolean, dateCreated: string, dateModified: string, office?: { __typename?: 'Account', id: number, client: string } | null, roles: Array<{ __typename?: 'Role', id: number, name: string, description: string }> } };

export type AssignPermissionsMutationVariables = Exact<{
  inputs: AssignEmployeePermissionsInputs;
}>;


export type AssignPermissionsMutation = { __typename?: 'Mutation', assignPermissions: { __typename?: 'Employee', id: number, permissions: Array<{ __typename?: 'Permission', id: number, name: string, source: PermissionSource, sourceName?: string | null }> } };

export type MawbVouchersQueryVariables = Exact<{
  filters?: InputMaybe<GetMawbVoucherFilters>;
}>;


export type MawbVouchersQuery = { __typename?: 'Query', mawbVouchersCount: number, mawbVouchers: Array<{ __typename?: 'MawbVoucher', id: number, airlinecode: string, isUsed: boolean, dateCreated: string, dateModified: string, isConsolidated: boolean, isBorrowed: boolean, mawbNumber: number, airline: { __typename?: 'Airline', id: number, airlinename: string }, ownedByOffice: { __typename?: 'Account', id: number, client: string }, assignments?: Array<{ __typename?: 'AssignedMawbVoucher', id: number, booking: { __typename?: 'Booking', coyhawb: string } }> | null }> };

export type CreateMawbVouchersMutationVariables = Exact<{
  inputs: CreateMawbVouchersInputs;
}>;


export type CreateMawbVouchersMutation = { __typename?: 'Mutation', createMawbVouchers: number };

export type DeleteMawbVoucherMutationVariables = Exact<{
  deleteMawbVoucherId: Scalars['Int'];
}>;


export type DeleteMawbVoucherMutation = { __typename?: 'Mutation', deleteMawbVoucher: { __typename?: 'MawbVoucher', id: number } };

export type RegulationFragment = { __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string };

export type GlobalUnNumbersQueryVariables = Exact<{
  filters?: InputMaybe<GetUNNumbersFilters>;
}>;


export type GlobalUnNumbersQuery = { __typename?: 'Query', unNumbersCount: number, unNumbers: Array<{ __typename?: 'UNNumber', id: number, unno: string, extraname: string, propername: string, classdiv: string, subrisk: string, labelno: string, isAuthRequired: boolean, hazlabel: string, specialProvision: string, ergcode: string, isActive: boolean, dateCreated: string, dateModified: string, regulations: Array<{ __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string }> }> };

export type UnNumberQueryVariables = Exact<{
  ID: Scalars['Int'];
}>;


export type UnNumberQuery = { __typename?: 'Query', unNumber: { __typename?: 'UNNumber', id: number, unno: string, extraname: string, propername: string, classdiv: string, subrisk: string, labelno: string, isAuthRequired: boolean, hazlabel: string, specialProvision: string, ergcode: string, isActive: boolean, dateCreated: string, dateModified: string, regulations: Array<{ __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string }> } };

export type CreateUNNumberMutationVariables = Exact<{
  inputs: CreateUNNumberInputs;
}>;


export type CreateUNNumberMutation = { __typename?: 'Mutation', createUNNumber: { __typename?: 'UNNumber', id: number, unno: string, extraname: string, propername: string, classdiv: string, subrisk: string, labelno: string, isAuthRequired: boolean, hazlabel: string, specialProvision: string, ergcode: string, isActive: boolean, dateCreated: string, dateModified: string, regulations: Array<{ __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string }> } };

export type UpdateUNNumberMutationVariables = Exact<{
  inputs: UpdateUNNumberInputs;
}>;


export type UpdateUNNumberMutation = { __typename?: 'Mutation', updateUNNumber: { __typename?: 'UNNumber', id: number, unno: string, extraname: string, propername: string, classdiv: string, subrisk: string, labelno: string, isAuthRequired: boolean, hazlabel: string, specialProvision: string, ergcode: string, isActive: boolean, dateCreated: string, dateModified: string, regulations: Array<{ __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string }> } };

export type DeleteUNNumberMutationVariables = Exact<{
  ID: Scalars['Float'];
}>;


export type DeleteUNNumberMutation = { __typename?: 'Mutation', deleteUNNumber: { __typename?: 'UNNumber', id: number } };

export type CreateRegulationMutationVariables = Exact<{
  inputs: CreateRegulationInputs;
}>;


export type CreateRegulationMutation = { __typename?: 'Mutation', createRegulation: { __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string } };

export type UpdateRegulationMutationVariables = Exact<{
  inputs: UpdateRegulationInputs;
}>;


export type UpdateRegulationMutation = { __typename?: 'Mutation', updateRegulation: { __typename?: 'Regulation', id: number, unno: string, packinggrp: string, packintpass: string, packintcar: string, packintltd: string, packqtypass: string, packqtycar: string, packqtyltd: string } };

export type DeleteRegulationMutationVariables = Exact<{
  ID: Scalars['Float'];
}>;


export type DeleteRegulationMutation = { __typename?: 'Mutation', deleteRegulation: { __typename?: 'Regulation', id: number } };

export type CreatePackagingOptionMutationVariables = Exact<{
  inputs: CreatePackagingOptionInputs;
}>;


export type CreatePackagingOptionMutation = { __typename?: 'Mutation', createPackagingOption: { __typename?: 'PackagingOption', id: number, name: string, isActive: boolean, dateCreated: string, dateModified: string } };

export type UpdatePackagingOptionMutationVariables = Exact<{
  inputs: UpdatePackagingOptionInputs;
}>;


export type UpdatePackagingOptionMutation = { __typename?: 'Mutation', updatePackagingOption: { __typename?: 'PackagingOption', id: number, name: string, isActive: boolean, dateCreated: string, dateModified: string } };

export type DeletePackagingOptionMutationVariables = Exact<{
  PackagingOptionID: Scalars['Int'];
}>;


export type DeletePackagingOptionMutation = { __typename?: 'Mutation', deletePackagingOption: { __typename?: 'PackagingOption', id: number, name: string, isActive: boolean, dateCreated: string, dateModified: string } };

export type PortcodeAndAgentsQueryVariables = Exact<{
  portcodeID: Scalars['Int'];
}>;


export type PortcodeAndAgentsQuery = { __typename?: 'Query', portcodeByID: { __typename?: 'Portcode', id: number, portcode: string, cityname: string, state: string, extraShippingDays: number, isRemoteLocation: boolean, notes: string, isActive: boolean, country?: { __typename?: 'Country', id: number, Country: string } | null, agents: Array<{ __typename?: 'Account', id: number, client: string }> } };

export type DeletePortcodeMutationVariables = Exact<{
  portcodeID: Scalars['Int'];
}>;


export type DeletePortcodeMutation = { __typename?: 'Mutation', deletePortcode: { __typename?: 'Portcode', id: number, cityname: string, isActive: boolean, portcode: string, isRemoteLocation: boolean, extraShippingDays: number, state: string, country?: { __typename?: 'Country', Country: string, id: number } | null } };

export type CreatePortcodeMutationVariables = Exact<{
  inputs: CreatePortcodeInputs;
}>;


export type CreatePortcodeMutation = { __typename?: 'Mutation', createPortcode: { __typename?: 'Portcode', id: number, cityname: string, isActive: boolean, portcode: string, isRemoteLocation: boolean, extraShippingDays: number, state: string, notes: string, country?: { __typename?: 'Country', Country: string, id: number } | null } };

export type UpdatePortcodeMutationVariables = Exact<{
  inputs: UpdatePortcodeInputs;
}>;


export type UpdatePortcodeMutation = { __typename?: 'Mutation', updatePortcode: { __typename?: 'Portcode', id: number, cityname: string, isActive: boolean, portcode: string, isRemoteLocation: boolean, extraShippingDays: number, state: string, notes: string, country?: { __typename?: 'Country', Country: string, id: number } | null } };

export type TransitTimesAndCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TransitTimesAndCountriesQuery = { __typename?: 'Query', transitTimes: Array<{ __typename?: 'TransitTime', id: number, tozone: number, days: number, dateCreated: string, dateModified: string, countries: Array<{ __typename?: 'Country', id: number, Country: string }> }> };

export type UpdateTransitTimeMutationVariables = Exact<{
  inputs: UpdateTransitTimeInputs;
}>;


export type UpdateTransitTimeMutation = { __typename?: 'Mutation', updateTransitTime: { __typename?: 'TransitTime', id: number, tozone: number, days: number, dateCreated: string, dateModified: string } };

export type OfficeConfigurationFragment = { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxRate: number, taxType: OfficeTaxType, quotePrefix: string, bookingPrefix: string, slug: string, email: string, office: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string, moneysymbol?: string | null, taxrate?: number | null, locale?: string | null } }, region?: { __typename?: 'Region', id: number, name: string } | null };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Profile', employee: { __typename?: 'Employee', id: number, fullname: string, email?: any | null, dgnumber?: string | null, position?: string | null, picture?: string | null, isActive: boolean }, periculumOffice?: { __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxRate: number, taxType: OfficeTaxType, quotePrefix: string, bookingPrefix: string, slug: string, email: string, office: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string, moneysymbol?: string | null, taxrate?: number | null, locale?: string | null } }, region?: { __typename?: 'Region', id: number, name: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string, description: string }>, permissions: Array<{ __typename?: 'Permission', id: number, name: string, source: PermissionSource, sourceName?: string | null }> } };

export type UnreadEmailCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadEmailCountQuery = { __typename?: 'Query', unreadEmailCount: number };

export type GlobalOfficeConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalOfficeConfigurationsQuery = { __typename?: 'Query', officeConfigurations: Array<{ __typename?: 'OfficeConfiguration', id: number, currencyCode: string, currencyName: string, locale: string, timezone: string, taxRate: number, taxType: OfficeTaxType, quotePrefix: string, bookingPrefix: string, slug: string, email: string, office: { __typename?: 'Account', id: number, client: string, country: { __typename?: 'Country', id: number, Country: string, moneysymbol?: string | null, taxrate?: number | null, locale?: string | null } }, region?: { __typename?: 'Region', id: number, name: string } | null }> };

export type GlobalRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: number, name: string, dateCreated: string, dateModified: string }> };

export type GlobalCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: number, Country: string, moneytype?: string | null, moneycode?: string | null, moneysymbol?: string | null, zone: number, timezone?: number | null, timeway?: string | null, taxtype: CountryTaxType, weighttype?: string | null, taxrate?: number | null, membercountry: boolean, officeid?: number | null, itemdesc?: string | null, daylight?: string | null, countrycode?: string | null, locale?: string | null, isActive: boolean, dateCreated: string, dateModified: string }> };

export type LocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalesQuery = { __typename?: 'Query', locales: Array<string> };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'CurrencyOption', code: string, name: string }> };

export type TimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezonesQuery = { __typename?: 'Query', timezones: Array<string> };

export type BookingTypeConfigQueryVariables = Exact<{
  bookingtype: BookingType;
}>;


export type BookingTypeConfigQuery = { __typename?: 'Query', bookingTypeConfiguration: { __typename?: 'BookingTypeConfiguration', id: number, bookingtype: BookingType, chargefreightcost: boolean, tariffmultiplier: number, chargetax: boolean } };

export type GlobalEmployeeFieldsFragment = { __typename?: 'Employee', id: number, fullname: string, position?: string | null, picture?: string | null, dgnumber?: string | null, email?: any | null, isActive: boolean, isPericulumSetup: boolean, authSubject?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null };

export type GlobalEmployeesQueryVariables = Exact<{
  filters?: InputMaybe<GetEmployeesFilters>;
}>;


export type GlobalEmployeesQuery = { __typename?: 'Query', employeesCount: number, employees: Array<{ __typename?: 'Employee', id: number, fullname: string, position?: string | null, picture?: string | null, dgnumber?: string | null, email?: any | null, isActive: boolean, isPericulumSetup: boolean, authSubject?: string | null, office?: { __typename?: 'Account', id: number, client: string } | null }> };

export type GlobalPortcodeFragment = { __typename?: 'Portcode', id: number, cityname: string, isActive: boolean, portcode: string, isRemoteLocation: boolean, extraShippingDays: number, state: string, notes: string, country?: { __typename?: 'Country', Country: string, id: number } | null };

export type GlobalPortcodesQueryVariables = Exact<{
  filters?: InputMaybe<GetPortcodesFilters>;
}>;


export type GlobalPortcodesQuery = { __typename?: 'Query', portcodes: Array<{ __typename?: 'Portcode', id: number, cityname: string, isActive: boolean, portcode: string, isRemoteLocation: boolean, extraShippingDays: number, state: string, notes: string, country?: { __typename?: 'Country', Country: string, id: number } | null }> };

export type GlobalAccountFieldsFragment = { __typename?: 'Account', id: number, client: string, isActive: boolean, town: string, countryid: number, defaultInvoicePartyID: number, isAgent: boolean, isPreferredAgent: boolean, address1: string, address2: string, state: string, zip: string, isJobHoldActive: boolean, openPurchaseOrder?: string | null };

export type GlobalAirlinesQueryVariables = Exact<{
  filters?: InputMaybe<FilterAirlinesInputs>;
}>;


export type GlobalAirlinesQuery = { __typename?: 'Query', airlines: Array<{ __typename?: 'Airline', id: number, airlinename: string, airlinecode: string, airlineid: string, airlineweb: string }> };

export type GlobalPackagingOptionsQueryVariables = Exact<{
  filters?: InputMaybe<GetPackagingOptionsFilters>;
}>;


export type GlobalPackagingOptionsQuery = { __typename?: 'Query', packagingOptionsCount: number, packagingOptions: Array<{ __typename?: 'PackagingOption', id: number, name: string, isActive: boolean, dateCreated: string, dateModified: string }> };

export type GlobalConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalConfigQuery = { __typename?: 'Query', globalConfig: Array<{ __typename?: 'GlobalConfig', id: number, item: GlobalConfigItem, description: string, dataType: GlobalConfigDataType, label: string, value: string, dateCreated: string, dateModified: string }> };

export type RecentlyUpdatedAccountsQueryVariables = Exact<{
  since: Scalars['DateTime'];
}>;


export type RecentlyUpdatedAccountsQuery = { __typename?: 'Query', recentlyUpdatedAccounts: Array<{ __typename?: 'Account', dateDeleted?: string | null, id: number, client: string, isActive: boolean, town: string, countryid: number, defaultInvoicePartyID: number, isAgent: boolean, isPreferredAgent: boolean, address1: string, address2: string, state: string, zip: string, isJobHoldActive: boolean, openPurchaseOrder?: string | null }> };

export const AddressSuggestionFieldsFragmentDoc = gql`
    fragment AddressSuggestionFields on AddressSuggestion {
  PlaceId
  Text
}
    `;
export const PlaceFieldsFragmentDoc = gql`
    fragment PlaceFields on Query {
  place(placeID: $placeId) {
    PlaceId
    Label
    Geometry {
      Point
    }
    AddressNumber
    Street
    Neighborhood
    Municipality
    SubRegion
    Region
    Country
    PostalCode
    Interpolated
    TimeZone {
      Name
      Offset
    }
    UnitType
    UnitNumber
  }
}
    `;
export const RelatedAccountFieldsFragmentDoc = gql`
    fragment RelatedAccountFields on RelatedAccount {
  id
  notes
  relatedAccount {
    id
    client
  }
}
    `;
export const AccountNoteFieldsFragmentDoc = gql`
    fragment AccountNoteFields on AccountNote {
  id
  noteinfo
  employee {
    id
    fullname
    picture
    office {
      id
      client
    }
  }
  isEdited
  dateCreated
  dateModified
}
    `;
export const AccountChargeFieldsFragmentDoc = gql`
    fragment AccountChargeFields on AccountCharge {
  id
  name
  type
  taxable
  amount
  charge_international
  charge_domestic
  charge_import
  charge_euro
  charge_shipdecpack
  charge_interoffice
  charge_citymetro
  charge_packaging
  delivery_dgi
  delivery_overnight
  delivery_road
  delivery_sameday
}
    `;
export const UploadedDocumentFieldsFragmentDoc = gql`
    fragment UploadedDocumentFields on UploadedDocument {
  id
  name
  storageKey
  mime
  filesize
  extention
  employee {
    id
    fullname
    picture
    office {
      id
      client
    }
  }
  dateCreated
}
    `;
export const ActivityLogFieldsFragmentDoc = gql`
    fragment ActivityLogFields on ActivityLog {
  id
  eventid
  description
  dateCreated
  metadata
  employee {
    id
    fullname
    picture
    office {
      id
      client
    }
  }
  description
  office {
    id
    client
  }
  booking {
    id
    coyhawb
  }
}
    `;
export const EditAccountFieldsFragmentDoc = gql`
    fragment EditAccountFields on Account {
  id
  client
  address1
  address2
  town
  state
  postal
  zip
  countryid
  country {
    id
    Country
    countrycode
  }
  phone
  fax
  web
  email
  isSupplier
  isAgent
  isPreferredAgent
  dgioffice
  discountrate
  officeid
  altHandling
  isActive
  industryType
  isJobHoldActive
  repregion
  isRegisteredForTax
  eawbemail
  finemail
  defaultInvoicePartyID
  relatedAccounts {
    ...RelatedAccountFields
  }
  buscode
  busnumber
  officeConfiguration {
    id
    office {
      id
      client
    }
    locale
    currencyCode
  }
  notes {
    ...AccountNoteFields
  }
  accountCharges {
    ...AccountChargeFields
  }
  uploadedDocuments {
    ...UploadedDocumentFields
  }
  dateCreated
  dateModified
  createdByOffice {
    id
    client
  }
  recentActivity {
    ...ActivityLogFields
  }
  openPurchaseOrder
}
    ${RelatedAccountFieldsFragmentDoc}
${AccountNoteFieldsFragmentDoc}
${AccountChargeFieldsFragmentDoc}
${UploadedDocumentFieldsFragmentDoc}
${ActivityLogFieldsFragmentDoc}`;
export const JobFragmentDoc = gql`
    fragment Job on Job {
  id
  name
  isRunning
  schedule
  disabled
  nextRunAt
  failReason
  failCount
  failedAt
}
    `;
export const EmployeeAvatarFragmentDoc = gql`
    fragment EmployeeAvatar on Employee {
  id
  picture
  fullname
}
    `;
export const SchedulerJobHistoryFragmentDoc = gql`
    fragment SchedulerJobHistory on SchedulerJobHistory {
  id
  jobName
  jobID
  durationMS
  failReason
  type
  results
  dateStarted
  dateFinished
  employee {
    ...EmployeeAvatar
  }
  dateCreated
}
    ${EmployeeAvatarFragmentDoc}`;
export const OfficeConfigurationFragmentFragmentDoc = gql`
    fragment OfficeConfigurationFragment on OfficeConfiguration {
  id
  currencyCode
  currencyName
  locale
  timezone
  taxType
  taxRate
  office {
    id
    client
    address1
    address2
    isAgent
    buscode
    busnumber
    country {
      id
      Country
      countrycode
      daylight
      itemdesc
      locale
      membercountry
      moneycode
      moneysymbol
      moneytype
      dateCreated
      dateModified
    }
  }
  region {
    id
    name
    dateCreated
    dateModified
  }
  paymentTermDays
  iataCode
  ibanNumber
  bankname
  bankcode
  bankaccount
  legalname
  email
  quotePrefix
  bookingPrefix
  slug
  domestic
  international
  import
  shippersDec
  europe
  interOffice
  cityMetro
  invoicemsg
  dateCreated
  dateModified
}
    `;
export const RoleFragmentFragmentDoc = gql`
    fragment RoleFragment on Role {
  id
  name
  description
  scopes {
    id
    action
  }
  assignedEmployees {
    id
    fullname
  }
  dateModified
  dateCreated
}
    `;
export const standardChargeFragmentDoc = gql`
    fragment standardCharge on Query {
  standardCharges {
    id
    name
    description
    type
    dateCreated
    dateModified
  }
}
    `;
export const SearchQuoteFieldsFragmentDoc = gql`
    fragment SearchQuoteFields on Quote {
  id
  quoteid
  activity
  clientnamenew
  total
  bookingtype
  itemdesc
  origcode
  destcode
  tariffZone
  tariffMinWeight
  tariffMinWeightKG
  tariffPerKG
  formattedTotal
  dateCreated
  client {
    id
    client
  }
  office {
    id
    client
  }
  contactName
  contactEmail
  contactPhone
}
    `;
export const PotentialBookingFieldsFragmentDoc = gql`
    fragment PotentialBookingFields on Booking {
  coyhawb
  consigadd1
  consigadd2
  consigtown
  consigemail
  consigzip
  consigfax
  persrep
  persrepphone
  agenthawb
  costcode
  specinst
  name
  email
  phone
  consigstate
  consigneeCountry {
    id
  }
  client {
    id
    client
    address1
    address2
    town
    countryid
    zip
    email
    fax
  }
  consignee {
    id
    client
  }
  bookingtype
  tariffZone
  jobdate
  origcode
  destcode
  shippersref
  status
  invoiceParty {
    id
  }
  bookingOffice {
    id
  }
  tariffZone
  tariffMinWeight
  tariffMinWeightKG
  tariffPerKG
  employee {
    id
    fullname
    email
    office {
      id
      phone
    }
  }
}
    `;
export const BookingNoteFieldsFragmentDoc = gql`
    fragment BookingNoteFields on BookingNote {
  id
  noteinfo
  employee {
    id
    fullname
    picture
    office {
      id
      client
    }
  }
  subject
  isSent
  isPrivate
  isEdited
  dateCreated
  dateModified
}
    `;
export const ShipmentFragmentFragmentDoc = gql`
    fragment ShipmentFragment on Shipment {
  id
  pieces
  weight
  volume
  unno
  unclass
  unpg
  description
  package
  packinginst
  aircraftType
  hazardous
  subsidiary
  objlength
  objwidth
  objheight
  packageqty
  packageamt
  dimweightfactor
  commodityChapterId
}
    `;
export const BookingPickupFragmentFragmentDoc = gql`
    fragment BookingPickupFragment on BookingPickup {
  id
  isPickupArranged
  pickupdate
  pickupjustification
  collectionAddress
  collectionMethod
  arrangedByEmployee {
    id
    fullname
    picture
  }
  isDGDCompleted
  aircraftType
  radioactive
  isBooked
  dgInspectionComplete
  dgInspectionJustification
}
    `;
export const BookingArrivalFragmentFragmentDoc = gql`
    fragment BookingArrivalFragment on BookingArrival {
  id
  isComplete
  agent {
    id
    client
  }
  dateReceived
  isDgdRaised
  isRepacked
  includesDryIce
  dgdRaisedBy {
    id
    fullname
    picture
  }
  dryicekg
}
    `;
export const BookingPackagingFragmentFragmentDoc = gql`
    fragment BookingPackagingFragment on BookingPackaging {
  id
  name
  numused
  size
  cost
}
    `;
export const BookingTransportFragmentFragmentDoc = gql`
    fragment BookingTransportFragment on BookingTransport {
  id
  mawb
  connote
  delivery
  agentcob
  agent {
    id
    client
  }
  flightarrival
  isConsolidated
  coymanifest
  isPrealertSent
  prealertSentDate
  shiparrived
  postfab
  postdate
  isComplete
  incotermId
}
    `;
export const BookingFlightFragmentFragmentDoc = gql`
    fragment BookingFlightFragment on BookingFlight {
  id
  journeynum
  airlineIataCode
  airlinecode
  airlineName
  flightnum
  dest
}
    `;
export const BookingDeliveryFragmentFragmentDoc = gql`
    fragment BookingDeliveryFragment on BookingDelivery {
  id
  poddate
  podname
  emailsent
  emailsentDate
  podsig
  dateCreated
}
    `;
export const EditBookingFieldsFragmentDoc = gql`
    fragment EditBookingFields on Booking {
  id
  coyhawb
  bookingtype
  categoryType
  quote {
    id
    quoteid
  }
  bookingTypeConfiguration {
    id
    requiredSteps
    bookingtype
    chargefreightcost
    tariffmultiplier
    chargetax
  }
  bookingOffice {
    id
    client
    officeConfiguration {
      id
    }
  }
  step
  status
  jobdate
  client {
    id
    client
    defaultCollectionAddress
    contacts {
      id
      name
      email
    }
  }
  consignee {
    id
    client
    contacts {
      id
      name
      email
    }
  }
  invoiceParty {
    id
    client
  }
  name
  consigadd1
  consigadd2
  email
  consigtown
  consigstate
  phone
  consigzip
  shippersref
  country {
    id
    Country
  }
  agenthawb
  persrep
  persrepphone
  origcode
  origin {
    id
    cityname
  }
  destcode
  destination {
    id
    cityname
  }
  consigfax
  specinst
  consigemail
  costcode
  tariffZone
  tariffMinWeight
  tariffMinWeightKG
  tariffPerKG
  notes {
    ...BookingNoteFields
  }
  shipments {
    ...ShipmentFragment
  }
  bookingPickup {
    ...BookingPickupFragment
  }
  bookingArrival {
    ...BookingArrivalFragment
  }
  packaging {
    ...BookingPackagingFragment
  }
  bookingTransport {
    ...BookingTransportFragment
  }
  flights {
    ...BookingFlightFragment
  }
  uploadedDocuments {
    ...UploadedDocumentFields
  }
  bookingDelivery {
    ...BookingDeliveryFragment
  }
  notes {
    ...BookingNoteFields
  }
  bookingTimeline {
    date
    event
  }
}
    ${BookingNoteFieldsFragmentDoc}
${ShipmentFragmentFragmentDoc}
${BookingPickupFragmentFragmentDoc}
${BookingArrivalFragmentFragmentDoc}
${BookingPackagingFragmentFragmentDoc}
${BookingTransportFragmentFragmentDoc}
${BookingFlightFragmentFragmentDoc}
${UploadedDocumentFieldsFragmentDoc}
${BookingDeliveryFragmentFragmentDoc}`;
export const BookingChargeFragmentDoc = gql`
    fragment BookingCharge on BookingCharge {
  id
  name
  source
  discountrate
  net
  tax
  taxable
  total
}
    `;
export const CostOfSaleFragmentDoc = gql`
    fragment CostOfSale on CostOfSale {
  id
  job
  clientname
  invoiceno
  invoicedate
  invoiceamt
  taxcode
  taxamt
  purchasenumber
  moneysymbol
  locale
  type
  description
  dateModified
}
    `;
export const ViewBookingFieldsFragmentDoc = gql`
    fragment ViewBookingFields on Booking {
  id
  coyhawb
  bookingtype
  step
  status
  invoicesentdate
  invoicedate
  categoryType
  bookingTypeConfiguration {
    id
    bookingtype
    chargefreightcost
    tariffmultiplier
    chargetax
    requiredSteps
  }
  bookingTimeline {
    event
    date
  }
  bookingOffice {
    id
    client
    finemail
    officeConfiguration {
      id
      locale
      currencyCode
      timezone
      taxRate
      taxType
      email
    }
  }
  jobdate
  client {
    id
    client
    discountrate
    contacts {
      id
      name
      email
    }
  }
  consignee {
    id
    client
    contacts {
      id
      name
      email
    }
  }
  invoiceParty {
    id
    client
    finemail
  }
  name
  consigadd1
  consigadd2
  email
  consigtown
  consigstate
  phone
  consigzip
  shippersref
  country {
    id
    Country
  }
  agenthawb
  persrep
  persrepphone
  origcode
  origin {
    id
    cityname
  }
  destcode
  destination {
    id
    cityname
  }
  consigfax
  specinst
  consigemail
  costcode
  tariffZone
  tariffMinWeight
  tariffMinWeightKG
  tariffPerKG
  notes {
    ...BookingNoteFields
  }
  bookingPickup {
    ...BookingPickupFragment
  }
  bookingArrival {
    ...BookingArrivalFragment
  }
  packaging {
    id
    name
    numused
    size
    cost
  }
  bookingTransport {
    id
    mawb
    connote
    delivery
    agentcob
    agent {
      id
      client
    }
    flightarrival
    isConsolidated
    coymanifest
    isPrealertSent
    shiparrived
    postdate
    postfab
    incotermId
  }
  flights {
    ...BookingFlightFragment
  }
  bookingDelivery {
    id
    poddate
    podname
    podsig
    emailsent
  }
  shipments {
    id
    description
    hazardous
    objheight
    objlength
    objwidth
    package
    packageamt
    packageqty
    packinginst
    pieces
    subsidiary
    unclass
    unno
    weight
    volume
    dimweightfactor
    unpg
    aircraftType
    commodityChapterId
  }
  uploadedDocuments {
    ...UploadedDocumentFields
  }
  recentActivity {
    ...ActivityLogFields
  }
}
    ${BookingNoteFieldsFragmentDoc}
${BookingPickupFragmentFragmentDoc}
${BookingArrivalFragmentFragmentDoc}
${BookingFlightFragmentFragmentDoc}
${UploadedDocumentFieldsFragmentDoc}
${ActivityLogFieldsFragmentDoc}`;
export const officeChargeFragmentFragmentDoc = gql`
    fragment officeChargeFragment on OfficeCharge {
  charge {
    id
    name
    type
    description
    dateCreated
    dateModified
  }
}
    `;
export const OfficeChargeFieldsFragmentDoc = gql`
    fragment OfficeChargeFields on OfficeCharge {
  id
  type
  customChargeName
  bookingTypes
  deliveryTypes
  amount
  taxable
  office {
    client
    id
  }
  ...officeChargeFragment
  dateCreated
  dateModified
}
    ${officeChargeFragmentFragmentDoc}`;
export const JobTariffFragmentDoc = gql`
    fragment JobTariff on JobTariff {
  id
  zone
  isActive
  minweight
  minweightkg
  dateCreated
  dateModified
  category
  perkg
  region {
    id
    name
  }
  officeAccount {
    id
    client
    country {
      id
      locale
      moneysymbol
    }
  }
}
    `;
export const QuoteNoteFragmentDoc = gql`
    fragment QuoteNote on QuoteNote {
  id
  dateCreated
  dateModified
  noteinfo
  isEdited
  canEdit
  employee {
    id
    fullname
    picture
    office {
      client
    }
  }
  dateCreated
  dateModified
}
    `;
export const QuotePackagingFragmentDoc = gql`
    fragment QuotePackaging on QuotePackaging {
  id
  name
  cost
  numused
  size
}
    `;
export const QuoteChargeFragmentDoc = gql`
    fragment QuoteCharge on QuoteCharge {
  id
  name
  source
  discountrate
  taxable
  net
  tax
  total
}
    `;
export const ViewQuoteFieldsFragmentDoc = gql`
    fragment ViewQuoteFields on Quote {
  id
  employee {
    id
    picture
    fullname
    position
  }
  quoteid
  client {
    id
    client
    country {
      id
      Country
    }
  }
  clientnamenew
  contactName
  contactEmail
  contactPhone
  bookingtype
  origcode
  destcode
  deliveryType
  itemdesc
  tariffZone
  tariffMinWeightKG
  tariffMinWeight
  tariffPerKG
  itemweight
  dgdraised
  repacked
  dryiceused
  dryiceamt
  activity
  isQuoteSent
  quoteSentDate
  returnclienttype
  leadorigin
  booking {
    id
    coyhawb
  }
  office {
    id
    client
    phone
    country {
      id
      taxrate
    }
    officeConfiguration {
      id
      locale
      timezone
      currencyCode
      currencyName
      email
      region {
        id
        name
      }
    }
  }
  quoteNotes {
    ...QuoteNote
  }
  quotePackaging {
    ...QuotePackaging
  }
  quoteCharges {
    ...QuoteCharge
  }
  dateCreated
  dateModified
}
    ${QuoteNoteFragmentDoc}
${QuotePackagingFragmentDoc}
${QuoteChargeFragmentDoc}`;
export const AccountChargeFragmentDoc = gql`
    fragment AccountCharge on AccountCharge {
  id
  name
  type
  amount
  taxable
  charge_international
  charge_domestic
  charge_import
  charge_euro
  charge_shipdecpack
  charge_interoffice
  charge_citymetro
  charge_packaging
  delivery_dgi
  delivery_overnight
  delivery_road
  delivery_sameday
}
    `;
export const QuoteAccountLookupFragmentDoc = gql`
    fragment QuoteAccountLookup on Account {
  id
  client
  town
  address1
  address2
  state
  postal
  zip
  country {
    id
    Country
  }
  isJobHoldActive
  industryType
  discountrate
  altHandling
  createdByOffice {
    id
    client
  }
  accountCharges {
    ...AccountCharge
  }
}
    ${AccountChargeFragmentDoc}`;
export const RegulationFragmentDoc = gql`
    fragment Regulation on Regulation {
  id
  unno
  packinggrp
  packintpass
  packintcar
  packintltd
  packqtypass
  packqtycar
  packqtyltd
}
    `;
export const OfficeConfigurationFragmentDoc = gql`
    fragment OfficeConfiguration on OfficeConfiguration {
  id
  currencyCode
  currencyName
  locale
  timezone
  taxRate
  taxType
  office {
    id
    client
    country {
      id
      Country
      moneysymbol
      taxrate
      locale
    }
  }
  region {
    id
    name
  }
  quotePrefix
  bookingPrefix
  slug
  email
}
    `;
export const GlobalEmployeeFieldsFragmentDoc = gql`
    fragment GlobalEmployeeFields on Employee {
  id
  fullname
  position
  picture
  dgnumber
  email
  isActive
  isPericulumSetup
  authSubject
  office {
    id
    client
  }
}
    `;
export const GlobalPortcodeFragmentDoc = gql`
    fragment GlobalPortcode on Portcode {
  id
  cityname
  country {
    Country
    id
  }
  isActive
  portcode
  isRemoteLocation
  extraShippingDays
  state
  notes
}
    `;
export const GlobalAccountFieldsFragmentDoc = gql`
    fragment GlobalAccountFields on Account {
  id
  client
  isActive
  town
  countryid
  defaultInvoicePartyID
  isAgent
  isPreferredAgent
  address1
  address2
  state
  zip
  countryid
  isJobHoldActive
  openPurchaseOrder
}
    `;
export const AccountByIDDocument = gql`
    query AccountByID($accountID: Int!) {
  accountByID(id: $accountID) {
    ...GlobalAccountFields
  }
}
    ${GlobalAccountFieldsFragmentDoc}`;

/**
 * __useAccountByIDQuery__
 *
 * To run a query within a React component, call `useAccountByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountByIDQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useAccountByIDQuery(baseOptions: Apollo.QueryHookOptions<AccountByIDQuery, AccountByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountByIDQuery, AccountByIDQueryVariables>(AccountByIDDocument, options);
      }
export function useAccountByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountByIDQuery, AccountByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountByIDQuery, AccountByIDQueryVariables>(AccountByIDDocument, options);
        }
export type AccountByIDQueryHookResult = ReturnType<typeof useAccountByIDQuery>;
export type AccountByIDLazyQueryHookResult = ReturnType<typeof useAccountByIDLazyQuery>;
export type AccountByIDQueryResult = Apollo.QueryResult<AccountByIDQuery, AccountByIDQueryVariables>;
export const AddressSuggestionsDocument = gql`
    query AddressSuggestions($partialAddress: String!, $biasAccountId: Float, $countryCodes: [String!]) {
  addressSuggestions(
    partialAddress: $partialAddress
    biasAccountID: $biasAccountId
    countryCodes: $countryCodes
  ) {
    ...AddressSuggestionFields
  }
}
    ${AddressSuggestionFieldsFragmentDoc}`;

/**
 * __useAddressSuggestionsQuery__
 *
 * To run a query within a React component, call `useAddressSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressSuggestionsQuery({
 *   variables: {
 *      partialAddress: // value for 'partialAddress'
 *      biasAccountId: // value for 'biasAccountId'
 *      countryCodes: // value for 'countryCodes'
 *   },
 * });
 */
export function useAddressSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>(AddressSuggestionsDocument, options);
      }
export function useAddressSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>(AddressSuggestionsDocument, options);
        }
export type AddressSuggestionsQueryHookResult = ReturnType<typeof useAddressSuggestionsQuery>;
export type AddressSuggestionsLazyQueryHookResult = ReturnType<typeof useAddressSuggestionsLazyQuery>;
export type AddressSuggestionsQueryResult = Apollo.QueryResult<AddressSuggestionsQuery, AddressSuggestionsQueryVariables>;
export const PlaceDocument = gql`
    query Place($placeId: String!) {
  ...PlaceFields
}
    ${PlaceFieldsFragmentDoc}`;

/**
 * __usePlaceQuery__
 *
 * To run a query within a React component, call `usePlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function usePlaceQuery(baseOptions: Apollo.QueryHookOptions<PlaceQuery, PlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaceQuery, PlaceQueryVariables>(PlaceDocument, options);
      }
export function usePlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaceQuery, PlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaceQuery, PlaceQueryVariables>(PlaceDocument, options);
        }
export type PlaceQueryHookResult = ReturnType<typeof usePlaceQuery>;
export type PlaceLazyQueryHookResult = ReturnType<typeof usePlaceLazyQuery>;
export type PlaceQueryResult = Apollo.QueryResult<PlaceQuery, PlaceQueryVariables>;
export const MergeAccountCheckDocument = gql`
    query MergeAccountCheck($accountId: Int!) {
  mergeAccountCheck(accountID: $accountId) {
    quotes
    jobs
    contacts
    uploads
    accountCharges
    notes
  }
}
    `;

/**
 * __useMergeAccountCheckQuery__
 *
 * To run a query within a React component, call `useMergeAccountCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeAccountCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeAccountCheckQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useMergeAccountCheckQuery(baseOptions: Apollo.QueryHookOptions<MergeAccountCheckQuery, MergeAccountCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeAccountCheckQuery, MergeAccountCheckQueryVariables>(MergeAccountCheckDocument, options);
      }
export function useMergeAccountCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeAccountCheckQuery, MergeAccountCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeAccountCheckQuery, MergeAccountCheckQueryVariables>(MergeAccountCheckDocument, options);
        }
export type MergeAccountCheckQueryHookResult = ReturnType<typeof useMergeAccountCheckQuery>;
export type MergeAccountCheckLazyQueryHookResult = ReturnType<typeof useMergeAccountCheckLazyQuery>;
export type MergeAccountCheckQueryResult = Apollo.QueryResult<MergeAccountCheckQuery, MergeAccountCheckQueryVariables>;
export const MergeAccountDocument = gql`
    mutation MergeAccount($inputs: MergeAccountInputs!) {
  mergeAccount(inputs: $inputs) {
    ...GlobalAccountFields
  }
}
    ${GlobalAccountFieldsFragmentDoc}`;
export type MergeAccountMutationFn = Apollo.MutationFunction<MergeAccountMutation, MergeAccountMutationVariables>;

/**
 * __useMergeAccountMutation__
 *
 * To run a mutation, you first call `useMergeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAccountMutation, { data, loading, error }] = useMergeAccountMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useMergeAccountMutation(baseOptions?: Apollo.MutationHookOptions<MergeAccountMutation, MergeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeAccountMutation, MergeAccountMutationVariables>(MergeAccountDocument, options);
      }
export type MergeAccountMutationHookResult = ReturnType<typeof useMergeAccountMutation>;
export type MergeAccountMutationResult = Apollo.MutationResult<MergeAccountMutation>;
export type MergeAccountMutationOptions = Apollo.BaseMutationOptions<MergeAccountMutation, MergeAccountMutationVariables>;
export const AccountActivityDocument = gql`
    query AccountActivity($inputs: FilterActivityLogs) {
  activityLogsCount(inputs: $inputs)
  activityLogs(inputs: $inputs) {
    ...ActivityLogFields
  }
}
    ${ActivityLogFieldsFragmentDoc}`;

/**
 * __useAccountActivityQuery__
 *
 * To run a query within a React component, call `useAccountActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountActivityQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAccountActivityQuery(baseOptions?: Apollo.QueryHookOptions<AccountActivityQuery, AccountActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountActivityQuery, AccountActivityQueryVariables>(AccountActivityDocument, options);
      }
export function useAccountActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountActivityQuery, AccountActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountActivityQuery, AccountActivityQueryVariables>(AccountActivityDocument, options);
        }
export type AccountActivityQueryHookResult = ReturnType<typeof useAccountActivityQuery>;
export type AccountActivityLazyQueryHookResult = ReturnType<typeof useAccountActivityLazyQuery>;
export type AccountActivityQueryResult = Apollo.QueryResult<AccountActivityQuery, AccountActivityQueryVariables>;
export const SaveAccountChargeDocument = gql`
    mutation SaveAccountCharge($inputs: SaveAccountChargeInputs!) {
  saveAccountCharge(inputs: $inputs) {
    ...AccountChargeFields
  }
}
    ${AccountChargeFieldsFragmentDoc}`;
export type SaveAccountChargeMutationFn = Apollo.MutationFunction<SaveAccountChargeMutation, SaveAccountChargeMutationVariables>;

/**
 * __useSaveAccountChargeMutation__
 *
 * To run a mutation, you first call `useSaveAccountChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccountChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccountChargeMutation, { data, loading, error }] = useSaveAccountChargeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveAccountChargeMutation(baseOptions?: Apollo.MutationHookOptions<SaveAccountChargeMutation, SaveAccountChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAccountChargeMutation, SaveAccountChargeMutationVariables>(SaveAccountChargeDocument, options);
      }
export type SaveAccountChargeMutationHookResult = ReturnType<typeof useSaveAccountChargeMutation>;
export type SaveAccountChargeMutationResult = Apollo.MutationResult<SaveAccountChargeMutation>;
export type SaveAccountChargeMutationOptions = Apollo.BaseMutationOptions<SaveAccountChargeMutation, SaveAccountChargeMutationVariables>;
export const DeleteAccountChargeDocument = gql`
    mutation DeleteAccountCharge($id: Int!) {
  deleteAccountCharge(id: $id) {
    id
  }
}
    `;
export type DeleteAccountChargeMutationFn = Apollo.MutationFunction<DeleteAccountChargeMutation, DeleteAccountChargeMutationVariables>;

/**
 * __useDeleteAccountChargeMutation__
 *
 * To run a mutation, you first call `useDeleteAccountChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountChargeMutation, { data, loading, error }] = useDeleteAccountChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountChargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountChargeMutation, DeleteAccountChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountChargeMutation, DeleteAccountChargeMutationVariables>(DeleteAccountChargeDocument, options);
      }
export type DeleteAccountChargeMutationHookResult = ReturnType<typeof useDeleteAccountChargeMutation>;
export type DeleteAccountChargeMutationResult = Apollo.MutationResult<DeleteAccountChargeMutation>;
export type DeleteAccountChargeMutationOptions = Apollo.BaseMutationOptions<DeleteAccountChargeMutation, DeleteAccountChargeMutationVariables>;
export const SearchAccountsDocument = gql`
    query SearchAccounts($filters: SearchAccountsFilters!) {
  searchAccounts(filters: $filters) {
    count
    query
    total
    records {
      id
      client
      address1
      town
      country {
        id
        Country
      }
      industryType
      createdByOffice {
        id
        client
      }
      isActive
      isAgent
      isPreferredAgent
      isSupplier
      dgioffice
      lastAccessed
    }
  }
}
    `;

/**
 * __useSearchAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchAccountsQuery(baseOptions: Apollo.QueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(SearchAccountsDocument, options);
      }
export function useSearchAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(SearchAccountsDocument, options);
        }
export type SearchAccountsQueryHookResult = ReturnType<typeof useSearchAccountsQuery>;
export type SearchAccountsLazyQueryHookResult = ReturnType<typeof useSearchAccountsLazyQuery>;
export type SearchAccountsQueryResult = Apollo.QueryResult<SearchAccountsQuery, SearchAccountsQueryVariables>;
export const EditAccountScreenDocument = gql`
    query EditAccountScreen($accountID: Int!, $contactsFilter: GetAccountContactsFilter!) {
  accountByID(id: $accountID) {
    ...EditAccountFields
  }
  accountContacts(filters: $contactsFilter) {
    id
    name
    email
  }
}
    ${EditAccountFieldsFragmentDoc}`;

/**
 * __useEditAccountScreenQuery__
 *
 * To run a query within a React component, call `useEditAccountScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAccountScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAccountScreenQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *      contactsFilter: // value for 'contactsFilter'
 *   },
 * });
 */
export function useEditAccountScreenQuery(baseOptions: Apollo.QueryHookOptions<EditAccountScreenQuery, EditAccountScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditAccountScreenQuery, EditAccountScreenQueryVariables>(EditAccountScreenDocument, options);
      }
export function useEditAccountScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditAccountScreenQuery, EditAccountScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditAccountScreenQuery, EditAccountScreenQueryVariables>(EditAccountScreenDocument, options);
        }
export type EditAccountScreenQueryHookResult = ReturnType<typeof useEditAccountScreenQuery>;
export type EditAccountScreenLazyQueryHookResult = ReturnType<typeof useEditAccountScreenLazyQuery>;
export type EditAccountScreenQueryResult = Apollo.QueryResult<EditAccountScreenQuery, EditAccountScreenQueryVariables>;
export const AddRelatedAccountDocument = gql`
    mutation AddRelatedAccount($inputs: AddRelatedAccountInputs!) {
  addRelatedAccount(inputs: $inputs) {
    id
    notes
    relatedAccount {
      id
      client
    }
  }
}
    `;
export type AddRelatedAccountMutationFn = Apollo.MutationFunction<AddRelatedAccountMutation, AddRelatedAccountMutationVariables>;

/**
 * __useAddRelatedAccountMutation__
 *
 * To run a mutation, you first call `useAddRelatedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRelatedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRelatedAccountMutation, { data, loading, error }] = useAddRelatedAccountMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAddRelatedAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddRelatedAccountMutation, AddRelatedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRelatedAccountMutation, AddRelatedAccountMutationVariables>(AddRelatedAccountDocument, options);
      }
export type AddRelatedAccountMutationHookResult = ReturnType<typeof useAddRelatedAccountMutation>;
export type AddRelatedAccountMutationResult = Apollo.MutationResult<AddRelatedAccountMutation>;
export type AddRelatedAccountMutationOptions = Apollo.BaseMutationOptions<AddRelatedAccountMutation, AddRelatedAccountMutationVariables>;
export const RemoveRelatedAccountDocument = gql`
    mutation RemoveRelatedAccount($relationId: Int!) {
  removeRelatedAccount(relationID: $relationId) {
    id
  }
}
    `;
export type RemoveRelatedAccountMutationFn = Apollo.MutationFunction<RemoveRelatedAccountMutation, RemoveRelatedAccountMutationVariables>;

/**
 * __useRemoveRelatedAccountMutation__
 *
 * To run a mutation, you first call `useRemoveRelatedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRelatedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRelatedAccountMutation, { data, loading, error }] = useRemoveRelatedAccountMutation({
 *   variables: {
 *      relationId: // value for 'relationId'
 *   },
 * });
 */
export function useRemoveRelatedAccountMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRelatedAccountMutation, RemoveRelatedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRelatedAccountMutation, RemoveRelatedAccountMutationVariables>(RemoveRelatedAccountDocument, options);
      }
export type RemoveRelatedAccountMutationHookResult = ReturnType<typeof useRemoveRelatedAccountMutation>;
export type RemoveRelatedAccountMutationResult = Apollo.MutationResult<RemoveRelatedAccountMutation>;
export type RemoveRelatedAccountMutationOptions = Apollo.BaseMutationOptions<RemoveRelatedAccountMutation, RemoveRelatedAccountMutationVariables>;
export const UpdateAccountDetailsScreenDocument = gql`
    mutation UpdateAccountDetailsScreen($inputs: UpdateAccountInputs!) {
  updateAccount(inputs: $inputs) {
    ...EditAccountFields
  }
}
    ${EditAccountFieldsFragmentDoc}`;
export type UpdateAccountDetailsScreenMutationFn = Apollo.MutationFunction<UpdateAccountDetailsScreenMutation, UpdateAccountDetailsScreenMutationVariables>;

/**
 * __useUpdateAccountDetailsScreenMutation__
 *
 * To run a mutation, you first call `useUpdateAccountDetailsScreenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountDetailsScreenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountDetailsScreenMutation, { data, loading, error }] = useUpdateAccountDetailsScreenMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateAccountDetailsScreenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountDetailsScreenMutation, UpdateAccountDetailsScreenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountDetailsScreenMutation, UpdateAccountDetailsScreenMutationVariables>(UpdateAccountDetailsScreenDocument, options);
      }
export type UpdateAccountDetailsScreenMutationHookResult = ReturnType<typeof useUpdateAccountDetailsScreenMutation>;
export type UpdateAccountDetailsScreenMutationResult = Apollo.MutationResult<UpdateAccountDetailsScreenMutation>;
export type UpdateAccountDetailsScreenMutationOptions = Apollo.BaseMutationOptions<UpdateAccountDetailsScreenMutation, UpdateAccountDetailsScreenMutationVariables>;
export const CreateAccountNoteDocument = gql`
    mutation CreateAccountNote($inputs: CreateAccountNoteInputs!) {
  createAccountNote(inputs: $inputs) {
    id
    notes {
      ...AccountNoteFields
    }
  }
}
    ${AccountNoteFieldsFragmentDoc}`;
export type CreateAccountNoteMutationFn = Apollo.MutationFunction<CreateAccountNoteMutation, CreateAccountNoteMutationVariables>;

/**
 * __useCreateAccountNoteMutation__
 *
 * To run a mutation, you first call `useCreateAccountNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountNoteMutation, { data, loading, error }] = useCreateAccountNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAccountNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountNoteMutation, CreateAccountNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountNoteMutation, CreateAccountNoteMutationVariables>(CreateAccountNoteDocument, options);
      }
export type CreateAccountNoteMutationHookResult = ReturnType<typeof useCreateAccountNoteMutation>;
export type CreateAccountNoteMutationResult = Apollo.MutationResult<CreateAccountNoteMutation>;
export type CreateAccountNoteMutationOptions = Apollo.BaseMutationOptions<CreateAccountNoteMutation, CreateAccountNoteMutationVariables>;
export const UpdateAccountNoteDocument = gql`
    mutation UpdateAccountNote($inputs: UpdateAccountNoteInputs!) {
  updateAccountNote(inputs: $inputs) {
    id
    notes {
      ...AccountNoteFields
    }
  }
}
    ${AccountNoteFieldsFragmentDoc}`;
export type UpdateAccountNoteMutationFn = Apollo.MutationFunction<UpdateAccountNoteMutation, UpdateAccountNoteMutationVariables>;

/**
 * __useUpdateAccountNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAccountNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountNoteMutation, { data, loading, error }] = useUpdateAccountNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateAccountNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountNoteMutation, UpdateAccountNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountNoteMutation, UpdateAccountNoteMutationVariables>(UpdateAccountNoteDocument, options);
      }
export type UpdateAccountNoteMutationHookResult = ReturnType<typeof useUpdateAccountNoteMutation>;
export type UpdateAccountNoteMutationResult = Apollo.MutationResult<UpdateAccountNoteMutation>;
export type UpdateAccountNoteMutationOptions = Apollo.BaseMutationOptions<UpdateAccountNoteMutation, UpdateAccountNoteMutationVariables>;
export const DeleteAccountNoteDocument = gql`
    mutation DeleteAccountNote($id: Int!) {
  deleteAccountNote(id: $id) {
    id
  }
}
    `;
export type DeleteAccountNoteMutationFn = Apollo.MutationFunction<DeleteAccountNoteMutation, DeleteAccountNoteMutationVariables>;

/**
 * __useDeleteAccountNoteMutation__
 *
 * To run a mutation, you first call `useDeleteAccountNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountNoteMutation, { data, loading, error }] = useDeleteAccountNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountNoteMutation, DeleteAccountNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountNoteMutation, DeleteAccountNoteMutationVariables>(DeleteAccountNoteDocument, options);
      }
export type DeleteAccountNoteMutationHookResult = ReturnType<typeof useDeleteAccountNoteMutation>;
export type DeleteAccountNoteMutationResult = Apollo.MutationResult<DeleteAccountNoteMutation>;
export type DeleteAccountNoteMutationOptions = Apollo.BaseMutationOptions<DeleteAccountNoteMutation, DeleteAccountNoteMutationVariables>;
export const DownloadAccountDocumentDocument = gql`
    mutation DownloadAccountDocument($downloadDocumentId: Int!) {
  downloadDocument(id: $downloadDocumentId)
}
    `;
export type DownloadAccountDocumentMutationFn = Apollo.MutationFunction<DownloadAccountDocumentMutation, DownloadAccountDocumentMutationVariables>;

/**
 * __useDownloadAccountDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadAccountDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAccountDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAccountDocumentMutation, { data, loading, error }] = useDownloadAccountDocumentMutation({
 *   variables: {
 *      downloadDocumentId: // value for 'downloadDocumentId'
 *   },
 * });
 */
export function useDownloadAccountDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAccountDocumentMutation, DownloadAccountDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAccountDocumentMutation, DownloadAccountDocumentMutationVariables>(DownloadAccountDocumentDocument, options);
      }
export type DownloadAccountDocumentMutationHookResult = ReturnType<typeof useDownloadAccountDocumentMutation>;
export type DownloadAccountDocumentMutationResult = Apollo.MutationResult<DownloadAccountDocumentMutation>;
export type DownloadAccountDocumentMutationOptions = Apollo.BaseMutationOptions<DownloadAccountDocumentMutation, DownloadAccountDocumentMutationVariables>;
export const StartAccountUploadDocument = gql`
    mutation StartAccountUpload($inputs: [UploadDocumentInputs!]!) {
  startUpload(inputs: $inputs)
}
    `;
export type StartAccountUploadMutationFn = Apollo.MutationFunction<StartAccountUploadMutation, StartAccountUploadMutationVariables>;

/**
 * __useStartAccountUploadMutation__
 *
 * To run a mutation, you first call `useStartAccountUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAccountUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAccountUploadMutation, { data, loading, error }] = useStartAccountUploadMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useStartAccountUploadMutation(baseOptions?: Apollo.MutationHookOptions<StartAccountUploadMutation, StartAccountUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAccountUploadMutation, StartAccountUploadMutationVariables>(StartAccountUploadDocument, options);
      }
export type StartAccountUploadMutationHookResult = ReturnType<typeof useStartAccountUploadMutation>;
export type StartAccountUploadMutationResult = Apollo.MutationResult<StartAccountUploadMutation>;
export type StartAccountUploadMutationOptions = Apollo.BaseMutationOptions<StartAccountUploadMutation, StartAccountUploadMutationVariables>;
export const ConfirmUploadDocument = gql`
    mutation ConfirmUpload($inputs: UploadDocumentInputs!) {
  confirmUpload(inputs: $inputs) {
    ...UploadedDocumentFields
  }
}
    ${UploadedDocumentFieldsFragmentDoc}`;
export type ConfirmUploadMutationFn = Apollo.MutationFunction<ConfirmUploadMutation, ConfirmUploadMutationVariables>;

/**
 * __useConfirmUploadMutation__
 *
 * To run a mutation, you first call `useConfirmUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUploadMutation, { data, loading, error }] = useConfirmUploadMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useConfirmUploadMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUploadMutation, ConfirmUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUploadMutation, ConfirmUploadMutationVariables>(ConfirmUploadDocument, options);
      }
export type ConfirmUploadMutationHookResult = ReturnType<typeof useConfirmUploadMutation>;
export type ConfirmUploadMutationResult = Apollo.MutationResult<ConfirmUploadMutation>;
export type ConfirmUploadMutationOptions = Apollo.BaseMutationOptions<ConfirmUploadMutation, ConfirmUploadMutationVariables>;
export const DeleteAccountDocumentDocument = gql`
    mutation DeleteAccountDocument($documentID: Int!) {
  deleteDocument(id: $documentID) {
    id
  }
}
    `;
export type DeleteAccountDocumentMutationFn = Apollo.MutationFunction<DeleteAccountDocumentMutation, DeleteAccountDocumentMutationVariables>;

/**
 * __useDeleteAccountDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteAccountDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountDocumentMutation, { data, loading, error }] = useDeleteAccountDocumentMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useDeleteAccountDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountDocumentMutation, DeleteAccountDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountDocumentMutation, DeleteAccountDocumentMutationVariables>(DeleteAccountDocumentDocument, options);
      }
export type DeleteAccountDocumentMutationHookResult = ReturnType<typeof useDeleteAccountDocumentMutation>;
export type DeleteAccountDocumentMutationResult = Apollo.MutationResult<DeleteAccountDocumentMutation>;
export type DeleteAccountDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteAccountDocumentMutation, DeleteAccountDocumentMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($inputs: CreateAccountInputs!) {
  createAccount(inputs: $inputs) {
    id
    client
    town
    countryid
    isAgent
    isPreferredAgent
    address1
    address2
    country {
      id
    }
    defaultInvoicePartyID
    isJobHoldActive
    state
    zip
    openPurchaseOrder
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const JobsDocument = gql`
    query Jobs($filters: JobHistoryFilters) {
  jobs {
    ...Job
  }
  schedulerJobHistory(filters: $filters) {
    ...SchedulerJobHistory
  }
  schedulerJobHistoryCount(filters: $filters)
}
    ${JobFragmentDoc}
${SchedulerJobHistoryFragmentDoc}`;

/**
 * __useJobsQuery__
 *
 * To run a query within a React component, call `useJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useJobsQuery(baseOptions?: Apollo.QueryHookOptions<JobsQuery, JobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
      }
export function useJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsQuery, JobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsQuery, JobsQueryVariables>(JobsDocument, options);
        }
export type JobsQueryHookResult = ReturnType<typeof useJobsQuery>;
export type JobsLazyQueryHookResult = ReturnType<typeof useJobsLazyQuery>;
export type JobsQueryResult = Apollo.QueryResult<JobsQuery, JobsQueryVariables>;
export const ToggleJobStatusDocument = gql`
    mutation ToggleJobStatus($jobID: PericulumJobID!) {
  toggleJobStatus(jobID: $jobID) {
    id
    disabled
  }
}
    `;
export type ToggleJobStatusMutationFn = Apollo.MutationFunction<ToggleJobStatusMutation, ToggleJobStatusMutationVariables>;

/**
 * __useToggleJobStatusMutation__
 *
 * To run a mutation, you first call `useToggleJobStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleJobStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleJobStatusMutation, { data, loading, error }] = useToggleJobStatusMutation({
 *   variables: {
 *      jobID: // value for 'jobID'
 *   },
 * });
 */
export function useToggleJobStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleJobStatusMutation, ToggleJobStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleJobStatusMutation, ToggleJobStatusMutationVariables>(ToggleJobStatusDocument, options);
      }
export type ToggleJobStatusMutationHookResult = ReturnType<typeof useToggleJobStatusMutation>;
export type ToggleJobStatusMutationResult = Apollo.MutationResult<ToggleJobStatusMutation>;
export type ToggleJobStatusMutationOptions = Apollo.BaseMutationOptions<ToggleJobStatusMutation, ToggleJobStatusMutationVariables>;
export const RunJobDocument = gql`
    mutation RunJob($jobID: PericulumJobID!, $data: JSON) {
  runJob(jobID: $jobID, data: $data) {
    id
    isRunning
  }
}
    `;
export type RunJobMutationFn = Apollo.MutationFunction<RunJobMutation, RunJobMutationVariables>;

/**
 * __useRunJobMutation__
 *
 * To run a mutation, you first call `useRunJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runJobMutation, { data, loading, error }] = useRunJobMutation({
 *   variables: {
 *      jobID: // value for 'jobID'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRunJobMutation(baseOptions?: Apollo.MutationHookOptions<RunJobMutation, RunJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunJobMutation, RunJobMutationVariables>(RunJobDocument, options);
      }
export type RunJobMutationHookResult = ReturnType<typeof useRunJobMutation>;
export type RunJobMutationResult = Apollo.MutationResult<RunJobMutation>;
export type RunJobMutationOptions = Apollo.BaseMutationOptions<RunJobMutation, RunJobMutationVariables>;
export const JobEventDocument = gql`
    subscription JobEvent {
  newJobNotification {
    ... on ToggleJobEvent {
      jobID
      disabled
      toggledByEmployee {
        ...EmployeeAvatar
      }
    }
    ... on RunJobEvent {
      jobID
      jobIsRunningState
      startedByEmployee {
        ...EmployeeAvatar
      }
    }
    ... on JobCompleteEvent {
      jobID
      history {
        id
        results
      }
    }
  }
}
    ${EmployeeAvatarFragmentDoc}`;

/**
 * __useJobEventSubscription__
 *
 * To run a query within a React component, call `useJobEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useJobEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobEventSubscription({
 *   variables: {
 *   },
 * });
 */
export function useJobEventSubscription(baseOptions?: Apollo.SubscriptionHookOptions<JobEventSubscription, JobEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<JobEventSubscription, JobEventSubscriptionVariables>(JobEventDocument, options);
      }
export type JobEventSubscriptionHookResult = ReturnType<typeof useJobEventSubscription>;
export type JobEventSubscriptionResult = Apollo.SubscriptionResult<JobEventSubscription>;
export const SearchAuth0LogsDocument = gql`
    query SearchAuth0Logs($searchText: String, $authSubject: String, $sortBy: String, $sortDirection: SortDirection, $skip: Int, $take: Int, $eventCodes: [LogEventTypeCode!]) {
  searchAuth0Logs(
    searchText: $searchText
    sortBy: $sortBy
    sortDirection: $sortDirection
    skip: $skip
    take: $take
    authSubject: $authSubject
    eventCodes: $eventCodes
  ) {
    log_id
    type
    audience
    client_id
    client_name
    connection
    connection_id
    date
    description
    details
    hostname
    ip
    isMobile
    location_info_city_name
    location_info_continent_code
    location_info_country_code
    location_info_country_code3
    location_info_country_name
    location_info_latitude
    location_info_longitude
    location_info_time_zone
    scope
    strategy
    strategy_type
    user_id
    user_agent
    user_name
    dateCreated
  }
  searchAuth0LogsCount(
    searchText: $searchText
    sortBy: $sortBy
    sortDirection: $sortDirection
    skip: $skip
    take: $take
    authSubject: $authSubject
    eventCodes: $eventCodes
  )
}
    `;

/**
 * __useSearchAuth0LogsQuery__
 *
 * To run a query within a React component, call `useSearchAuth0LogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAuth0LogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAuth0LogsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      authSubject: // value for 'authSubject'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      eventCodes: // value for 'eventCodes'
 *   },
 * });
 */
export function useSearchAuth0LogsQuery(baseOptions?: Apollo.QueryHookOptions<SearchAuth0LogsQuery, SearchAuth0LogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAuth0LogsQuery, SearchAuth0LogsQueryVariables>(SearchAuth0LogsDocument, options);
      }
export function useSearchAuth0LogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAuth0LogsQuery, SearchAuth0LogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAuth0LogsQuery, SearchAuth0LogsQueryVariables>(SearchAuth0LogsDocument, options);
        }
export type SearchAuth0LogsQueryHookResult = ReturnType<typeof useSearchAuth0LogsQuery>;
export type SearchAuth0LogsLazyQueryHookResult = ReturnType<typeof useSearchAuth0LogsLazyQuery>;
export type SearchAuth0LogsQueryResult = Apollo.QueryResult<SearchAuth0LogsQuery, SearchAuth0LogsQueryVariables>;
export const ActivityLogsDocument = gql`
    query ActivityLogs($inputs: FilterActivityLogs) {
  activityLogsCount(inputs: $inputs)
  activityLogs(inputs: $inputs) {
    id
    account {
      id
      client
    }
    office {
      id
      client
    }
    contact {
      id
      name
    }
    booking {
      id
      coyhawb
    }
    employee {
      id
      fullname
    }
    description
    dateCreated
    eventid
  }
}
    `;

/**
 * __useActivityLogsQuery__
 *
 * To run a query within a React component, call `useActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useActivityLogsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
      }
export function useActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogsQuery, ActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogsQuery, ActivityLogsQueryVariables>(ActivityLogsDocument, options);
        }
export type ActivityLogsQueryHookResult = ReturnType<typeof useActivityLogsQuery>;
export type ActivityLogsLazyQueryHookResult = ReturnType<typeof useActivityLogsLazyQuery>;
export type ActivityLogsQueryResult = Apollo.QueryResult<ActivityLogsQuery, ActivityLogsQueryVariables>;
export const SearchEmailLogsDocument = gql`
    query SearchEmailLogs($inputs: FilterEmailLogs) {
  searchEmailLogs(inputs: $inputs) {
    id
    emailto
    emailcc
    emailbcc
    emailbody
    emailsubject
    attachments
    dateCreated
  }
  searchEmailLogsCount(inputs: $inputs)
}
    `;

/**
 * __useSearchEmailLogsQuery__
 *
 * To run a query within a React component, call `useSearchEmailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailLogsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSearchEmailLogsQuery(baseOptions?: Apollo.QueryHookOptions<SearchEmailLogsQuery, SearchEmailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmailLogsQuery, SearchEmailLogsQueryVariables>(SearchEmailLogsDocument, options);
      }
export function useSearchEmailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmailLogsQuery, SearchEmailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmailLogsQuery, SearchEmailLogsQueryVariables>(SearchEmailLogsDocument, options);
        }
export type SearchEmailLogsQueryHookResult = ReturnType<typeof useSearchEmailLogsQuery>;
export type SearchEmailLogsLazyQueryHookResult = ReturnType<typeof useSearchEmailLogsLazyQuery>;
export type SearchEmailLogsQueryResult = Apollo.QueryResult<SearchEmailLogsQuery, SearchEmailLogsQueryVariables>;
export const EditOfficeConfigScreenDocument = gql`
    query EditOfficeConfigScreen($officeConfigurationById: Int!) {
  officeConfigurationByID(id: $officeConfigurationById) {
    ...OfficeConfigurationFragment
  }
  locales
  currencies {
    name
    code
  }
  timezones
  regions {
    id
    name
  }
}
    ${OfficeConfigurationFragmentFragmentDoc}`;

/**
 * __useEditOfficeConfigScreenQuery__
 *
 * To run a query within a React component, call `useEditOfficeConfigScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOfficeConfigScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOfficeConfigScreenQuery({
 *   variables: {
 *      officeConfigurationById: // value for 'officeConfigurationById'
 *   },
 * });
 */
export function useEditOfficeConfigScreenQuery(baseOptions: Apollo.QueryHookOptions<EditOfficeConfigScreenQuery, EditOfficeConfigScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditOfficeConfigScreenQuery, EditOfficeConfigScreenQueryVariables>(EditOfficeConfigScreenDocument, options);
      }
export function useEditOfficeConfigScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditOfficeConfigScreenQuery, EditOfficeConfigScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditOfficeConfigScreenQuery, EditOfficeConfigScreenQueryVariables>(EditOfficeConfigScreenDocument, options);
        }
export type EditOfficeConfigScreenQueryHookResult = ReturnType<typeof useEditOfficeConfigScreenQuery>;
export type EditOfficeConfigScreenLazyQueryHookResult = ReturnType<typeof useEditOfficeConfigScreenLazyQuery>;
export type EditOfficeConfigScreenQueryResult = Apollo.QueryResult<EditOfficeConfigScreenQuery, EditOfficeConfigScreenQueryVariables>;
export const CreateOfficeConfigurationDocument = gql`
    mutation CreateOfficeConfiguration($inputs: CreateOfficeConfigurationInputs!) {
  createOfficeConfiguration(inputs: $inputs) {
    ...OfficeConfigurationFragment
  }
}
    ${OfficeConfigurationFragmentFragmentDoc}`;
export type CreateOfficeConfigurationMutationFn = Apollo.MutationFunction<CreateOfficeConfigurationMutation, CreateOfficeConfigurationMutationVariables>;

/**
 * __useCreateOfficeConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateOfficeConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeConfigurationMutation, { data, loading, error }] = useCreateOfficeConfigurationMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateOfficeConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeConfigurationMutation, CreateOfficeConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeConfigurationMutation, CreateOfficeConfigurationMutationVariables>(CreateOfficeConfigurationDocument, options);
      }
export type CreateOfficeConfigurationMutationHookResult = ReturnType<typeof useCreateOfficeConfigurationMutation>;
export type CreateOfficeConfigurationMutationResult = Apollo.MutationResult<CreateOfficeConfigurationMutation>;
export type CreateOfficeConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateOfficeConfigurationMutation, CreateOfficeConfigurationMutationVariables>;
export const UpdateOfficeConfigurationDocument = gql`
    mutation UpdateOfficeConfiguration($inputs: UpdateOfficeConfigurationInputs!) {
  updateOfficeConfiguration(inputs: $inputs) {
    ...OfficeConfigurationFragment
  }
}
    ${OfficeConfigurationFragmentFragmentDoc}`;
export type UpdateOfficeConfigurationMutationFn = Apollo.MutationFunction<UpdateOfficeConfigurationMutation, UpdateOfficeConfigurationMutationVariables>;

/**
 * __useUpdateOfficeConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeConfigurationMutation, { data, loading, error }] = useUpdateOfficeConfigurationMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateOfficeConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeConfigurationMutation, UpdateOfficeConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeConfigurationMutation, UpdateOfficeConfigurationMutationVariables>(UpdateOfficeConfigurationDocument, options);
      }
export type UpdateOfficeConfigurationMutationHookResult = ReturnType<typeof useUpdateOfficeConfigurationMutation>;
export type UpdateOfficeConfigurationMutationResult = Apollo.MutationResult<UpdateOfficeConfigurationMutation>;
export type UpdateOfficeConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeConfigurationMutation, UpdateOfficeConfigurationMutationVariables>;
export const DeleteOfficeConfigurationDocument = gql`
    mutation DeleteOfficeConfiguration($id: Int!) {
  deleteOfficeConfiguration(id: $id) {
    id
  }
}
    `;
export type DeleteOfficeConfigurationMutationFn = Apollo.MutationFunction<DeleteOfficeConfigurationMutation, DeleteOfficeConfigurationMutationVariables>;

/**
 * __useDeleteOfficeConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeConfigurationMutation, { data, loading, error }] = useDeleteOfficeConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfficeConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfficeConfigurationMutation, DeleteOfficeConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfficeConfigurationMutation, DeleteOfficeConfigurationMutationVariables>(DeleteOfficeConfigurationDocument, options);
      }
export type DeleteOfficeConfigurationMutationHookResult = ReturnType<typeof useDeleteOfficeConfigurationMutation>;
export type DeleteOfficeConfigurationMutationResult = Apollo.MutationResult<DeleteOfficeConfigurationMutation>;
export type DeleteOfficeConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteOfficeConfigurationMutation, DeleteOfficeConfigurationMutationVariables>;
export const CreateRegionDocument = gql`
    mutation CreateRegion($inputs: CreateRegionInputs!) {
  createRegion(inputs: $inputs) {
    id
    name
    dateCreated
    dateModified
  }
}
    `;
export type CreateRegionMutationFn = Apollo.MutationFunction<CreateRegionMutation, CreateRegionMutationVariables>;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegionMutation, { data, loading, error }] = useCreateRegionMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateRegionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegionMutation, CreateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
      }
export type CreateRegionMutationHookResult = ReturnType<typeof useCreateRegionMutation>;
export type CreateRegionMutationResult = Apollo.MutationResult<CreateRegionMutation>;
export type CreateRegionMutationOptions = Apollo.BaseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation UpdateRegion($inputs: UpdateRegionInputs!) {
  updateRegion(inputs: $inputs) {
    id
    name
    dateCreated
    dateModified
  }
}
    `;
export type UpdateRegionMutationFn = Apollo.MutationFunction<UpdateRegionMutation, UpdateRegionMutationVariables>;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionMutation, { data, loading, error }] = useUpdateRegionMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateRegionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionMutation, UpdateRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
      }
export type UpdateRegionMutationHookResult = ReturnType<typeof useUpdateRegionMutation>;
export type UpdateRegionMutationResult = Apollo.MutationResult<UpdateRegionMutation>;
export type UpdateRegionMutationOptions = Apollo.BaseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const DeleteRegionDocument = gql`
    mutation DeleteRegion($id: Int!) {
  deleteRegion(id: $id) {
    id
  }
}
    `;
export type DeleteRegionMutationFn = Apollo.MutationFunction<DeleteRegionMutation, DeleteRegionMutationVariables>;

/**
 * __useDeleteRegionMutation__
 *
 * To run a mutation, you first call `useDeleteRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegionMutation, { data, loading, error }] = useDeleteRegionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRegionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegionMutation, DeleteRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegionMutation, DeleteRegionMutationVariables>(DeleteRegionDocument, options);
      }
export type DeleteRegionMutationHookResult = ReturnType<typeof useDeleteRegionMutation>;
export type DeleteRegionMutationResult = Apollo.MutationResult<DeleteRegionMutation>;
export type DeleteRegionMutationOptions = Apollo.BaseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const RolesDocument = gql`
    query Roles {
  roles {
    ...RoleFragment
  }
}
    ${RoleFragmentFragmentDoc}`;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($inputs: CreateRoleInputs!) {
  createRole(inputs: $inputs) {
    ...RoleFragment
  }
}
    ${RoleFragmentFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($roleID: Int!) {
  deleteRole(id: $roleID) {
    ...RoleFragment
  }
}
    ${RoleFragmentFragmentDoc}`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($inputs: UpdateRoleInputs!) {
  updateRole(inputs: $inputs) {
    ...RoleFragment
  }
}
    ${RoleFragmentFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const StandardChargesDocument = gql`
    query StandardCharges {
  ...standardCharge
}
    ${standardChargeFragmentDoc}`;

/**
 * __useStandardChargesQuery__
 *
 * To run a query within a React component, call `useStandardChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardChargesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardChargesQuery(baseOptions?: Apollo.QueryHookOptions<StandardChargesQuery, StandardChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardChargesQuery, StandardChargesQueryVariables>(StandardChargesDocument, options);
      }
export function useStandardChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardChargesQuery, StandardChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardChargesQuery, StandardChargesQueryVariables>(StandardChargesDocument, options);
        }
export type StandardChargesQueryHookResult = ReturnType<typeof useStandardChargesQuery>;
export type StandardChargesLazyQueryHookResult = ReturnType<typeof useStandardChargesLazyQuery>;
export type StandardChargesQueryResult = Apollo.QueryResult<StandardChargesQuery, StandardChargesQueryVariables>;
export const CreateStandardChargeDocument = gql`
    mutation CreateStandardCharge($inputs: CreateStandardChargeInputs!) {
  createStandardCharge(inputs: $inputs) {
    id
    name
    description
    type
    dateCreated
    dateModified
  }
}
    `;
export type CreateStandardChargeMutationFn = Apollo.MutationFunction<CreateStandardChargeMutation, CreateStandardChargeMutationVariables>;

/**
 * __useCreateStandardChargeMutation__
 *
 * To run a mutation, you first call `useCreateStandardChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStandardChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStandardChargeMutation, { data, loading, error }] = useCreateStandardChargeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateStandardChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateStandardChargeMutation, CreateStandardChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStandardChargeMutation, CreateStandardChargeMutationVariables>(CreateStandardChargeDocument, options);
      }
export type CreateStandardChargeMutationHookResult = ReturnType<typeof useCreateStandardChargeMutation>;
export type CreateStandardChargeMutationResult = Apollo.MutationResult<CreateStandardChargeMutation>;
export type CreateStandardChargeMutationOptions = Apollo.BaseMutationOptions<CreateStandardChargeMutation, CreateStandardChargeMutationVariables>;
export const UpdateStandardChargeDocument = gql`
    mutation UpdateStandardCharge($inputs: UpdateStandardChargeInputs!) {
  updateStandardCharge(inputs: $inputs) {
    id
    name
    description
    type
    dateCreated
    dateModified
  }
}
    `;
export type UpdateStandardChargeMutationFn = Apollo.MutationFunction<UpdateStandardChargeMutation, UpdateStandardChargeMutationVariables>;

/**
 * __useUpdateStandardChargeMutation__
 *
 * To run a mutation, you first call `useUpdateStandardChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStandardChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStandardChargeMutation, { data, loading, error }] = useUpdateStandardChargeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateStandardChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStandardChargeMutation, UpdateStandardChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStandardChargeMutation, UpdateStandardChargeMutationVariables>(UpdateStandardChargeDocument, options);
      }
export type UpdateStandardChargeMutationHookResult = ReturnType<typeof useUpdateStandardChargeMutation>;
export type UpdateStandardChargeMutationResult = Apollo.MutationResult<UpdateStandardChargeMutation>;
export type UpdateStandardChargeMutationOptions = Apollo.BaseMutationOptions<UpdateStandardChargeMutation, UpdateStandardChargeMutationVariables>;
export const DeleteStandardChargeDocument = gql`
    mutation DeleteStandardCharge($id: Int!) {
  deleteStandardCharge(id: $id) {
    id
    name
    description
    type
    dateCreated
    dateModified
  }
}
    `;
export type DeleteStandardChargeMutationFn = Apollo.MutationFunction<DeleteStandardChargeMutation, DeleteStandardChargeMutationVariables>;

/**
 * __useDeleteStandardChargeMutation__
 *
 * To run a mutation, you first call `useDeleteStandardChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStandardChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStandardChargeMutation, { data, loading, error }] = useDeleteStandardChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStandardChargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStandardChargeMutation, DeleteStandardChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStandardChargeMutation, DeleteStandardChargeMutationVariables>(DeleteStandardChargeDocument, options);
      }
export type DeleteStandardChargeMutationHookResult = ReturnType<typeof useDeleteStandardChargeMutation>;
export type DeleteStandardChargeMutationResult = Apollo.MutationResult<DeleteStandardChargeMutation>;
export type DeleteStandardChargeMutationOptions = Apollo.BaseMutationOptions<DeleteStandardChargeMutation, DeleteStandardChargeMutationVariables>;
export const BookingToRepairDocument = gql`
    query BookingToRepair($hawb: String!) {
  booking(hawb: $hawb) {
    id
    coyhawb
    jobdate
    client {
      id
      client
    }
    consignee {
      id
      client
    }
    step
    status
  }
}
    `;

/**
 * __useBookingToRepairQuery__
 *
 * To run a query within a React component, call `useBookingToRepairQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingToRepairQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingToRepairQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useBookingToRepairQuery(baseOptions: Apollo.QueryHookOptions<BookingToRepairQuery, BookingToRepairQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingToRepairQuery, BookingToRepairQueryVariables>(BookingToRepairDocument, options);
      }
export function useBookingToRepairLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingToRepairQuery, BookingToRepairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingToRepairQuery, BookingToRepairQueryVariables>(BookingToRepairDocument, options);
        }
export type BookingToRepairQueryHookResult = ReturnType<typeof useBookingToRepairQuery>;
export type BookingToRepairLazyQueryHookResult = ReturnType<typeof useBookingToRepairLazyQuery>;
export type BookingToRepairQueryResult = Apollo.QueryResult<BookingToRepairQuery, BookingToRepairQueryVariables>;
export const RepairBookingDocument = gql`
    mutation RepairBooking($inputs: RepairBookingInputs!) {
  repairBooking(inputs: $inputs) {
    id
    coyhawb
    jobdate
    client {
      id
      client
    }
    consignee {
      id
      client
    }
    step
    status
  }
}
    `;
export type RepairBookingMutationFn = Apollo.MutationFunction<RepairBookingMutation, RepairBookingMutationVariables>;

/**
 * __useRepairBookingMutation__
 *
 * To run a mutation, you first call `useRepairBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepairBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repairBookingMutation, { data, loading, error }] = useRepairBookingMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRepairBookingMutation(baseOptions?: Apollo.MutationHookOptions<RepairBookingMutation, RepairBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RepairBookingMutation, RepairBookingMutationVariables>(RepairBookingDocument, options);
      }
export type RepairBookingMutationHookResult = ReturnType<typeof useRepairBookingMutation>;
export type RepairBookingMutationResult = Apollo.MutationResult<RepairBookingMutation>;
export type RepairBookingMutationOptions = Apollo.BaseMutationOptions<RepairBookingMutation, RepairBookingMutationVariables>;
export const TrackingRequestsDocument = gql`
    query TrackingRequests($filters: GetTrackingRequestFilters) {
  trackingRequestsMonthAggregation {
    Month
    MonthNumber
    Year
    Count
  }
  trackingRequestsCount(filters: $filters)
  trackingRequests(filters: $filters) {
    id
    hawb
    dateCreated
  }
}
    `;

/**
 * __useTrackingRequestsQuery__
 *
 * To run a query within a React component, call `useTrackingRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackingRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackingRequestsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTrackingRequestsQuery(baseOptions?: Apollo.QueryHookOptions<TrackingRequestsQuery, TrackingRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackingRequestsQuery, TrackingRequestsQueryVariables>(TrackingRequestsDocument, options);
      }
export function useTrackingRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackingRequestsQuery, TrackingRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackingRequestsQuery, TrackingRequestsQueryVariables>(TrackingRequestsDocument, options);
        }
export type TrackingRequestsQueryHookResult = ReturnType<typeof useTrackingRequestsQuery>;
export type TrackingRequestsLazyQueryHookResult = ReturnType<typeof useTrackingRequestsLazyQuery>;
export type TrackingRequestsQueryResult = Apollo.QueryResult<TrackingRequestsQuery, TrackingRequestsQueryVariables>;
export const SearchActiveQuotesDocument = gql`
    query SearchActiveQuotes($filters: SearchQuotesFilters) {
  searchQuotes(filters: $filters) {
    count
    records {
      ...SearchQuoteFields
    }
    total
  }
}
    ${SearchQuoteFieldsFragmentDoc}`;

/**
 * __useSearchActiveQuotesQuery__
 *
 * To run a query within a React component, call `useSearchActiveQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActiveQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchActiveQuotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchActiveQuotesQuery(baseOptions?: Apollo.QueryHookOptions<SearchActiveQuotesQuery, SearchActiveQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchActiveQuotesQuery, SearchActiveQuotesQueryVariables>(SearchActiveQuotesDocument, options);
      }
export function useSearchActiveQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchActiveQuotesQuery, SearchActiveQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchActiveQuotesQuery, SearchActiveQuotesQueryVariables>(SearchActiveQuotesDocument, options);
        }
export type SearchActiveQuotesQueryHookResult = ReturnType<typeof useSearchActiveQuotesQuery>;
export type SearchActiveQuotesLazyQueryHookResult = ReturnType<typeof useSearchActiveQuotesLazyQuery>;
export type SearchActiveQuotesQueryResult = Apollo.QueryResult<SearchActiveQuotesQuery, SearchActiveQuotesQueryVariables>;
export const SearchQuoteByIDDocument = gql`
    query SearchQuoteByID($quoteId: String!) {
  quoteByQuoteID(quoteID: $quoteId) {
    ...SearchQuoteFields
  }
}
    ${SearchQuoteFieldsFragmentDoc}`;

/**
 * __useSearchQuoteByIDQuery__
 *
 * To run a query within a React component, call `useSearchQuoteByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuoteByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuoteByIDQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useSearchQuoteByIDQuery(baseOptions: Apollo.QueryHookOptions<SearchQuoteByIDQuery, SearchQuoteByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuoteByIDQuery, SearchQuoteByIDQueryVariables>(SearchQuoteByIDDocument, options);
      }
export function useSearchQuoteByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuoteByIDQuery, SearchQuoteByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuoteByIDQuery, SearchQuoteByIDQueryVariables>(SearchQuoteByIDDocument, options);
        }
export type SearchQuoteByIDQueryHookResult = ReturnType<typeof useSearchQuoteByIDQuery>;
export type SearchQuoteByIDLazyQueryHookResult = ReturnType<typeof useSearchQuoteByIDLazyQuery>;
export type SearchQuoteByIDQueryResult = Apollo.QueryResult<SearchQuoteByIDQuery, SearchQuoteByIDQueryVariables>;
export const LoadBookingFromQuoteDocument = gql`
    query LoadBookingFromQuote($shipperid: Int!) {
  accountByID(id: $shipperid) {
    id
    client
    defaultInvoicePartyID
  }
}
    `;

/**
 * __useLoadBookingFromQuoteQuery__
 *
 * To run a query within a React component, call `useLoadBookingFromQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadBookingFromQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadBookingFromQuoteQuery({
 *   variables: {
 *      shipperid: // value for 'shipperid'
 *   },
 * });
 */
export function useLoadBookingFromQuoteQuery(baseOptions: Apollo.QueryHookOptions<LoadBookingFromQuoteQuery, LoadBookingFromQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadBookingFromQuoteQuery, LoadBookingFromQuoteQueryVariables>(LoadBookingFromQuoteDocument, options);
      }
export function useLoadBookingFromQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadBookingFromQuoteQuery, LoadBookingFromQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadBookingFromQuoteQuery, LoadBookingFromQuoteQueryVariables>(LoadBookingFromQuoteDocument, options);
        }
export type LoadBookingFromQuoteQueryHookResult = ReturnType<typeof useLoadBookingFromQuoteQuery>;
export type LoadBookingFromQuoteLazyQueryHookResult = ReturnType<typeof useLoadBookingFromQuoteLazyQuery>;
export type LoadBookingFromQuoteQueryResult = Apollo.QueryResult<LoadBookingFromQuoteQuery, LoadBookingFromQuoteQueryVariables>;
export const CreateBookingDocument = gql`
    mutation CreateBooking($inputs: CreateBookingInputs!) {
  createBooking(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type CreateBookingMutationFn = Apollo.MutationFunction<CreateBookingMutation, CreateBookingMutationVariables>;

/**
 * __useCreateBookingMutation__
 *
 * To run a mutation, you first call `useCreateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingMutation, { data, loading, error }] = useCreateBookingMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingMutation, CreateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument, options);
      }
export type CreateBookingMutationHookResult = ReturnType<typeof useCreateBookingMutation>;
export type CreateBookingMutationResult = Apollo.MutationResult<CreateBookingMutation>;
export type CreateBookingMutationOptions = Apollo.BaseMutationOptions<CreateBookingMutation, CreateBookingMutationVariables>;
export const PotentialReturnJobsDocument = gql`
    query PotentialReturnJobs($filters: SearchBookingsFilters) {
  searchBookings(filters: $filters) {
    count
    records {
      ...PotentialBookingFields
    }
    total
  }
}
    ${PotentialBookingFieldsFragmentDoc}`;

/**
 * __usePotentialReturnJobsQuery__
 *
 * To run a query within a React component, call `usePotentialReturnJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialReturnJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialReturnJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePotentialReturnJobsQuery(baseOptions?: Apollo.QueryHookOptions<PotentialReturnJobsQuery, PotentialReturnJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialReturnJobsQuery, PotentialReturnJobsQueryVariables>(PotentialReturnJobsDocument, options);
      }
export function usePotentialReturnJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialReturnJobsQuery, PotentialReturnJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialReturnJobsQuery, PotentialReturnJobsQueryVariables>(PotentialReturnJobsDocument, options);
        }
export type PotentialReturnJobsQueryHookResult = ReturnType<typeof usePotentialReturnJobsQuery>;
export type PotentialReturnJobsLazyQueryHookResult = ReturnType<typeof usePotentialReturnJobsLazyQuery>;
export type PotentialReturnJobsQueryResult = Apollo.QueryResult<PotentialReturnJobsQuery, PotentialReturnJobsQueryVariables>;
export const PotentialAgentJobsDocument = gql`
    query PotentialAgentJobs($filters: SearchBookingsFilters) {
  searchBookings(filters: $filters) {
    count
    records {
      ...PotentialBookingFields
    }
    total
  }
}
    ${PotentialBookingFieldsFragmentDoc}`;

/**
 * __usePotentialAgentJobsQuery__
 *
 * To run a query within a React component, call `usePotentialAgentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePotentialAgentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePotentialAgentJobsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePotentialAgentJobsQuery(baseOptions?: Apollo.QueryHookOptions<PotentialAgentJobsQuery, PotentialAgentJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PotentialAgentJobsQuery, PotentialAgentJobsQueryVariables>(PotentialAgentJobsDocument, options);
      }
export function usePotentialAgentJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PotentialAgentJobsQuery, PotentialAgentJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PotentialAgentJobsQuery, PotentialAgentJobsQueryVariables>(PotentialAgentJobsDocument, options);
        }
export type PotentialAgentJobsQueryHookResult = ReturnType<typeof usePotentialAgentJobsQuery>;
export type PotentialAgentJobsLazyQueryHookResult = ReturnType<typeof usePotentialAgentJobsLazyQuery>;
export type PotentialAgentJobsQueryResult = Apollo.QueryResult<PotentialAgentJobsQuery, PotentialAgentJobsQueryVariables>;
export const SaveBookingArrivalDocument = gql`
    mutation SaveBookingArrival($inputs: SaveBookingArrivalInputs!) {
  saveBookingArrival(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type SaveBookingArrivalMutationFn = Apollo.MutationFunction<SaveBookingArrivalMutation, SaveBookingArrivalMutationVariables>;

/**
 * __useSaveBookingArrivalMutation__
 *
 * To run a mutation, you first call `useSaveBookingArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingArrivalMutation, { data, loading, error }] = useSaveBookingArrivalMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveBookingArrivalMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingArrivalMutation, SaveBookingArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingArrivalMutation, SaveBookingArrivalMutationVariables>(SaveBookingArrivalDocument, options);
      }
export type SaveBookingArrivalMutationHookResult = ReturnType<typeof useSaveBookingArrivalMutation>;
export type SaveBookingArrivalMutationResult = Apollo.MutationResult<SaveBookingArrivalMutation>;
export type SaveBookingArrivalMutationOptions = Apollo.BaseMutationOptions<SaveBookingArrivalMutation, SaveBookingArrivalMutationVariables>;
export const CompleteBookingArrivalDocument = gql`
    mutation CompleteBookingArrival($coyhawb: String!) {
  completeBookingArrival(coyhawb: $coyhawb) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type CompleteBookingArrivalMutationFn = Apollo.MutationFunction<CompleteBookingArrivalMutation, CompleteBookingArrivalMutationVariables>;

/**
 * __useCompleteBookingArrivalMutation__
 *
 * To run a mutation, you first call `useCompleteBookingArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBookingArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBookingArrivalMutation, { data, loading, error }] = useCompleteBookingArrivalMutation({
 *   variables: {
 *      coyhawb: // value for 'coyhawb'
 *   },
 * });
 */
export function useCompleteBookingArrivalMutation(baseOptions?: Apollo.MutationHookOptions<CompleteBookingArrivalMutation, CompleteBookingArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteBookingArrivalMutation, CompleteBookingArrivalMutationVariables>(CompleteBookingArrivalDocument, options);
      }
export type CompleteBookingArrivalMutationHookResult = ReturnType<typeof useCompleteBookingArrivalMutation>;
export type CompleteBookingArrivalMutationResult = Apollo.MutationResult<CompleteBookingArrivalMutation>;
export type CompleteBookingArrivalMutationOptions = Apollo.BaseMutationOptions<CompleteBookingArrivalMutation, CompleteBookingArrivalMutationVariables>;
export const CompleteBookingDeliveryDocument = gql`
    mutation CompleteBookingDelivery($inputs: SaveBookingDeliveryInputs!) {
  completeBookingDelivery(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type CompleteBookingDeliveryMutationFn = Apollo.MutationFunction<CompleteBookingDeliveryMutation, CompleteBookingDeliveryMutationVariables>;

/**
 * __useCompleteBookingDeliveryMutation__
 *
 * To run a mutation, you first call `useCompleteBookingDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBookingDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBookingDeliveryMutation, { data, loading, error }] = useCompleteBookingDeliveryMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCompleteBookingDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CompleteBookingDeliveryMutation, CompleteBookingDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteBookingDeliveryMutation, CompleteBookingDeliveryMutationVariables>(CompleteBookingDeliveryDocument, options);
      }
export type CompleteBookingDeliveryMutationHookResult = ReturnType<typeof useCompleteBookingDeliveryMutation>;
export type CompleteBookingDeliveryMutationResult = Apollo.MutationResult<CompleteBookingDeliveryMutation>;
export type CompleteBookingDeliveryMutationOptions = Apollo.BaseMutationOptions<CompleteBookingDeliveryMutation, CompleteBookingDeliveryMutationVariables>;
export const EmailShipperPODDocument = gql`
    mutation EmailShipperPOD($inputs: EmailPODInputs!) {
  emailShipperPOD(inputs: $inputs) {
    coyhawb
    bookingDelivery {
      id
      emailsent
      emailsentDate
    }
  }
}
    `;
export type EmailShipperPODMutationFn = Apollo.MutationFunction<EmailShipperPODMutation, EmailShipperPODMutationVariables>;

/**
 * __useEmailShipperPODMutation__
 *
 * To run a mutation, you first call `useEmailShipperPODMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailShipperPODMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailShipperPodMutation, { data, loading, error }] = useEmailShipperPODMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailShipperPODMutation(baseOptions?: Apollo.MutationHookOptions<EmailShipperPODMutation, EmailShipperPODMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailShipperPODMutation, EmailShipperPODMutationVariables>(EmailShipperPODDocument, options);
      }
export type EmailShipperPODMutationHookResult = ReturnType<typeof useEmailShipperPODMutation>;
export type EmailShipperPODMutationResult = Apollo.MutationResult<EmailShipperPODMutation>;
export type EmailShipperPODMutationOptions = Apollo.BaseMutationOptions<EmailShipperPODMutation, EmailShipperPODMutationVariables>;
export const AccountContactsDocument = gql`
    query AccountContacts($filters: GetAccountContactsFilter!) {
  accountContacts(filters: $filters) {
    id
    name
    email
    phone
    fax
  }
}
    `;

/**
 * __useAccountContactsQuery__
 *
 * To run a query within a React component, call `useAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccountContactsQuery(baseOptions: Apollo.QueryHookOptions<AccountContactsQuery, AccountContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountContactsQuery, AccountContactsQueryVariables>(AccountContactsDocument, options);
      }
export function useAccountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountContactsQuery, AccountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountContactsQuery, AccountContactsQueryVariables>(AccountContactsDocument, options);
        }
export type AccountContactsQueryHookResult = ReturnType<typeof useAccountContactsQuery>;
export type AccountContactsLazyQueryHookResult = ReturnType<typeof useAccountContactsLazyQuery>;
export type AccountContactsQueryResult = Apollo.QueryResult<AccountContactsQuery, AccountContactsQueryVariables>;
export const JobTariffByNameDocument = gql`
    query JobTariffByName($officeid: Int!, $tariffZone: String!) {
  jobTariffByName(officeid: $officeid, name: $tariffZone) {
    id
    category
    zone
    minweightkg
    minweight
    perkg
  }
}
    `;

/**
 * __useJobTariffByNameQuery__
 *
 * To run a query within a React component, call `useJobTariffByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTariffByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTariffByNameQuery({
 *   variables: {
 *      officeid: // value for 'officeid'
 *      tariffZone: // value for 'tariffZone'
 *   },
 * });
 */
export function useJobTariffByNameQuery(baseOptions: Apollo.QueryHookOptions<JobTariffByNameQuery, JobTariffByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTariffByNameQuery, JobTariffByNameQueryVariables>(JobTariffByNameDocument, options);
      }
export function useJobTariffByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTariffByNameQuery, JobTariffByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTariffByNameQuery, JobTariffByNameQueryVariables>(JobTariffByNameDocument, options);
        }
export type JobTariffByNameQueryHookResult = ReturnType<typeof useJobTariffByNameQuery>;
export type JobTariffByNameLazyQueryHookResult = ReturnType<typeof useJobTariffByNameLazyQuery>;
export type JobTariffByNameQueryResult = Apollo.QueryResult<JobTariffByNameQuery, JobTariffByNameQueryVariables>;
export const SaveBookingPickupDocument = gql`
    mutation SaveBookingPickup($inputs: SaveBookingPickupInputs!) {
  saveBookingPickup(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type SaveBookingPickupMutationFn = Apollo.MutationFunction<SaveBookingPickupMutation, SaveBookingPickupMutationVariables>;

/**
 * __useSaveBookingPickupMutation__
 *
 * To run a mutation, you first call `useSaveBookingPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingPickupMutation, { data, loading, error }] = useSaveBookingPickupMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveBookingPickupMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingPickupMutation, SaveBookingPickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingPickupMutation, SaveBookingPickupMutationVariables>(SaveBookingPickupDocument, options);
      }
export type SaveBookingPickupMutationHookResult = ReturnType<typeof useSaveBookingPickupMutation>;
export type SaveBookingPickupMutationResult = Apollo.MutationResult<SaveBookingPickupMutation>;
export type SaveBookingPickupMutationOptions = Apollo.BaseMutationOptions<SaveBookingPickupMutation, SaveBookingPickupMutationVariables>;
export const CompleteBookingPickupDocument = gql`
    mutation CompleteBookingPickup($coyhawb: String!) {
  completeBookingPickup(coyhawb: $coyhawb) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type CompleteBookingPickupMutationFn = Apollo.MutationFunction<CompleteBookingPickupMutation, CompleteBookingPickupMutationVariables>;

/**
 * __useCompleteBookingPickupMutation__
 *
 * To run a mutation, you first call `useCompleteBookingPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBookingPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBookingPickupMutation, { data, loading, error }] = useCompleteBookingPickupMutation({
 *   variables: {
 *      coyhawb: // value for 'coyhawb'
 *   },
 * });
 */
export function useCompleteBookingPickupMutation(baseOptions?: Apollo.MutationHookOptions<CompleteBookingPickupMutation, CompleteBookingPickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteBookingPickupMutation, CompleteBookingPickupMutationVariables>(CompleteBookingPickupDocument, options);
      }
export type CompleteBookingPickupMutationHookResult = ReturnType<typeof useCompleteBookingPickupMutation>;
export type CompleteBookingPickupMutationResult = Apollo.MutationResult<CompleteBookingPickupMutation>;
export type CompleteBookingPickupMutationOptions = Apollo.BaseMutationOptions<CompleteBookingPickupMutation, CompleteBookingPickupMutationVariables>;
export const LookupEmployeeByIDDocument = gql`
    query LookupEmployeeByID($employeeID: Int!) {
  employeeByID(id: $employeeID) {
    ...GlobalEmployeeFields
  }
}
    ${GlobalEmployeeFieldsFragmentDoc}`;

/**
 * __useLookupEmployeeByIDQuery__
 *
 * To run a query within a React component, call `useLookupEmployeeByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupEmployeeByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupEmployeeByIDQuery({
 *   variables: {
 *      employeeID: // value for 'employeeID'
 *   },
 * });
 */
export function useLookupEmployeeByIDQuery(baseOptions: Apollo.QueryHookOptions<LookupEmployeeByIDQuery, LookupEmployeeByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupEmployeeByIDQuery, LookupEmployeeByIDQueryVariables>(LookupEmployeeByIDDocument, options);
      }
export function useLookupEmployeeByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupEmployeeByIDQuery, LookupEmployeeByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupEmployeeByIDQuery, LookupEmployeeByIDQueryVariables>(LookupEmployeeByIDDocument, options);
        }
export type LookupEmployeeByIDQueryHookResult = ReturnType<typeof useLookupEmployeeByIDQuery>;
export type LookupEmployeeByIDLazyQueryHookResult = ReturnType<typeof useLookupEmployeeByIDLazyQuery>;
export type LookupEmployeeByIDQueryResult = Apollo.QueryResult<LookupEmployeeByIDQuery, LookupEmployeeByIDQueryVariables>;
export const LookupBookingShipmentsDocument = gql`
    query LookupBookingShipments($hawb: String!) {
  booking(hawb: $hawb) {
    coyhawb
    jobdate
    shipments {
      ...ShipmentFragment
    }
    step
    status
    bookingOffice {
      id
      client
    }
    employee {
      id
      picture
      fullname
    }
    dateCreated
    dateModified
  }
}
    ${ShipmentFragmentFragmentDoc}`;

/**
 * __useLookupBookingShipmentsQuery__
 *
 * To run a query within a React component, call `useLookupBookingShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupBookingShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupBookingShipmentsQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useLookupBookingShipmentsQuery(baseOptions: Apollo.QueryHookOptions<LookupBookingShipmentsQuery, LookupBookingShipmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupBookingShipmentsQuery, LookupBookingShipmentsQueryVariables>(LookupBookingShipmentsDocument, options);
      }
export function useLookupBookingShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupBookingShipmentsQuery, LookupBookingShipmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupBookingShipmentsQuery, LookupBookingShipmentsQueryVariables>(LookupBookingShipmentsDocument, options);
        }
export type LookupBookingShipmentsQueryHookResult = ReturnType<typeof useLookupBookingShipmentsQuery>;
export type LookupBookingShipmentsLazyQueryHookResult = ReturnType<typeof useLookupBookingShipmentsLazyQuery>;
export type LookupBookingShipmentsQueryResult = Apollo.QueryResult<LookupBookingShipmentsQuery, LookupBookingShipmentsQueryVariables>;
export const CommoditySectionsDocument = gql`
    query CommoditySections {
  commoditySections {
    id
    section
    description
    commodityChapters {
      id
      code
      description
    }
  }
}
    `;

/**
 * __useCommoditySectionsQuery__
 *
 * To run a query within a React component, call `useCommoditySectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommoditySectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommoditySectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommoditySectionsQuery(baseOptions?: Apollo.QueryHookOptions<CommoditySectionsQuery, CommoditySectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommoditySectionsQuery, CommoditySectionsQueryVariables>(CommoditySectionsDocument, options);
      }
export function useCommoditySectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommoditySectionsQuery, CommoditySectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommoditySectionsQuery, CommoditySectionsQueryVariables>(CommoditySectionsDocument, options);
        }
export type CommoditySectionsQueryHookResult = ReturnType<typeof useCommoditySectionsQuery>;
export type CommoditySectionsLazyQueryHookResult = ReturnType<typeof useCommoditySectionsLazyQuery>;
export type CommoditySectionsQueryResult = Apollo.QueryResult<CommoditySectionsQuery, CommoditySectionsQueryVariables>;
export const SaveBookingTransportDocument = gql`
    mutation SaveBookingTransport($inputs: SaveBookingTransportInputs!) {
  saveBookingTransport(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type SaveBookingTransportMutationFn = Apollo.MutationFunction<SaveBookingTransportMutation, SaveBookingTransportMutationVariables>;

/**
 * __useSaveBookingTransportMutation__
 *
 * To run a mutation, you first call `useSaveBookingTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingTransportMutation, { data, loading, error }] = useSaveBookingTransportMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveBookingTransportMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingTransportMutation, SaveBookingTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingTransportMutation, SaveBookingTransportMutationVariables>(SaveBookingTransportDocument, options);
      }
export type SaveBookingTransportMutationHookResult = ReturnType<typeof useSaveBookingTransportMutation>;
export type SaveBookingTransportMutationResult = Apollo.MutationResult<SaveBookingTransportMutation>;
export type SaveBookingTransportMutationOptions = Apollo.BaseMutationOptions<SaveBookingTransportMutation, SaveBookingTransportMutationVariables>;
export const CompleteBookingTransportDocument = gql`
    mutation CompleteBookingTransport($coyhawb: String!) {
  completeBookingTransport(coyhawb: $coyhawb) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type CompleteBookingTransportMutationFn = Apollo.MutationFunction<CompleteBookingTransportMutation, CompleteBookingTransportMutationVariables>;

/**
 * __useCompleteBookingTransportMutation__
 *
 * To run a mutation, you first call `useCompleteBookingTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteBookingTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeBookingTransportMutation, { data, loading, error }] = useCompleteBookingTransportMutation({
 *   variables: {
 *      coyhawb: // value for 'coyhawb'
 *   },
 * });
 */
export function useCompleteBookingTransportMutation(baseOptions?: Apollo.MutationHookOptions<CompleteBookingTransportMutation, CompleteBookingTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteBookingTransportMutation, CompleteBookingTransportMutationVariables>(CompleteBookingTransportDocument, options);
      }
export type CompleteBookingTransportMutationHookResult = ReturnType<typeof useCompleteBookingTransportMutation>;
export type CompleteBookingTransportMutationResult = Apollo.MutationResult<CompleteBookingTransportMutation>;
export type CompleteBookingTransportMutationOptions = Apollo.BaseMutationOptions<CompleteBookingTransportMutation, CompleteBookingTransportMutationVariables>;
export const OfficeActiveManifestsDocument = gql`
    query OfficeActiveManifests($officeid: Int!) {
  officeActiveManifests(officeid: $officeid)
}
    `;

/**
 * __useOfficeActiveManifestsQuery__
 *
 * To run a query within a React component, call `useOfficeActiveManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeActiveManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeActiveManifestsQuery({
 *   variables: {
 *      officeid: // value for 'officeid'
 *   },
 * });
 */
export function useOfficeActiveManifestsQuery(baseOptions: Apollo.QueryHookOptions<OfficeActiveManifestsQuery, OfficeActiveManifestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeActiveManifestsQuery, OfficeActiveManifestsQueryVariables>(OfficeActiveManifestsDocument, options);
      }
export function useOfficeActiveManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeActiveManifestsQuery, OfficeActiveManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeActiveManifestsQuery, OfficeActiveManifestsQueryVariables>(OfficeActiveManifestsDocument, options);
        }
export type OfficeActiveManifestsQueryHookResult = ReturnType<typeof useOfficeActiveManifestsQuery>;
export type OfficeActiveManifestsLazyQueryHookResult = ReturnType<typeof useOfficeActiveManifestsLazyQuery>;
export type OfficeActiveManifestsQueryResult = Apollo.QueryResult<OfficeActiveManifestsQuery, OfficeActiveManifestsQueryVariables>;
export const GetUnusedAndRecentlyUsedMawbVouchersDocument = gql`
    query GetUnusedAndRecentlyUsedMawbVouchers($days: Float, $officeid: Int!) {
  getUnusedAndRecentlyUsedMawbVouchers(officeid: $officeid, days: $days) {
    id
    borrowedByOffice {
      id
      client
    }
    ownedByOffice {
      id
      client
    }
    borrowedByOffice {
      id
      client
    }
    airline {
      id
      airlinename
      airlinecode
    }
    isUsed
    mawbNumber
  }
}
    `;

/**
 * __useGetUnusedAndRecentlyUsedMawbVouchersQuery__
 *
 * To run a query within a React component, call `useGetUnusedAndRecentlyUsedMawbVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnusedAndRecentlyUsedMawbVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnusedAndRecentlyUsedMawbVouchersQuery({
 *   variables: {
 *      days: // value for 'days'
 *      officeid: // value for 'officeid'
 *   },
 * });
 */
export function useGetUnusedAndRecentlyUsedMawbVouchersQuery(baseOptions: Apollo.QueryHookOptions<GetUnusedAndRecentlyUsedMawbVouchersQuery, GetUnusedAndRecentlyUsedMawbVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnusedAndRecentlyUsedMawbVouchersQuery, GetUnusedAndRecentlyUsedMawbVouchersQueryVariables>(GetUnusedAndRecentlyUsedMawbVouchersDocument, options);
      }
export function useGetUnusedAndRecentlyUsedMawbVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnusedAndRecentlyUsedMawbVouchersQuery, GetUnusedAndRecentlyUsedMawbVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnusedAndRecentlyUsedMawbVouchersQuery, GetUnusedAndRecentlyUsedMawbVouchersQueryVariables>(GetUnusedAndRecentlyUsedMawbVouchersDocument, options);
        }
export type GetUnusedAndRecentlyUsedMawbVouchersQueryHookResult = ReturnType<typeof useGetUnusedAndRecentlyUsedMawbVouchersQuery>;
export type GetUnusedAndRecentlyUsedMawbVouchersLazyQueryHookResult = ReturnType<typeof useGetUnusedAndRecentlyUsedMawbVouchersLazyQuery>;
export type GetUnusedAndRecentlyUsedMawbVouchersQueryResult = Apollo.QueryResult<GetUnusedAndRecentlyUsedMawbVouchersQuery, GetUnusedAndRecentlyUsedMawbVouchersQueryVariables>;
export const EmailAgentPrealertDocument = gql`
    mutation EmailAgentPrealert($inputs: EmailAgentPrealertInputs!) {
  emailAgentPrealert(inputs: $inputs) {
    coyhawb
    bookingTransport {
      id
      isPrealertSent
      prealertSentDate
    }
  }
}
    `;
export type EmailAgentPrealertMutationFn = Apollo.MutationFunction<EmailAgentPrealertMutation, EmailAgentPrealertMutationVariables>;

/**
 * __useEmailAgentPrealertMutation__
 *
 * To run a mutation, you first call `useEmailAgentPrealertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailAgentPrealertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailAgentPrealertMutation, { data, loading, error }] = useEmailAgentPrealertMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailAgentPrealertMutation(baseOptions?: Apollo.MutationHookOptions<EmailAgentPrealertMutation, EmailAgentPrealertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailAgentPrealertMutation, EmailAgentPrealertMutationVariables>(EmailAgentPrealertDocument, options);
      }
export type EmailAgentPrealertMutationHookResult = ReturnType<typeof useEmailAgentPrealertMutation>;
export type EmailAgentPrealertMutationResult = Apollo.MutationResult<EmailAgentPrealertMutation>;
export type EmailAgentPrealertMutationOptions = Apollo.BaseMutationOptions<EmailAgentPrealertMutation, EmailAgentPrealertMutationVariables>;
export const BookingContactsLookupDocument = gql`
    query BookingContactsLookup($inputs: GetBookingEmailInputs!) {
  GetBookingEmailInputs(inputs: $inputs) {
    contacts {
      email
      name
    }
    group
  }
}
    `;

/**
 * __useBookingContactsLookupQuery__
 *
 * To run a query within a React component, call `useBookingContactsLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingContactsLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingContactsLookupQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBookingContactsLookupQuery(baseOptions: Apollo.QueryHookOptions<BookingContactsLookupQuery, BookingContactsLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingContactsLookupQuery, BookingContactsLookupQueryVariables>(BookingContactsLookupDocument, options);
      }
export function useBookingContactsLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingContactsLookupQuery, BookingContactsLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingContactsLookupQuery, BookingContactsLookupQueryVariables>(BookingContactsLookupDocument, options);
        }
export type BookingContactsLookupQueryHookResult = ReturnType<typeof useBookingContactsLookupQuery>;
export type BookingContactsLookupLazyQueryHookResult = ReturnType<typeof useBookingContactsLookupLazyQuery>;
export type BookingContactsLookupQueryResult = Apollo.QueryResult<BookingContactsLookupQuery, BookingContactsLookupQueryVariables>;
export const IncotermsDocument = gql`
    query Incoterms {
  incoterms {
    id
    code
    name
    description
  }
}
    `;

/**
 * __useIncotermsQuery__
 *
 * To run a query within a React component, call `useIncotermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncotermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncotermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIncotermsQuery(baseOptions?: Apollo.QueryHookOptions<IncotermsQuery, IncotermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncotermsQuery, IncotermsQueryVariables>(IncotermsDocument, options);
      }
export function useIncotermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncotermsQuery, IncotermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncotermsQuery, IncotermsQueryVariables>(IncotermsDocument, options);
        }
export type IncotermsQueryHookResult = ReturnType<typeof useIncotermsQuery>;
export type IncotermsLazyQueryHookResult = ReturnType<typeof useIncotermsLazyQuery>;
export type IncotermsQueryResult = Apollo.QueryResult<IncotermsQuery, IncotermsQueryVariables>;
export const EditBookingDocument = gql`
    query EditBooking($hawb: String!) {
  booking(hawb: $hawb) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;

/**
 * __useEditBookingQuery__
 *
 * To run a query within a React component, call `useEditBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditBookingQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useEditBookingQuery(baseOptions: Apollo.QueryHookOptions<EditBookingQuery, EditBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditBookingQuery, EditBookingQueryVariables>(EditBookingDocument, options);
      }
export function useEditBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditBookingQuery, EditBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditBookingQuery, EditBookingQueryVariables>(EditBookingDocument, options);
        }
export type EditBookingQueryHookResult = ReturnType<typeof useEditBookingQuery>;
export type EditBookingLazyQueryHookResult = ReturnType<typeof useEditBookingLazyQuery>;
export type EditBookingQueryResult = Apollo.QueryResult<EditBookingQuery, EditBookingQueryVariables>;
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($inputs: UpdateBookingInputs!) {
  updateBooking(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const SaveBookingShipmentsDocument = gql`
    mutation SaveBookingShipments($inputs: SaveBookingShipmentsInputs!) {
  saveBookingShipments(inputs: $inputs) {
    ...EditBookingFields
  }
}
    ${EditBookingFieldsFragmentDoc}`;
export type SaveBookingShipmentsMutationFn = Apollo.MutationFunction<SaveBookingShipmentsMutation, SaveBookingShipmentsMutationVariables>;

/**
 * __useSaveBookingShipmentsMutation__
 *
 * To run a mutation, you first call `useSaveBookingShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingShipmentsMutation, { data, loading, error }] = useSaveBookingShipmentsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveBookingShipmentsMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingShipmentsMutation, SaveBookingShipmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingShipmentsMutation, SaveBookingShipmentsMutationVariables>(SaveBookingShipmentsDocument, options);
      }
export type SaveBookingShipmentsMutationHookResult = ReturnType<typeof useSaveBookingShipmentsMutation>;
export type SaveBookingShipmentsMutationResult = Apollo.MutationResult<SaveBookingShipmentsMutation>;
export type SaveBookingShipmentsMutationOptions = Apollo.BaseMutationOptions<SaveBookingShipmentsMutation, SaveBookingShipmentsMutationVariables>;
export const GenerateBookingChargesDocument = gql`
    query GenerateBookingCharges($coyhawb: String!) {
  generateBookingCharges(coyhawb: $coyhawb) {
    name
    net
    tax
    total
    discountrate
    source
    taxable
  }
}
    `;

/**
 * __useGenerateBookingChargesQuery__
 *
 * To run a query within a React component, call `useGenerateBookingChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateBookingChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateBookingChargesQuery({
 *   variables: {
 *      coyhawb: // value for 'coyhawb'
 *   },
 * });
 */
export function useGenerateBookingChargesQuery(baseOptions: Apollo.QueryHookOptions<GenerateBookingChargesQuery, GenerateBookingChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateBookingChargesQuery, GenerateBookingChargesQueryVariables>(GenerateBookingChargesDocument, options);
      }
export function useGenerateBookingChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateBookingChargesQuery, GenerateBookingChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateBookingChargesQuery, GenerateBookingChargesQueryVariables>(GenerateBookingChargesDocument, options);
        }
export type GenerateBookingChargesQueryHookResult = ReturnType<typeof useGenerateBookingChargesQuery>;
export type GenerateBookingChargesLazyQueryHookResult = ReturnType<typeof useGenerateBookingChargesLazyQuery>;
export type GenerateBookingChargesQueryResult = Apollo.QueryResult<GenerateBookingChargesQuery, GenerateBookingChargesQueryVariables>;
export const GenerateInvoiceDocument = gql`
    mutation GenerateInvoice($hawb: String!) {
  generateInvoice(hawb: $hawb) {
    coyhawb
    invoicedate
  }
}
    `;
export type GenerateInvoiceMutationFn = Apollo.MutationFunction<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>;

/**
 * __useGenerateInvoiceMutation__
 *
 * To run a mutation, you first call `useGenerateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoiceMutation, { data, loading, error }] = useGenerateInvoiceMutation({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useGenerateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>(GenerateInvoiceDocument, options);
      }
export type GenerateInvoiceMutationHookResult = ReturnType<typeof useGenerateInvoiceMutation>;
export type GenerateInvoiceMutationResult = Apollo.MutationResult<GenerateInvoiceMutation>;
export type GenerateInvoiceMutationOptions = Apollo.BaseMutationOptions<GenerateInvoiceMutation, GenerateInvoiceMutationVariables>;
export const BookingInvoiceDownloadURLDocument = gql`
    query BookingInvoiceDownloadURL($hawb: String!) {
  downloadBookingInvoice(hawb: $hawb)
}
    `;

/**
 * __useBookingInvoiceDownloadURLQuery__
 *
 * To run a query within a React component, call `useBookingInvoiceDownloadURLQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingInvoiceDownloadURLQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingInvoiceDownloadURLQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useBookingInvoiceDownloadURLQuery(baseOptions: Apollo.QueryHookOptions<BookingInvoiceDownloadURLQuery, BookingInvoiceDownloadURLQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingInvoiceDownloadURLQuery, BookingInvoiceDownloadURLQueryVariables>(BookingInvoiceDownloadURLDocument, options);
      }
export function useBookingInvoiceDownloadURLLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingInvoiceDownloadURLQuery, BookingInvoiceDownloadURLQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingInvoiceDownloadURLQuery, BookingInvoiceDownloadURLQueryVariables>(BookingInvoiceDownloadURLDocument, options);
        }
export type BookingInvoiceDownloadURLQueryHookResult = ReturnType<typeof useBookingInvoiceDownloadURLQuery>;
export type BookingInvoiceDownloadURLLazyQueryHookResult = ReturnType<typeof useBookingInvoiceDownloadURLLazyQuery>;
export type BookingInvoiceDownloadURLQueryResult = Apollo.QueryResult<BookingInvoiceDownloadURLQuery, BookingInvoiceDownloadURLQueryVariables>;
export const EmailBookingInvoiceDocument = gql`
    mutation EmailBookingInvoice($inputs: EmailInvoiceInputs!) {
  emailBookingInvoice(inputs: $inputs) {
    coyhawb
    invoiced
    invoicedate
    invoicesentdate
    invoiceno
  }
}
    `;
export type EmailBookingInvoiceMutationFn = Apollo.MutationFunction<EmailBookingInvoiceMutation, EmailBookingInvoiceMutationVariables>;

/**
 * __useEmailBookingInvoiceMutation__
 *
 * To run a mutation, you first call `useEmailBookingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailBookingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailBookingInvoiceMutation, { data, loading, error }] = useEmailBookingInvoiceMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailBookingInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<EmailBookingInvoiceMutation, EmailBookingInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailBookingInvoiceMutation, EmailBookingInvoiceMutationVariables>(EmailBookingInvoiceDocument, options);
      }
export type EmailBookingInvoiceMutationHookResult = ReturnType<typeof useEmailBookingInvoiceMutation>;
export type EmailBookingInvoiceMutationResult = Apollo.MutationResult<EmailBookingInvoiceMutation>;
export type EmailBookingInvoiceMutationOptions = Apollo.BaseMutationOptions<EmailBookingInvoiceMutation, EmailBookingInvoiceMutationVariables>;
export const BookingFinanceTabDocument = gql`
    query BookingFinanceTab($hawb: String!) {
  booking(hawb: $hawb) {
    coyhawb
    bookingCharges {
      ...BookingCharge
    }
    bookingCosts {
      ...CostOfSale
    }
  }
}
    ${BookingChargeFragmentDoc}
${CostOfSaleFragmentDoc}`;

/**
 * __useBookingFinanceTabQuery__
 *
 * To run a query within a React component, call `useBookingFinanceTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFinanceTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFinanceTabQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useBookingFinanceTabQuery(baseOptions: Apollo.QueryHookOptions<BookingFinanceTabQuery, BookingFinanceTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingFinanceTabQuery, BookingFinanceTabQueryVariables>(BookingFinanceTabDocument, options);
      }
export function useBookingFinanceTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingFinanceTabQuery, BookingFinanceTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingFinanceTabQuery, BookingFinanceTabQueryVariables>(BookingFinanceTabDocument, options);
        }
export type BookingFinanceTabQueryHookResult = ReturnType<typeof useBookingFinanceTabQuery>;
export type BookingFinanceTabLazyQueryHookResult = ReturnType<typeof useBookingFinanceTabLazyQuery>;
export type BookingFinanceTabQueryResult = Apollo.QueryResult<BookingFinanceTabQuery, BookingFinanceTabQueryVariables>;
export const SaveBookingFinanceDocument = gql`
    mutation SaveBookingFinance($inputs: SaveBookingFinanceInputs!) {
  saveBookingFinance(inputs: $inputs) {
    coyhawb
    bookingCharges {
      ...BookingCharge
    }
    bookingCosts {
      ...CostOfSale
    }
  }
}
    ${BookingChargeFragmentDoc}
${CostOfSaleFragmentDoc}`;
export type SaveBookingFinanceMutationFn = Apollo.MutationFunction<SaveBookingFinanceMutation, SaveBookingFinanceMutationVariables>;

/**
 * __useSaveBookingFinanceMutation__
 *
 * To run a mutation, you first call `useSaveBookingFinanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingFinanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingFinanceMutation, { data, loading, error }] = useSaveBookingFinanceMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveBookingFinanceMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingFinanceMutation, SaveBookingFinanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingFinanceMutation, SaveBookingFinanceMutationVariables>(SaveBookingFinanceDocument, options);
      }
export type SaveBookingFinanceMutationHookResult = ReturnType<typeof useSaveBookingFinanceMutation>;
export type SaveBookingFinanceMutationResult = Apollo.MutationResult<SaveBookingFinanceMutation>;
export type SaveBookingFinanceMutationOptions = Apollo.BaseMutationOptions<SaveBookingFinanceMutation, SaveBookingFinanceMutationVariables>;
export const BookingFormInputsDocument = gql`
    query BookingFormInputs($hawb: String!, $formID: PericulumFormID!) {
  booking(hawb: $hawb) {
    coyhawb
    bookingFormInputs(formID: $formID) {
      id
      coyhawb
      formID
      inputsJSON
    }
  }
}
    `;

/**
 * __useBookingFormInputsQuery__
 *
 * To run a query within a React component, call `useBookingFormInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingFormInputsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingFormInputsQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *      formID: // value for 'formID'
 *   },
 * });
 */
export function useBookingFormInputsQuery(baseOptions: Apollo.QueryHookOptions<BookingFormInputsQuery, BookingFormInputsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingFormInputsQuery, BookingFormInputsQueryVariables>(BookingFormInputsDocument, options);
      }
export function useBookingFormInputsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingFormInputsQuery, BookingFormInputsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingFormInputsQuery, BookingFormInputsQueryVariables>(BookingFormInputsDocument, options);
        }
export type BookingFormInputsQueryHookResult = ReturnType<typeof useBookingFormInputsQuery>;
export type BookingFormInputsLazyQueryHookResult = ReturnType<typeof useBookingFormInputsLazyQuery>;
export type BookingFormInputsQueryResult = Apollo.QueryResult<BookingFormInputsQuery, BookingFormInputsQueryVariables>;
export const DownloadBookingDocumentDocument = gql`
    mutation DownloadBookingDocument($downloadDocumentId: Int!) {
  downloadDocument(id: $downloadDocumentId)
}
    `;
export type DownloadBookingDocumentMutationFn = Apollo.MutationFunction<DownloadBookingDocumentMutation, DownloadBookingDocumentMutationVariables>;

/**
 * __useDownloadBookingDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadBookingDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadBookingDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadBookingDocumentMutation, { data, loading, error }] = useDownloadBookingDocumentMutation({
 *   variables: {
 *      downloadDocumentId: // value for 'downloadDocumentId'
 *   },
 * });
 */
export function useDownloadBookingDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DownloadBookingDocumentMutation, DownloadBookingDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadBookingDocumentMutation, DownloadBookingDocumentMutationVariables>(DownloadBookingDocumentDocument, options);
      }
export type DownloadBookingDocumentMutationHookResult = ReturnType<typeof useDownloadBookingDocumentMutation>;
export type DownloadBookingDocumentMutationResult = Apollo.MutationResult<DownloadBookingDocumentMutation>;
export type DownloadBookingDocumentMutationOptions = Apollo.BaseMutationOptions<DownloadBookingDocumentMutation, DownloadBookingDocumentMutationVariables>;
export const StartBookingUploadDocument = gql`
    mutation StartBookingUpload($inputs: [UploadDocumentInputs!]!) {
  startUpload(inputs: $inputs)
}
    `;
export type StartBookingUploadMutationFn = Apollo.MutationFunction<StartBookingUploadMutation, StartBookingUploadMutationVariables>;

/**
 * __useStartBookingUploadMutation__
 *
 * To run a mutation, you first call `useStartBookingUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBookingUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBookingUploadMutation, { data, loading, error }] = useStartBookingUploadMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useStartBookingUploadMutation(baseOptions?: Apollo.MutationHookOptions<StartBookingUploadMutation, StartBookingUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBookingUploadMutation, StartBookingUploadMutationVariables>(StartBookingUploadDocument, options);
      }
export type StartBookingUploadMutationHookResult = ReturnType<typeof useStartBookingUploadMutation>;
export type StartBookingUploadMutationResult = Apollo.MutationResult<StartBookingUploadMutation>;
export type StartBookingUploadMutationOptions = Apollo.BaseMutationOptions<StartBookingUploadMutation, StartBookingUploadMutationVariables>;
export const DeleteBookingDocumentDocument = gql`
    mutation DeleteBookingDocument($documentID: Int!) {
  deleteDocument(id: $documentID) {
    id
  }
}
    `;
export type DeleteBookingDocumentMutationFn = Apollo.MutationFunction<DeleteBookingDocumentMutation, DeleteBookingDocumentMutationVariables>;

/**
 * __useDeleteBookingDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteBookingDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingDocumentMutation, { data, loading, error }] = useDeleteBookingDocumentMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useDeleteBookingDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingDocumentMutation, DeleteBookingDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingDocumentMutation, DeleteBookingDocumentMutationVariables>(DeleteBookingDocumentDocument, options);
      }
export type DeleteBookingDocumentMutationHookResult = ReturnType<typeof useDeleteBookingDocumentMutation>;
export type DeleteBookingDocumentMutationResult = Apollo.MutationResult<DeleteBookingDocumentMutation>;
export type DeleteBookingDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteBookingDocumentMutation, DeleteBookingDocumentMutationVariables>;
export const SearchBookingsDocument = gql`
    query SearchBookings($filters: SearchBookingsFilters) {
  searchBookings(filters: $filters) {
    count
    total
    query
    records {
      id
      coyhawb
      categoryType
      lastNoteDate
      client {
        id
        client
      }
      consignee {
        id
        client
      }
      jobdate
      origcode
      origin {
        id
        cityname
      }
      destcode
      destination {
        id
        cityname
      }
      bookingOffice {
        id
        client
      }
      bookingtype
      status
    }
  }
}
    `;

/**
 * __useSearchBookingsQuery__
 *
 * To run a query within a React component, call `useSearchBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBookingsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchBookingsQuery(baseOptions?: Apollo.QueryHookOptions<SearchBookingsQuery, SearchBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBookingsQuery, SearchBookingsQueryVariables>(SearchBookingsDocument, options);
      }
export function useSearchBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBookingsQuery, SearchBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBookingsQuery, SearchBookingsQueryVariables>(SearchBookingsDocument, options);
        }
export type SearchBookingsQueryHookResult = ReturnType<typeof useSearchBookingsQuery>;
export type SearchBookingsLazyQueryHookResult = ReturnType<typeof useSearchBookingsLazyQuery>;
export type SearchBookingsQueryResult = Apollo.QueryResult<SearchBookingsQuery, SearchBookingsQueryVariables>;
export const ViewBookingDocument = gql`
    query ViewBooking($hawb: String!) {
  booking(hawb: $hawb) {
    ...ViewBookingFields
  }
}
    ${ViewBookingFieldsFragmentDoc}`;

/**
 * __useViewBookingQuery__
 *
 * To run a query within a React component, call `useViewBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewBookingQuery({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useViewBookingQuery(baseOptions: Apollo.QueryHookOptions<ViewBookingQuery, ViewBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewBookingQuery, ViewBookingQueryVariables>(ViewBookingDocument, options);
      }
export function useViewBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewBookingQuery, ViewBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewBookingQuery, ViewBookingQueryVariables>(ViewBookingDocument, options);
        }
export type ViewBookingQueryHookResult = ReturnType<typeof useViewBookingQuery>;
export type ViewBookingLazyQueryHookResult = ReturnType<typeof useViewBookingLazyQuery>;
export type ViewBookingQueryResult = Apollo.QueryResult<ViewBookingQuery, ViewBookingQueryVariables>;
export const CreateBookingNoteDocument = gql`
    mutation CreateBookingNote($inputs: CreateBookingNoteInputs!) {
  createBookingNote(inputs: $inputs) {
    id
    coyhawb
    notes {
      ...BookingNoteFields
    }
  }
}
    ${BookingNoteFieldsFragmentDoc}`;
export type CreateBookingNoteMutationFn = Apollo.MutationFunction<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>;

/**
 * __useCreateBookingNoteMutation__
 *
 * To run a mutation, you first call `useCreateBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingNoteMutation, { data, loading, error }] = useCreateBookingNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>(CreateBookingNoteDocument, options);
      }
export type CreateBookingNoteMutationHookResult = ReturnType<typeof useCreateBookingNoteMutation>;
export type CreateBookingNoteMutationResult = Apollo.MutationResult<CreateBookingNoteMutation>;
export type CreateBookingNoteMutationOptions = Apollo.BaseMutationOptions<CreateBookingNoteMutation, CreateBookingNoteMutationVariables>;
export const UpdateBookingNoteDocument = gql`
    mutation UpdateBookingNote($inputs: UpdateBookingNoteInputs!) {
  updateBookingNote(inputs: $inputs) {
    id
    coyhawb
    lastNoteDate
    notes {
      ...BookingNoteFields
    }
  }
}
    ${BookingNoteFieldsFragmentDoc}`;
export type UpdateBookingNoteMutationFn = Apollo.MutationFunction<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>;

/**
 * __useUpdateBookingNoteMutation__
 *
 * To run a mutation, you first call `useUpdateBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingNoteMutation, { data, loading, error }] = useUpdateBookingNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>(UpdateBookingNoteDocument, options);
      }
export type UpdateBookingNoteMutationHookResult = ReturnType<typeof useUpdateBookingNoteMutation>;
export type UpdateBookingNoteMutationResult = Apollo.MutationResult<UpdateBookingNoteMutation>;
export type UpdateBookingNoteMutationOptions = Apollo.BaseMutationOptions<UpdateBookingNoteMutation, UpdateBookingNoteMutationVariables>;
export const DeleteBookingNoteDocument = gql`
    mutation DeleteBookingNote($id: Int!) {
  deleteBookingNote(id: $id) {
    id
  }
}
    `;
export type DeleteBookingNoteMutationFn = Apollo.MutationFunction<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>;

/**
 * __useDeleteBookingNoteMutation__
 *
 * To run a mutation, you first call `useDeleteBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingNoteMutation, { data, loading, error }] = useDeleteBookingNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>(DeleteBookingNoteDocument, options);
      }
export type DeleteBookingNoteMutationHookResult = ReturnType<typeof useDeleteBookingNoteMutation>;
export type DeleteBookingNoteMutationResult = Apollo.MutationResult<DeleteBookingNoteMutation>;
export type DeleteBookingNoteMutationOptions = Apollo.BaseMutationOptions<DeleteBookingNoteMutation, DeleteBookingNoteMutationVariables>;
export const EmailBookingNoteDocument = gql`
    mutation EmailBookingNote($inputs: EmailBookingNoteInputs!) {
  emailNote(inputs: $inputs) {
    id
    coyhawb
    lastNoteDate
    notes {
      ...BookingNoteFields
    }
  }
}
    ${BookingNoteFieldsFragmentDoc}`;
export type EmailBookingNoteMutationFn = Apollo.MutationFunction<EmailBookingNoteMutation, EmailBookingNoteMutationVariables>;

/**
 * __useEmailBookingNoteMutation__
 *
 * To run a mutation, you first call `useEmailBookingNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailBookingNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailBookingNoteMutation, { data, loading, error }] = useEmailBookingNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailBookingNoteMutation(baseOptions?: Apollo.MutationHookOptions<EmailBookingNoteMutation, EmailBookingNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailBookingNoteMutation, EmailBookingNoteMutationVariables>(EmailBookingNoteDocument, options);
      }
export type EmailBookingNoteMutationHookResult = ReturnType<typeof useEmailBookingNoteMutation>;
export type EmailBookingNoteMutationResult = Apollo.MutationResult<EmailBookingNoteMutation>;
export type EmailBookingNoteMutationOptions = Apollo.BaseMutationOptions<EmailBookingNoteMutation, EmailBookingNoteMutationVariables>;
export const BookingActivityDocument = gql`
    query BookingActivity($inputs: FilterActivityLogs) {
  activityLogsCount(inputs: $inputs)
  activityLogs(inputs: $inputs) {
    ...ActivityLogFields
  }
}
    ${ActivityLogFieldsFragmentDoc}`;

/**
 * __useBookingActivityQuery__
 *
 * To run a query within a React component, call `useBookingActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingActivityQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBookingActivityQuery(baseOptions?: Apollo.QueryHookOptions<BookingActivityQuery, BookingActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingActivityQuery, BookingActivityQueryVariables>(BookingActivityDocument, options);
      }
export function useBookingActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingActivityQuery, BookingActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingActivityQuery, BookingActivityQueryVariables>(BookingActivityDocument, options);
        }
export type BookingActivityQueryHookResult = ReturnType<typeof useBookingActivityQuery>;
export type BookingActivityLazyQueryHookResult = ReturnType<typeof useBookingActivityLazyQuery>;
export type BookingActivityQueryResult = Apollo.QueryResult<BookingActivityQuery, BookingActivityQueryVariables>;
export const GeneratePericulumFormDocument = gql`
    mutation GeneratePericulumForm($formId: PericulumFormID!, $hawb: String!, $format: PericulumFormFormat!, $inputs: JSONObject) {
  generatePericulumForm(
    formID: $formId
    hawb: $hawb
    format: $format
    inputs: $inputs
  )
}
    `;
export type GeneratePericulumFormMutationFn = Apollo.MutationFunction<GeneratePericulumFormMutation, GeneratePericulumFormMutationVariables>;

/**
 * __useGeneratePericulumFormMutation__
 *
 * To run a mutation, you first call `useGeneratePericulumFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePericulumFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePericulumFormMutation, { data, loading, error }] = useGeneratePericulumFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      hawb: // value for 'hawb'
 *      format: // value for 'format'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGeneratePericulumFormMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePericulumFormMutation, GeneratePericulumFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePericulumFormMutation, GeneratePericulumFormMutationVariables>(GeneratePericulumFormDocument, options);
      }
export type GeneratePericulumFormMutationHookResult = ReturnType<typeof useGeneratePericulumFormMutation>;
export type GeneratePericulumFormMutationResult = Apollo.MutationResult<GeneratePericulumFormMutation>;
export type GeneratePericulumFormMutationOptions = Apollo.BaseMutationOptions<GeneratePericulumFormMutation, GeneratePericulumFormMutationVariables>;
export const DeleteBookingDocument = gql`
    mutation DeleteBooking($coyhawb: String!) {
  deleteBooking(coyhawb: $coyhawb) {
    coyhawb
  }
}
    `;
export type DeleteBookingMutationFn = Apollo.MutationFunction<DeleteBookingMutation, DeleteBookingMutationVariables>;

/**
 * __useDeleteBookingMutation__
 *
 * To run a mutation, you first call `useDeleteBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookingMutation, { data, loading, error }] = useDeleteBookingMutation({
 *   variables: {
 *      coyhawb: // value for 'coyhawb'
 *   },
 * });
 */
export function useDeleteBookingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookingMutation, DeleteBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookingMutation, DeleteBookingMutationVariables>(DeleteBookingDocument, options);
      }
export type DeleteBookingMutationHookResult = ReturnType<typeof useDeleteBookingMutation>;
export type DeleteBookingMutationResult = Apollo.MutationResult<DeleteBookingMutation>;
export type DeleteBookingMutationOptions = Apollo.BaseMutationOptions<DeleteBookingMutation, DeleteBookingMutationVariables>;
export const CloneBookingDocument = gql`
    mutation CloneBooking($inputs: CloneBookingInputs!) {
  cloneBooking(inputs: $inputs) {
    ...ViewBookingFields
  }
}
    ${ViewBookingFieldsFragmentDoc}`;
export type CloneBookingMutationFn = Apollo.MutationFunction<CloneBookingMutation, CloneBookingMutationVariables>;

/**
 * __useCloneBookingMutation__
 *
 * To run a mutation, you first call `useCloneBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneBookingMutation, { data, loading, error }] = useCloneBookingMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCloneBookingMutation(baseOptions?: Apollo.MutationHookOptions<CloneBookingMutation, CloneBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneBookingMutation, CloneBookingMutationVariables>(CloneBookingDocument, options);
      }
export type CloneBookingMutationHookResult = ReturnType<typeof useCloneBookingMutation>;
export type CloneBookingMutationResult = Apollo.MutationResult<CloneBookingMutation>;
export type CloneBookingMutationOptions = Apollo.BaseMutationOptions<CloneBookingMutation, CloneBookingMutationVariables>;
export const CancelBookingDocument = gql`
    mutation CancelBooking($hawb: String!) {
  cancelBooking(hawb: $hawb) {
    coyhawb
    status
    notes {
      ...BookingNoteFields
    }
  }
}
    ${BookingNoteFieldsFragmentDoc}`;
export type CancelBookingMutationFn = Apollo.MutationFunction<CancelBookingMutation, CancelBookingMutationVariables>;

/**
 * __useCancelBookingMutation__
 *
 * To run a mutation, you first call `useCancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBookingMutation, { data, loading, error }] = useCancelBookingMutation({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useCancelBookingMutation(baseOptions?: Apollo.MutationHookOptions<CancelBookingMutation, CancelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, options);
      }
export type CancelBookingMutationHookResult = ReturnType<typeof useCancelBookingMutation>;
export type CancelBookingMutationResult = Apollo.MutationResult<CancelBookingMutation>;
export type CancelBookingMutationOptions = Apollo.BaseMutationOptions<CancelBookingMutation, CancelBookingMutationVariables>;
export const UncancelBookingDocument = gql`
    mutation UncancelBooking($hawb: String!) {
  uncancelBooking(hawb: $hawb) {
    coyhawb
    status
    notes {
      ...BookingNoteFields
    }
  }
}
    ${BookingNoteFieldsFragmentDoc}`;
export type UncancelBookingMutationFn = Apollo.MutationFunction<UncancelBookingMutation, UncancelBookingMutationVariables>;

/**
 * __useUncancelBookingMutation__
 *
 * To run a mutation, you first call `useUncancelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncancelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncancelBookingMutation, { data, loading, error }] = useUncancelBookingMutation({
 *   variables: {
 *      hawb: // value for 'hawb'
 *   },
 * });
 */
export function useUncancelBookingMutation(baseOptions?: Apollo.MutationHookOptions<UncancelBookingMutation, UncancelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncancelBookingMutation, UncancelBookingMutationVariables>(UncancelBookingDocument, options);
      }
export type UncancelBookingMutationHookResult = ReturnType<typeof useUncancelBookingMutation>;
export type UncancelBookingMutationResult = Apollo.MutationResult<UncancelBookingMutation>;
export type UncancelBookingMutationOptions = Apollo.BaseMutationOptions<UncancelBookingMutation, UncancelBookingMutationVariables>;
export const OfficeChargesJobTariffsDocument = gql`
    query OfficeChargesJobTariffs($inputs: GetJobTariffsFilters) {
  jobTariffsCount(inputs: $inputs)
  jobTariffs(inputs: $inputs) {
    ...JobTariff
  }
}
    ${JobTariffFragmentDoc}`;

/**
 * __useOfficeChargesJobTariffsQuery__
 *
 * To run a query within a React component, call `useOfficeChargesJobTariffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeChargesJobTariffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeChargesJobTariffsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useOfficeChargesJobTariffsQuery(baseOptions?: Apollo.QueryHookOptions<OfficeChargesJobTariffsQuery, OfficeChargesJobTariffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeChargesJobTariffsQuery, OfficeChargesJobTariffsQueryVariables>(OfficeChargesJobTariffsDocument, options);
      }
export function useOfficeChargesJobTariffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeChargesJobTariffsQuery, OfficeChargesJobTariffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeChargesJobTariffsQuery, OfficeChargesJobTariffsQueryVariables>(OfficeChargesJobTariffsDocument, options);
        }
export type OfficeChargesJobTariffsQueryHookResult = ReturnType<typeof useOfficeChargesJobTariffsQuery>;
export type OfficeChargesJobTariffsLazyQueryHookResult = ReturnType<typeof useOfficeChargesJobTariffsLazyQuery>;
export type OfficeChargesJobTariffsQueryResult = Apollo.QueryResult<OfficeChargesJobTariffsQuery, OfficeChargesJobTariffsQueryVariables>;
export const JobTariffDetailsByIDDocument = gql`
    query JobTariffDetailsByID($id: Int!) {
  jobTariffByID(id: $id) {
    id
    zone
    isActive
    minweight
    minweightkg
    dateCreated
    dateModified
    category
    perkg
    region {
      id
      name
    }
    officeAccount {
      id
      client
      country {
        id
        locale
        moneysymbol
      }
    }
  }
}
    `;

/**
 * __useJobTariffDetailsByIDQuery__
 *
 * To run a query within a React component, call `useJobTariffDetailsByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTariffDetailsByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTariffDetailsByIDQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobTariffDetailsByIDQuery(baseOptions: Apollo.QueryHookOptions<JobTariffDetailsByIDQuery, JobTariffDetailsByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTariffDetailsByIDQuery, JobTariffDetailsByIDQueryVariables>(JobTariffDetailsByIDDocument, options);
      }
export function useJobTariffDetailsByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTariffDetailsByIDQuery, JobTariffDetailsByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTariffDetailsByIDQuery, JobTariffDetailsByIDQueryVariables>(JobTariffDetailsByIDDocument, options);
        }
export type JobTariffDetailsByIDQueryHookResult = ReturnType<typeof useJobTariffDetailsByIDQuery>;
export type JobTariffDetailsByIDLazyQueryHookResult = ReturnType<typeof useJobTariffDetailsByIDLazyQuery>;
export type JobTariffDetailsByIDQueryResult = Apollo.QueryResult<JobTariffDetailsByIDQuery, JobTariffDetailsByIDQueryVariables>;
export const CreateJobTariffDocument = gql`
    mutation CreateJobTariff($inputs: CreateJobTariffInputs!) {
  createJobTariff(inputs: $inputs) {
    id
    zone
    isActive
    minweight
    minweightkg
    dateCreated
    dateModified
    category
    perkg
    region {
      id
      name
    }
    officeAccount {
      id
      client
      country {
        id
        locale
        moneysymbol
      }
    }
  }
}
    `;
export type CreateJobTariffMutationFn = Apollo.MutationFunction<CreateJobTariffMutation, CreateJobTariffMutationVariables>;

/**
 * __useCreateJobTariffMutation__
 *
 * To run a mutation, you first call `useCreateJobTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobTariffMutation, { data, loading, error }] = useCreateJobTariffMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateJobTariffMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobTariffMutation, CreateJobTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobTariffMutation, CreateJobTariffMutationVariables>(CreateJobTariffDocument, options);
      }
export type CreateJobTariffMutationHookResult = ReturnType<typeof useCreateJobTariffMutation>;
export type CreateJobTariffMutationResult = Apollo.MutationResult<CreateJobTariffMutation>;
export type CreateJobTariffMutationOptions = Apollo.BaseMutationOptions<CreateJobTariffMutation, CreateJobTariffMutationVariables>;
export const UpdateJobTariffDocument = gql`
    mutation UpdateJobTariff($inputs: UpdateJobTariffInputs!) {
  updateJobTariff(inputs: $inputs) {
    id
    zone
    isActive
    minweight
    minweightkg
    dateCreated
    dateModified
    category
    perkg
    region {
      id
      name
    }
    officeAccount {
      id
      client
      country {
        id
        locale
        moneysymbol
      }
    }
  }
}
    `;
export type UpdateJobTariffMutationFn = Apollo.MutationFunction<UpdateJobTariffMutation, UpdateJobTariffMutationVariables>;

/**
 * __useUpdateJobTariffMutation__
 *
 * To run a mutation, you first call `useUpdateJobTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobTariffMutation, { data, loading, error }] = useUpdateJobTariffMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateJobTariffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobTariffMutation, UpdateJobTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobTariffMutation, UpdateJobTariffMutationVariables>(UpdateJobTariffDocument, options);
      }
export type UpdateJobTariffMutationHookResult = ReturnType<typeof useUpdateJobTariffMutation>;
export type UpdateJobTariffMutationResult = Apollo.MutationResult<UpdateJobTariffMutation>;
export type UpdateJobTariffMutationOptions = Apollo.BaseMutationOptions<UpdateJobTariffMutation, UpdateJobTariffMutationVariables>;
export const PackagingTariffsDocument = gql`
    query PackagingTariffs($filters: GetPackagingTariffsFilters!) {
  packagingTariffs(filters: $filters) {
    id
    office {
      id
    }
    packtype
    packsize
    cost
    cost2
    isActive
    dateModified
  }
}
    `;

/**
 * __usePackagingTariffsQuery__
 *
 * To run a query within a React component, call `usePackagingTariffsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingTariffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingTariffsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePackagingTariffsQuery(baseOptions: Apollo.QueryHookOptions<PackagingTariffsQuery, PackagingTariffsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingTariffsQuery, PackagingTariffsQueryVariables>(PackagingTariffsDocument, options);
      }
export function usePackagingTariffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingTariffsQuery, PackagingTariffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingTariffsQuery, PackagingTariffsQueryVariables>(PackagingTariffsDocument, options);
        }
export type PackagingTariffsQueryHookResult = ReturnType<typeof usePackagingTariffsQuery>;
export type PackagingTariffsLazyQueryHookResult = ReturnType<typeof usePackagingTariffsLazyQuery>;
export type PackagingTariffsQueryResult = Apollo.QueryResult<PackagingTariffsQuery, PackagingTariffsQueryVariables>;
export const UpdatePackagingTariffDocument = gql`
    mutation UpdatePackagingTariff($inputs: UpdatePackagingTariffInputs!) {
  updatePackagingTariff(inputs: $inputs) {
    id
    packtype
    packsize
    cost
    cost2
    isActive
    dateModified
  }
}
    `;
export type UpdatePackagingTariffMutationFn = Apollo.MutationFunction<UpdatePackagingTariffMutation, UpdatePackagingTariffMutationVariables>;

/**
 * __useUpdatePackagingTariffMutation__
 *
 * To run a mutation, you first call `useUpdatePackagingTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackagingTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackagingTariffMutation, { data, loading, error }] = useUpdatePackagingTariffMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdatePackagingTariffMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackagingTariffMutation, UpdatePackagingTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackagingTariffMutation, UpdatePackagingTariffMutationVariables>(UpdatePackagingTariffDocument, options);
      }
export type UpdatePackagingTariffMutationHookResult = ReturnType<typeof useUpdatePackagingTariffMutation>;
export type UpdatePackagingTariffMutationResult = Apollo.MutationResult<UpdatePackagingTariffMutation>;
export type UpdatePackagingTariffMutationOptions = Apollo.BaseMutationOptions<UpdatePackagingTariffMutation, UpdatePackagingTariffMutationVariables>;
export const CreatePackagingTariffDocument = gql`
    mutation CreatePackagingTariff($inputs: CreatePackagingTariffInputs!) {
  createPackagingTariff(inputs: $inputs) {
    id
    packtype
    packsize
    cost
    cost2
    isActive
    dateModified
  }
}
    `;
export type CreatePackagingTariffMutationFn = Apollo.MutationFunction<CreatePackagingTariffMutation, CreatePackagingTariffMutationVariables>;

/**
 * __useCreatePackagingTariffMutation__
 *
 * To run a mutation, you first call `useCreatePackagingTariffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackagingTariffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackagingTariffMutation, { data, loading, error }] = useCreatePackagingTariffMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreatePackagingTariffMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackagingTariffMutation, CreatePackagingTariffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackagingTariffMutation, CreatePackagingTariffMutationVariables>(CreatePackagingTariffDocument, options);
      }
export type CreatePackagingTariffMutationHookResult = ReturnType<typeof useCreatePackagingTariffMutation>;
export type CreatePackagingTariffMutationResult = Apollo.MutationResult<CreatePackagingTariffMutation>;
export type CreatePackagingTariffMutationOptions = Apollo.BaseMutationOptions<CreatePackagingTariffMutation, CreatePackagingTariffMutationVariables>;
export const OfficeChargesByOfficeDocument = gql`
    query OfficeChargesByOffice($id: Int!) {
  officeChargesByOfficeID(id: $id) {
    ...OfficeChargeFields
  }
}
    ${OfficeChargeFieldsFragmentDoc}`;

/**
 * __useOfficeChargesByOfficeQuery__
 *
 * To run a query within a React component, call `useOfficeChargesByOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeChargesByOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeChargesByOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfficeChargesByOfficeQuery(baseOptions: Apollo.QueryHookOptions<OfficeChargesByOfficeQuery, OfficeChargesByOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeChargesByOfficeQuery, OfficeChargesByOfficeQueryVariables>(OfficeChargesByOfficeDocument, options);
      }
export function useOfficeChargesByOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeChargesByOfficeQuery, OfficeChargesByOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeChargesByOfficeQuery, OfficeChargesByOfficeQueryVariables>(OfficeChargesByOfficeDocument, options);
        }
export type OfficeChargesByOfficeQueryHookResult = ReturnType<typeof useOfficeChargesByOfficeQuery>;
export type OfficeChargesByOfficeLazyQueryHookResult = ReturnType<typeof useOfficeChargesByOfficeLazyQuery>;
export type OfficeChargesByOfficeQueryResult = Apollo.QueryResult<OfficeChargesByOfficeQuery, OfficeChargesByOfficeQueryVariables>;
export const OfficeChargeByIDDocument = gql`
    query OfficeChargeByID($id: Int!) {
  officeChargeByID(id: $id) {
    ...OfficeChargeFields
    office {
      id
      client
      officeConfiguration {
        id
        locale
        currencyCode
      }
    }
  }
}
    ${OfficeChargeFieldsFragmentDoc}`;

/**
 * __useOfficeChargeByIDQuery__
 *
 * To run a query within a React component, call `useOfficeChargeByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfficeChargeByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfficeChargeByIDQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfficeChargeByIDQuery(baseOptions: Apollo.QueryHookOptions<OfficeChargeByIDQuery, OfficeChargeByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfficeChargeByIDQuery, OfficeChargeByIDQueryVariables>(OfficeChargeByIDDocument, options);
      }
export function useOfficeChargeByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfficeChargeByIDQuery, OfficeChargeByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfficeChargeByIDQuery, OfficeChargeByIDQueryVariables>(OfficeChargeByIDDocument, options);
        }
export type OfficeChargeByIDQueryHookResult = ReturnType<typeof useOfficeChargeByIDQuery>;
export type OfficeChargeByIDLazyQueryHookResult = ReturnType<typeof useOfficeChargeByIDLazyQuery>;
export type OfficeChargeByIDQueryResult = Apollo.QueryResult<OfficeChargeByIDQuery, OfficeChargeByIDQueryVariables>;
export const CreateOfficeChargeDocument = gql`
    mutation CreateOfficeCharge($inputs: CreateOfficeChargeInputs!) {
  createOfficeCharge(inputs: $inputs) {
    ...OfficeChargeFields
  }
}
    ${OfficeChargeFieldsFragmentDoc}`;
export type CreateOfficeChargeMutationFn = Apollo.MutationFunction<CreateOfficeChargeMutation, CreateOfficeChargeMutationVariables>;

/**
 * __useCreateOfficeChargeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeChargeMutation, { data, loading, error }] = useCreateOfficeChargeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateOfficeChargeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfficeChargeMutation, CreateOfficeChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfficeChargeMutation, CreateOfficeChargeMutationVariables>(CreateOfficeChargeDocument, options);
      }
export type CreateOfficeChargeMutationHookResult = ReturnType<typeof useCreateOfficeChargeMutation>;
export type CreateOfficeChargeMutationResult = Apollo.MutationResult<CreateOfficeChargeMutation>;
export type CreateOfficeChargeMutationOptions = Apollo.BaseMutationOptions<CreateOfficeChargeMutation, CreateOfficeChargeMutationVariables>;
export const UpdateOfficeChargeDocument = gql`
    mutation UpdateOfficeCharge($inputs: UpdateOfficeChargeInputs!) {
  updateOfficeCharge(inputs: $inputs) {
    ...OfficeChargeFields
  }
}
    ${OfficeChargeFieldsFragmentDoc}`;
export type UpdateOfficeChargeMutationFn = Apollo.MutationFunction<UpdateOfficeChargeMutation, UpdateOfficeChargeMutationVariables>;

/**
 * __useUpdateOfficeChargeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeChargeMutation, { data, loading, error }] = useUpdateOfficeChargeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateOfficeChargeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfficeChargeMutation, UpdateOfficeChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfficeChargeMutation, UpdateOfficeChargeMutationVariables>(UpdateOfficeChargeDocument, options);
      }
export type UpdateOfficeChargeMutationHookResult = ReturnType<typeof useUpdateOfficeChargeMutation>;
export type UpdateOfficeChargeMutationResult = Apollo.MutationResult<UpdateOfficeChargeMutation>;
export type UpdateOfficeChargeMutationOptions = Apollo.BaseMutationOptions<UpdateOfficeChargeMutation, UpdateOfficeChargeMutationVariables>;
export const DeleteOfficeChargeDocument = gql`
    mutation DeleteOfficeCharge($id: Int!) {
  deleteOfficeCharge(id: $id) {
    id
  }
}
    `;
export type DeleteOfficeChargeMutationFn = Apollo.MutationFunction<DeleteOfficeChargeMutation, DeleteOfficeChargeMutationVariables>;

/**
 * __useDeleteOfficeChargeMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeChargeMutation, { data, loading, error }] = useDeleteOfficeChargeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfficeChargeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfficeChargeMutation, DeleteOfficeChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfficeChargeMutation, DeleteOfficeChargeMutationVariables>(DeleteOfficeChargeDocument, options);
      }
export type DeleteOfficeChargeMutationHookResult = ReturnType<typeof useDeleteOfficeChargeMutation>;
export type DeleteOfficeChargeMutationResult = Apollo.MutationResult<DeleteOfficeChargeMutation>;
export type DeleteOfficeChargeMutationOptions = Apollo.BaseMutationOptions<DeleteOfficeChargeMutation, DeleteOfficeChargeMutationVariables>;
export const SearchContactsDocument = gql`
    query SearchContacts($filters: SearchContactsFilters!) {
  searchContacts(filters: $filters) {
    count
    records {
      id
      account {
        id
        client
      }
      name
      position
      phone
      email
      isActive
      dateModified
    }
    total
    query
  }
}
    `;

/**
 * __useSearchContactsQuery__
 *
 * To run a query within a React component, call `useSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
      }
export function useSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export type SearchContactsQueryHookResult = ReturnType<typeof useSearchContactsQuery>;
export type SearchContactsLazyQueryHookResult = ReturnType<typeof useSearchContactsLazyQuery>;
export type SearchContactsQueryResult = Apollo.QueryResult<SearchContactsQuery, SearchContactsQueryVariables>;
export const AccountContactDocument = gql`
    query AccountContact($contactID: Int!, $inputs: FilterActivityLogs) {
  accountContact(id: $contactID) {
    id
    account {
      id
      client
      address1
      address2
      town
      country {
        id
        Country
      }
    }
    name
    position
    phone
    phone2
    fax
    email
    address1
    address2
    town
    state
    zip
    country {
      id
      Country
    }
    isActive
    notes
    dateCreated
    dateModified
  }
  activityLogs(inputs: $inputs) {
    id
    description
    employee {
      id
      fullname
      picture
      office {
        id
        client
      }
    }
    dateCreated
  }
}
    `;

/**
 * __useAccountContactQuery__
 *
 * To run a query within a React component, call `useAccountContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountContactQuery({
 *   variables: {
 *      contactID: // value for 'contactID'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAccountContactQuery(baseOptions: Apollo.QueryHookOptions<AccountContactQuery, AccountContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountContactQuery, AccountContactQueryVariables>(AccountContactDocument, options);
      }
export function useAccountContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountContactQuery, AccountContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountContactQuery, AccountContactQueryVariables>(AccountContactDocument, options);
        }
export type AccountContactQueryHookResult = ReturnType<typeof useAccountContactQuery>;
export type AccountContactLazyQueryHookResult = ReturnType<typeof useAccountContactLazyQuery>;
export type AccountContactQueryResult = Apollo.QueryResult<AccountContactQuery, AccountContactQueryVariables>;
export const CreateAccountContactDocument = gql`
    mutation CreateAccountContact($inputs: CreateAccountContactInput!) {
  createAccountContact(inputs: $inputs) {
    id
    account {
      id
      client
    }
    name
    position
    phone
    phone2
    fax
    email
    address1
    address2
    town
    state
    zip
    country {
      id
      Country
    }
    isActive
    notes
    dateCreated
    dateModified
  }
}
    `;
export type CreateAccountContactMutationFn = Apollo.MutationFunction<CreateAccountContactMutation, CreateAccountContactMutationVariables>;

/**
 * __useCreateAccountContactMutation__
 *
 * To run a mutation, you first call `useCreateAccountContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountContactMutation, { data, loading, error }] = useCreateAccountContactMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAccountContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountContactMutation, CreateAccountContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountContactMutation, CreateAccountContactMutationVariables>(CreateAccountContactDocument, options);
      }
export type CreateAccountContactMutationHookResult = ReturnType<typeof useCreateAccountContactMutation>;
export type CreateAccountContactMutationResult = Apollo.MutationResult<CreateAccountContactMutation>;
export type CreateAccountContactMutationOptions = Apollo.BaseMutationOptions<CreateAccountContactMutation, CreateAccountContactMutationVariables>;
export const UpdateAccountContactDocument = gql`
    mutation UpdateAccountContact($inputs: UpdateAccountContactInput!) {
  updateAccountContact(inputs: $inputs) {
    id
    account {
      id
      client
    }
    name
    position
    phone
    phone2
    fax
    email
    address1
    address2
    town
    state
    zip
    country {
      id
      Country
    }
    isActive
    notes
    dateCreated
    dateModified
  }
}
    `;
export type UpdateAccountContactMutationFn = Apollo.MutationFunction<UpdateAccountContactMutation, UpdateAccountContactMutationVariables>;

/**
 * __useUpdateAccountContactMutation__
 *
 * To run a mutation, you first call `useUpdateAccountContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountContactMutation, { data, loading, error }] = useUpdateAccountContactMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateAccountContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountContactMutation, UpdateAccountContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountContactMutation, UpdateAccountContactMutationVariables>(UpdateAccountContactDocument, options);
      }
export type UpdateAccountContactMutationHookResult = ReturnType<typeof useUpdateAccountContactMutation>;
export type UpdateAccountContactMutationResult = Apollo.MutationResult<UpdateAccountContactMutation>;
export type UpdateAccountContactMutationOptions = Apollo.BaseMutationOptions<UpdateAccountContactMutation, UpdateAccountContactMutationVariables>;
export const DeleteAccountContactDocument = gql`
    mutation DeleteAccountContact($contactID: Int!) {
  deleteAccountContact(id: $contactID) {
    id
  }
}
    `;
export type DeleteAccountContactMutationFn = Apollo.MutationFunction<DeleteAccountContactMutation, DeleteAccountContactMutationVariables>;

/**
 * __useDeleteAccountContactMutation__
 *
 * To run a mutation, you first call `useDeleteAccountContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountContactMutation, { data, loading, error }] = useDeleteAccountContactMutation({
 *   variables: {
 *      contactID: // value for 'contactID'
 *   },
 * });
 */
export function useDeleteAccountContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountContactMutation, DeleteAccountContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountContactMutation, DeleteAccountContactMutationVariables>(DeleteAccountContactDocument, options);
      }
export type DeleteAccountContactMutationHookResult = ReturnType<typeof useDeleteAccountContactMutation>;
export type DeleteAccountContactMutationResult = Apollo.MutationResult<DeleteAccountContactMutation>;
export type DeleteAccountContactMutationOptions = Apollo.BaseMutationOptions<DeleteAccountContactMutation, DeleteAccountContactMutationVariables>;
export const BugReportDocument = gql`
    query BugReport($id: Int!) {
  bugReport(id: $id) {
    id
    employee {
      id
      fullname
      picture
    }
    employeeOffice {
      id
      client
      officeConfiguration {
        timezone
      }
    }
    title
    priority
    frequency
    dateCreated
    status
    errordate
    job
    action
    expectedresult
    actualresult
    errormessage
    comments
  }
}
    `;

/**
 * __useBugReportQuery__
 *
 * To run a query within a React component, call `useBugReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useBugReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBugReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBugReportQuery(baseOptions: Apollo.QueryHookOptions<BugReportQuery, BugReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BugReportQuery, BugReportQueryVariables>(BugReportDocument, options);
      }
export function useBugReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BugReportQuery, BugReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BugReportQuery, BugReportQueryVariables>(BugReportDocument, options);
        }
export type BugReportQueryHookResult = ReturnType<typeof useBugReportQuery>;
export type BugReportLazyQueryHookResult = ReturnType<typeof useBugReportLazyQuery>;
export type BugReportQueryResult = Apollo.QueryResult<BugReportQuery, BugReportQueryVariables>;
export const BugReportCommentsDocument = gql`
    query BugReportComments($reportId: Int!) {
  bugReportComments(reportID: $reportId) {
    id
    comment
    employee {
      id
      fullname
      picture
      office {
        id
        client
      }
    }
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useBugReportCommentsQuery__
 *
 * To run a query within a React component, call `useBugReportCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBugReportCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBugReportCommentsQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useBugReportCommentsQuery(baseOptions: Apollo.QueryHookOptions<BugReportCommentsQuery, BugReportCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BugReportCommentsQuery, BugReportCommentsQueryVariables>(BugReportCommentsDocument, options);
      }
export function useBugReportCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BugReportCommentsQuery, BugReportCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BugReportCommentsQuery, BugReportCommentsQueryVariables>(BugReportCommentsDocument, options);
        }
export type BugReportCommentsQueryHookResult = ReturnType<typeof useBugReportCommentsQuery>;
export type BugReportCommentsLazyQueryHookResult = ReturnType<typeof useBugReportCommentsLazyQuery>;
export type BugReportCommentsQueryResult = Apollo.QueryResult<BugReportCommentsQuery, BugReportCommentsQueryVariables>;
export const BugReportsDocument = gql`
    query BugReports($filters: GetBugReportsFilters!) {
  bugReportsCount(filters: $filters)
  bugReports(filters: $filters) {
    id
    employee {
      id
      fullname
      picture
    }
    employeeOffice {
      id
      client
    }
    title
    priority
    frequency
    dateCreated
    status
    comments
    commentsCount
  }
}
    `;

/**
 * __useBugReportsQuery__
 *
 * To run a query within a React component, call `useBugReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBugReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBugReportsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useBugReportsQuery(baseOptions: Apollo.QueryHookOptions<BugReportsQuery, BugReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BugReportsQuery, BugReportsQueryVariables>(BugReportsDocument, options);
      }
export function useBugReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BugReportsQuery, BugReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BugReportsQuery, BugReportsQueryVariables>(BugReportsDocument, options);
        }
export type BugReportsQueryHookResult = ReturnType<typeof useBugReportsQuery>;
export type BugReportsLazyQueryHookResult = ReturnType<typeof useBugReportsLazyQuery>;
export type BugReportsQueryResult = Apollo.QueryResult<BugReportsQuery, BugReportsQueryVariables>;
export const DeleteBugReportDocument = gql`
    mutation DeleteBugReport($deleteBugReportId: Int!) {
  deleteBugReport(id: $deleteBugReportId) {
    id
    status
  }
}
    `;
export type DeleteBugReportMutationFn = Apollo.MutationFunction<DeleteBugReportMutation, DeleteBugReportMutationVariables>;

/**
 * __useDeleteBugReportMutation__
 *
 * To run a mutation, you first call `useDeleteBugReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBugReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBugReportMutation, { data, loading, error }] = useDeleteBugReportMutation({
 *   variables: {
 *      deleteBugReportId: // value for 'deleteBugReportId'
 *   },
 * });
 */
export function useDeleteBugReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBugReportMutation, DeleteBugReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBugReportMutation, DeleteBugReportMutationVariables>(DeleteBugReportDocument, options);
      }
export type DeleteBugReportMutationHookResult = ReturnType<typeof useDeleteBugReportMutation>;
export type DeleteBugReportMutationResult = Apollo.MutationResult<DeleteBugReportMutation>;
export type DeleteBugReportMutationOptions = Apollo.BaseMutationOptions<DeleteBugReportMutation, DeleteBugReportMutationVariables>;
export const CreateBugReportDocument = gql`
    mutation CreateBugReport($inputs: CreateBugReportInputs!) {
  createBugReport(inputs: $inputs) {
    id
    employee {
      id
      fullname
      picture
    }
    employeeOffice {
      id
      client
    }
    title
    priority
    frequency
    dateCreated
    status
    comments
    commentsCount
  }
}
    `;
export type CreateBugReportMutationFn = Apollo.MutationFunction<CreateBugReportMutation, CreateBugReportMutationVariables>;

/**
 * __useCreateBugReportMutation__
 *
 * To run a mutation, you first call `useCreateBugReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBugReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBugReportMutation, { data, loading, error }] = useCreateBugReportMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBugReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateBugReportMutation, CreateBugReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBugReportMutation, CreateBugReportMutationVariables>(CreateBugReportDocument, options);
      }
export type CreateBugReportMutationHookResult = ReturnType<typeof useCreateBugReportMutation>;
export type CreateBugReportMutationResult = Apollo.MutationResult<CreateBugReportMutation>;
export type CreateBugReportMutationOptions = Apollo.BaseMutationOptions<CreateBugReportMutation, CreateBugReportMutationVariables>;
export const UpdateBugReportDocument = gql`
    mutation UpdateBugReport($inputs: UpdateBugReportInputs!) {
  updateBugReport(inputs: $inputs) {
    id
    employee {
      id
      fullname
      picture
    }
    employeeOffice {
      id
      client
    }
    title
    priority
    frequency
    dateCreated
    status
    comments
    commentsCount
  }
}
    `;
export type UpdateBugReportMutationFn = Apollo.MutationFunction<UpdateBugReportMutation, UpdateBugReportMutationVariables>;

/**
 * __useUpdateBugReportMutation__
 *
 * To run a mutation, you first call `useUpdateBugReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBugReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBugReportMutation, { data, loading, error }] = useUpdateBugReportMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateBugReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBugReportMutation, UpdateBugReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBugReportMutation, UpdateBugReportMutationVariables>(UpdateBugReportDocument, options);
      }
export type UpdateBugReportMutationHookResult = ReturnType<typeof useUpdateBugReportMutation>;
export type UpdateBugReportMutationResult = Apollo.MutationResult<UpdateBugReportMutation>;
export type UpdateBugReportMutationOptions = Apollo.BaseMutationOptions<UpdateBugReportMutation, UpdateBugReportMutationVariables>;
export const CreateBugReportCommentDocument = gql`
    mutation CreateBugReportComment($inputs: CreateBugReportCommentInputs!) {
  createBugReportComment(inputs: $inputs) {
    id
    comment
    employee {
      id
      fullname
      picture
    }
    dateModified
  }
}
    `;
export type CreateBugReportCommentMutationFn = Apollo.MutationFunction<CreateBugReportCommentMutation, CreateBugReportCommentMutationVariables>;

/**
 * __useCreateBugReportCommentMutation__
 *
 * To run a mutation, you first call `useCreateBugReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBugReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBugReportCommentMutation, { data, loading, error }] = useCreateBugReportCommentMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBugReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBugReportCommentMutation, CreateBugReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBugReportCommentMutation, CreateBugReportCommentMutationVariables>(CreateBugReportCommentDocument, options);
      }
export type CreateBugReportCommentMutationHookResult = ReturnType<typeof useCreateBugReportCommentMutation>;
export type CreateBugReportCommentMutationResult = Apollo.MutationResult<CreateBugReportCommentMutation>;
export type CreateBugReportCommentMutationOptions = Apollo.BaseMutationOptions<CreateBugReportCommentMutation, CreateBugReportCommentMutationVariables>;
export const DeleteBugReportCommentDocument = gql`
    mutation DeleteBugReportComment($deleteBugReportCommentId: Int!) {
  deleteBugReportComment(id: $deleteBugReportCommentId) {
    id
  }
}
    `;
export type DeleteBugReportCommentMutationFn = Apollo.MutationFunction<DeleteBugReportCommentMutation, DeleteBugReportCommentMutationVariables>;

/**
 * __useDeleteBugReportCommentMutation__
 *
 * To run a mutation, you first call `useDeleteBugReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBugReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBugReportCommentMutation, { data, loading, error }] = useDeleteBugReportCommentMutation({
 *   variables: {
 *      deleteBugReportCommentId: // value for 'deleteBugReportCommentId'
 *   },
 * });
 */
export function useDeleteBugReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBugReportCommentMutation, DeleteBugReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBugReportCommentMutation, DeleteBugReportCommentMutationVariables>(DeleteBugReportCommentDocument, options);
      }
export type DeleteBugReportCommentMutationHookResult = ReturnType<typeof useDeleteBugReportCommentMutation>;
export type DeleteBugReportCommentMutationResult = Apollo.MutationResult<DeleteBugReportCommentMutation>;
export type DeleteBugReportCommentMutationOptions = Apollo.BaseMutationOptions<DeleteBugReportCommentMutation, DeleteBugReportCommentMutationVariables>;
export const FeatureRequestDocument = gql`
    query FeatureRequest($id: Int!) {
  featureRequest(id: $id) {
    id
    title
    priority
    description
    comments
    hasUserVoted
    voteCount
    status
    employee {
      id
      fullname
      picture
    }
    office {
      id
      client
    }
    closingcomments
    dateCreated
  }
}
    `;

/**
 * __useFeatureRequestQuery__
 *
 * To run a query within a React component, call `useFeatureRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureRequestQuery(baseOptions: Apollo.QueryHookOptions<FeatureRequestQuery, FeatureRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureRequestQuery, FeatureRequestQueryVariables>(FeatureRequestDocument, options);
      }
export function useFeatureRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureRequestQuery, FeatureRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureRequestQuery, FeatureRequestQueryVariables>(FeatureRequestDocument, options);
        }
export type FeatureRequestQueryHookResult = ReturnType<typeof useFeatureRequestQuery>;
export type FeatureRequestLazyQueryHookResult = ReturnType<typeof useFeatureRequestLazyQuery>;
export type FeatureRequestQueryResult = Apollo.QueryResult<FeatureRequestQuery, FeatureRequestQueryVariables>;
export const FeatureRequestsDocument = gql`
    query FeatureRequests($filters: GetFeatureRequestsFilters) {
  featureRequestsCount(filters: $filters)
  featureRequests(filters: $filters) {
    id
    title
    priority
    description
    comments
    hasUserVoted
    voteCount
    status
    employee {
      id
      fullname
      picture
    }
    office {
      id
      client
    }
    closingcomments
    dateCreated
  }
}
    `;

/**
 * __useFeatureRequestsQuery__
 *
 * To run a query within a React component, call `useFeatureRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureRequestsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFeatureRequestsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureRequestsQuery, FeatureRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureRequestsQuery, FeatureRequestsQueryVariables>(FeatureRequestsDocument, options);
      }
export function useFeatureRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureRequestsQuery, FeatureRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureRequestsQuery, FeatureRequestsQueryVariables>(FeatureRequestsDocument, options);
        }
export type FeatureRequestsQueryHookResult = ReturnType<typeof useFeatureRequestsQuery>;
export type FeatureRequestsLazyQueryHookResult = ReturnType<typeof useFeatureRequestsLazyQuery>;
export type FeatureRequestsQueryResult = Apollo.QueryResult<FeatureRequestsQuery, FeatureRequestsQueryVariables>;
export const CreateFeatureRequestDocument = gql`
    mutation CreateFeatureRequest($inputs: CreateFeatureRequestInputs!) {
  createFeatureRequest(inputs: $inputs) {
    id
    title
    priority
    description
    comments
    hasUserVoted
    voteCount
    status
    employee {
      id
      fullname
      picture
    }
    office {
      id
      client
    }
    closingcomments
    dateCreated
  }
}
    `;
export type CreateFeatureRequestMutationFn = Apollo.MutationFunction<CreateFeatureRequestMutation, CreateFeatureRequestMutationVariables>;

/**
 * __useCreateFeatureRequestMutation__
 *
 * To run a mutation, you first call `useCreateFeatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureRequestMutation, { data, loading, error }] = useCreateFeatureRequestMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateFeatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureRequestMutation, CreateFeatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureRequestMutation, CreateFeatureRequestMutationVariables>(CreateFeatureRequestDocument, options);
      }
export type CreateFeatureRequestMutationHookResult = ReturnType<typeof useCreateFeatureRequestMutation>;
export type CreateFeatureRequestMutationResult = Apollo.MutationResult<CreateFeatureRequestMutation>;
export type CreateFeatureRequestMutationOptions = Apollo.BaseMutationOptions<CreateFeatureRequestMutation, CreateFeatureRequestMutationVariables>;
export const UpdateFeatureRequestDocument = gql`
    mutation UpdateFeatureRequest($inputs: UpdateFeatureRequestInputs!) {
  updateFeatureRequest(inputs: $inputs) {
    id
    title
    priority
    description
    comments
    hasUserVoted
    voteCount
    status
    employee {
      id
      fullname
      picture
    }
    office {
      id
      client
    }
    closingcomments
    dateCreated
  }
}
    `;
export type UpdateFeatureRequestMutationFn = Apollo.MutationFunction<UpdateFeatureRequestMutation, UpdateFeatureRequestMutationVariables>;

/**
 * __useUpdateFeatureRequestMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureRequestMutation, { data, loading, error }] = useUpdateFeatureRequestMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateFeatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureRequestMutation, UpdateFeatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureRequestMutation, UpdateFeatureRequestMutationVariables>(UpdateFeatureRequestDocument, options);
      }
export type UpdateFeatureRequestMutationHookResult = ReturnType<typeof useUpdateFeatureRequestMutation>;
export type UpdateFeatureRequestMutationResult = Apollo.MutationResult<UpdateFeatureRequestMutation>;
export type UpdateFeatureRequestMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureRequestMutation, UpdateFeatureRequestMutationVariables>;
export const DeleteFeatureRequestDocument = gql`
    mutation DeleteFeatureRequest($id: Int!) {
  deleteFeatureRequest(id: $id) {
    id
  }
}
    `;
export type DeleteFeatureRequestMutationFn = Apollo.MutationFunction<DeleteFeatureRequestMutation, DeleteFeatureRequestMutationVariables>;

/**
 * __useDeleteFeatureRequestMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureRequestMutation, { data, loading, error }] = useDeleteFeatureRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureRequestMutation, DeleteFeatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureRequestMutation, DeleteFeatureRequestMutationVariables>(DeleteFeatureRequestDocument, options);
      }
export type DeleteFeatureRequestMutationHookResult = ReturnType<typeof useDeleteFeatureRequestMutation>;
export type DeleteFeatureRequestMutationResult = Apollo.MutationResult<DeleteFeatureRequestMutation>;
export type DeleteFeatureRequestMutationOptions = Apollo.BaseMutationOptions<DeleteFeatureRequestMutation, DeleteFeatureRequestMutationVariables>;
export const ToggleFeatureRequestVoteDocument = gql`
    mutation ToggleFeatureRequestVote($featureRequestId: Int!) {
  toggleFeatureRequestVote(featureRequestID: $featureRequestId) {
    id
    voteCount
    hasUserVoted
  }
}
    `;
export type ToggleFeatureRequestVoteMutationFn = Apollo.MutationFunction<ToggleFeatureRequestVoteMutation, ToggleFeatureRequestVoteMutationVariables>;

/**
 * __useToggleFeatureRequestVoteMutation__
 *
 * To run a mutation, you first call `useToggleFeatureRequestVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFeatureRequestVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFeatureRequestVoteMutation, { data, loading, error }] = useToggleFeatureRequestVoteMutation({
 *   variables: {
 *      featureRequestId: // value for 'featureRequestId'
 *   },
 * });
 */
export function useToggleFeatureRequestVoteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFeatureRequestVoteMutation, ToggleFeatureRequestVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFeatureRequestVoteMutation, ToggleFeatureRequestVoteMutationVariables>(ToggleFeatureRequestVoteDocument, options);
      }
export type ToggleFeatureRequestVoteMutationHookResult = ReturnType<typeof useToggleFeatureRequestVoteMutation>;
export type ToggleFeatureRequestVoteMutationResult = Apollo.MutationResult<ToggleFeatureRequestVoteMutation>;
export type ToggleFeatureRequestVoteMutationOptions = Apollo.BaseMutationOptions<ToggleFeatureRequestVoteMutation, ToggleFeatureRequestVoteMutationVariables>;
export const NewBookingsSubscriptionDocument = gql`
    subscription NewBookingsSubscription($officeid: Int!) {
  newBooking(officeid: $officeid) {
    coyhawb
  }
}
    `;

/**
 * __useNewBookingsSubscriptionSubscription__
 *
 * To run a query within a React component, call `useNewBookingsSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewBookingsSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewBookingsSubscriptionSubscription({
 *   variables: {
 *      officeid: // value for 'officeid'
 *   },
 * });
 */
export function useNewBookingsSubscriptionSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewBookingsSubscriptionSubscription, NewBookingsSubscriptionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewBookingsSubscriptionSubscription, NewBookingsSubscriptionSubscriptionVariables>(NewBookingsSubscriptionDocument, options);
      }
export type NewBookingsSubscriptionSubscriptionHookResult = ReturnType<typeof useNewBookingsSubscriptionSubscription>;
export type NewBookingsSubscriptionSubscriptionResult = Apollo.SubscriptionResult<NewBookingsSubscriptionSubscription>;
export const HomeScreenDataDocument = gql`
    query HomeScreenData($inputs: FilterActivityLogs) {
  activityLogs(inputs: $inputs) {
    id
    eventid
    dateCreated
    description
    booking {
      coyhawb
    }
    employee {
      fullname
    }
  }
  homeBookmarks {
    id
    icon
    label
    url
  }
}
    `;

/**
 * __useHomeScreenDataQuery__
 *
 * To run a query within a React component, call `useHomeScreenDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeScreenDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeScreenDataQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useHomeScreenDataQuery(baseOptions?: Apollo.QueryHookOptions<HomeScreenDataQuery, HomeScreenDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeScreenDataQuery, HomeScreenDataQueryVariables>(HomeScreenDataDocument, options);
      }
export function useHomeScreenDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeScreenDataQuery, HomeScreenDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeScreenDataQuery, HomeScreenDataQueryVariables>(HomeScreenDataDocument, options);
        }
export type HomeScreenDataQueryHookResult = ReturnType<typeof useHomeScreenDataQuery>;
export type HomeScreenDataLazyQueryHookResult = ReturnType<typeof useHomeScreenDataLazyQuery>;
export type HomeScreenDataQueryResult = Apollo.QueryResult<HomeScreenDataQuery, HomeScreenDataQueryVariables>;
export const CreateBookmarkDocument = gql`
    mutation CreateBookmark($inputs: CreateHomeBookmarkInputs!) {
  createBookmark(inputs: $inputs) {
    id
    employee {
      id
      fullname
    }
    label
    url
    icon
    dateCreated
    dateModified
  }
}
    `;
export type CreateBookmarkMutationFn = Apollo.MutationFunction<CreateBookmarkMutation, CreateBookmarkMutationVariables>;

/**
 * __useCreateBookmarkMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkMutation, { data, loading, error }] = useCreateBookmarkMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookmarkMutation, CreateBookmarkMutationVariables>(CreateBookmarkDocument, options);
      }
export type CreateBookmarkMutationHookResult = ReturnType<typeof useCreateBookmarkMutation>;
export type CreateBookmarkMutationResult = Apollo.MutationResult<CreateBookmarkMutation>;
export type CreateBookmarkMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>;
export const UpdateBookmarkDocument = gql`
    mutation UpdateBookmark($inputs: UpdateHomeBookmarkInputs!) {
  updateBookmark(inputs: $inputs) {
    id
    employee {
      id
      fullname
      email
    }
    label
    url
    icon
    dateCreated
    dateModified
  }
}
    `;
export type UpdateBookmarkMutationFn = Apollo.MutationFunction<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;

/**
 * __useUpdateBookmarkMutation__
 *
 * To run a mutation, you first call `useUpdateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookmarkMutation, { data, loading, error }] = useUpdateBookmarkMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>(UpdateBookmarkDocument, options);
      }
export type UpdateBookmarkMutationHookResult = ReturnType<typeof useUpdateBookmarkMutation>;
export type UpdateBookmarkMutationResult = Apollo.MutationResult<UpdateBookmarkMutation>;
export type UpdateBookmarkMutationOptions = Apollo.BaseMutationOptions<UpdateBookmarkMutation, UpdateBookmarkMutationVariables>;
export const DeleteBookmarkDocument = gql`
    mutation DeleteBookmark($id: Float!) {
  deleteBookmark(id: $id) {
    id
    employee {
      id
      email
      fullname
    }
    label
    url
    icon
    dateCreated
    dateModified
  }
}
    `;
export type DeleteBookmarkMutationFn = Apollo.MutationFunction<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;

/**
 * __useDeleteBookmarkMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkMutation, { data, loading, error }] = useDeleteBookmarkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>(DeleteBookmarkDocument, options);
      }
export type DeleteBookmarkMutationHookResult = ReturnType<typeof useDeleteBookmarkMutation>;
export type DeleteBookmarkMutationResult = Apollo.MutationResult<DeleteBookmarkMutation>;
export type DeleteBookmarkMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;
export const RecentBookingsDocument = gql`
    query RecentBookings($inputs: SearchBookingsFilters!) {
  searchBookings(filters: $inputs) {
    count
    total
    query
    records {
      coyhawb
      lastNoteDate
      categoryType
      transitTime
      transitTimeAllowed
      client {
        id
        client
      }
      consignee {
        id
        client
      }
      jobdate
      origcode
      origin {
        id
        portcode
        cityname
      }
      destcode
      destination {
        id
        portcode
        cityname
      }
      bookingOffice {
        id
        client
      }
      bookingtype
      status
      dateCreated
      dateModified
    }
  }
}
    `;

/**
 * __useRecentBookingsQuery__
 *
 * To run a query within a React component, call `useRecentBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentBookingsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useRecentBookingsQuery(baseOptions: Apollo.QueryHookOptions<RecentBookingsQuery, RecentBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentBookingsQuery, RecentBookingsQueryVariables>(RecentBookingsDocument, options);
      }
export function useRecentBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentBookingsQuery, RecentBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentBookingsQuery, RecentBookingsQueryVariables>(RecentBookingsDocument, options);
        }
export type RecentBookingsQueryHookResult = ReturnType<typeof useRecentBookingsQuery>;
export type RecentBookingsLazyQueryHookResult = ReturnType<typeof useRecentBookingsLazyQuery>;
export type RecentBookingsQueryResult = Apollo.QueryResult<RecentBookingsQuery, RecentBookingsQueryVariables>;
export const TransitBookingsDocument = gql`
    query TransitBookings($inputs: SearchBookingsFilters!) {
  searchBookings(filters: $inputs) {
    count
    total
    query
    records {
      coyhawb
      categoryType
      lastNoteDate
      client {
        id
        client
      }
      consignee {
        id
        client
      }
      jobdate
      origcode
      origin {
        portcode
        cityname
      }
      destcode
      destination {
        portcode
        cityname
      }
      bookingOffice {
        id
        client
      }
      bookingtype
      status
      dateCreated
      dateModified
      bookingPickup {
        id
        pickupdate
      }
      transitTime
      transitTimeAllowed
    }
  }
}
    `;

/**
 * __useTransitBookingsQuery__
 *
 * To run a query within a React component, call `useTransitBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitBookingsQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useTransitBookingsQuery(baseOptions: Apollo.QueryHookOptions<TransitBookingsQuery, TransitBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransitBookingsQuery, TransitBookingsQueryVariables>(TransitBookingsDocument, options);
      }
export function useTransitBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransitBookingsQuery, TransitBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransitBookingsQuery, TransitBookingsQueryVariables>(TransitBookingsDocument, options);
        }
export type TransitBookingsQueryHookResult = ReturnType<typeof useTransitBookingsQuery>;
export type TransitBookingsLazyQueryHookResult = ReturnType<typeof useTransitBookingsLazyQuery>;
export type TransitBookingsQueryResult = Apollo.QueryResult<TransitBookingsQuery, TransitBookingsQueryVariables>;
export const ChangeActiveOfficeDocument = gql`
    mutation ChangeActiveOffice($officeConfigId: Int!) {
  changeActiveOffice(officeConfigID: $officeConfigId)
}
    `;
export type ChangeActiveOfficeMutationFn = Apollo.MutationFunction<ChangeActiveOfficeMutation, ChangeActiveOfficeMutationVariables>;

/**
 * __useChangeActiveOfficeMutation__
 *
 * To run a mutation, you first call `useChangeActiveOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeActiveOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeActiveOfficeMutation, { data, loading, error }] = useChangeActiveOfficeMutation({
 *   variables: {
 *      officeConfigId: // value for 'officeConfigId'
 *   },
 * });
 */
export function useChangeActiveOfficeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeActiveOfficeMutation, ChangeActiveOfficeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeActiveOfficeMutation, ChangeActiveOfficeMutationVariables>(ChangeActiveOfficeDocument, options);
      }
export type ChangeActiveOfficeMutationHookResult = ReturnType<typeof useChangeActiveOfficeMutation>;
export type ChangeActiveOfficeMutationResult = Apollo.MutationResult<ChangeActiveOfficeMutation>;
export type ChangeActiveOfficeMutationOptions = Apollo.BaseMutationOptions<ChangeActiveOfficeMutation, ChangeActiveOfficeMutationVariables>;
export const CountUncreatedAccountsWithNameDocument = gql`
    query CountUncreatedAccountsWithName($name: String!) {
  uncreatedAccountsWithName(name: $name)
}
    `;

/**
 * __useCountUncreatedAccountsWithNameQuery__
 *
 * To run a query within a React component, call `useCountUncreatedAccountsWithNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountUncreatedAccountsWithNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountUncreatedAccountsWithNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCountUncreatedAccountsWithNameQuery(baseOptions: Apollo.QueryHookOptions<CountUncreatedAccountsWithNameQuery, CountUncreatedAccountsWithNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountUncreatedAccountsWithNameQuery, CountUncreatedAccountsWithNameQueryVariables>(CountUncreatedAccountsWithNameDocument, options);
      }
export function useCountUncreatedAccountsWithNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountUncreatedAccountsWithNameQuery, CountUncreatedAccountsWithNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountUncreatedAccountsWithNameQuery, CountUncreatedAccountsWithNameQueryVariables>(CountUncreatedAccountsWithNameDocument, options);
        }
export type CountUncreatedAccountsWithNameQueryHookResult = ReturnType<typeof useCountUncreatedAccountsWithNameQuery>;
export type CountUncreatedAccountsWithNameLazyQueryHookResult = ReturnType<typeof useCountUncreatedAccountsWithNameLazyQuery>;
export type CountUncreatedAccountsWithNameQueryResult = Apollo.QueryResult<CountUncreatedAccountsWithNameQuery, CountUncreatedAccountsWithNameQueryVariables>;
export const QuoteAccountContactsDocument = gql`
    query QuoteAccountContacts($filters: GetAccountContactsFilter!) {
  accountContacts(filters: $filters) {
    id
    name
    position
    phone
    email
    notes
  }
}
    `;

/**
 * __useQuoteAccountContactsQuery__
 *
 * To run a query within a React component, call `useQuoteAccountContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteAccountContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteAccountContactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useQuoteAccountContactsQuery(baseOptions: Apollo.QueryHookOptions<QuoteAccountContactsQuery, QuoteAccountContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteAccountContactsQuery, QuoteAccountContactsQueryVariables>(QuoteAccountContactsDocument, options);
      }
export function useQuoteAccountContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteAccountContactsQuery, QuoteAccountContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteAccountContactsQuery, QuoteAccountContactsQueryVariables>(QuoteAccountContactsDocument, options);
        }
export type QuoteAccountContactsQueryHookResult = ReturnType<typeof useQuoteAccountContactsQuery>;
export type QuoteAccountContactsLazyQueryHookResult = ReturnType<typeof useQuoteAccountContactsLazyQuery>;
export type QuoteAccountContactsQueryResult = Apollo.QueryResult<QuoteAccountContactsQuery, QuoteAccountContactsQueryVariables>;
export const IsPortcodeRemoteDocument = gql`
    query IsPortcodeRemote($portcode: String!) {
  isPortcodeRemote(portcode: $portcode)
}
    `;

/**
 * __useIsPortcodeRemoteQuery__
 *
 * To run a query within a React component, call `useIsPortcodeRemoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPortcodeRemoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPortcodeRemoteQuery({
 *   variables: {
 *      portcode: // value for 'portcode'
 *   },
 * });
 */
export function useIsPortcodeRemoteQuery(baseOptions: Apollo.QueryHookOptions<IsPortcodeRemoteQuery, IsPortcodeRemoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPortcodeRemoteQuery, IsPortcodeRemoteQueryVariables>(IsPortcodeRemoteDocument, options);
      }
export function useIsPortcodeRemoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPortcodeRemoteQuery, IsPortcodeRemoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPortcodeRemoteQuery, IsPortcodeRemoteQueryVariables>(IsPortcodeRemoteDocument, options);
        }
export type IsPortcodeRemoteQueryHookResult = ReturnType<typeof useIsPortcodeRemoteQuery>;
export type IsPortcodeRemoteLazyQueryHookResult = ReturnType<typeof useIsPortcodeRemoteLazyQuery>;
export type IsPortcodeRemoteQueryResult = Apollo.QueryResult<IsPortcodeRemoteQuery, IsPortcodeRemoteQueryVariables>;
export const CreateQuoteDocument = gql`
    mutation CreateQuote($inputs: CreateQuoteInputs!) {
  createQuote(inputs: $inputs) {
    ...ViewQuoteFields
  }
}
    ${ViewQuoteFieldsFragmentDoc}`;
export type CreateQuoteMutationFn = Apollo.MutationFunction<CreateQuoteMutation, CreateQuoteMutationVariables>;

/**
 * __useCreateQuoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteMutation, { data, loading, error }] = useCreateQuoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteMutation, CreateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteMutation, CreateQuoteMutationVariables>(CreateQuoteDocument, options);
      }
export type CreateQuoteMutationHookResult = ReturnType<typeof useCreateQuoteMutation>;
export type CreateQuoteMutationResult = Apollo.MutationResult<CreateQuoteMutation>;
export type CreateQuoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteMutation, CreateQuoteMutationVariables>;
export const UpdateQuoteDocument = gql`
    mutation UpdateQuote($inputs: UpdateQuoteInputs!) {
  updateQuote(inputs: $inputs) {
    ...ViewQuoteFields
  }
}
    ${ViewQuoteFieldsFragmentDoc}`;
export type UpdateQuoteMutationFn = Apollo.MutationFunction<UpdateQuoteMutation, UpdateQuoteMutationVariables>;

/**
 * __useUpdateQuoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteMutation, { data, loading, error }] = useUpdateQuoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteMutation, UpdateQuoteMutationVariables>(UpdateQuoteDocument, options);
      }
export type UpdateQuoteMutationHookResult = ReturnType<typeof useUpdateQuoteMutation>;
export type UpdateQuoteMutationResult = Apollo.MutationResult<UpdateQuoteMutation>;
export type UpdateQuoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteMutation, UpdateQuoteMutationVariables>;
export const QuoteAccountByIDDocument = gql`
    query QuoteAccountByID($accountID: Int!) {
  accountByID(id: $accountID) {
    ...QuoteAccountLookup
  }
}
    ${QuoteAccountLookupFragmentDoc}`;

/**
 * __useQuoteAccountByIDQuery__
 *
 * To run a query within a React component, call `useQuoteAccountByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteAccountByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteAccountByIDQuery({
 *   variables: {
 *      accountID: // value for 'accountID'
 *   },
 * });
 */
export function useQuoteAccountByIDQuery(baseOptions: Apollo.QueryHookOptions<QuoteAccountByIDQuery, QuoteAccountByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteAccountByIDQuery, QuoteAccountByIDQueryVariables>(QuoteAccountByIDDocument, options);
      }
export function useQuoteAccountByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteAccountByIDQuery, QuoteAccountByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteAccountByIDQuery, QuoteAccountByIDQueryVariables>(QuoteAccountByIDDocument, options);
        }
export type QuoteAccountByIDQueryHookResult = ReturnType<typeof useQuoteAccountByIDQuery>;
export type QuoteAccountByIDLazyQueryHookResult = ReturnType<typeof useQuoteAccountByIDLazyQuery>;
export type QuoteAccountByIDQueryResult = Apollo.QueryResult<QuoteAccountByIDQuery, QuoteAccountByIDQueryVariables>;
export const SearchQuotesDocument = gql`
    query SearchQuotes($filters: SearchQuotesFilters) {
  searchQuotes(filters: $filters) {
    count
    records {
      id
      lastNoteDate
      quoteid
      bookingsFromQuote {
        id
        coyhawb
      }
      clientnamenew
      client {
        id
        client
      }
      office {
        id
        client
      }
      contactName
      origcode
      origin {
        id
        portcode
        cityname
      }
      destcode
      destination {
        id
        portcode
        cityname
      }
      itemdesc
      tariffMinWeight
      tariffMinWeightKG
      tariffPerKG
      tariffZone
      activity
      total
      office {
        id
        client
        officeConfiguration {
          id
          locale
          currencyCode
        }
      }
      returnclienttype
      employee {
        id
        fullname
        picture
      }
      dateCreated
      dateModified
    }
    total
    query
  }
}
    `;

/**
 * __useSearchQuotesQuery__
 *
 * To run a query within a React component, call `useSearchQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuotesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchQuotesQuery(baseOptions?: Apollo.QueryHookOptions<SearchQuotesQuery, SearchQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuotesQuery, SearchQuotesQueryVariables>(SearchQuotesDocument, options);
      }
export function useSearchQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuotesQuery, SearchQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuotesQuery, SearchQuotesQueryVariables>(SearchQuotesDocument, options);
        }
export type SearchQuotesQueryHookResult = ReturnType<typeof useSearchQuotesQuery>;
export type SearchQuotesLazyQueryHookResult = ReturnType<typeof useSearchQuotesLazyQuery>;
export type SearchQuotesQueryResult = Apollo.QueryResult<SearchQuotesQuery, SearchQuotesQueryVariables>;
export const ViewQuoteDocument = gql`
    query ViewQuote($quoteId: String!, $inputs: GetFixedChargesInputs!) {
  quoteByQuoteID(quoteID: $quoteId) {
    ...ViewQuoteFields
  }
  fixedCharges(inputs: $inputs) {
    id
    jobid
    type
    name
    net
    tax
    total
  }
}
    ${ViewQuoteFieldsFragmentDoc}`;

/**
 * __useViewQuoteQuery__
 *
 * To run a query within a React component, call `useViewQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewQuoteQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useViewQuoteQuery(baseOptions: Apollo.QueryHookOptions<ViewQuoteQuery, ViewQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewQuoteQuery, ViewQuoteQueryVariables>(ViewQuoteDocument, options);
      }
export function useViewQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewQuoteQuery, ViewQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewQuoteQuery, ViewQuoteQueryVariables>(ViewQuoteDocument, options);
        }
export type ViewQuoteQueryHookResult = ReturnType<typeof useViewQuoteQuery>;
export type ViewQuoteLazyQueryHookResult = ReturnType<typeof useViewQuoteLazyQuery>;
export type ViewQuoteQueryResult = Apollo.QueryResult<ViewQuoteQuery, ViewQuoteQueryVariables>;
export const CreateQuoteNoteDocument = gql`
    mutation CreateQuoteNote($inputs: CreateQuoteNoteInputs!) {
  createQuoteNote(inputs: $inputs) {
    id
    lastNoteDate
    quoteNotes {
      ...QuoteNote
    }
  }
}
    ${QuoteNoteFragmentDoc}`;
export type CreateQuoteNoteMutationFn = Apollo.MutationFunction<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>;

/**
 * __useCreateQuoteNoteMutation__
 *
 * To run a mutation, you first call `useCreateQuoteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuoteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuoteNoteMutation, { data, loading, error }] = useCreateQuoteNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateQuoteNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>(CreateQuoteNoteDocument, options);
      }
export type CreateQuoteNoteMutationHookResult = ReturnType<typeof useCreateQuoteNoteMutation>;
export type CreateQuoteNoteMutationResult = Apollo.MutationResult<CreateQuoteNoteMutation>;
export type CreateQuoteNoteMutationOptions = Apollo.BaseMutationOptions<CreateQuoteNoteMutation, CreateQuoteNoteMutationVariables>;
export const UpdateQuoteNoteDocument = gql`
    mutation UpdateQuoteNote($inputs: UpdateQuoteNoteInputs!) {
  updateQuoteNote(inputs: $inputs) {
    id
    lastNoteDate
    quoteNotes {
      ...QuoteNote
    }
  }
}
    ${QuoteNoteFragmentDoc}`;
export type UpdateQuoteNoteMutationFn = Apollo.MutationFunction<UpdateQuoteNoteMutation, UpdateQuoteNoteMutationVariables>;

/**
 * __useUpdateQuoteNoteMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteNoteMutation, { data, loading, error }] = useUpdateQuoteNoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateQuoteNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteNoteMutation, UpdateQuoteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteNoteMutation, UpdateQuoteNoteMutationVariables>(UpdateQuoteNoteDocument, options);
      }
export type UpdateQuoteNoteMutationHookResult = ReturnType<typeof useUpdateQuoteNoteMutation>;
export type UpdateQuoteNoteMutationResult = Apollo.MutationResult<UpdateQuoteNoteMutation>;
export type UpdateQuoteNoteMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteNoteMutation, UpdateQuoteNoteMutationVariables>;
export const DeleteQuoteNoteDocument = gql`
    mutation DeleteQuoteNote($noteId: Int!) {
  deleteQuoteNote(noteID: $noteId) {
    id
  }
}
    `;
export type DeleteQuoteNoteMutationFn = Apollo.MutationFunction<DeleteQuoteNoteMutation, DeleteQuoteNoteMutationVariables>;

/**
 * __useDeleteQuoteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteNoteMutation, { data, loading, error }] = useDeleteQuoteNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteQuoteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteNoteMutation, DeleteQuoteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteNoteMutation, DeleteQuoteNoteMutationVariables>(DeleteQuoteNoteDocument, options);
      }
export type DeleteQuoteNoteMutationHookResult = ReturnType<typeof useDeleteQuoteNoteMutation>;
export type DeleteQuoteNoteMutationResult = Apollo.MutationResult<DeleteQuoteNoteMutation>;
export type DeleteQuoteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteNoteMutation, DeleteQuoteNoteMutationVariables>;
export const DeleteQuoteDocument = gql`
    mutation DeleteQuote($id: Int!) {
  deleteQuote(id: $id) {
    id
  }
}
    `;
export type DeleteQuoteMutationFn = Apollo.MutationFunction<DeleteQuoteMutation, DeleteQuoteMutationVariables>;

/**
 * __useDeleteQuoteMutation__
 *
 * To run a mutation, you first call `useDeleteQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuoteMutation, { data, loading, error }] = useDeleteQuoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuoteMutation, DeleteQuoteMutationVariables>(DeleteQuoteDocument, options);
      }
export type DeleteQuoteMutationHookResult = ReturnType<typeof useDeleteQuoteMutation>;
export type DeleteQuoteMutationResult = Apollo.MutationResult<DeleteQuoteMutation>;
export type DeleteQuoteMutationOptions = Apollo.BaseMutationOptions<DeleteQuoteMutation, DeleteQuoteMutationVariables>;
export const EmailQuoteDocument = gql`
    mutation EmailQuote($inputs: EmailQuoteInputs!) {
  emailQuote(inputs: $inputs) {
    id
    isQuoteSent
    quoteSentDate
  }
}
    `;
export type EmailQuoteMutationFn = Apollo.MutationFunction<EmailQuoteMutation, EmailQuoteMutationVariables>;

/**
 * __useEmailQuoteMutation__
 *
 * To run a mutation, you first call `useEmailQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailQuoteMutation, { data, loading, error }] = useEmailQuoteMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailQuoteMutation(baseOptions?: Apollo.MutationHookOptions<EmailQuoteMutation, EmailQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailQuoteMutation, EmailQuoteMutationVariables>(EmailQuoteDocument, options);
      }
export type EmailQuoteMutationHookResult = ReturnType<typeof useEmailQuoteMutation>;
export type EmailQuoteMutationResult = Apollo.MutationResult<EmailQuoteMutation>;
export type EmailQuoteMutationOptions = Apollo.BaseMutationOptions<EmailQuoteMutation, EmailQuoteMutationVariables>;
export const UpdateQuoteStatusDocument = gql`
    mutation UpdateQuoteStatus($newStatus: QuoteStatus!, $quoteId: String!) {
  updateQuoteStatus(newStatus: $newStatus, quoteID: $quoteId) {
    id
    activity
    quoteNotes {
      ...QuoteNote
    }
  }
}
    ${QuoteNoteFragmentDoc}`;
export type UpdateQuoteStatusMutationFn = Apollo.MutationFunction<UpdateQuoteStatusMutation, UpdateQuoteStatusMutationVariables>;

/**
 * __useUpdateQuoteStatusMutation__
 *
 * To run a mutation, you first call `useUpdateQuoteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuoteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuoteStatusMutation, { data, loading, error }] = useUpdateQuoteStatusMutation({
 *   variables: {
 *      newStatus: // value for 'newStatus'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useUpdateQuoteStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuoteStatusMutation, UpdateQuoteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuoteStatusMutation, UpdateQuoteStatusMutationVariables>(UpdateQuoteStatusDocument, options);
      }
export type UpdateQuoteStatusMutationHookResult = ReturnType<typeof useUpdateQuoteStatusMutation>;
export type UpdateQuoteStatusMutationResult = Apollo.MutationResult<UpdateQuoteStatusMutation>;
export type UpdateQuoteStatusMutationOptions = Apollo.BaseMutationOptions<UpdateQuoteStatusMutation, UpdateQuoteStatusMutationVariables>;
export const EmailQuoteReminderDocument = gql`
    mutation EmailQuoteReminder($inputs: EmailQuoteReminderInputs!) {
  emailQuoteReminder(inputs: $inputs) {
    id
    quoteNotes {
      ...QuoteNote
    }
  }
}
    ${QuoteNoteFragmentDoc}`;
export type EmailQuoteReminderMutationFn = Apollo.MutationFunction<EmailQuoteReminderMutation, EmailQuoteReminderMutationVariables>;

/**
 * __useEmailQuoteReminderMutation__
 *
 * To run a mutation, you first call `useEmailQuoteReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailQuoteReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailQuoteReminderMutation, { data, loading, error }] = useEmailQuoteReminderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useEmailQuoteReminderMutation(baseOptions?: Apollo.MutationHookOptions<EmailQuoteReminderMutation, EmailQuoteReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailQuoteReminderMutation, EmailQuoteReminderMutationVariables>(EmailQuoteReminderDocument, options);
      }
export type EmailQuoteReminderMutationHookResult = ReturnType<typeof useEmailQuoteReminderMutation>;
export type EmailQuoteReminderMutationResult = Apollo.MutationResult<EmailQuoteReminderMutation>;
export type EmailQuoteReminderMutationOptions = Apollo.BaseMutationOptions<EmailQuoteReminderMutation, EmailQuoteReminderMutationVariables>;
export const GeneratePericulumReportDocument = gql`
    query GeneratePericulumReport($reportId: PericulumReportID!, $inputs: JSONObject, $format: PericulumReportFormat!) {
  generateReport(reportID: $reportId, inputs: $inputs, format: $format)
}
    `;

/**
 * __useGeneratePericulumReportQuery__
 *
 * To run a query within a React component, call `useGeneratePericulumReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneratePericulumReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratePericulumReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      inputs: // value for 'inputs'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useGeneratePericulumReportQuery(baseOptions: Apollo.QueryHookOptions<GeneratePericulumReportQuery, GeneratePericulumReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneratePericulumReportQuery, GeneratePericulumReportQueryVariables>(GeneratePericulumReportDocument, options);
      }
export function useGeneratePericulumReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneratePericulumReportQuery, GeneratePericulumReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneratePericulumReportQuery, GeneratePericulumReportQueryVariables>(GeneratePericulumReportDocument, options);
        }
export type GeneratePericulumReportQueryHookResult = ReturnType<typeof useGeneratePericulumReportQuery>;
export type GeneratePericulumReportLazyQueryHookResult = ReturnType<typeof useGeneratePericulumReportLazyQuery>;
export type GeneratePericulumReportQueryResult = Apollo.QueryResult<GeneratePericulumReportQuery, GeneratePericulumReportQueryVariables>;
export const AirlineDocument = gql`
    query Airline($airlineID: Int!) {
  airline(airlineID: $airlineID) {
    id
    airlinecode
    airlineid
    airlinename
    airlineweb
    airlineadd1
    airlineadd2
    airlinephone
    notes
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useAirlineQuery__
 *
 * To run a query within a React component, call `useAirlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlineQuery({
 *   variables: {
 *      airlineID: // value for 'airlineID'
 *   },
 * });
 */
export function useAirlineQuery(baseOptions: Apollo.QueryHookOptions<AirlineQuery, AirlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirlineQuery, AirlineQueryVariables>(AirlineDocument, options);
      }
export function useAirlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirlineQuery, AirlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirlineQuery, AirlineQueryVariables>(AirlineDocument, options);
        }
export type AirlineQueryHookResult = ReturnType<typeof useAirlineQuery>;
export type AirlineLazyQueryHookResult = ReturnType<typeof useAirlineLazyQuery>;
export type AirlineQueryResult = Apollo.QueryResult<AirlineQuery, AirlineQueryVariables>;
export const CreateAirlineDocument = gql`
    mutation CreateAirline($inputs: CreateAirlineInputs!) {
  createAirline(inputs: $inputs) {
    id
    airlinename
    airlinecode
    airlineid
  }
}
    `;
export type CreateAirlineMutationFn = Apollo.MutationFunction<CreateAirlineMutation, CreateAirlineMutationVariables>;

/**
 * __useCreateAirlineMutation__
 *
 * To run a mutation, you first call `useCreateAirlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAirlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAirlineMutation, { data, loading, error }] = useCreateAirlineMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateAirlineMutation(baseOptions?: Apollo.MutationHookOptions<CreateAirlineMutation, CreateAirlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAirlineMutation, CreateAirlineMutationVariables>(CreateAirlineDocument, options);
      }
export type CreateAirlineMutationHookResult = ReturnType<typeof useCreateAirlineMutation>;
export type CreateAirlineMutationResult = Apollo.MutationResult<CreateAirlineMutation>;
export type CreateAirlineMutationOptions = Apollo.BaseMutationOptions<CreateAirlineMutation, CreateAirlineMutationVariables>;
export const UpdateAirlineDocument = gql`
    mutation UpdateAirline($inputs: UpdateAirlineInputs!) {
  updateAirline(inputs: $inputs) {
    id
    airlinename
    airlinecode
    airlineid
  }
}
    `;
export type UpdateAirlineMutationFn = Apollo.MutationFunction<UpdateAirlineMutation, UpdateAirlineMutationVariables>;

/**
 * __useUpdateAirlineMutation__
 *
 * To run a mutation, you first call `useUpdateAirlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAirlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAirlineMutation, { data, loading, error }] = useUpdateAirlineMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateAirlineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAirlineMutation, UpdateAirlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAirlineMutation, UpdateAirlineMutationVariables>(UpdateAirlineDocument, options);
      }
export type UpdateAirlineMutationHookResult = ReturnType<typeof useUpdateAirlineMutation>;
export type UpdateAirlineMutationResult = Apollo.MutationResult<UpdateAirlineMutation>;
export type UpdateAirlineMutationOptions = Apollo.BaseMutationOptions<UpdateAirlineMutation, UpdateAirlineMutationVariables>;
export const DeleteAirlineDocument = gql`
    mutation DeleteAirline($airlineId: Int!) {
  deleteAirline(airlineID: $airlineId) {
    id
    airlinename
    airlinecode
    airlineid
  }
}
    `;
export type DeleteAirlineMutationFn = Apollo.MutationFunction<DeleteAirlineMutation, DeleteAirlineMutationVariables>;

/**
 * __useDeleteAirlineMutation__
 *
 * To run a mutation, you first call `useDeleteAirlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAirlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAirlineMutation, { data, loading, error }] = useDeleteAirlineMutation({
 *   variables: {
 *      airlineId: // value for 'airlineId'
 *   },
 * });
 */
export function useDeleteAirlineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAirlineMutation, DeleteAirlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAirlineMutation, DeleteAirlineMutationVariables>(DeleteAirlineDocument, options);
      }
export type DeleteAirlineMutationHookResult = ReturnType<typeof useDeleteAirlineMutation>;
export type DeleteAirlineMutationResult = Apollo.MutationResult<DeleteAirlineMutation>;
export type DeleteAirlineMutationOptions = Apollo.BaseMutationOptions<DeleteAirlineMutation, DeleteAirlineMutationVariables>;
export const ChargeOptionsDocument = gql`
    query ChargeOptions($filters: GetChargeOptionsFilters) {
  chargeOptions(filters: $filters) {
    id
    name
    isActive
  }
}
    `;

/**
 * __useChargeOptionsQuery__
 *
 * To run a query within a React component, call `useChargeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useChargeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ChargeOptionsQuery, ChargeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChargeOptionsQuery, ChargeOptionsQueryVariables>(ChargeOptionsDocument, options);
      }
export function useChargeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChargeOptionsQuery, ChargeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChargeOptionsQuery, ChargeOptionsQueryVariables>(ChargeOptionsDocument, options);
        }
export type ChargeOptionsQueryHookResult = ReturnType<typeof useChargeOptionsQuery>;
export type ChargeOptionsLazyQueryHookResult = ReturnType<typeof useChargeOptionsLazyQuery>;
export type ChargeOptionsQueryResult = Apollo.QueryResult<ChargeOptionsQuery, ChargeOptionsQueryVariables>;
export const DeleteChargeOptionDocument = gql`
    mutation DeleteChargeOption($deleteChargeOptionId: Int!) {
  deleteChargeOption(id: $deleteChargeOptionId) {
    id
    name
    isActive
  }
}
    `;
export type DeleteChargeOptionMutationFn = Apollo.MutationFunction<DeleteChargeOptionMutation, DeleteChargeOptionMutationVariables>;

/**
 * __useDeleteChargeOptionMutation__
 *
 * To run a mutation, you first call `useDeleteChargeOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChargeOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChargeOptionMutation, { data, loading, error }] = useDeleteChargeOptionMutation({
 *   variables: {
 *      deleteChargeOptionId: // value for 'deleteChargeOptionId'
 *   },
 * });
 */
export function useDeleteChargeOptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChargeOptionMutation, DeleteChargeOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChargeOptionMutation, DeleteChargeOptionMutationVariables>(DeleteChargeOptionDocument, options);
      }
export type DeleteChargeOptionMutationHookResult = ReturnType<typeof useDeleteChargeOptionMutation>;
export type DeleteChargeOptionMutationResult = Apollo.MutationResult<DeleteChargeOptionMutation>;
export type DeleteChargeOptionMutationOptions = Apollo.BaseMutationOptions<DeleteChargeOptionMutation, DeleteChargeOptionMutationVariables>;
export const SaveChargeOptionDocument = gql`
    mutation SaveChargeOption($inputs: SaveChargeOptionInputs!) {
  saveChargeOption(inputs: $inputs) {
    id
    name
    isActive
  }
}
    `;
export type SaveChargeOptionMutationFn = Apollo.MutationFunction<SaveChargeOptionMutation, SaveChargeOptionMutationVariables>;

/**
 * __useSaveChargeOptionMutation__
 *
 * To run a mutation, you first call `useSaveChargeOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChargeOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChargeOptionMutation, { data, loading, error }] = useSaveChargeOptionMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveChargeOptionMutation(baseOptions?: Apollo.MutationHookOptions<SaveChargeOptionMutation, SaveChargeOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveChargeOptionMutation, SaveChargeOptionMutationVariables>(SaveChargeOptionDocument, options);
      }
export type SaveChargeOptionMutationHookResult = ReturnType<typeof useSaveChargeOptionMutation>;
export type SaveChargeOptionMutationResult = Apollo.MutationResult<SaveChargeOptionMutation>;
export type SaveChargeOptionMutationOptions = Apollo.BaseMutationOptions<SaveChargeOptionMutation, SaveChargeOptionMutationVariables>;
export const UpdateGlobalConfigDocument = gql`
    mutation UpdateGlobalConfig($inputs: UpdateGlobalConfigInputs!) {
  updateGlobalConfig(inputs: $inputs) {
    id
    item
    dataType
    label
    value
    dateCreated
    dateModified
  }
}
    `;
export type UpdateGlobalConfigMutationFn = Apollo.MutationFunction<UpdateGlobalConfigMutation, UpdateGlobalConfigMutationVariables>;

/**
 * __useUpdateGlobalConfigMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalConfigMutation, { data, loading, error }] = useUpdateGlobalConfigMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateGlobalConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalConfigMutation, UpdateGlobalConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalConfigMutation, UpdateGlobalConfigMutationVariables>(UpdateGlobalConfigDocument, options);
      }
export type UpdateGlobalConfigMutationHookResult = ReturnType<typeof useUpdateGlobalConfigMutation>;
export type UpdateGlobalConfigMutationResult = Apollo.MutationResult<UpdateGlobalConfigMutation>;
export type UpdateGlobalConfigMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalConfigMutation, UpdateGlobalConfigMutationVariables>;
export const CostOfSalesDocument = gql`
    query CostOfSales($filters: GetCostOfSalesFilters) {
  costOfSalesCount(filters: $filters)
  costOfSales(filters: $filters) {
    id
    job
    booking {
      id
      coyhawb
    }
    clientname
    invoiceno
    invoicedate
    invoiceamt
    taxcode
    taxamt
    purchasenumber
    moneysymbol
    locale
    type
    description
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useCostOfSalesQuery__
 *
 * To run a query within a React component, call `useCostOfSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostOfSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostOfSalesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCostOfSalesQuery(baseOptions?: Apollo.QueryHookOptions<CostOfSalesQuery, CostOfSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostOfSalesQuery, CostOfSalesQueryVariables>(CostOfSalesDocument, options);
      }
export function useCostOfSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostOfSalesQuery, CostOfSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostOfSalesQuery, CostOfSalesQueryVariables>(CostOfSalesDocument, options);
        }
export type CostOfSalesQueryHookResult = ReturnType<typeof useCostOfSalesQuery>;
export type CostOfSalesLazyQueryHookResult = ReturnType<typeof useCostOfSalesLazyQuery>;
export type CostOfSalesQueryResult = Apollo.QueryResult<CostOfSalesQuery, CostOfSalesQueryVariables>;
export const DeleteCostOfSaleDocument = gql`
    mutation DeleteCostOfSale($ID: Int!) {
  deleteCostOfSale(id: $ID) {
    id
  }
}
    `;
export type DeleteCostOfSaleMutationFn = Apollo.MutationFunction<DeleteCostOfSaleMutation, DeleteCostOfSaleMutationVariables>;

/**
 * __useDeleteCostOfSaleMutation__
 *
 * To run a mutation, you first call `useDeleteCostOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCostOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCostOfSaleMutation, { data, loading, error }] = useDeleteCostOfSaleMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteCostOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCostOfSaleMutation, DeleteCostOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCostOfSaleMutation, DeleteCostOfSaleMutationVariables>(DeleteCostOfSaleDocument, options);
      }
export type DeleteCostOfSaleMutationHookResult = ReturnType<typeof useDeleteCostOfSaleMutation>;
export type DeleteCostOfSaleMutationResult = Apollo.MutationResult<DeleteCostOfSaleMutation>;
export type DeleteCostOfSaleMutationOptions = Apollo.BaseMutationOptions<DeleteCostOfSaleMutation, DeleteCostOfSaleMutationVariables>;
export const UploadCostOfSalesDocument = gql`
    mutation UploadCostOfSales($inputs: CostOfSalesUploadInputs!) {
  uploadCostOfSales(inputs: $inputs)
}
    `;
export type UploadCostOfSalesMutationFn = Apollo.MutationFunction<UploadCostOfSalesMutation, UploadCostOfSalesMutationVariables>;

/**
 * __useUploadCostOfSalesMutation__
 *
 * To run a mutation, you first call `useUploadCostOfSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCostOfSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCostOfSalesMutation, { data, loading, error }] = useUploadCostOfSalesMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUploadCostOfSalesMutation(baseOptions?: Apollo.MutationHookOptions<UploadCostOfSalesMutation, UploadCostOfSalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCostOfSalesMutation, UploadCostOfSalesMutationVariables>(UploadCostOfSalesDocument, options);
      }
export type UploadCostOfSalesMutationHookResult = ReturnType<typeof useUploadCostOfSalesMutation>;
export type UploadCostOfSalesMutationResult = Apollo.MutationResult<UploadCostOfSalesMutation>;
export type UploadCostOfSalesMutationOptions = Apollo.BaseMutationOptions<UploadCostOfSalesMutation, UploadCostOfSalesMutationVariables>;
export const CreateCountryDocument = gql`
    mutation CreateCountry($inputs: CreateCountryInputs!) {
  createCountry(inputs: $inputs) {
    id
    Country
    moneytype
    moneycode
    moneysymbol
    zone
    timezone
    timeway
    taxtype
    weighttype
    taxrate
    membercountry
    officeid
    itemdesc
    daylight
    countrycode
    locale
    isActive
    dateCreated
    dateModified
  }
}
    `;
export type CreateCountryMutationFn = Apollo.MutationFunction<CreateCountryMutation, CreateCountryMutationVariables>;

/**
 * __useCreateCountryMutation__
 *
 * To run a mutation, you first call `useCreateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCountryMutation, { data, loading, error }] = useCreateCountryMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateCountryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCountryMutation, CreateCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCountryMutation, CreateCountryMutationVariables>(CreateCountryDocument, options);
      }
export type CreateCountryMutationHookResult = ReturnType<typeof useCreateCountryMutation>;
export type CreateCountryMutationResult = Apollo.MutationResult<CreateCountryMutation>;
export type CreateCountryMutationOptions = Apollo.BaseMutationOptions<CreateCountryMutation, CreateCountryMutationVariables>;
export const UpdateCountryDocument = gql`
    mutation UpdateCountry($inputs: UpdateCountryInputs!) {
  updateCountry(inputs: $inputs) {
    id
    Country
    moneytype
    moneycode
    moneysymbol
    zone
    timezone
    timeway
    taxtype
    weighttype
    taxrate
    membercountry
    officeid
    itemdesc
    daylight
    countrycode
    locale
    isActive
    dateCreated
    dateModified
  }
}
    `;
export type UpdateCountryMutationFn = Apollo.MutationFunction<UpdateCountryMutation, UpdateCountryMutationVariables>;

/**
 * __useUpdateCountryMutation__
 *
 * To run a mutation, you first call `useUpdateCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCountryMutation, { data, loading, error }] = useUpdateCountryMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateCountryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCountryMutation, UpdateCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCountryMutation, UpdateCountryMutationVariables>(UpdateCountryDocument, options);
      }
export type UpdateCountryMutationHookResult = ReturnType<typeof useUpdateCountryMutation>;
export type UpdateCountryMutationResult = Apollo.MutationResult<UpdateCountryMutation>;
export type UpdateCountryMutationOptions = Apollo.BaseMutationOptions<UpdateCountryMutation, UpdateCountryMutationVariables>;
export const EmployeeByIDDocument = gql`
    query EmployeeByID($employeeID: Int!) {
  employeeByID(id: $employeeID) {
    id
    fullname
    position
    isActive
    dgnumber
    email
    picture
    isPericulumSetup
    office {
      id
      client
    }
    roles {
      id
      name
      description
    }
    permissions {
      id
      name
      source
      sourceName
    }
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useEmployeeByIDQuery__
 *
 * To run a query within a React component, call `useEmployeeByIDQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeByIDQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeByIDQuery({
 *   variables: {
 *      employeeID: // value for 'employeeID'
 *   },
 * });
 */
export function useEmployeeByIDQuery(baseOptions: Apollo.QueryHookOptions<EmployeeByIDQuery, EmployeeByIDQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeByIDQuery, EmployeeByIDQueryVariables>(EmployeeByIDDocument, options);
      }
export function useEmployeeByIDLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeByIDQuery, EmployeeByIDQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeByIDQuery, EmployeeByIDQueryVariables>(EmployeeByIDDocument, options);
        }
export type EmployeeByIDQueryHookResult = ReturnType<typeof useEmployeeByIDQuery>;
export type EmployeeByIDLazyQueryHookResult = ReturnType<typeof useEmployeeByIDLazyQuery>;
export type EmployeeByIDQueryResult = Apollo.QueryResult<EmployeeByIDQuery, EmployeeByIDQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($inputs: CreateEmployeeInputs!) {
  createEmployee(inputs: $inputs) {
    id
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($inputs: UpdateEmployeeInputs!) {
  updateEmployee(inputs: $inputs) {
    id
    fullname
    position
    isActive
    dgnumber
    email
    picture
    office {
      id
      client
    }
    roles {
      id
      name
      description
    }
    isPericulumSetup
    dateCreated
    dateModified
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const AssignPermissionsDocument = gql`
    mutation AssignPermissions($inputs: AssignEmployeePermissionsInputs!) {
  assignPermissions(inputs: $inputs) {
    id
    permissions {
      id
      name
      source
      sourceName
    }
  }
}
    `;
export type AssignPermissionsMutationFn = Apollo.MutationFunction<AssignPermissionsMutation, AssignPermissionsMutationVariables>;

/**
 * __useAssignPermissionsMutation__
 *
 * To run a mutation, you first call `useAssignPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPermissionsMutation, { data, loading, error }] = useAssignPermissionsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useAssignPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<AssignPermissionsMutation, AssignPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPermissionsMutation, AssignPermissionsMutationVariables>(AssignPermissionsDocument, options);
      }
export type AssignPermissionsMutationHookResult = ReturnType<typeof useAssignPermissionsMutation>;
export type AssignPermissionsMutationResult = Apollo.MutationResult<AssignPermissionsMutation>;
export type AssignPermissionsMutationOptions = Apollo.BaseMutationOptions<AssignPermissionsMutation, AssignPermissionsMutationVariables>;
export const MawbVouchersDocument = gql`
    query MawbVouchers($filters: GetMawbVoucherFilters) {
  mawbVouchersCount(filters: $filters)
  mawbVouchers(filters: $filters) {
    id
    airlinecode
    isUsed
    dateCreated
    dateModified
    isConsolidated
    isBorrowed
    mawbNumber
    airline {
      id
      airlinename
    }
    ownedByOffice {
      id
      client
    }
    assignments {
      id
      booking {
        coyhawb
      }
    }
  }
}
    `;

/**
 * __useMawbVouchersQuery__
 *
 * To run a query within a React component, call `useMawbVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMawbVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMawbVouchersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMawbVouchersQuery(baseOptions?: Apollo.QueryHookOptions<MawbVouchersQuery, MawbVouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MawbVouchersQuery, MawbVouchersQueryVariables>(MawbVouchersDocument, options);
      }
export function useMawbVouchersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MawbVouchersQuery, MawbVouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MawbVouchersQuery, MawbVouchersQueryVariables>(MawbVouchersDocument, options);
        }
export type MawbVouchersQueryHookResult = ReturnType<typeof useMawbVouchersQuery>;
export type MawbVouchersLazyQueryHookResult = ReturnType<typeof useMawbVouchersLazyQuery>;
export type MawbVouchersQueryResult = Apollo.QueryResult<MawbVouchersQuery, MawbVouchersQueryVariables>;
export const CreateMawbVouchersDocument = gql`
    mutation CreateMawbVouchers($inputs: CreateMawbVouchersInputs!) {
  createMawbVouchers(inputs: $inputs)
}
    `;
export type CreateMawbVouchersMutationFn = Apollo.MutationFunction<CreateMawbVouchersMutation, CreateMawbVouchersMutationVariables>;

/**
 * __useCreateMawbVouchersMutation__
 *
 * To run a mutation, you first call `useCreateMawbVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMawbVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMawbVouchersMutation, { data, loading, error }] = useCreateMawbVouchersMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateMawbVouchersMutation(baseOptions?: Apollo.MutationHookOptions<CreateMawbVouchersMutation, CreateMawbVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMawbVouchersMutation, CreateMawbVouchersMutationVariables>(CreateMawbVouchersDocument, options);
      }
export type CreateMawbVouchersMutationHookResult = ReturnType<typeof useCreateMawbVouchersMutation>;
export type CreateMawbVouchersMutationResult = Apollo.MutationResult<CreateMawbVouchersMutation>;
export type CreateMawbVouchersMutationOptions = Apollo.BaseMutationOptions<CreateMawbVouchersMutation, CreateMawbVouchersMutationVariables>;
export const DeleteMawbVoucherDocument = gql`
    mutation DeleteMawbVoucher($deleteMawbVoucherId: Int!) {
  deleteMawbVoucher(id: $deleteMawbVoucherId) {
    id
  }
}
    `;
export type DeleteMawbVoucherMutationFn = Apollo.MutationFunction<DeleteMawbVoucherMutation, DeleteMawbVoucherMutationVariables>;

/**
 * __useDeleteMawbVoucherMutation__
 *
 * To run a mutation, you first call `useDeleteMawbVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMawbVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMawbVoucherMutation, { data, loading, error }] = useDeleteMawbVoucherMutation({
 *   variables: {
 *      deleteMawbVoucherId: // value for 'deleteMawbVoucherId'
 *   },
 * });
 */
export function useDeleteMawbVoucherMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMawbVoucherMutation, DeleteMawbVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMawbVoucherMutation, DeleteMawbVoucherMutationVariables>(DeleteMawbVoucherDocument, options);
      }
export type DeleteMawbVoucherMutationHookResult = ReturnType<typeof useDeleteMawbVoucherMutation>;
export type DeleteMawbVoucherMutationResult = Apollo.MutationResult<DeleteMawbVoucherMutation>;
export type DeleteMawbVoucherMutationOptions = Apollo.BaseMutationOptions<DeleteMawbVoucherMutation, DeleteMawbVoucherMutationVariables>;
export const GlobalUnNumbersDocument = gql`
    query GlobalUnNumbers($filters: GetUNNumbersFilters) {
  unNumbers(filters: $filters) {
    id
    unno
    extraname
    propername
    classdiv
    subrisk
    labelno
    isAuthRequired
    hazlabel
    specialProvision
    ergcode
    isActive
    regulations {
      ...Regulation
    }
    dateCreated
    dateModified
  }
  unNumbersCount(filters: $filters)
}
    ${RegulationFragmentDoc}`;

/**
 * __useGlobalUnNumbersQuery__
 *
 * To run a query within a React component, call `useGlobalUnNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalUnNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalUnNumbersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalUnNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GlobalUnNumbersQuery, GlobalUnNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalUnNumbersQuery, GlobalUnNumbersQueryVariables>(GlobalUnNumbersDocument, options);
      }
export function useGlobalUnNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalUnNumbersQuery, GlobalUnNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalUnNumbersQuery, GlobalUnNumbersQueryVariables>(GlobalUnNumbersDocument, options);
        }
export type GlobalUnNumbersQueryHookResult = ReturnType<typeof useGlobalUnNumbersQuery>;
export type GlobalUnNumbersLazyQueryHookResult = ReturnType<typeof useGlobalUnNumbersLazyQuery>;
export type GlobalUnNumbersQueryResult = Apollo.QueryResult<GlobalUnNumbersQuery, GlobalUnNumbersQueryVariables>;
export const UnNumberDocument = gql`
    query UnNumber($ID: Int!) {
  unNumber(id: $ID) {
    id
    unno
    extraname
    propername
    classdiv
    subrisk
    labelno
    isAuthRequired
    hazlabel
    specialProvision
    ergcode
    isActive
    regulations {
      ...Regulation
    }
    dateCreated
    dateModified
  }
}
    ${RegulationFragmentDoc}`;

/**
 * __useUnNumberQuery__
 *
 * To run a query within a React component, call `useUnNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnNumberQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useUnNumberQuery(baseOptions: Apollo.QueryHookOptions<UnNumberQuery, UnNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnNumberQuery, UnNumberQueryVariables>(UnNumberDocument, options);
      }
export function useUnNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnNumberQuery, UnNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnNumberQuery, UnNumberQueryVariables>(UnNumberDocument, options);
        }
export type UnNumberQueryHookResult = ReturnType<typeof useUnNumberQuery>;
export type UnNumberLazyQueryHookResult = ReturnType<typeof useUnNumberLazyQuery>;
export type UnNumberQueryResult = Apollo.QueryResult<UnNumberQuery, UnNumberQueryVariables>;
export const CreateUNNumberDocument = gql`
    mutation CreateUNNumber($inputs: CreateUNNumberInputs!) {
  createUNNumber(inputs: $inputs) {
    id
    unno
    extraname
    propername
    classdiv
    subrisk
    labelno
    isAuthRequired
    hazlabel
    specialProvision
    ergcode
    isActive
    regulations {
      ...Regulation
    }
    dateCreated
    dateModified
  }
}
    ${RegulationFragmentDoc}`;
export type CreateUNNumberMutationFn = Apollo.MutationFunction<CreateUNNumberMutation, CreateUNNumberMutationVariables>;

/**
 * __useCreateUNNumberMutation__
 *
 * To run a mutation, you first call `useCreateUNNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUNNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUnNumberMutation, { data, loading, error }] = useCreateUNNumberMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateUNNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateUNNumberMutation, CreateUNNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUNNumberMutation, CreateUNNumberMutationVariables>(CreateUNNumberDocument, options);
      }
export type CreateUNNumberMutationHookResult = ReturnType<typeof useCreateUNNumberMutation>;
export type CreateUNNumberMutationResult = Apollo.MutationResult<CreateUNNumberMutation>;
export type CreateUNNumberMutationOptions = Apollo.BaseMutationOptions<CreateUNNumberMutation, CreateUNNumberMutationVariables>;
export const UpdateUNNumberDocument = gql`
    mutation UpdateUNNumber($inputs: UpdateUNNumberInputs!) {
  updateUNNumber(inputs: $inputs) {
    id
    unno
    extraname
    propername
    classdiv
    subrisk
    labelno
    isAuthRequired
    hazlabel
    specialProvision
    ergcode
    isActive
    regulations {
      ...Regulation
    }
    dateCreated
    dateModified
  }
}
    ${RegulationFragmentDoc}`;
export type UpdateUNNumberMutationFn = Apollo.MutationFunction<UpdateUNNumberMutation, UpdateUNNumberMutationVariables>;

/**
 * __useUpdateUNNumberMutation__
 *
 * To run a mutation, you first call `useUpdateUNNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUNNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnNumberMutation, { data, loading, error }] = useUpdateUNNumberMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateUNNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUNNumberMutation, UpdateUNNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUNNumberMutation, UpdateUNNumberMutationVariables>(UpdateUNNumberDocument, options);
      }
export type UpdateUNNumberMutationHookResult = ReturnType<typeof useUpdateUNNumberMutation>;
export type UpdateUNNumberMutationResult = Apollo.MutationResult<UpdateUNNumberMutation>;
export type UpdateUNNumberMutationOptions = Apollo.BaseMutationOptions<UpdateUNNumberMutation, UpdateUNNumberMutationVariables>;
export const DeleteUNNumberDocument = gql`
    mutation DeleteUNNumber($ID: Float!) {
  deleteUNNumber(id: $ID) {
    id
  }
}
    `;
export type DeleteUNNumberMutationFn = Apollo.MutationFunction<DeleteUNNumberMutation, DeleteUNNumberMutationVariables>;

/**
 * __useDeleteUNNumberMutation__
 *
 * To run a mutation, you first call `useDeleteUNNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUNNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnNumberMutation, { data, loading, error }] = useDeleteUNNumberMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteUNNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUNNumberMutation, DeleteUNNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUNNumberMutation, DeleteUNNumberMutationVariables>(DeleteUNNumberDocument, options);
      }
export type DeleteUNNumberMutationHookResult = ReturnType<typeof useDeleteUNNumberMutation>;
export type DeleteUNNumberMutationResult = Apollo.MutationResult<DeleteUNNumberMutation>;
export type DeleteUNNumberMutationOptions = Apollo.BaseMutationOptions<DeleteUNNumberMutation, DeleteUNNumberMutationVariables>;
export const CreateRegulationDocument = gql`
    mutation CreateRegulation($inputs: CreateRegulationInputs!) {
  createRegulation(inputs: $inputs) {
    ...Regulation
  }
}
    ${RegulationFragmentDoc}`;
export type CreateRegulationMutationFn = Apollo.MutationFunction<CreateRegulationMutation, CreateRegulationMutationVariables>;

/**
 * __useCreateRegulationMutation__
 *
 * To run a mutation, you first call `useCreateRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegulationMutation, { data, loading, error }] = useCreateRegulationMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateRegulationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegulationMutation, CreateRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegulationMutation, CreateRegulationMutationVariables>(CreateRegulationDocument, options);
      }
export type CreateRegulationMutationHookResult = ReturnType<typeof useCreateRegulationMutation>;
export type CreateRegulationMutationResult = Apollo.MutationResult<CreateRegulationMutation>;
export type CreateRegulationMutationOptions = Apollo.BaseMutationOptions<CreateRegulationMutation, CreateRegulationMutationVariables>;
export const UpdateRegulationDocument = gql`
    mutation UpdateRegulation($inputs: UpdateRegulationInputs!) {
  updateRegulation(inputs: $inputs) {
    ...Regulation
  }
}
    ${RegulationFragmentDoc}`;
export type UpdateRegulationMutationFn = Apollo.MutationFunction<UpdateRegulationMutation, UpdateRegulationMutationVariables>;

/**
 * __useUpdateRegulationMutation__
 *
 * To run a mutation, you first call `useUpdateRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulationMutation, { data, loading, error }] = useUpdateRegulationMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateRegulationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulationMutation, UpdateRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulationMutation, UpdateRegulationMutationVariables>(UpdateRegulationDocument, options);
      }
export type UpdateRegulationMutationHookResult = ReturnType<typeof useUpdateRegulationMutation>;
export type UpdateRegulationMutationResult = Apollo.MutationResult<UpdateRegulationMutation>;
export type UpdateRegulationMutationOptions = Apollo.BaseMutationOptions<UpdateRegulationMutation, UpdateRegulationMutationVariables>;
export const DeleteRegulationDocument = gql`
    mutation DeleteRegulation($ID: Float!) {
  deleteRegulation(id: $ID) {
    id
  }
}
    `;
export type DeleteRegulationMutationFn = Apollo.MutationFunction<DeleteRegulationMutation, DeleteRegulationMutationVariables>;

/**
 * __useDeleteRegulationMutation__
 *
 * To run a mutation, you first call `useDeleteRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegulationMutation, { data, loading, error }] = useDeleteRegulationMutation({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useDeleteRegulationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegulationMutation, DeleteRegulationMutationVariables>(DeleteRegulationDocument, options);
      }
export type DeleteRegulationMutationHookResult = ReturnType<typeof useDeleteRegulationMutation>;
export type DeleteRegulationMutationResult = Apollo.MutationResult<DeleteRegulationMutation>;
export type DeleteRegulationMutationOptions = Apollo.BaseMutationOptions<DeleteRegulationMutation, DeleteRegulationMutationVariables>;
export const CreatePackagingOptionDocument = gql`
    mutation CreatePackagingOption($inputs: CreatePackagingOptionInputs!) {
  createPackagingOption(inputs: $inputs) {
    id
    name
    isActive
    dateCreated
    dateModified
  }
}
    `;
export type CreatePackagingOptionMutationFn = Apollo.MutationFunction<CreatePackagingOptionMutation, CreatePackagingOptionMutationVariables>;

/**
 * __useCreatePackagingOptionMutation__
 *
 * To run a mutation, you first call `useCreatePackagingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePackagingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPackagingOptionMutation, { data, loading, error }] = useCreatePackagingOptionMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreatePackagingOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePackagingOptionMutation, CreatePackagingOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePackagingOptionMutation, CreatePackagingOptionMutationVariables>(CreatePackagingOptionDocument, options);
      }
export type CreatePackagingOptionMutationHookResult = ReturnType<typeof useCreatePackagingOptionMutation>;
export type CreatePackagingOptionMutationResult = Apollo.MutationResult<CreatePackagingOptionMutation>;
export type CreatePackagingOptionMutationOptions = Apollo.BaseMutationOptions<CreatePackagingOptionMutation, CreatePackagingOptionMutationVariables>;
export const UpdatePackagingOptionDocument = gql`
    mutation UpdatePackagingOption($inputs: UpdatePackagingOptionInputs!) {
  updatePackagingOption(inputs: $inputs) {
    id
    name
    isActive
    dateCreated
    dateModified
  }
}
    `;
export type UpdatePackagingOptionMutationFn = Apollo.MutationFunction<UpdatePackagingOptionMutation, UpdatePackagingOptionMutationVariables>;

/**
 * __useUpdatePackagingOptionMutation__
 *
 * To run a mutation, you first call `useUpdatePackagingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackagingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackagingOptionMutation, { data, loading, error }] = useUpdatePackagingOptionMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdatePackagingOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackagingOptionMutation, UpdatePackagingOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackagingOptionMutation, UpdatePackagingOptionMutationVariables>(UpdatePackagingOptionDocument, options);
      }
export type UpdatePackagingOptionMutationHookResult = ReturnType<typeof useUpdatePackagingOptionMutation>;
export type UpdatePackagingOptionMutationResult = Apollo.MutationResult<UpdatePackagingOptionMutation>;
export type UpdatePackagingOptionMutationOptions = Apollo.BaseMutationOptions<UpdatePackagingOptionMutation, UpdatePackagingOptionMutationVariables>;
export const DeletePackagingOptionDocument = gql`
    mutation DeletePackagingOption($PackagingOptionID: Int!) {
  deletePackagingOption(id: $PackagingOptionID) {
    id
    name
    isActive
    dateCreated
    dateModified
  }
}
    `;
export type DeletePackagingOptionMutationFn = Apollo.MutationFunction<DeletePackagingOptionMutation, DeletePackagingOptionMutationVariables>;

/**
 * __useDeletePackagingOptionMutation__
 *
 * To run a mutation, you first call `useDeletePackagingOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePackagingOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePackagingOptionMutation, { data, loading, error }] = useDeletePackagingOptionMutation({
 *   variables: {
 *      PackagingOptionID: // value for 'PackagingOptionID'
 *   },
 * });
 */
export function useDeletePackagingOptionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePackagingOptionMutation, DeletePackagingOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePackagingOptionMutation, DeletePackagingOptionMutationVariables>(DeletePackagingOptionDocument, options);
      }
export type DeletePackagingOptionMutationHookResult = ReturnType<typeof useDeletePackagingOptionMutation>;
export type DeletePackagingOptionMutationResult = Apollo.MutationResult<DeletePackagingOptionMutation>;
export type DeletePackagingOptionMutationOptions = Apollo.BaseMutationOptions<DeletePackagingOptionMutation, DeletePackagingOptionMutationVariables>;
export const PortcodeAndAgentsDocument = gql`
    query PortcodeAndAgents($portcodeID: Int!) {
  portcodeByID(portcodeID: $portcodeID) {
    id
    portcode
    cityname
    state
    country {
      id
      Country
    }
    extraShippingDays
    isRemoteLocation
    notes
    isActive
    agents {
      id
      client
    }
  }
}
    `;

/**
 * __usePortcodeAndAgentsQuery__
 *
 * To run a query within a React component, call `usePortcodeAndAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortcodeAndAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortcodeAndAgentsQuery({
 *   variables: {
 *      portcodeID: // value for 'portcodeID'
 *   },
 * });
 */
export function usePortcodeAndAgentsQuery(baseOptions: Apollo.QueryHookOptions<PortcodeAndAgentsQuery, PortcodeAndAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortcodeAndAgentsQuery, PortcodeAndAgentsQueryVariables>(PortcodeAndAgentsDocument, options);
      }
export function usePortcodeAndAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortcodeAndAgentsQuery, PortcodeAndAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortcodeAndAgentsQuery, PortcodeAndAgentsQueryVariables>(PortcodeAndAgentsDocument, options);
        }
export type PortcodeAndAgentsQueryHookResult = ReturnType<typeof usePortcodeAndAgentsQuery>;
export type PortcodeAndAgentsLazyQueryHookResult = ReturnType<typeof usePortcodeAndAgentsLazyQuery>;
export type PortcodeAndAgentsQueryResult = Apollo.QueryResult<PortcodeAndAgentsQuery, PortcodeAndAgentsQueryVariables>;
export const DeletePortcodeDocument = gql`
    mutation DeletePortcode($portcodeID: Int!) {
  deletePortcode(portcodeID: $portcodeID) {
    id
    cityname
    country {
      Country
      id
    }
    isActive
    portcode
    isRemoteLocation
    extraShippingDays
    state
  }
}
    `;
export type DeletePortcodeMutationFn = Apollo.MutationFunction<DeletePortcodeMutation, DeletePortcodeMutationVariables>;

/**
 * __useDeletePortcodeMutation__
 *
 * To run a mutation, you first call `useDeletePortcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortcodeMutation, { data, loading, error }] = useDeletePortcodeMutation({
 *   variables: {
 *      portcodeID: // value for 'portcodeID'
 *   },
 * });
 */
export function useDeletePortcodeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePortcodeMutation, DeletePortcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePortcodeMutation, DeletePortcodeMutationVariables>(DeletePortcodeDocument, options);
      }
export type DeletePortcodeMutationHookResult = ReturnType<typeof useDeletePortcodeMutation>;
export type DeletePortcodeMutationResult = Apollo.MutationResult<DeletePortcodeMutation>;
export type DeletePortcodeMutationOptions = Apollo.BaseMutationOptions<DeletePortcodeMutation, DeletePortcodeMutationVariables>;
export const CreatePortcodeDocument = gql`
    mutation CreatePortcode($inputs: CreatePortcodeInputs!) {
  createPortcode(inputs: $inputs) {
    id
    cityname
    country {
      Country
      id
    }
    isActive
    portcode
    isRemoteLocation
    extraShippingDays
    state
    notes
  }
}
    `;
export type CreatePortcodeMutationFn = Apollo.MutationFunction<CreatePortcodeMutation, CreatePortcodeMutationVariables>;

/**
 * __useCreatePortcodeMutation__
 *
 * To run a mutation, you first call `useCreatePortcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortcodeMutation, { data, loading, error }] = useCreatePortcodeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreatePortcodeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortcodeMutation, CreatePortcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortcodeMutation, CreatePortcodeMutationVariables>(CreatePortcodeDocument, options);
      }
export type CreatePortcodeMutationHookResult = ReturnType<typeof useCreatePortcodeMutation>;
export type CreatePortcodeMutationResult = Apollo.MutationResult<CreatePortcodeMutation>;
export type CreatePortcodeMutationOptions = Apollo.BaseMutationOptions<CreatePortcodeMutation, CreatePortcodeMutationVariables>;
export const UpdatePortcodeDocument = gql`
    mutation UpdatePortcode($inputs: UpdatePortcodeInputs!) {
  updatePortcode(inputs: $inputs) {
    id
    cityname
    country {
      Country
      id
    }
    isActive
    portcode
    isRemoteLocation
    extraShippingDays
    state
    notes
  }
}
    `;
export type UpdatePortcodeMutationFn = Apollo.MutationFunction<UpdatePortcodeMutation, UpdatePortcodeMutationVariables>;

/**
 * __useUpdatePortcodeMutation__
 *
 * To run a mutation, you first call `useUpdatePortcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortcodeMutation, { data, loading, error }] = useUpdatePortcodeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdatePortcodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortcodeMutation, UpdatePortcodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortcodeMutation, UpdatePortcodeMutationVariables>(UpdatePortcodeDocument, options);
      }
export type UpdatePortcodeMutationHookResult = ReturnType<typeof useUpdatePortcodeMutation>;
export type UpdatePortcodeMutationResult = Apollo.MutationResult<UpdatePortcodeMutation>;
export type UpdatePortcodeMutationOptions = Apollo.BaseMutationOptions<UpdatePortcodeMutation, UpdatePortcodeMutationVariables>;
export const TransitTimesAndCountriesDocument = gql`
    query TransitTimesAndCountries {
  transitTimes {
    id
    tozone
    days
    countries {
      id
      Country
    }
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useTransitTimesAndCountriesQuery__
 *
 * To run a query within a React component, call `useTransitTimesAndCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransitTimesAndCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransitTimesAndCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransitTimesAndCountriesQuery(baseOptions?: Apollo.QueryHookOptions<TransitTimesAndCountriesQuery, TransitTimesAndCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransitTimesAndCountriesQuery, TransitTimesAndCountriesQueryVariables>(TransitTimesAndCountriesDocument, options);
      }
export function useTransitTimesAndCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransitTimesAndCountriesQuery, TransitTimesAndCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransitTimesAndCountriesQuery, TransitTimesAndCountriesQueryVariables>(TransitTimesAndCountriesDocument, options);
        }
export type TransitTimesAndCountriesQueryHookResult = ReturnType<typeof useTransitTimesAndCountriesQuery>;
export type TransitTimesAndCountriesLazyQueryHookResult = ReturnType<typeof useTransitTimesAndCountriesLazyQuery>;
export type TransitTimesAndCountriesQueryResult = Apollo.QueryResult<TransitTimesAndCountriesQuery, TransitTimesAndCountriesQueryVariables>;
export const UpdateTransitTimeDocument = gql`
    mutation UpdateTransitTime($inputs: UpdateTransitTimeInputs!) {
  updateTransitTime(inputs: $inputs) {
    id
    tozone
    days
    dateCreated
    dateModified
  }
}
    `;
export type UpdateTransitTimeMutationFn = Apollo.MutationFunction<UpdateTransitTimeMutation, UpdateTransitTimeMutationVariables>;

/**
 * __useUpdateTransitTimeMutation__
 *
 * To run a mutation, you first call `useUpdateTransitTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransitTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransitTimeMutation, { data, loading, error }] = useUpdateTransitTimeMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateTransitTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransitTimeMutation, UpdateTransitTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransitTimeMutation, UpdateTransitTimeMutationVariables>(UpdateTransitTimeDocument, options);
      }
export type UpdateTransitTimeMutationHookResult = ReturnType<typeof useUpdateTransitTimeMutation>;
export type UpdateTransitTimeMutationResult = Apollo.MutationResult<UpdateTransitTimeMutation>;
export type UpdateTransitTimeMutationOptions = Apollo.BaseMutationOptions<UpdateTransitTimeMutation, UpdateTransitTimeMutationVariables>;
export const ProfileDocument = gql`
    query Profile {
  profile {
    employee {
      id
      fullname
      email
      dgnumber
      position
      picture
      isActive
    }
    periculumOffice {
      ...OfficeConfiguration
    }
    roles {
      id
      name
      description
    }
    permissions {
      id
      name
      source
      sourceName
    }
  }
}
    ${OfficeConfigurationFragmentDoc}`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const UnreadEmailCountDocument = gql`
    query UnreadEmailCount {
  unreadEmailCount
}
    `;

/**
 * __useUnreadEmailCountQuery__
 *
 * To run a query within a React component, call `useUnreadEmailCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadEmailCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadEmailCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadEmailCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadEmailCountQuery, UnreadEmailCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadEmailCountQuery, UnreadEmailCountQueryVariables>(UnreadEmailCountDocument, options);
      }
export function useUnreadEmailCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadEmailCountQuery, UnreadEmailCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadEmailCountQuery, UnreadEmailCountQueryVariables>(UnreadEmailCountDocument, options);
        }
export type UnreadEmailCountQueryHookResult = ReturnType<typeof useUnreadEmailCountQuery>;
export type UnreadEmailCountLazyQueryHookResult = ReturnType<typeof useUnreadEmailCountLazyQuery>;
export type UnreadEmailCountQueryResult = Apollo.QueryResult<UnreadEmailCountQuery, UnreadEmailCountQueryVariables>;
export const GlobalOfficeConfigurationsDocument = gql`
    query GlobalOfficeConfigurations {
  officeConfigurations {
    ...OfficeConfiguration
  }
}
    ${OfficeConfigurationFragmentDoc}`;

/**
 * __useGlobalOfficeConfigurationsQuery__
 *
 * To run a query within a React component, call `useGlobalOfficeConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOfficeConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOfficeConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalOfficeConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalOfficeConfigurationsQuery, GlobalOfficeConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalOfficeConfigurationsQuery, GlobalOfficeConfigurationsQueryVariables>(GlobalOfficeConfigurationsDocument, options);
      }
export function useGlobalOfficeConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalOfficeConfigurationsQuery, GlobalOfficeConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalOfficeConfigurationsQuery, GlobalOfficeConfigurationsQueryVariables>(GlobalOfficeConfigurationsDocument, options);
        }
export type GlobalOfficeConfigurationsQueryHookResult = ReturnType<typeof useGlobalOfficeConfigurationsQuery>;
export type GlobalOfficeConfigurationsLazyQueryHookResult = ReturnType<typeof useGlobalOfficeConfigurationsLazyQuery>;
export type GlobalOfficeConfigurationsQueryResult = Apollo.QueryResult<GlobalOfficeConfigurationsQuery, GlobalOfficeConfigurationsQueryVariables>;
export const GlobalRegionsDocument = gql`
    query GlobalRegions {
  regions {
    id
    name
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useGlobalRegionsQuery__
 *
 * To run a query within a React component, call `useGlobalRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalRegionsQuery, GlobalRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalRegionsQuery, GlobalRegionsQueryVariables>(GlobalRegionsDocument, options);
      }
export function useGlobalRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalRegionsQuery, GlobalRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalRegionsQuery, GlobalRegionsQueryVariables>(GlobalRegionsDocument, options);
        }
export type GlobalRegionsQueryHookResult = ReturnType<typeof useGlobalRegionsQuery>;
export type GlobalRegionsLazyQueryHookResult = ReturnType<typeof useGlobalRegionsLazyQuery>;
export type GlobalRegionsQueryResult = Apollo.QueryResult<GlobalRegionsQuery, GlobalRegionsQueryVariables>;
export const GlobalCountriesDocument = gql`
    query GlobalCountries {
  countries {
    id
    Country
    moneytype
    moneycode
    moneysymbol
    zone
    timezone
    timeway
    taxtype
    weighttype
    taxrate
    membercountry
    officeid
    itemdesc
    daylight
    countrycode
    locale
    isActive
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useGlobalCountriesQuery__
 *
 * To run a query within a React component, call `useGlobalCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalCountriesQuery, GlobalCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalCountriesQuery, GlobalCountriesQueryVariables>(GlobalCountriesDocument, options);
      }
export function useGlobalCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalCountriesQuery, GlobalCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalCountriesQuery, GlobalCountriesQueryVariables>(GlobalCountriesDocument, options);
        }
export type GlobalCountriesQueryHookResult = ReturnType<typeof useGlobalCountriesQuery>;
export type GlobalCountriesLazyQueryHookResult = ReturnType<typeof useGlobalCountriesLazyQuery>;
export type GlobalCountriesQueryResult = Apollo.QueryResult<GlobalCountriesQuery, GlobalCountriesQueryVariables>;
export const LocalesDocument = gql`
    query Locales {
  locales
}
    `;

/**
 * __useLocalesQuery__
 *
 * To run a query within a React component, call `useLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocalesQuery(baseOptions?: Apollo.QueryHookOptions<LocalesQuery, LocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalesQuery, LocalesQueryVariables>(LocalesDocument, options);
      }
export function useLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalesQuery, LocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalesQuery, LocalesQueryVariables>(LocalesDocument, options);
        }
export type LocalesQueryHookResult = ReturnType<typeof useLocalesQuery>;
export type LocalesLazyQueryHookResult = ReturnType<typeof useLocalesLazyQuery>;
export type LocalesQueryResult = Apollo.QueryResult<LocalesQuery, LocalesQueryVariables>;
export const CurrenciesDocument = gql`
    query Currencies {
  currencies {
    code
    name
  }
}
    `;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
      }
export function useCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
        }
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = Apollo.QueryResult<CurrenciesQuery, CurrenciesQueryVariables>;
export const TimezonesDocument = gql`
    query Timezones {
  timezones
}
    `;

/**
 * __useTimezonesQuery__
 *
 * To run a query within a React component, call `useTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
      }
export function useTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimezonesQuery, TimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimezonesQuery, TimezonesQueryVariables>(TimezonesDocument, options);
        }
export type TimezonesQueryHookResult = ReturnType<typeof useTimezonesQuery>;
export type TimezonesLazyQueryHookResult = ReturnType<typeof useTimezonesLazyQuery>;
export type TimezonesQueryResult = Apollo.QueryResult<TimezonesQuery, TimezonesQueryVariables>;
export const BookingTypeConfigDocument = gql`
    query BookingTypeConfig($bookingtype: BookingType!) {
  bookingTypeConfiguration(bookingtype: $bookingtype) {
    id
    bookingtype
    chargefreightcost
    tariffmultiplier
    chargetax
  }
}
    `;

/**
 * __useBookingTypeConfigQuery__
 *
 * To run a query within a React component, call `useBookingTypeConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingTypeConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingTypeConfigQuery({
 *   variables: {
 *      bookingtype: // value for 'bookingtype'
 *   },
 * });
 */
export function useBookingTypeConfigQuery(baseOptions: Apollo.QueryHookOptions<BookingTypeConfigQuery, BookingTypeConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingTypeConfigQuery, BookingTypeConfigQueryVariables>(BookingTypeConfigDocument, options);
      }
export function useBookingTypeConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingTypeConfigQuery, BookingTypeConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingTypeConfigQuery, BookingTypeConfigQueryVariables>(BookingTypeConfigDocument, options);
        }
export type BookingTypeConfigQueryHookResult = ReturnType<typeof useBookingTypeConfigQuery>;
export type BookingTypeConfigLazyQueryHookResult = ReturnType<typeof useBookingTypeConfigLazyQuery>;
export type BookingTypeConfigQueryResult = Apollo.QueryResult<BookingTypeConfigQuery, BookingTypeConfigQueryVariables>;
export const GlobalEmployeesDocument = gql`
    query GlobalEmployees($filters: GetEmployeesFilters) {
  employeesCount(filters: $filters)
  employees(filters: $filters) {
    ...GlobalEmployeeFields
  }
}
    ${GlobalEmployeeFieldsFragmentDoc}`;

/**
 * __useGlobalEmployeesQuery__
 *
 * To run a query within a React component, call `useGlobalEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalEmployeesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalEmployeesQuery, GlobalEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalEmployeesQuery, GlobalEmployeesQueryVariables>(GlobalEmployeesDocument, options);
      }
export function useGlobalEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalEmployeesQuery, GlobalEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalEmployeesQuery, GlobalEmployeesQueryVariables>(GlobalEmployeesDocument, options);
        }
export type GlobalEmployeesQueryHookResult = ReturnType<typeof useGlobalEmployeesQuery>;
export type GlobalEmployeesLazyQueryHookResult = ReturnType<typeof useGlobalEmployeesLazyQuery>;
export type GlobalEmployeesQueryResult = Apollo.QueryResult<GlobalEmployeesQuery, GlobalEmployeesQueryVariables>;
export const GlobalPortcodesDocument = gql`
    query GlobalPortcodes($filters: GetPortcodesFilters) {
  portcodes(filters: $filters) {
    ...GlobalPortcode
  }
}
    ${GlobalPortcodeFragmentDoc}`;

/**
 * __useGlobalPortcodesQuery__
 *
 * To run a query within a React component, call `useGlobalPortcodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPortcodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPortcodesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalPortcodesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalPortcodesQuery, GlobalPortcodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalPortcodesQuery, GlobalPortcodesQueryVariables>(GlobalPortcodesDocument, options);
      }
export function useGlobalPortcodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPortcodesQuery, GlobalPortcodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalPortcodesQuery, GlobalPortcodesQueryVariables>(GlobalPortcodesDocument, options);
        }
export type GlobalPortcodesQueryHookResult = ReturnType<typeof useGlobalPortcodesQuery>;
export type GlobalPortcodesLazyQueryHookResult = ReturnType<typeof useGlobalPortcodesLazyQuery>;
export type GlobalPortcodesQueryResult = Apollo.QueryResult<GlobalPortcodesQuery, GlobalPortcodesQueryVariables>;
export const GlobalAirlinesDocument = gql`
    query GlobalAirlines($filters: FilterAirlinesInputs) {
  airlines(filters: $filters) {
    id
    airlinename
    airlinecode
    airlineid
    airlineweb
  }
}
    `;

/**
 * __useGlobalAirlinesQuery__
 *
 * To run a query within a React component, call `useGlobalAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalAirlinesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalAirlinesQuery(baseOptions?: Apollo.QueryHookOptions<GlobalAirlinesQuery, GlobalAirlinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalAirlinesQuery, GlobalAirlinesQueryVariables>(GlobalAirlinesDocument, options);
      }
export function useGlobalAirlinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalAirlinesQuery, GlobalAirlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalAirlinesQuery, GlobalAirlinesQueryVariables>(GlobalAirlinesDocument, options);
        }
export type GlobalAirlinesQueryHookResult = ReturnType<typeof useGlobalAirlinesQuery>;
export type GlobalAirlinesLazyQueryHookResult = ReturnType<typeof useGlobalAirlinesLazyQuery>;
export type GlobalAirlinesQueryResult = Apollo.QueryResult<GlobalAirlinesQuery, GlobalAirlinesQueryVariables>;
export const GlobalPackagingOptionsDocument = gql`
    query GlobalPackagingOptions($filters: GetPackagingOptionsFilters) {
  packagingOptionsCount(filters: $filters)
  packagingOptions(filters: $filters) {
    id
    name
    isActive
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useGlobalPackagingOptionsQuery__
 *
 * To run a query within a React component, call `useGlobalPackagingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalPackagingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalPackagingOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalPackagingOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GlobalPackagingOptionsQuery, GlobalPackagingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalPackagingOptionsQuery, GlobalPackagingOptionsQueryVariables>(GlobalPackagingOptionsDocument, options);
      }
export function useGlobalPackagingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalPackagingOptionsQuery, GlobalPackagingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalPackagingOptionsQuery, GlobalPackagingOptionsQueryVariables>(GlobalPackagingOptionsDocument, options);
        }
export type GlobalPackagingOptionsQueryHookResult = ReturnType<typeof useGlobalPackagingOptionsQuery>;
export type GlobalPackagingOptionsLazyQueryHookResult = ReturnType<typeof useGlobalPackagingOptionsLazyQuery>;
export type GlobalPackagingOptionsQueryResult = Apollo.QueryResult<GlobalPackagingOptionsQuery, GlobalPackagingOptionsQueryVariables>;
export const GlobalConfigDocument = gql`
    query GlobalConfig {
  globalConfig {
    id
    item
    description
    dataType
    label
    value
    dateCreated
    dateModified
  }
}
    `;

/**
 * __useGlobalConfigQuery__
 *
 * To run a query within a React component, call `useGlobalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalConfigQuery(baseOptions?: Apollo.QueryHookOptions<GlobalConfigQuery, GlobalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GlobalConfigQuery, GlobalConfigQueryVariables>(GlobalConfigDocument, options);
      }
export function useGlobalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GlobalConfigQuery, GlobalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GlobalConfigQuery, GlobalConfigQueryVariables>(GlobalConfigDocument, options);
        }
export type GlobalConfigQueryHookResult = ReturnType<typeof useGlobalConfigQuery>;
export type GlobalConfigLazyQueryHookResult = ReturnType<typeof useGlobalConfigLazyQuery>;
export type GlobalConfigQueryResult = Apollo.QueryResult<GlobalConfigQuery, GlobalConfigQueryVariables>;
export const RecentlyUpdatedAccountsDocument = gql`
    query RecentlyUpdatedAccounts($since: DateTime!) {
  recentlyUpdatedAccounts(since: $since) {
    ...GlobalAccountFields
    dateDeleted
  }
}
    ${GlobalAccountFieldsFragmentDoc}`;

/**
 * __useRecentlyUpdatedAccountsQuery__
 *
 * To run a query within a React component, call `useRecentlyUpdatedAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyUpdatedAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyUpdatedAccountsQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useRecentlyUpdatedAccountsQuery(baseOptions: Apollo.QueryHookOptions<RecentlyUpdatedAccountsQuery, RecentlyUpdatedAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentlyUpdatedAccountsQuery, RecentlyUpdatedAccountsQueryVariables>(RecentlyUpdatedAccountsDocument, options);
      }
export function useRecentlyUpdatedAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentlyUpdatedAccountsQuery, RecentlyUpdatedAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentlyUpdatedAccountsQuery, RecentlyUpdatedAccountsQueryVariables>(RecentlyUpdatedAccountsDocument, options);
        }
export type RecentlyUpdatedAccountsQueryHookResult = ReturnType<typeof useRecentlyUpdatedAccountsQuery>;
export type RecentlyUpdatedAccountsLazyQueryHookResult = ReturnType<typeof useRecentlyUpdatedAccountsLazyQuery>;
export type RecentlyUpdatedAccountsQueryResult = Apollo.QueryResult<RecentlyUpdatedAccountsQuery, RecentlyUpdatedAccountsQueryVariables>;